webpackJsonp([14],{

/***/ "+9ZE":
/***/ (function(module, exports) {



/***/ }),

/***/ "+agw":
/***/ (function(module, exports) {



/***/ }),

/***/ "+sBR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Project show components
 */
var Projects = function Projects(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("wzFr"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectGaap = function ProjectGaap(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("tFo+"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectDebt = function ProjectDebt(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("GHwm"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectOpex = function ProjectOpex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("7G+J"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectsShow = function ProjectsShow(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("vTou"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectCapex = function ProjectCapex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("Uo+D"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectIncome = function ProjectIncome(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("vzL/"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectEquity = function ProjectEquity(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("eSxW"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectSummary = function ProjectSummary(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("xCsd"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectCashFlow = function ProjectCashFlow(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("B4Gi"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectActivity = function ProjectActivity(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("uti6"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectDevBudget = function ProjectDevBudget(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("zDnC"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectFromTemplate = function ProjectFromTemplate(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("N7IG"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectClosingCosts = function ProjectClosingCosts(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("SuIW"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectUserManagement = function ProjectUserManagement(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("fo1K"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * General project components
 */
var ProjectInbox = function ProjectInbox(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(7)]).then((function () {
        return r(__webpack_require__("tlU0"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectLinks = function ProjectLinks(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(7)]).then((function () {
        return r(__webpack_require__("N+Ue"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectInvitations = function ProjectInvitations(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(7)]).then((function () {
        return r(__webpack_require__("Nx9+"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Project edit components
 */
var ProjectEdit = function ProjectEdit(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(12)]).then((function () {
        return r(__webpack_require__("9nxP"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Project create components
 */
var ProjectCreate = function ProjectCreate(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(11)]).then((function () {
        return r(__webpack_require__("gI+f"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectChoices = function ProjectChoices(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(11)]).then((function () {
        return r(__webpack_require__("v8Lb"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Project Routes
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    path: 'projects',
    component: Projects,
    redirect: '/',
    children: [{
        path: 'choose-project-type',
        name: 'projects.choices',
        component: ProjectChoices
    }, {
        path: 'create',
        name: 'projects.create',
        component: ProjectCreate
    }, {
        path: 'links',
        name: 'projects.links',
        component: ProjectLinks
    }, {
        path: 'invitations',
        name: 'projects.invitations',
        component: ProjectInvitations
    }, {
        path: 'inbox',
        name: 'projects.inbox',
        component: ProjectInbox
    }, {
        path: ':projectId',
        component: ProjectsShow,
        children: [{
            path: '',
            name: 'projects.tearsheet',
            component: ProjectSummary
        }, {
            path: 'development-budget',
            name: 'projects.devbudget',
            component: ProjectDevBudget
        }, {
            path: 'income',
            name: 'projects.income',
            component: ProjectIncome
        }, {
            path: 'gaap',
            name: 'projects.gaap',
            component: ProjectGaap
        }, {
            path: 'cash_flow',
            name: 'projects.cash_flow',
            component: ProjectCashFlow
        }, {
            path: 'opex',
            name: 'projects.opex',
            component: ProjectOpex
        }, {
            path: 'capex',
            name: 'projects.capex',
            component: ProjectCapex
        }, {
            path: 'equity',
            name: 'projects.equity',
            component: ProjectEquity
        }, {
            path: 'debt',
            name: 'projects.debt',
            component: ProjectDebt
        }, {
            path: 'closing-costs',
            name: 'projects.closing_costs',
            component: ProjectClosingCosts
        }, {
            path: 'user-management',
            name: 'projects.userManagement',
            component: ProjectUserManagement
        }, {
            path: 'activity',
            name: 'projects.activity',
            component: ProjectActivity
        }]
    }, {
        path: ':projectId/edit',
        name: 'projects.edit',
        component: ProjectEdit
    }, {
        path: 'template/:templateId',
        name: 'projects.template',
        component: ProjectFromTemplate
    }]
});

/***/ }),

/***/ "/X8q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0IxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Route Dependencies
 */
var DashboardIndex = function DashboardIndex(r) {
  return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(9)]).then((function () {
    return r(__webpack_require__("B2c9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Dashboard Routes
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  path: '',
  name: 'dashboard',
  component: DashboardIndex
});

/***/ }),

/***/ "0u5z":
/***/ (function(module, exports) {



/***/ }),

/***/ "6txZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7A7I":
/***/ (function(module, exports) {



/***/ }),

/***/ "8xdo":
/***/ (function(module, exports) {



/***/ }),

/***/ "9Lh1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AfxY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B9gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateUserAdminStatus; });
/* unused harmony export removeUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpService__ = __webpack_require__("VOtV");
/**
 * Service Dependencies
 */



/**
 * Retrieve company users
 *
 * @param  {Number} company
 * @return {Promise}
 */
var getUsers = function getUsers(company) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('auth/companies/' + company + '/users/?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(params));
};

/**
 * Update a user's privilege for a company
 *
 * @type {Promise}
 */
var updateUserAdminStatus = function updateUserAdminStatus(company, user, privilege) {
  return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].patch('auth/companies/' + company + '/users/' + user + '/', privilege);
};

/**
 * Delete a user from a company
 *
 * @param  {Number} company
 * @param  {Number} user
 * @return {Promise}
 */
var removeUser = function removeUser(company, user) {
  return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].del('auth/companies/' + company + '/users/' + user + '/');
};

/***/ }),

/***/ "CIML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/cleave.js/dist/cleave.js
var cleave = __webpack_require__("sJdk");
var cleave_default = /*#__PURE__*/__webpack_require__.n(cleave);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/misc/Cleave.vue
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */


/**
 * Cleave Form Input Component
 */
/* harmony default export */ var Cleave = ({
    props: {
        value: {
            default: ''
        },
        options: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function data() {
        return {
            number: null
        };
    },

    watch: {
        value: function value(val) {
            var _this = this;

            if (this.number !== val) {
                this.number = val;
                this.$nextTick(function () {
                    _this.cleave.setRawValue(val);
                });
            }
        },
        disabled: function disabled() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.cleave.setRawValue(_this2.number);
            });
        }
    },
    methods: {
        updateValue: function updateValue(value) {
            this.$emit('input', parseFloat(this.cleave.getRawValue(), 2));
        },
        tabbed: function tabbed() {
            this.$emit('tabbed');
        }
    },
    created: function created() {
        this.number = this.value;
    },
    mounted: function mounted() {
        this.cleave = new cleave_default.a(this.$el, this.options);
    },
    beforeDestroy: function beforeDestroy() {
        this.cleave.destroy();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8281d254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/misc/Cleave.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.number},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.tabbed($event)},"input":function($event){_vm.updateValue($event.target.value)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var misc_Cleave = (esExports);
// CONCATENATED MODULE: ./src/components/general/forms/misc/Cleave.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Cleave,
  misc_Cleave,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var forms_misc_Cleave = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EsF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Route Dependencies
 */
var ProjectGaap = function ProjectGaap(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("tFo+"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectDebt = function ProjectDebt(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("GHwm"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectOpex = function ProjectOpex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("7G+J"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectCapex = function ProjectCapex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("Uo+D"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectIncome = function ProjectIncome(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("vzL/"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectEquity = function ProjectEquity(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("eSxW"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectWarRoom = function ProjectWarRoom(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("aOVB"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectSummary = function ProjectSummary(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("xCsd"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectCashFlow = function ProjectCashFlow(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("B4Gi"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectDevBudget = function ProjectDevBudget(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("zDnC"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProjectClosingCosts = function ProjectClosingCosts(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("SuIW"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * View Project Routes
 */
/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '',
    name: 'projects.view.tearsheet',
    component: ProjectSummary
}, {
    path: 'development-budget',
    name: 'projects.view.devbudget',
    component: ProjectDevBudget
}, {
    path: 'income',
    name: 'projects.view.income',
    component: ProjectIncome
}, {
    path: 'gaap',
    name: 'projects.view.gaap',
    component: ProjectGaap
}, {
    path: 'cash_flow',
    name: 'projects.view.cash_flow',
    component: ProjectCashFlow
}, {
    path: 'opex',
    name: 'projects.view.opex',
    component: ProjectOpex
}, {
    path: 'capex',
    name: 'projects.view.capex',
    component: ProjectCapex
}, {
    path: 'equity',
    name: 'projects.view.equity',
    component: ProjectEquity
}, {
    path: 'debt',
    name: 'projects.view.debt',
    component: ProjectDebt
}, {
    path: 'closing-costs',
    name: 'projects.view.closing_costs',
    component: ProjectClosingCosts
}, {
    path: 'war-room',
    name: 'projects.view.war_room',
    component: ProjectWarRoom
}]);

/***/ }),

/***/ "EyoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getWarRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDownloadKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteMultipleFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__("VOtV");
/**
 * Dependencies
 */


/**
 * Query the API for a war room based on ID
 *
 * @param  {Number} id
 * @return {Promise}
 */
var getWarRoom = function getWarRoom(id) {
  return __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* default */].get('war_rooms/' + id + '/');
};

/**
 * Get the key/url for a downloadable file
 *
 * @param  {Number} warRoomId
 * @param  {Number} fileId
 * @return {Promise}
 */
var getDownloadKey = function getDownloadKey(warRoomId, fileId) {
  return __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* default */].post('war_rooms/' + warRoomId + '/files/' + fileId + '/download/');
};

/**
 * Delete an individual file in a war room
 *
 * @param  {Number} warRoomId
 * @param  {Number} fileId
 * @return {Promise}
 */
var deleteFile = function deleteFile(warRoomId, fileId) {
  return __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* default */].del('war_rooms/' + warRoomId + '/files/' + fileId + '/');
};

/**
 * Delete multiple files
 *
 * @param  {String} fileIds
 * @return {Promise}
 */
var deleteMultipleFiles = function deleteMultipleFiles(warRoomId, fileIds) {
  return __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* default */].del('war_rooms/' + warRoomId + '/files/?file_ids=' + fileIds);
};

/**
 * Get a file by ID
 *
 * @param  {Number} warRoomId
 * @param  {Number} fileId
 * @return {Promise}
 */
var getFile = function getFile(warRoomId, fileId) {
  return __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* default */].get('war_rooms/' + warRoomId + '/files/' + fileId + '/');
};

/***/ }),

/***/ "FYRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Route Dependencies
 */
var Portfolios = function Portfolios(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("3QVH"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioEdit = function PortfolioEdit(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("VaJU"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfoliosShow = function PortfoliosShow(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("PyTB"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioCreate = function PortfolioCreate(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("scO9"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfoliosIndex = function PortfoliosIndex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("iD/Q"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioOpex = function PortfolioOpex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("rSmu"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioGaap = function PortfolioGaap(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("Vsfx"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioDebt = function PortfolioDebt(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("u7jY"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioCapex = function PortfolioCapex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("N0MT"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioIncome = function PortfolioIncome(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("JknI"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioEquity = function PortfolioEquity(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("RVUp"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioSummary = function PortfolioSummary(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("m9Ej"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioCashFlow = function PortfolioCashFlow(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("YWXE"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioDevBudget = function PortfolioDevBudget(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("wg3w"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PortfolioClosingCosts = function PortfolioClosingCosts(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function () {
        return r(__webpack_require__("fYO3"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Portfolio Routes
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    path: 'portfolios',
    component: Portfolios,
    children: [{
        path: '',
        name: 'portfolios',
        component: PortfoliosIndex
    }, {
        path: ':portfolioId/edit',
        name: 'portfolios.edit',
        component: PortfolioEdit
    }, {
        path: 'create',
        name: 'portfolios.create',
        component: PortfolioCreate
    }, {
        path: ':portfolioId',
        component: PortfoliosShow,
        children: [{
            path: '',
            name: 'portfolios.summary',
            component: PortfolioSummary
        }, {
            path: 'development-budget',
            name: 'portfolios.devbudget',
            component: PortfolioDevBudget
        }, {
            path: 'cash-flow',
            name: 'portfolios.cash_flow',
            component: PortfolioCashFlow
        }, {
            path: 'income',
            name: 'portfolios.income',
            component: PortfolioIncome
        }, {
            path: 'gaap',
            name: 'portfolios.gaap',
            component: PortfolioGaap
        }, {
            path: 'opex',
            name: 'portfolios.opex',
            component: PortfolioOpex
        }, {
            path: 'capex',
            name: 'portfolios.capex',
            component: PortfolioCapex
        }, {
            path: 'equity',
            name: 'portfolios.equity',
            component: PortfolioEquity
        }, {
            path: 'debt',
            name: 'portfolios.debt',
            component: PortfolioDebt
        }, {
            path: 'closing-costs',
            name: 'portfolios.closing_costs',
            component: PortfolioClosingCosts
        }]
    }]
});

/***/ }),

/***/ "JC6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/general/forms/misc/Cleave.vue + 2 modules
var Cleave = __webpack_require__("CIML");

// EXTERNAL MODULE: ./src/components/general/forms/BaseField.vue + 1 modules
var BaseField = __webpack_require__("j/QW");

// EXTERNAL MODULE: ./src/components/general/HelpText.vue + 2 modules
var HelpText = __webpack_require__("kC2x");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/PercentageField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */




/**
 * Percentage Field Component
 */
/* harmony default export */ var PercentageField = ({
    name: 'percentage_field',
    extends: BaseField["a" /* default */],
    components: {
        Cleave: Cleave["a" /* default */],
        HelpText: HelpText["a" /* default */]
    },
    props: {
        value: {
            type: Number,
            required: false
        }
    },
    data: function data() {
        return {
            cleaveOptions: {
                numeral: true,
                /**
                 * Numeral scale determined to be 20, may need review
                 *
                 * @type {Number}
                 */
                numeralDecimalScale: 20,
                rawValueTrimPrefix: true
            }
        };
    },

    methods: {
        updateValue: function updateValue(value) {
            var val = Number(value);
            this.$emit('updated', !isNaN(val) ? val : null);
        },
        tabbed: function tabbed() {
            this.$emit('tabbed');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-490e1c63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/PercentageField.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--percentage",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"formatted-input formatted-input--monetary"},[(_vm.disabled)?_c('span',{staticClass:"formatted-input__disabled"}):_vm._e(),_vm._v(" "),_c('cleave',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"options":_vm.cleaveOptions},on:{"tabbed":_vm.tabbed,"input":_vm.updateValue}}),_vm._v(" "),_c('span',{staticClass:"formatted-input--monetary__prefix"},[_vm._v("\n                    %\n                ")])],1)])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var forms_PercentageField = (esExports);
// CONCATENATED MODULE: ./src/components/general/forms/PercentageField.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  PercentageField,
  forms_PercentageField,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var general_forms_PercentageField = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mk6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Route Dependencies
 */
var DealPipeline = function DealPipeline(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(6)]).then((function () {
        return r(__webpack_require__("K25M"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DealPipelineStage = function DealPipelineStage(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(6)]).then((function () {
        return r(__webpack_require__("VZjc"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DealPipelineIndex = function DealPipelineIndex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(6)]).then((function () {
        return r(__webpack_require__("6S1U"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Account Routes
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    path: 'deal-pipeline',
    component: DealPipeline,
    children: [{
        path: '',
        name: 'deal_pipeline',
        component: DealPipelineIndex
    }, {
        path: ':stage',
        name: 'deal_pipeline.stage',
        component: DealPipelineStage
    }]
});

/***/ }),

/***/ "N5e3":
/***/ (function(module, exports) {



/***/ }),

/***/ "NCuM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/define-properties.js
var define_properties = __webpack_require__("HSQo");
var define_properties_default = /*#__PURE__*/__webpack_require__.n(define_properties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/services/HttpService.js
var HttpService = __webpack_require__("VOtV");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//

/**
 * Component Dependencies
 */



/**
 * Base Application Component
 */
/* harmony default export */ var App = ({
    name: 'app',
    methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['resetApplicationState'])),
    watch: {
        isLoggedIn: function isLoggedIn(loggedIn) {
            if (loggedIn === false) {
                Object(HttpService["c" /* removeAuthorizationHeader */])();
                this.resetApplicationState().then(this.$router.push({
                    name: 'login'
                }));
            }
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('user', ['isLoggedIn']), {
        pageClasses: function pageClasses() {
            return 'page--' + this.$route.name;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c34d17b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.pageClasses,attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// CONCATENATED MODULE: ./src/events/index.js
/**
 * Event Dependencies
 */


/**
 * Event Bus Definition
 *
 * @param {Vue}
 */
var bus = new vue_esm["a" /* default */]();

/* harmony default export */ var events = (bus);
// EXTERNAL MODULE: ./src/state/store.js + 266 modules
var store = __webpack_require__("ZiWJ");

// EXTERNAL MODULE: ./src/filters/index.js
var filters = __webpack_require__("Q0Ca");

// EXTERNAL MODULE: ./node_modules/sortablejs/Sortable.js
var Sortable = __webpack_require__("Lokx");
var Sortable_default = /*#__PURE__*/__webpack_require__.n(Sortable);

// CONCATENATED MODULE: ./src/directives/sortable.js
/**
 * Directive Dependencies
 */


/**
 * Sortable Directive
 */
/* harmony default export */ var directives_sortable = ({
  inserted: function inserted(el, binding) {
    /* eslint-disable no-new */
    /* eslint-disable no-unused-vars */
    var sortable = new Sortable_default.a(el, binding.value || {});
  }
});
// EXTERNAL MODULE: ./node_modules/clipboard/lib/clipboard.js
var lib_clipboard = __webpack_require__("V33R");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(lib_clipboard);

// CONCATENATED MODULE: ./src/directives/clipboard.js
/**
 * Directive Dependencies
 */


/**
 * Clipboard Copy Directive
 *
 * @type {Object}
 */
/* harmony default export */ var directives_clipboard = ({
    inserted: function inserted(el, binding, vnode) {
        /* eslint-disable no-new */
        var clipboard = new clipboard_default.a(el);
        /* eslint-disable no-new */

        clipboard.on('success', function (e) {
            vnode.context.$bus.$emit('copied', e);
        });

        clipboard.on('error', function (e) {
            vnode.context.$bus.$emit('copyFailed', e);
        });
    }
});
// CONCATENATED MODULE: ./src/directives/index.js
/**
 * Global Directive Dependencies
 */



/**
 * Global Directives Object
 *
 * @type {Object}
 */
var directives = {
  sortable: directives_sortable,
  clipboard: directives_clipboard
};

/* harmony default export */ var src_directives = (directives);
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/Btn.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
* Component
*/
/* harmony default export */ var Btn = ({
    name: 'btn',
    props: {
        block: {
            type: Boolean,
            required: false,
            default: false
        },
        btnType: {
            type: String,
            required: false,
            default: null
        },
        canSubmit: {
            type: Boolean,
            required: false,
            default: false
        },
        icon: {
            type: String,
            required: false,
            default: null
        },
        text: {
            type: String,
            required: false,
            default: null
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        loadingText: {
            type: String,
            required: false,
            default: null
        }
    },
    methods: {
        onClick: function onClick() {
            this.$emit('on-click');
        }
    },
    computed: {
        iconOnly: function iconOnly() {
            return this.hasIcon && !this.text;
        },
        hasIcon: function hasIcon() {
            return !!this.icon;
        },
        buttonType: function buttonType() {
            return this.canSubmit ? 'submit' : 'button';
        },
        buttonClasses: function buttonClasses() {
            return {
                'full-width': this.block,
                'button--with-icon': this.hasIcon && !this.iconOnly,
                'button--success': this.btnType === 'success',
                'button--tertiary': this.btnType === 'tertiary',
                'button--secondary': this.btnType === 'secondary',
                'button--primary': this.btnType === 'primary',
                'button--danger': this.btnType === 'danger'
            };
        },
        iconClass: function iconClass() {
            return this.loading ? 'fa-spin fa-cog' : this.icon;
        },
        isDisabled: function isDisabled() {
            return this.loading || this.disabled;
        },
        buttonText: function buttonText() {
            return this.loading ? this.loadingText ? this.loadingText : this.text : this.text;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99f3c4ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Btn.vue
var Btn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.buttonClasses,attrs:{"type":_vm.buttonType,"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[(_vm.iconOnly)?[_c('i',{staticClass:"no-margin fa",class:_vm.iconClass})]:[_vm._v("\n        "+_vm._s(_vm.buttonText)+"\n        "),(_vm.hasIcon)?_c('span',{staticClass:"button--with-icon__icon-container"},[_c('i',{staticClass:"no-margin fa",class:_vm.iconClass})]):_vm._e()]],2)}
var Btn_staticRenderFns = []
var Btn_esExports = { render: Btn_render, staticRenderFns: Btn_staticRenderFns }
/* harmony default export */ var general_Btn = (Btn_esExports);
// CONCATENATED MODULE: ./src/components/general/Btn.vue
var Btn_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Btn___vue_template_functional__ = false
/* styles */
var Btn___vue_styles__ = null
/* scopeId */
var Btn___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Btn___vue_module_identifier__ = null
var Btn_Component = Btn_normalizeComponent(
  Btn,
  general_Btn,
  Btn___vue_template_functional__,
  Btn___vue_styles__,
  Btn___vue_scopeId__,
  Btn___vue_module_identifier__
)

/* harmony default export */ var components_general_Btn = (Btn_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/Row.vue
//
//
//
//
//
//
//
//
//

/**
* Component
*/
/* harmony default export */ var Row = ({
    name: 'row',
    props: {
        collapse: {
            type: Boolean,
            required: false,
            default: false
        },
        align: {
            type: String,
            required: false,
            default: null
        },
        fullHeight: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        rowClasses: function rowClasses() {
            return {
                'full-height': this.fullHeight,
                'collapse no-pad': this.collapse,
                'align-left': this.align === 'left',
                'align-right': this.align === 'right',
                'align-stretch': this.align === 'stretch'
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c367da4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Row.vue
var Row_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",class:_vm.rowClasses},[_vm._t("default")],2)}
var Row_staticRenderFns = []
var Row_esExports = { render: Row_render, staticRenderFns: Row_staticRenderFns }
/* harmony default export */ var general_Row = (Row_esExports);
// CONCATENATED MODULE: ./src/components/general/Row.vue
var Row_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Row___vue_template_functional__ = false
/* styles */
var Row___vue_styles__ = null
/* scopeId */
var Row___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Row___vue_module_identifier__ = null
var Row_Component = Row_normalizeComponent(
  Row,
  general_Row,
  Row___vue_template_functional__,
  Row___vue_styles__,
  Row___vue_scopeId__,
  Row___vue_module_identifier__
)

/* harmony default export */ var components_general_Row = (Row_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/Tabs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Tabs Component
 */
/* harmony default export */ var Tabs = ({
    name: 'tabs',
    data: function data() {
        return {
            tabPanes: [],
            activeTab: 0
        };
    },

    methods: {
        changeTab: function changeTab(activeTab) {
            this.activeTab = activeTab;
        }
    },
    watch: {
        tabPanes: function tabPanes() {
            this.tabPanes[this.activeTab].active = true;
        },
        activeTab: function activeTab(_activeTab) {
            this.tabPanes.forEach(function (pane, idx) {
                pane.active = idx === _activeTab;
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$bus.$on('change-tab', function (tab) {
            _this.activeTab = tab;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32bf3ef4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Tabs.vue
var Tabs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-tabs"},[_c('ul',{staticClass:"section-tabs__list no-bullet clearfix"},_vm._l((_vm.tabPanes),function(tab,idx){return _c('li',{staticClass:"section-tabs__list-item",class:{'active': idx === _vm.activeTab},on:{"click":function($event){_vm.changeTab(idx)}}},[_vm._v("\n            "+_vm._s(tab.label)+" "),(tab.labelValue)?_c('span',[_vm._v(_vm._s(tab.labelValue))]):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"section-tabs__content"},[_vm._t("default")],2)])}
var Tabs_staticRenderFns = []
var Tabs_esExports = { render: Tabs_render, staticRenderFns: Tabs_staticRenderFns }
/* harmony default export */ var general_Tabs = (Tabs_esExports);
// CONCATENATED MODULE: ./src/components/general/Tabs.vue
var Tabs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tabs___vue_template_functional__ = false
/* styles */
var Tabs___vue_styles__ = null
/* scopeId */
var Tabs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Tabs___vue_module_identifier__ = null
var Tabs_Component = Tabs_normalizeComponent(
  Tabs,
  general_Tabs,
  Tabs___vue_template_functional__,
  Tabs___vue_styles__,
  Tabs___vue_scopeId__,
  Tabs___vue_module_identifier__
)

/* harmony default export */ var components_general_Tabs = (Tabs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/LoadingSpinner.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LoadingSpinner = ({
    name: 'loading_spinner',
    props: {
        transition: {
            type: String,
            required: false,
            default: 'fade'
        },
        transparent: {
            type: Boolean,
            required: false,
            default: false
        },
        message: {
            type: String,
            required: false
        },
        minHeight: {
            type: Number,
            required: false
        }
    },
    computed: {
        loadingClasses: function loadingClasses() {
            return {
                'transparent': this.transparent
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb06c13","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/LoadingSpinner.vue
var LoadingSpinner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:_vm.loadingClasses,style:({'min-height': _vm.minHeight ? (_vm.minHeight + "px") : null})},[_c('div',{staticClass:"loader__content"},[_c('div',{staticClass:"loader__spinner"}),_vm._v(" "),(_vm.message)?_c('p',{staticClass:"loader__message",domProps:{"textContent":_vm._s(_vm.message)}}):_vm._e()])])}
var LoadingSpinner_staticRenderFns = []
var LoadingSpinner_esExports = { render: LoadingSpinner_render, staticRenderFns: LoadingSpinner_staticRenderFns }
/* harmony default export */ var general_LoadingSpinner = (LoadingSpinner_esExports);
// CONCATENATED MODULE: ./src/components/general/LoadingSpinner.vue
function injectStyle (ssrContext) {
  __webpack_require__("RDYn")
}
var LoadingSpinner_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LoadingSpinner___vue_template_functional__ = false
/* styles */
var LoadingSpinner___vue_styles__ = injectStyle
/* scopeId */
var LoadingSpinner___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LoadingSpinner___vue_module_identifier__ = null
var LoadingSpinner_Component = LoadingSpinner_normalizeComponent(
  LoadingSpinner,
  general_LoadingSpinner,
  LoadingSpinner___vue_template_functional__,
  LoadingSpinner___vue_styles__,
  LoadingSpinner___vue_scopeId__,
  LoadingSpinner___vue_module_identifier__
)

/* harmony default export */ var components_general_LoadingSpinner = (LoadingSpinner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/Card.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * Card Component
 */
/* harmony default export */ var Card = ({
    name: 'card',
    components: {
        LoadingSpinner: components_general_LoadingSpinner
    },
    props: {
        heading: {
            type: String,
            required: false
        },
        loading: {
            type: Boolean,
            required: false
        },
        flat: {
            type: Boolean,
            required: false,
            default: false
        },
        loadingMessage: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        cardContentClasses: function cardContentClasses() {
            return {
                'no-pad': this.flat
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e97e5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Card.vue
var Card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.heading)?_c('header',{staticClass:"card__header clearfix"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns shrink no-pad"},[(_vm.heading)?_c('h3',{staticClass:"card__heading no-margin"},[_vm._v(_vm._s(_vm.heading))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns align-right no-pad"},[_vm._t("card-actions")],2)])]):_vm._e(),_vm._v(" "),_vm._t("custom-heading"),_vm._v(" "),_c('div',{staticClass:"card__content",class:_vm.cardContentClasses},[(_vm.loading)?_c('loading-spinner',{attrs:{"message":_vm.loadingMessage,"transition":"fade","transition-mode":"out-in"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_vm._t("card-footer")],2)}
var Card_staticRenderFns = []
var Card_esExports = { render: Card_render, staticRenderFns: Card_staticRenderFns }
/* harmony default export */ var general_Card = (Card_esExports);
// CONCATENATED MODULE: ./src/components/general/Card.vue
function Card_injectStyle (ssrContext) {
  __webpack_require__("g523")
}
var Card_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Card___vue_template_functional__ = false
/* styles */
var Card___vue_styles__ = Card_injectStyle
/* scopeId */
var Card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Card___vue_module_identifier__ = null
var Card_Component = Card_normalizeComponent(
  Card,
  general_Card,
  Card___vue_template_functional__,
  Card___vue_styles__,
  Card___vue_scopeId__,
  Card___vue_module_identifier__
)

/* harmony default export */ var components_general_Card = (Card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/Column.vue
//
//
//
//
//
//
//
//
//

/**
* Component
*/
/* harmony default export */ var Column = ({
    name: 'column',
    props: {
        shrink: {
            type: Boolean,
            required: false,
            default: false
        },
        small: {
            type: Number,
            required: false,
            default: null
        },
        medium: {
            type: Number,
            required: false,
            default: null
        },
        large: {
            type: Number,
            required: false,
            default: null
        },
        fluid: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function data() {
        return {
            sizes: ['small', 'medium', 'large']
        };
    },

    methods: {
        getSize: function getSize(width) {
            return width > 1 && width <= 12 ? width : 12;
        }
    },
    computed: {
        smallSize: function smallSize() {
            return 'small-' + this.getSize(this.small);
        },
        mediumSize: function mediumSize() {
            return 'medium-' + this.getSize(this.medium);
        },
        largeSize: function largeSize() {
            return 'large-' + this.getSize(this.large);
        },
        columnClasses: function columnClasses() {
            var _this = this;

            switch (true) {
                case this.fluid:
                    return null;
                case this.shrink:
                    return 'shrink';
                default:
                    var arr = [];
                    this.sizes.forEach(function (s) {
                        var i = s + 'Size';
                        if (_this[s]) arr.push(_this[i]);
                    });

                    return arr;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c77f6fca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Column.vue
var Column_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns",class:_vm.columnClasses},[_vm._t("default")],2)}
var Column_staticRenderFns = []
var Column_esExports = { render: Column_render, staticRenderFns: Column_staticRenderFns }
/* harmony default export */ var general_Column = (Column_esExports);
// CONCATENATED MODULE: ./src/components/general/Column.vue
var Column_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Column___vue_template_functional__ = false
/* styles */
var Column___vue_styles__ = null
/* scopeId */
var Column___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Column___vue_module_identifier__ = null
var Column_Component = Column_normalizeComponent(
  Column,
  general_Column,
  Column___vue_template_functional__,
  Column___vue_styles__,
  Column___vue_scopeId__,
  Column___vue_module_identifier__
)

/* harmony default export */ var components_general_Column = (Column_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/Notice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Notice = ({
    props: {
        show: {
            type: Boolean,
            required: false,
            default: true
        },
        clickable: {
            type: Boolean,
            required: false,
            default: false
        },
        message: {
            type: String,
            required: false
        },
        type: {
            type: String,
            required: false,
            default: 'default'
        },
        dismissable: {
            type: Boolean,
            required: false,
            default: false
        },
        withMargin: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        messageType: function messageType() {
            switch (this.type) {
                case 'danger':
                    return 'notice--danger';
                case 'success':
                    return 'notice--success';
                case 'warning':
                    return 'notice--warning';
                default:
                    return 'notice--normal';
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f0fbfeb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Notice.vue
var Notice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice",class:[_vm.messageType, {'with-margin': _vm.withMargin, 'clickable': this.clickable}]},[(_vm.message)?_c('span',{staticClass:"notice__message"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),_vm._t("message-list"),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.dismissable)?_c('button',{staticClass:"notice__button",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('on-close')}}},[_c('i',{staticClass:"fa fa-close"})]):_vm._e()],2)}
var Notice_staticRenderFns = []
var Notice_esExports = { render: Notice_render, staticRenderFns: Notice_staticRenderFns }
/* harmony default export */ var general_Notice = (Notice_esExports);
// CONCATENATED MODULE: ./src/components/general/Notice.vue
function Notice_injectStyle (ssrContext) {
  __webpack_require__("NCuM")
}
var Notice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Notice___vue_template_functional__ = false
/* styles */
var Notice___vue_styles__ = Notice_injectStyle
/* scopeId */
var Notice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Notice___vue_module_identifier__ = null
var Notice_Component = Notice_normalizeComponent(
  Notice,
  general_Notice,
  Notice___vue_template_functional__,
  Notice___vue_styles__,
  Notice___vue_scopeId__,
  Notice___vue_module_identifier__
)

/* harmony default export */ var components_general_Notice = (Notice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/TabPane.vue
//
//
//
//
//
//
//
//
//
//
//

/**
 * Tab Pane Component
 */
/* harmony default export */ var TabPane = ({
    name: 'tab_pane',
    props: {
        label: {
            type: String,
            required: true
        },
        labelValue: {
            required: false
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function data() {
        return {
            active: false
        };
    },
    created: function created() {
        this.$parent.tabPanes.push(this);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd03f3fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/TabPane.vue
var TabPane_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab__pane"},[(_vm.active)?_c('div',{staticClass:"tab__pane-content",class:{ 'collapsed': _vm.collapsed }},[_vm._t("default")],2):_vm._e()])}
var TabPane_staticRenderFns = []
var TabPane_esExports = { render: TabPane_render, staticRenderFns: TabPane_staticRenderFns }
/* harmony default export */ var general_TabPane = (TabPane_esExports);
// CONCATENATED MODULE: ./src/components/general/TabPane.vue
var TabPane_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TabPane___vue_template_functional__ = false
/* styles */
var TabPane___vue_styles__ = null
/* scopeId */
var TabPane___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TabPane___vue_module_identifier__ = null
var TabPane_Component = TabPane_normalizeComponent(
  TabPane,
  general_TabPane,
  TabPane___vue_template_functional__,
  TabPane___vue_styles__,
  TabPane___vue_scopeId__,
  TabPane___vue_module_identifier__
)

/* harmony default export */ var components_general_TabPane = (TabPane_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/BtnGroup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
* Component
*/
/* harmony default export */ var BtnGroup = ({
    name: 'btn-group',
    props: {
        collapse: {
            type: Boolean,
            required: false,
            default: false
        },
        align: {
            type: String,
            required: false,
            default: 'left'
        },
        dark: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        buttonGroupClasses: function buttonGroupClasses() {
            return {
                'dark': this.dark,
                'collapse': this.collapse
            };
        },
        buttonGroupRowClasses: function buttonGroupRowClasses() {
            return {
                'align-right': this.align === 'right',
                'align-left': this.align === 'left'
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b507b1ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/BtnGroup.vue
var BtnGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-group",class:_vm.buttonGroupClasses},[_c('div',{staticClass:"row",class:_vm.buttonGroupRowClasses},[_c('div',{staticClass:"columns"},[_vm._t("default")],2)])])}
var BtnGroup_staticRenderFns = []
var BtnGroup_esExports = { render: BtnGroup_render, staticRenderFns: BtnGroup_staticRenderFns }
/* harmony default export */ var general_BtnGroup = (BtnGroup_esExports);
// CONCATENATED MODULE: ./src/components/general/BtnGroup.vue
function BtnGroup_injectStyle (ssrContext) {
  __webpack_require__("AfxY")
}
var BtnGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BtnGroup___vue_template_functional__ = false
/* styles */
var BtnGroup___vue_styles__ = BtnGroup_injectStyle
/* scopeId */
var BtnGroup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BtnGroup___vue_module_identifier__ = null
var BtnGroup_Component = BtnGroup_normalizeComponent(
  BtnGroup,
  general_BtnGroup,
  BtnGroup___vue_template_functional__,
  BtnGroup___vue_styles__,
  BtnGroup___vue_scopeId__,
  BtnGroup___vue_module_identifier__
)

/* harmony default export */ var components_general_BtnGroup = (BtnGroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/Branding.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Branding Component
 */
/* harmony default export */ var Branding = ({
    name: 'branding',
    props: {
        type: {
            type: String,
            required: false,
            default: 'light'
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        classes: function classes() {
            return {
                'branding__logo--light': this.type === 'light',
                'branding__logo--normal': this.type !== 'light'
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c04132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Branding.vue
var Branding_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"branding"},[(_vm.collapsed)?_c('svg',{staticClass:"branding__logo",class:_vm.classes,attrs:{"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 190 168.02"}},[_c('title',[_vm._v("Lucro")]),_vm._v(" "),_c('path',{staticClass:"branding__color branding__color--1",attrs:{"d":"M149.37,6.86L169.68,42,191,78.89l3,5.12-3,5.11L169.68,126v0l-20.3,35.16L137.51,140.6l14.37-24.89h0L170.2,84,151.88,52.28,137.52,27.4,149.37,6.86h0ZM44.54,161.15L24.23,126,3,89.12,0,84l3-5.12L24.23,42v0L44.53,6.85,56.4,27.43,42,52.32h0L23.71,84,42,115.74l14.36,24.87Z"}}),_vm._v(" "),_c('path',{staticClass:"branding__color branding__color--2",attrs:{"d":"M137.52,168H97v0H56.4l11.85-20.54H97v0h28.67L137.52,168h0ZM125.65,20.58H97v0H68.28L56.38,0H97V0H137.5L125.65,20.58h0Zm11.87,37H97v0H56.4L68.26,37H97v0h28.67l11.9,20.62h0Zm0,36.78H97v0H56.4L68.26,73.79H97v0h28.67l11.9,20.62h0Zm0,36.67H97v0H56.4l11.85-20.54H97v0h28.67Z"}})]):_c('svg',{staticClass:"branding__logo",class:_vm.classes,attrs:{"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 620.26 168.02"}},[_c('title',[_vm._v("Lucro")]),_vm._v(" "),_c('path',{staticClass:"branding__color branding__color--1",attrs:{"d":"M620.26,83a41.25,41.25,0,0,1-12.69,30.1,44.38,44.38,0,0,1-14.13,9.25,43.32,43.32,0,0,1-16.52,3.22,43.86,43.86,0,0,1-16.7-3.23,43.19,43.19,0,0,1-14.06-9.23,41.13,41.13,0,0,1-9.42-13.7,42.2,42.2,0,0,1,9.42-46.61,43,43,0,0,1,14.08-9.19,45.39,45.39,0,0,1,33.28,0A43,43,0,0,1,617,66.66,41.91,41.91,0,0,1,620.26,83h0Zm-13.75,0a31,31,0,0,0-2.25-11.69,30.1,30.1,0,0,0-6.45-9.86,28.35,28.35,0,0,0-9.5-6.56,29.11,29.11,0,0,0-32.39,6.56,29.39,29.39,0,0,0-6.43,9.8A31.48,31.48,0,0,0,547.27,83a30.91,30.91,0,0,0,2.21,11.65,30.18,30.18,0,0,0,6.43,9.8,29.23,29.23,0,0,0,32.27,6.6,29.61,29.61,0,0,0,9.61-6.6,30,30,0,0,0,6.45-9.84A30.52,30.52,0,0,0,606.51,83Z"}}),_vm._v(" "),_c('path',{staticClass:"branding__color branding__color--1",attrs:{"d":"M471.59,92.33V123.5H459.24V42.36h37.18c14.06,0,26,7.19,26.35,24.05s-8.53,23.36-21.51,25.35l18.16,31.74H505.36l-17.75-31c-5.12,0-11.83-.17-16-0.17h0Zm0.83-10.25h16.05c11.63,0,20.76-3.38,20.76-14.5,0-11.91-8.43-13.89-17.35-13.89H472.42v28.4Z"}}),_vm._v(" "),_c('path',{staticClass:"branding__color branding__color--1",attrs:{"d":"M442.89,62.09a40.67,40.67,0,0,0-11.82-7.15A36.44,36.44,0,0,0,418,52.56q-13.31,0-21.64,8.53T388,83.21q0,13.14,8.12,21.68t20.49,8.53a37.34,37.34,0,0,0,13.72-2.55,43.48,43.48,0,0,0,12.49-7.7v14.91a38.63,38.63,0,0,1-11.58,5.69,46.58,46.58,0,0,1-13.58,1.89,47.68,47.68,0,0,1-17.21-3,40.58,40.58,0,0,1-23-22.7,44.63,44.63,0,0,1-3.18-16.82,44.13,44.13,0,0,1,3.18-16.76A41.56,41.56,0,0,1,400.5,43.5a45.44,45.44,0,0,1,16.89-3.08A44.58,44.58,0,0,1,431,42.5a48,48,0,0,1,12.58,6.28Z"}}),_vm._v(" "),_c('path',{staticClass:"branding__color branding__color--1",attrs:{"d":"M291.26,42.36h13V91.63c0,7.32,1.68,12.81,5.07,16.5s10.15,5.51,16.86,5.51,13.44-1.84,16.82-5.51,5.07-9.17,5.07-16.5V42.36h13.19V92.86q0,16.46-8.31,24.63c-5.54,5.45-15.61,8.17-26.76,8.17s-21.21-2.73-26.72-8.15-8.25-13.64-8.25-24.65V42.36Z"}}),_vm._v(" "),_c('polygon',{staticClass:"branding__color branding__color--1",attrs:{"points":"228.24 123.5 228.24 42.36 241.43 42.36 241.43 111.7 284.59 111.7 284.59 123.5 228.24 123.5"}}),_vm._v(" "),_c('path',{staticClass:"branding__color branding__color--1",attrs:{"d":"M149.37,6.86L169.68,42,191,78.89l3,5.12-3,5.11L169.68,126v0l-20.3,35.16L137.51,140.6l14.37-24.89h0L170.2,84,151.88,52.28,137.52,27.4,149.37,6.86h0ZM44.54,161.15L24.23,126,3,89.12,0,84l3-5.12L24.23,42v0L44.53,6.85,56.4,27.43,42,52.32h0L23.71,84,42,115.74l14.36,24.87Z"}}),_vm._v(" "),_c('path',{staticClass:"branding__color branding__color--2",attrs:{"d":"M137.52,168H97v0H56.4l11.85-20.54H97v0h28.67L137.52,168h0ZM125.65,20.58H97v0H68.28L56.38,0H97V0H137.5L125.65,20.58h0Zm11.87,37H97v0H56.4L68.26,37H97v0h28.67l11.9,20.62h0Zm0,36.78H97v0H56.4L68.26,73.79H97v0h28.67l11.9,20.62h0Zm0,36.67H97v0H56.4l11.85-20.54H97v0h28.67Z"}})])])}
var Branding_staticRenderFns = []
var Branding_esExports = { render: Branding_render, staticRenderFns: Branding_staticRenderFns }
/* harmony default export */ var general_Branding = (Branding_esExports);
// CONCATENATED MODULE: ./src/components/general/Branding.vue
function Branding_injectStyle (ssrContext) {
  __webpack_require__("9Lh1")
}
var Branding_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Branding___vue_template_functional__ = false
/* styles */
var Branding___vue_styles__ = Branding_injectStyle
/* scopeId */
var Branding___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Branding___vue_module_identifier__ = null
var Branding_Component = Branding_normalizeComponent(
  Branding,
  general_Branding,
  Branding___vue_template_functional__,
  Branding___vue_styles__,
  Branding___vue_scopeId__,
  Branding___vue_module_identifier__
)

/* harmony default export */ var components_general_Branding = (Branding_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/ProgressBar.vue
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Progress Bar Component
 */
/* harmony default export */ var ProgressBar = ({
    name: 'progress_bar',
    props: {
        success: {
            type: Boolean,
            required: true,
            default: false
        },
        error: {
            type: Boolean,
            required: true,
            default: false
        },
        progress: {
            type: Number,
            required: true,
            default: 0
        }
    },
    computed: {
        progressBarClasses: function progressBarClasses() {
            return {
                'progress-bar--success': this.success,
                'progress-bar--danger': this.error
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037b2282","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/ProgressBar.vue
var ProgressBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar",class:_vm.progressBarClasses},[_c('div',{staticClass:"progress-bar__progress",style:({ 'width': _vm.progress + '%' })},[_vm._v("\n        "+_vm._s(_vm._f("percent")(_vm.progress / 100))+"\n    ")])])}
var ProgressBar_staticRenderFns = []
var ProgressBar_esExports = { render: ProgressBar_render, staticRenderFns: ProgressBar_staticRenderFns }
/* harmony default export */ var general_ProgressBar = (ProgressBar_esExports);
// CONCATENATED MODULE: ./src/components/general/ProgressBar.vue
function ProgressBar_injectStyle (ssrContext) {
  __webpack_require__("d4Po")
}
var ProgressBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ProgressBar___vue_template_functional__ = false
/* styles */
var ProgressBar___vue_styles__ = ProgressBar_injectStyle
/* scopeId */
var ProgressBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProgressBar___vue_module_identifier__ = null
var ProgressBar_Component = ProgressBar_normalizeComponent(
  ProgressBar,
  general_ProgressBar,
  ProgressBar___vue_template_functional__,
  ProgressBar___vue_styles__,
  ProgressBar___vue_scopeId__,
  ProgressBar___vue_module_identifier__
)

/* harmony default export */ var components_general_ProgressBar = (ProgressBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/SuccessCheck.vue
//
//
//
//
//
//
//

/**
 * Success Check Component
 */
/* harmony default export */ var SuccessCheck = ({
  name: 'success_check'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699a726f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/SuccessCheck.vue
var SuccessCheck_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"success-circle",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}},[_c('circle',{staticClass:"success-circle__circle",attrs:{"cx":"26","cy":"26","r":"25","fill":"none"}}),_vm._v(" "),_c('path',{staticClass:"success-circle__check",attrs:{"fill":"none","d":"M14.1 27.2l7.1 7.2 16.7-16.8"}})])}
var SuccessCheck_staticRenderFns = []
var SuccessCheck_esExports = { render: SuccessCheck_render, staticRenderFns: SuccessCheck_staticRenderFns }
/* harmony default export */ var general_SuccessCheck = (SuccessCheck_esExports);
// CONCATENATED MODULE: ./src/components/general/SuccessCheck.vue
var SuccessCheck_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SuccessCheck___vue_template_functional__ = false
/* styles */
var SuccessCheck___vue_styles__ = null
/* scopeId */
var SuccessCheck___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SuccessCheck___vue_module_identifier__ = null
var SuccessCheck_Component = SuccessCheck_normalizeComponent(
  SuccessCheck,
  general_SuccessCheck,
  SuccessCheck___vue_template_functional__,
  SuccessCheck___vue_styles__,
  SuccessCheck___vue_scopeId__,
  SuccessCheck___vue_module_identifier__
)

/* harmony default export */ var components_general_SuccessCheck = (SuccessCheck_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/PercentageBar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PercentageBar = ({
    name: 'percentage_bar',
    props: {
        labelA: {
            type: String,
            required: false,
            default: ''
        },
        labelB: {
            type: String,
            required: false,
            default: ''
        },
        percentageA: {
            type: Number,
            required: false,
            default: 0
        },
        percentageB: {
            type: Number,
            required: false,
            default: 0
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-591a2861","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/PercentageBar.vue
var PercentageBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"percentage-bar"},[(_vm.labelA && _vm.labelB)?_c('div',{staticClass:"clearfix percentage-bar__labels"},[_c('p',{staticClass:"percentage-bar__label float-left"},[_vm._v("\n            "+_vm._s(_vm.labelA)+": "+_vm._s(_vm._f("percent")(_vm.percentageA))+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"percentage-bar__label float-right"},[_vm._v("\n            "+_vm._s(_vm.labelB)+": "+_vm._s(_vm._f("percent")(_vm.percentageB))+"\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"percentage-bar__container"},[_c('span',{staticClass:"percentage-bar__percentage percentage-bar__percentage--a",style:({ width: (_vm.percentageA ? _vm.percentageA : 0) * 100 + '%' })}),_vm._v(" "),_c('span',{staticClass:"percentage-bar__percentage percentage-bar__percentage--b",style:({ width: (_vm.percentageB ? _vm.percentageB : 0) * 100 + '%' })})])])}
var PercentageBar_staticRenderFns = []
var PercentageBar_esExports = { render: PercentageBar_render, staticRenderFns: PercentageBar_staticRenderFns }
/* harmony default export */ var general_PercentageBar = (PercentageBar_esExports);
// CONCATENATED MODULE: ./src/components/general/PercentageBar.vue
function PercentageBar_injectStyle (ssrContext) {
  __webpack_require__("wmJy")
}
var PercentageBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PercentageBar___vue_template_functional__ = false
/* styles */
var PercentageBar___vue_styles__ = PercentageBar_injectStyle
/* scopeId */
var PercentageBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PercentageBar___vue_module_identifier__ = null
var PercentageBar_Component = PercentageBar_normalizeComponent(
  PercentageBar,
  general_PercentageBar,
  PercentageBar___vue_template_functional__,
  PercentageBar___vue_styles__,
  PercentageBar___vue_scopeId__,
  PercentageBar___vue_module_identifier__
)

/* harmony default export */ var components_general_PercentageBar = (PercentageBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/SectionHeading.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
* Component
*/
/* harmony default export */ var SectionHeading = ({
    name: 'section-heading',
    props: {
        text: {
            type: String,
            required: true
        },
        subText: {
            type: String,
            required: false
        }
    },
    computed: {
        hasSlotData: function hasSlotData() {
            return keys_default()(this.$slots).length > 0;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3936fff1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/SectionHeading.vue
var SectionHeading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-heading"},[_c('row',[_c('column',{attrs:{"fluid":""}},[_c('h4',{staticClass:"section-heading__text",domProps:{"textContent":_vm._s(_vm.text)}}),_vm._v(" "),(_vm.subText)?_c('p',{staticClass:"section-heading__sub-text",domProps:{"textContent":_vm._s(_vm.subText)}}):_vm._e()]),_vm._v(" "),(_vm.hasSlotData)?_c('column',{attrs:{"shrink":""}},[_vm._t("default")],2):_vm._e()],1)],1)}
var SectionHeading_staticRenderFns = []
var SectionHeading_esExports = { render: SectionHeading_render, staticRenderFns: SectionHeading_staticRenderFns }
/* harmony default export */ var general_SectionHeading = (SectionHeading_esExports);
// CONCATENATED MODULE: ./src/components/general/SectionHeading.vue
function SectionHeading_injectStyle (ssrContext) {
  __webpack_require__("ibMf")
}
var SectionHeading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SectionHeading___vue_template_functional__ = false
/* styles */
var SectionHeading___vue_styles__ = SectionHeading_injectStyle
/* scopeId */
var SectionHeading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SectionHeading___vue_module_identifier__ = null
var SectionHeading_Component = SectionHeading_normalizeComponent(
  SectionHeading,
  general_SectionHeading,
  SectionHeading___vue_template_functional__,
  SectionHeading___vue_styles__,
  SectionHeading___vue_scopeId__,
  SectionHeading___vue_module_identifier__
)

/* harmony default export */ var components_general_SectionHeading = (SectionHeading_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// EXTERNAL MODULE: ./src/components/general/forms/BaseField.vue + 1 modules
var BaseField = __webpack_require__("j/QW");

// EXTERNAL MODULE: ./src/components/general/HelpText.vue + 2 modules
var HelpText = __webpack_require__("kC2x");

// EXTERNAL MODULE: ./src/services/ProjectService.js
var ProjectService = __webpack_require__("c5pT");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/TagsField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */





/**
 * Tags Component
 */
/* harmony default export */ var TagsField = ({
    name: 'field_tags',
    extends: BaseField["a" /* default */],
    components: {
        vSelect: vue_select_default.a,
        HelpText: HelpText["a" /* default */]
    },
    data: function data() {
        return {
            options: []
        };
    },
    methods: {
        setTags: function setTags(res) {
            this.options = res.data;
        },
        failedToGetTags: function failedToGetTags(err) {
            console.log(err);
        }
    },
    mounted: function mounted() {
        Object(ProjectService["f" /* fetchTags */])().then(this.setTags).catch(this.failedToGetTags);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19e75afa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/TagsField.vue
var TagsField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--tags",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('v-select',{attrs:{"value":_vm.value,"multiple":true,"placeholder":"Select Tags ...","push-tags":true,"taggable":true,"options":_vm.options,"on-change":function (val) { _vm.$emit('updated', val) }}})],1)])])}
var TagsField_staticRenderFns = []
var TagsField_esExports = { render: TagsField_render, staticRenderFns: TagsField_staticRenderFns }
/* harmony default export */ var forms_TagsField = (TagsField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/TagsField.vue
var TagsField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagsField___vue_template_functional__ = false
/* styles */
var TagsField___vue_styles__ = null
/* scopeId */
var TagsField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TagsField___vue_module_identifier__ = null
var TagsField_Component = TagsField_normalizeComponent(
  TagsField,
  forms_TagsField,
  TagsField___vue_template_functional__,
  TagsField___vue_styles__,
  TagsField___vue_scopeId__,
  TagsField___vue_module_identifier__
)

/* harmony default export */ var general_forms_TagsField = (TagsField_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/CheckBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */


/**
 * Component
 */
/* harmony default export */ var CheckBox = ({
    name: 'check_box',
    extends: BaseField["a" /* default */],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function data() {
        return {
            checked: false
        };
    },

    methods: {
        updateValue: function updateValue(e) {
            var newVal = e.target.checked;
            this.checked = newVal;
            this.$emit('updated', newVal);
        }
    },
    created: function created() {
        this.checked = !!this.value;
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1edd7a5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/CheckBox.vue
var CheckBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--text",class:_vm.fieldClasses},[_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns"},[(_vm.label)?_c('label',{class:_vm.labelClasses},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.updateValue}}),_vm._v(_vm._s(_vm.label)+"\n            ")]):_vm._e()])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var CheckBox_staticRenderFns = []
var CheckBox_esExports = { render: CheckBox_render, staticRenderFns: CheckBox_staticRenderFns }
/* harmony default export */ var forms_CheckBox = (CheckBox_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/CheckBox.vue
var CheckBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CheckBox___vue_template_functional__ = false
/* styles */
var CheckBox___vue_styles__ = null
/* scopeId */
var CheckBox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CheckBox___vue_module_identifier__ = null
var CheckBox_Component = CheckBox_normalizeComponent(
  CheckBox,
  forms_CheckBox,
  CheckBox___vue_template_functional__,
  CheckBox___vue_styles__,
  CheckBox___vue_scopeId__,
  CheckBox___vue_module_identifier__
)


/* harmony default export */ var general_forms_CheckBox = (CheckBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/YearField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Dependencies
 */



/**
 * Component
 */
/* harmony default export */ var YearField = ({
    name: 'year-field',
    extends: BaseField["a" /* default */],
    components: {
        HelpText: HelpText["a" /* default */]
    },
    methods: {
        updateValue: function updateValue(value) {
            var val = !value ? null : Number(value);
            this.$emit('updated', !isNaN(val) ? val : null);
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            if (_this.value === null) {
                _this.updateValue(new Date().getFullYear());
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e7b026c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/YearField.vue
var YearField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--number",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('div',[_c('input',{attrs:{"type":"number","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateValue($event.target.value)}}})])])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var YearField_staticRenderFns = []
var YearField_esExports = { render: YearField_render, staticRenderFns: YearField_staticRenderFns }
/* harmony default export */ var forms_YearField = (YearField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/YearField.vue
var YearField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var YearField___vue_template_functional__ = false
/* styles */
var YearField___vue_styles__ = null
/* scopeId */
var YearField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var YearField___vue_module_identifier__ = null
var YearField_Component = YearField_normalizeComponent(
  YearField,
  forms_YearField,
  YearField___vue_template_functional__,
  YearField___vue_styles__,
  YearField___vue_scopeId__,
  YearField___vue_module_identifier__
)

/* harmony default export */ var general_forms_YearField = (YearField_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var build = __webpack_require__("XILU");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/DateField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */





/**
 * Datepicker COmponent
 */
/* harmony default export */ var DateField = ({
    name: 'date_field',
    extends: BaseField["a" /* default */],
    components: {
        Datepicker: build_default.a,
        HelpText: HelpText["a" /* default */]
    },
    watch: {
        value: function value(newDate) {
            if (newDate === null) {
                this.date = '';
            }
        }
    },
    data: function data() {
        return {
            date: this.value ? moment_default()(this.value, 'YYYY-MM-DD').toDate() : null
        };
    },

    methods: {
        datepickerOpenedFunction: function datepickerOpenedFunction(data) {},
        updateValue: function updateValue(date) {
            this.$emit('updated', moment_default()(date).format('YYYY-MM-DD'));
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47604f31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/DateField.vue
var DateField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--date",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns"},[(_vm.label)?_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"datepicker"},[_c('datepicker',{attrs:{"value":_vm.date},on:{"selected":_vm.updateValue,"opened":_vm.datepickerOpenedFunction}}),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),(_vm.hasErrors)?_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])})):_vm._e()])}
var DateField_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datepicker__prefix"},[_c('i',{staticClass:"fa fa-calendar"})])}]
var DateField_esExports = { render: DateField_render, staticRenderFns: DateField_staticRenderFns }
/* harmony default export */ var forms_DateField = (DateField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/DateField.vue
var DateField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DateField___vue_template_functional__ = false
/* styles */
var DateField___vue_styles__ = null
/* scopeId */
var DateField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DateField___vue_module_identifier__ = null
var DateField_Component = DateField_normalizeComponent(
  DateField,
  forms_DateField,
  DateField___vue_template_functional__,
  DateField___vue_styles__,
  DateField___vue_scopeId__,
  DateField___vue_module_identifier__
)

/* harmony default export */ var general_forms_DateField = (DateField_Component.exports);

// EXTERNAL MODULE: ./src/components/general/forms/TextField.vue + 2 modules
var TextField = __webpack_require__("vDvX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/MonthField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Dependencies
 */



/**
 * Component
 */
/* harmony default export */ var MonthField = ({
    name: 'month-field',
    extends: BaseField["a" /* default */],
    components: {
        HelpText: HelpText["a" /* default */]
    },
    props: {
        initialText: {
            type: String,
            required: false,
            default: '-- Select --'
        }
    },
    data: function data() {
        return {
            options: [{ key: 1, label: 'January' }, { key: 2, label: 'February' }, { key: 3, label: 'March' }, { key: 4, label: 'April' }, { key: 5, label: 'May' }, { key: 6, label: 'June' }, { key: 7, label: 'July' }, { key: 8, label: 'August' }, { key: 9, label: 'September' }, { key: 10, label: 'October' }, { key: 11, label: 'November' }, { key: 12, label: 'December' }]
        };
    },

    methods: {
        updateValue: function updateValue(e) {
            var parsedValue = isNaN(parseInt(e.target.value)) ? e.target.value : parseInt(e.target.value);
            this.$emit('updated', parsedValue);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b108988","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/MonthField.vue
var MonthField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--select",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('select',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.updateValue}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.value === ''}},[_vm._v("\n                    "+_vm._s(_vm.initialText)+"\n                ")]),_vm._v(" "),_vm._l((_vm.options),function(option,idx){return _c('option',{domProps:{"value":option.key,"selected":option.key === _vm.value}},[_vm._v("\n                    "+_vm._s(option.label)+"\n                ")])})],2)])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var MonthField_staticRenderFns = []
var MonthField_esExports = { render: MonthField_render, staticRenderFns: MonthField_staticRenderFns }
/* harmony default export */ var forms_MonthField = (MonthField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/MonthField.vue
var MonthField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MonthField___vue_template_functional__ = false
/* styles */
var MonthField___vue_styles__ = null
/* scopeId */
var MonthField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MonthField___vue_module_identifier__ = null
var MonthField_Component = MonthField_normalizeComponent(
  MonthField,
  forms_MonthField,
  MonthField___vue_template_functional__,
  MonthField___vue_styles__,
  MonthField___vue_scopeId__,
  MonthField___vue_module_identifier__
)

/* harmony default export */ var general_forms_MonthField = (MonthField_Component.exports);

// EXTERNAL MODULE: ./src/components/general/forms/NumberField.vue + 2 modules
var NumberField = __webpack_require__("t29X");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/SelectField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */



/**
 * Select Field Component
 */
/* harmony default export */ var SelectField = ({
    name: 'select-field',
    extends: BaseField["a" /* default */],
    components: {
        HelpText: HelpText["a" /* default */]
    },
    props: {
        options: {
            type: Array,
            required: false,
            default: function _default() {
                return [];
            }
        },
        initialText: {
            type: String,
            required: false,
            default: '-- Select --'
        },
        allowEmpty: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    methods: {
        updateValue: function updateValue(e) {
            var parsedValue = isNaN(parseInt(e.target.value)) ? e.target.value : parseInt(e.target.value);
            this.$emit('updated', parsedValue);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3d0d3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/SelectField.vue
var SelectField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--select",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('select',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.updateValue}},[(_vm.allowEmpty)?_c('option',{attrs:{"value":""},domProps:{"selected":_vm.value === ''}},[_vm._v("\n                    "+_vm._s(_vm.initialText)+"\n                ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(option,idx){return _c('option',{domProps:{"value":option.key,"selected":option.key === _vm.value}},[_vm._v("\n                    "+_vm._s(option.label)+"\n                ")])})],2)])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var SelectField_staticRenderFns = []
var SelectField_esExports = { render: SelectField_render, staticRenderFns: SelectField_staticRenderFns }
/* harmony default export */ var forms_SelectField = (SelectField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/SelectField.vue
var SelectField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SelectField___vue_template_functional__ = false
/* styles */
var SelectField___vue_styles__ = null
/* scopeId */
var SelectField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SelectField___vue_module_identifier__ = null
var SelectField_Component = SelectField_normalizeComponent(
  SelectField,
  forms_SelectField,
  SelectField___vue_template_functional__,
  SelectField___vue_styles__,
  SelectField___vue_scopeId__,
  SelectField___vue_module_identifier__
)

/* harmony default export */ var general_forms_SelectField = (SelectField_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/services/UtilityService.js
var UtilityService = __webpack_require__("QqZI");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/AddressField.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Dependencies
 */


/**
 * Component
 */
/* harmony default export */ var AddressField = ({
    name: 'address-field',
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            states: UtilityService["c" /* stateOptions */],
            model: {}
        };
    },

    watch: {
        model: {
            deep: true,
            handler: function handler(updatedAddress) {
                this.$emit('updated', updatedAddress);
            }
        }
    },
    created: function created() {
        this.model = JSON.parse(stringify_default()(this.value));
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44d622e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/AddressField.vue
var AddressField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field form-field--address"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"form__group"},[_c('label',[_vm._v("Address 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address_street_1),expression:"model.address_street_1"}],attrs:{"type":"text","placeholder":"Address 1"},domProps:{"value":(_vm.model.address_street_1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address_street_1", $event.target.value)}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"form__group"},[_c('label',[_vm._v("Address 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address_street_2),expression:"model.address_street_2"}],attrs:{"type":"text","placeholder":"Address 2"},domProps:{"value":(_vm.model.address_street_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address_street_2", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"form__group"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address_city),expression:"model.address_city"}],attrs:{"type":"text","placeholder":"City"},domProps:{"value":(_vm.model.address_city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address_city", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"form__group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address_state),expression:"model.address_state"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "address_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Select --")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.abbreviation}},[_vm._v("\n                        "+_vm._s(state.name)+"\n                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"form__group"},[_c('label',[_vm._v("Zip")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address_zipcode),expression:"model.address_zipcode"}],attrs:{"type":"number","placeholder":"Zip Code"},domProps:{"value":(_vm.model.address_zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address_zipcode", $event.target.value)}}})])])]),_vm._v(" "),_c('br')])}
var AddressField_staticRenderFns = []
var AddressField_esExports = { render: AddressField_render, staticRenderFns: AddressField_staticRenderFns }
/* harmony default export */ var forms_AddressField = (AddressField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/AddressField.vue
var AddressField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AddressField___vue_template_functional__ = false
/* styles */
var AddressField___vue_styles__ = null
/* scopeId */
var AddressField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AddressField___vue_module_identifier__ = null
var AddressField_Component = AddressField_normalizeComponent(
  AddressField,
  forms_AddressField,
  AddressField___vue_template_functional__,
  AddressField___vue_styles__,
  AddressField___vue_scopeId__,
  AddressField___vue_module_identifier__
)

/* harmony default export */ var general_forms_AddressField = (AddressField_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/ZipcodeField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */



/**
 * Zipcode Form Component
 */
/* harmony default export */ var ZipcodeField = ({
    name: 'zipcode_field',
    extends: BaseField["a" /* default */],
    components: {
        HelpText: HelpText["a" /* default */]
    },
    computed: {
        isValid: function isValid() {
            return (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.value)
            );
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e778d4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/ZipcodeField.vue
var ZipcodeField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--zipcode",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('input',{attrs:{"type":"number","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var ZipcodeField_staticRenderFns = []
var ZipcodeField_esExports = { render: ZipcodeField_render, staticRenderFns: ZipcodeField_staticRenderFns }
/* harmony default export */ var forms_ZipcodeField = (ZipcodeField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/ZipcodeField.vue
var ZipcodeField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ZipcodeField___vue_template_functional__ = false
/* styles */
var ZipcodeField___vue_styles__ = null
/* scopeId */
var ZipcodeField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ZipcodeField___vue_module_identifier__ = null
var ZipcodeField_Component = ZipcodeField_normalizeComponent(
  ZipcodeField,
  forms_ZipcodeField,
  ZipcodeField___vue_template_functional__,
  ZipcodeField___vue_styles__,
  ZipcodeField___vue_scopeId__,
  ZipcodeField___vue_module_identifier__
)

/* harmony default export */ var general_forms_ZipcodeField = (ZipcodeField_Component.exports);

// EXTERNAL MODULE: ./src/components/general/forms/CurrencyField.vue + 2 modules
var CurrencyField = __webpack_require__("iuxk");

// EXTERNAL MODULE: ./src/components/general/forms/PercentageField.vue + 2 modules
var PercentageField = __webpack_require__("JC6k");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/StateSelectField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */




/**
 * Component
 */
/* harmony default export */ var StateSelectField = ({
    name: 'state_select_field',
    extends: general_forms_SelectField,
    components: {
        HelpText: HelpText["a" /* default */]
    },
    data: function data() {
        return {
            stateOptions: UtilityService["c" /* stateOptions */]
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d469dc5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/StateSelectField.vue
var StateSelectField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--select",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('select',{domProps:{"value":_vm.value},on:{"change":_vm.updateValue}},[_c('option',{attrs:{"value":""}},[_vm._v("\n                    "+_vm._s(_vm.initialText)+"\n                ")]),_vm._v(" "),_vm._l((_vm.stateOptions),function(option){return _c('option',{domProps:{"value":option.abbreviation}},[_vm._v("\n                    "+_vm._s(option.name)+"\n                ")])})],2)])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var StateSelectField_staticRenderFns = []
var StateSelectField_esExports = { render: StateSelectField_render, staticRenderFns: StateSelectField_staticRenderFns }
/* harmony default export */ var forms_StateSelectField = (StateSelectField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/StateSelectField.vue
var StateSelectField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var StateSelectField___vue_template_functional__ = false
/* styles */
var StateSelectField___vue_styles__ = null
/* scopeId */
var StateSelectField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StateSelectField___vue_module_identifier__ = null
var StateSelectField_Component = StateSelectField_normalizeComponent(
  StateSelectField,
  forms_StateSelectField,
  StateSelectField___vue_template_functional__,
  StateSelectField___vue_styles__,
  StateSelectField___vue_scopeId__,
  StateSelectField___vue_module_identifier__
)

/* harmony default export */ var general_forms_StateSelectField = (StateSelectField_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/MultiSelectField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */



/**
 * Multi-Select Field Component
 */
/* harmony default export */ var MultiSelectField = ({
    name: 'multi_select_field',
    extends: general_forms_SelectField,
    components: {
        HelpText: HelpText["a" /* default */]
    },
    props: {},
    data: function data() {
        return {
            searchTerm: '',
            showOptions: false
        };
    },

    methods: {
        toggleOptions: function toggleOptions() {
            this.showOptions = !this.showOptions;
        },
        isChecked: function isChecked(key) {
            return this.value.includes(key);
        },
        updateValue: function updateValue(e) {
            var payload = this.value;
            var existingIndex = payload.indexOf(e.target.value);
            existingIndex > -1 ? payload.splice(existingIndex, 1) : payload.push(e.target.value);
            this.$emit('updated', payload);
        }
    },
    watch: {
        toggleOptions: function toggleOptions(toggled) {
            if (toggled) {
                this.$refs.multiSelectInput.focus();
            }
        }
    },
    computed: {
        selectedText: function selectedText() {
            if (this.value) {
                return this.value.length > 0 ? this.value.length + ' selected' : '-- Select --';
            }
            return '-- Select --';
        },
        filteredOptions: function filteredOptions() {
            var _this = this;

            return this.options.filter(function (item) {
                return item.label.toLowerCase().includes(_this.searchTerm.toLowerCase());
            });
        },
        hasOptions: function hasOptions() {
            return this.filteredOptions.length > 0;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137d3954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/MultiSelectField.vue
var MultiSelectField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--multi-select"},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns"},[(_vm.label)?_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"field--multi-select__content"},[_c('h4',{staticClass:"field--multi-select__heading",class:{
                        'field--multi-select__heading--active': _vm.showOptions,
                        'field--multi-select__heading--disabled': !_vm.hasOptions
                    },on:{"click":function($event){_vm.toggleOptions()}}},[_vm._v("\n                    "+_vm._s(_vm.selectedText)+"\n                ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptions),expression:"showOptions"}],staticClass:"field--multi-select__options"},[_c('header',{staticClass:"field--multi-select__search-header"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"field--multi-select__search",attrs:{"type":"search","placeholder":"Filter by name"},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"field--multi-select__close",attrs:{"type":"button"},on:{"click":_vm.toggleOptions}},[_vm._v("\n                            ×\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"field--multi-select__lists"},[_c('div',{staticClass:"field--multi-select__group"},[(_vm.hasOptions)?_c('ul',_vm._l((_vm.filteredOptions),function(option){return _c('li',{staticClass:"field--multi-select__option"},[_c('input',{ref:"multiSelectInput",refInFor:true,staticClass:"field--multi-select__checkbox",attrs:{"type":"checkbox","id":("chk_" + (option.key))},domProps:{"value":option.key,"checked":_vm.isChecked(option.key)},on:{"change":_vm.updateValue}}),_vm._v(" "),_c('label',{staticClass:"field--multi-select__label",attrs:{"for":("chk_" + (option.key))}},[_vm._v("\n                                        "+_vm._s(option.label)+"\n                                    ")])])})):_c('p',{staticClass:"field--multi-select__not-available"},[_vm._v("\n                                N/A\n                            ")])])])])])])])])}
var MultiSelectField_staticRenderFns = []
var MultiSelectField_esExports = { render: MultiSelectField_render, staticRenderFns: MultiSelectField_staticRenderFns }
/* harmony default export */ var forms_MultiSelectField = (MultiSelectField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/MultiSelectField.vue
var MultiSelectField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MultiSelectField___vue_template_functional__ = false
/* styles */
var MultiSelectField___vue_styles__ = null
/* scopeId */
var MultiSelectField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MultiSelectField___vue_module_identifier__ = null
var MultiSelectField_Component = MultiSelectField_normalizeComponent(
  MultiSelectField,
  forms_MultiSelectField,
  MultiSelectField___vue_template_functional__,
  MultiSelectField___vue_styles__,
  MultiSelectField___vue_scopeId__,
  MultiSelectField___vue_module_identifier__
)

/* harmony default export */ var general_forms_MultiSelectField = (MultiSelectField_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/TextareaField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */



/**
 * Component
 */
/* harmony default export */ var TextareaField = ({
  name: 'textarea_field',
  extends: BaseField["a" /* default */],
  components: {
    HelpText: HelpText["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9070fb06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/TextareaField.vue
var TextareaField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--text-area",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('textarea',{ref:"input",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"autofocus":_vm.autofocus},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var TextareaField_staticRenderFns = []
var TextareaField_esExports = { render: TextareaField_render, staticRenderFns: TextareaField_staticRenderFns }
/* harmony default export */ var forms_TextareaField = (TextareaField_esExports);
// CONCATENATED MODULE: ./src/components/general/forms/TextareaField.vue
function TextareaField_injectStyle (ssrContext) {
  __webpack_require__("/X8q")
}
var TextareaField_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TextareaField___vue_template_functional__ = false
/* styles */
var TextareaField___vue_styles__ = TextareaField_injectStyle
/* scopeId */
var TextareaField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TextareaField___vue_module_identifier__ = null
var TextareaField_Component = TextareaField_normalizeComponent(
  TextareaField,
  forms_TextareaField,
  TextareaField___vue_template_functional__,
  TextareaField___vue_styles__,
  TextareaField___vue_scopeId__,
  TextareaField___vue_module_identifier__
)

/* harmony default export */ var general_forms_TextareaField = (TextareaField_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/tables/TableHeader.vue
//
//
//
//
//
//
//
//
//
//
//

/**
* Dependencies
*/


/**
 * Component
 */
/* harmony default export */ var TableHeader = ({
    name: 'table-header',
    components: {
        HelpText: HelpText["a" /* default */]
    },
    props: {
        label: {
            type: String,
            required: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        helptext: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        className: function className() {
            return {
                'is-required': this.required
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-410db5cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/tables/TableHeader.vue
var TableHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:_vm.className},[_c('div',{staticClass:"row collapse no-pad align-bottom"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns",domProps:{"textContent":_vm._s(_vm.label)}})])])}
var TableHeader_staticRenderFns = []
var TableHeader_esExports = { render: TableHeader_render, staticRenderFns: TableHeader_staticRenderFns }
/* harmony default export */ var tables_TableHeader = (TableHeader_esExports);
// CONCATENATED MODULE: ./src/components/general/tables/TableHeader.vue
var TableHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TableHeader___vue_template_functional__ = false
/* styles */
var TableHeader___vue_styles__ = null
/* scopeId */
var TableHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TableHeader___vue_module_identifier__ = null
var TableHeader_Component = TableHeader_normalizeComponent(
  TableHeader,
  tables_TableHeader,
  TableHeader___vue_template_functional__,
  TableHeader___vue_styles__,
  TableHeader___vue_scopeId__,
  TableHeader___vue_module_identifier__
)

/* harmony default export */ var general_tables_TableHeader = (TableHeader_Component.exports);

// CONCATENATED MODULE: ./src/components/index.js
/**
 * Global Component Dependencies
 */















/**
 * Global Custom Input Dependencies
 */
















/**
 * Global Custom Table Dependencies
 */


/**
 * Global Components
 *
 * @type {Object}
 */
var components = {
  'btn': components_general_Btn,
  'row': components_general_Row,
  'tabs': components_general_Tabs,
  'card': components_general_Card,
  'notice': components_general_Notice,
  'column': components_general_Column,
  'tags-field': general_forms_TagsField,
  'tab-pane': components_general_TabPane,
  'branding': components_general_Branding,
  'check-box': general_forms_CheckBox,
  'btn-group': components_general_BtnGroup,
  'date-field': general_forms_DateField,
  'text-field': TextField["a" /* default */],
  'year-field': general_forms_YearField,
  'month-field': general_forms_MonthField,
  'progress-bar': components_general_ProgressBar,
  'number-field': NumberField["a" /* default */],
  'select-field': general_forms_SelectField,
  'table-header': general_tables_TableHeader,
  'address-field': general_forms_AddressField,
  'success-check': components_general_SuccessCheck,
  'zipcode-field': general_forms_ZipcodeField,
  'percentage-bar': components_general_PercentageBar,
  'currency-field': CurrencyField["a" /* default */],
  'section-heading': components_general_SectionHeading,
  'loading-spinner': components_general_LoadingSpinner,
  'percentage-field': PercentageField["a" /* default */],
  'state-select-field': general_forms_StateSelectField,
  'multi-select-field': general_forms_MultiSelectField,
  'textarea-field': general_forms_TextareaField
};

/* harmony default export */ var src_components = (components);
// CONCATENATED MODULE: ./src/main.js


/**
 * Base Application Dependencies
 */












// Stylesheet
__webpack_require__("6txZ");

/**
 * Global Filters
 */
keys_default()(filters).forEach(function (filter) {
    return vue_esm["a" /* default */].filter(filter, filters[filter]);
});

/**
 * Global Directives
 */
keys_default()(src_directives).forEach(function (directive) {
    return vue_esm["a" /* default */].directive(directive, src_directives[directive]);
});

/**
 * Global Components
 */
keys_default()(src_components).forEach(function (component) {
    return vue_esm["a" /* default */].component(component, src_components[component]);
});

/**
 * Sync router with Vuex
 */
Object(vuex_router_sync["sync"])(store["a" /* default */], router["a" /* default */]);

/**
 * Vue Plugins
 */
vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

if (true) {
    vue_esm["a" /* default */].use(vue_analytics_default.a, {
        id: "UA-66075163-1",
        router: router["a" /* default */],
        autoTracking: {
            pageviewOnLoad: false
        }
    });
}

/**
 * Add additional Vue properties
 */
define_properties_default()(vue_esm["a" /* default */].prototype, {
    $bus: {
        get: function get() {
            return events;
        }
    }
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
    el: '#app',
    store: store["a" /* default */],
    router: router["a" /* default */],
    template: '<App/>',
    components: { App: src_App }
});

/***/ }),

/***/ "Ncbd":
/***/ (function(module, exports) {



/***/ }),

/***/ "PKBW":
/***/ (function(module, exports) {



/***/ }),

/***/ "Pxfh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JWT_CHECK_URL; });
/* unused harmony export PROJECT_LIST_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PORTFOLIO_LIST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PORTFOLIO_CREATE_URL; });
/**
 * API Authentication URLs
 */
var LOGIN_URL = 'auth/api-token-auth/';
var JWT_CHECK_URL = 'auth/api-token-verify/';

/**
 * Projects URLs
 */
var PROJECT_LIST_URL = 'projects/';

/**
 * Portfolio URLs
 */
var PORTFOLIO_LIST_URL = 'portfolios/';
var PORTFOLIO_CREATE_URL = 'portfolios/create/';

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currency", function() { return currency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "percent", function() { return percent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multiple", function() { return multiple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mime", function() { return mime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "date", function() { return date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bytes", function() { return bytes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "number", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truncate", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "address", function() { return address; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "variableFormat", function() { return variableFormat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/**
 * Filter Dependencies
 */



/**
 * Establish the non-numeric values that may come back
 *
 * @type {Array}
 */
var oddValues = ['Infinity', '-Infinity', 'NaN'];

/**
 * Digits regex
 *
 * @type {RegExp}
 */
var digitsRE = /(\d{3})(?=\d)/g;

/**
 * Handle translating edge cases where Infinity or other unexpected values show up in the payload
 *
 * @param  {Number|String|Null} value
 * @param  {String} format
 * @return {String}
 */
var parseValue = function parseValue(value) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    switch (value) {
        case 'Infinity':
            return '∞';
        case '-Infinity':
            return '-∞';
        case 'NaN':
            return 'N/A';
        default:
            return __WEBPACK_IMPORTED_MODULE_1_numeral___default()(value).format(format);
    }
};

/**
 * Get the currency postfix
 *
 * @param  {String} unit
 * @return {String}
 */
var getUnitPostfix = function getUnitPostfix() {
    var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dollars';

    switch (unit) {
        case 'dollars':
            return '';
        case 'thousands':
            return ' K';
        case 'millions':
            return ' M';
        default:
            return '';
    }
};

/**
 * Currency filter
 *
 * @param  {Number}  val
 * @param  {Number}  decimals
 * @param  {String}  unit
 * @param  {Boolean} includePrefix
 * @return {String}
 */
var currency = function currency(val) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dollars';
    var includePrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (val === 0 || !val) return '—';

    // Establish value
    var value = divideUnit(parseFloat(val), unit);

    // Return if blank
    if (!isFinite(value) || !value && value !== 0) return '';

    // Decimal assignment
    decimals = determineDecimals(decimals, unit);

    // Magic
    var stringified = Math.abs(value).toFixed(decimals);
    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    var i = _int.length % 3;
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    var _float = decimals ? stringified.slice(-1 - decimals) : '';
    var output = head + _int.slice(i).replace(digitsRE, '$1,') + _float;

    // Send back the value if positive, wrap the negative output in parentheses
    var result = includePrefix ? value < 0 ? '($' + output + ')' : '$' + output : value < 0 ? '(' + output + ')' : output;

    return '' + result + getUnitPostfix(unit);
};

/**
 * Divide the unit based on the unit preference
 *
 * @param  {Number} value
 * @param  {String} unit
 * @return {Number}
 */
var divideUnit = function divideUnit() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dollars';

    switch (unit) {
        case 'thousands':
            return value / 1000;
        case 'millions':
            return value / 1000000;
        default:
            return value;
    }
};

/**
 * Determine the decimal scale
 *
 * @param  {Number} decimals
 * @param  {String} unit
 * @return {[type]}
 */
var determineDecimals = function determineDecimals() {
    var decimals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dollars';
    return unit === 'dollars' ? decimals || 0 : 2;
};

/**
 * Format value to percentage string
 *
 * @param  {Integer|Number|Float} value
 * @return {String}
 */
var percent = function percent(value) {
    return parseValue(value, '0.00%');
};

/**
 * Format to a multiple (x) value
 *
 * @param  {Integer|Number|Float} value
 * @return {String}
 */
var multiple = function multiple(value) {
    var parsed = parseValue(value, '0.00');

    return oddValues.includes(value) ? parsed : parsed + 'x';
};

/**
 * Determine the MIME type
 *
 * @param  {String} value
 * @return {String}
 */
var mime = function mime(value) {
    return value.replace('/', '_').replace(/\./g, '-');
};

/**
 * Convert a date string to a readable format
 *
 * @param  {String} value
 * @return {String}
 */
var date = function date(_date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'M/D/Y';
    var currentFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD';
    return _date !== 'NaN' && _date !== null && _date !== '' ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(_date, currentFormat).format(format) : null;
};

/**
 * Translate the bytes of a file size
 *
 * @param  {Number} bytes
 * @param  {Number} decimals
 * @return {String}
 */
var bytes = function bytes(_bytes, decimals) {
    return __WEBPACK_IMPORTED_MODULE_1_numeral___default()(parseFloat(_bytes).toFixed(2)).format('0.00b');
};

/**
 * Translate the number into a thousands comma-separated value
 *
 * @param  {Number} value
 * @return {String}
 */
var number = function number(value) {
    return __WEBPACK_IMPORTED_MODULE_1_numeral___default()(value).format('0,0');
};

/**
 * Truncate a string by a given max length
 *
 * @param  {String} string
 * @param  {Number} max
 * @return {String}
 */
var truncate = function truncate(string) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
    return string.length > max ? string.substring(0, max) + ' ...' : string;
};

/**
 * Parse an address object and convert it to a string
 *
 * @param  {Object} obj
 * @return {String}
 */
var address = function address(obj) {
    var arr = [obj.address_street_1, obj.address_street_2, obj.address_city, obj.address_state, obj.address_zipcode];

    return arr.filter(function (i) {
        return !!i;
    }).join(', ');
};

/**
 * Return an adjusted string
 *
 * @param  {String} str
 * @return {String}
 */
var convertString = function convertString(str) {
    return str || '—';
};

/**
 * Return an appropriate mutated format based on a filter parameter
 *
 * @param  {mixed} value
 * @param  {String} filterName
 * @return {String}
 */
var variableFormat = function variableFormat(value, filterName) {
    var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'dollars';
    var includePrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    switch (filterName) {
        case 'currency_string':
            return currency(value, decimals, unit, false);
        case 'currency':
            return currency(value, decimals, unit, includePrefix);
        case 'monetary':
            return currency(value, decimals, unit, includePrefix);
        case 'dollar':
            return currency(value, decimals, unit, includePrefix);
        case 'percentage':
            return percent(value);
        case 'percent':
            return percent(value);
        case 'multiple':
            return multiple(value);
        case 'date':
            return date(value);
        case 'number':
            return number(value);
        case 'address':
            return address(value);
        case 'string':
            return convertString(value);
        default:
            return value;
    }
};

/***/ }),

/***/ "QqZI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stateOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateAmmortizationTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/**
 * Dependencies
 */


/**
 * Return a list of state options for a select input
 *
 * @type {Array}
 */
var stateOptions = [{
    name: 'Alabama',
    abbreviation: 'AL'
}, {
    name: 'Alaska',
    abbreviation: 'AK'
}, {
    name: 'American Samoa',
    abbreviation: 'AS'
}, {
    name: 'Arizona',
    abbreviation: 'AZ'
}, {
    name: 'Arkansas',
    abbreviation: 'AR'
}, {
    name: 'California',
    abbreviation: 'CA'
}, {
    name: 'Colorado',
    abbreviation: 'CO'
}, {
    name: 'Connecticut',
    abbreviation: 'CT'
}, {
    name: 'Delaware',
    abbreviation: 'DE'
}, {
    name: 'District Of Columbia',
    abbreviation: 'DC'
}, {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM'
}, {
    name: 'Florida',
    abbreviation: 'FL'
}, {
    name: 'Georgia',
    abbreviation: 'GA'
}, {
    name: 'Guam',
    abbreviation: 'GU'
}, {
    name: 'Hawaii',
    abbreviation: 'HI'
}, {
    name: 'Idaho',
    abbreviation: 'ID'
}, {
    name: 'Illinois',
    abbreviation: 'IL'
}, {
    name: 'Indiana',
    abbreviation: 'IN'
}, {
    name: 'Iowa',
    abbreviation: 'IA'
}, {
    name: 'Kansas',
    abbreviation: 'KS'
}, {
    name: 'Kentucky',
    abbreviation: 'KY'
}, {
    name: 'Louisiana',
    abbreviation: 'LA'
}, {
    name: 'Maine',
    abbreviation: 'ME'
}, {
    name: 'Marshall Islands',
    abbreviation: 'MH'
}, {
    name: 'Maryland',
    abbreviation: 'MD'
}, {
    name: 'Massachusetts',
    abbreviation: 'MA'
}, {
    name: 'Michigan',
    abbreviation: 'MI'
}, {
    name: 'Minnesota',
    abbreviation: 'MN'
}, {
    name: 'Mississippi',
    abbreviation: 'MS'
}, {
    name: 'Missouri',
    abbreviation: 'MO'
}, {
    name: 'Montana',
    abbreviation: 'MT'
}, {
    name: 'Nebraska',
    abbreviation: 'NE'
}, {
    name: 'Nevada',
    abbreviation: 'NV'
}, {
    name: 'New Hampshire',
    abbreviation: 'NH'
}, {
    name: 'New Jersey',
    abbreviation: 'NJ'
}, {
    name: 'New Mexico',
    abbreviation: 'NM'
}, {
    name: 'New York',
    abbreviation: 'NY'
}, {
    name: 'North Carolina',
    abbreviation: 'NC'
}, {
    name: 'North Dakota',
    abbreviation: 'ND'
}, {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP'
}, {
    name: 'Ohio',
    abbreviation: 'OH'
}, {
    name: 'Oklahoma',
    abbreviation: 'OK'
}, {
    name: 'Oregon',
    abbreviation: 'OR'
}, {
    name: 'Palau',
    abbreviation: 'PW'
}, {
    name: 'Pennsylvania',
    abbreviation: 'PA'
}, {
    name: 'Puerto Rico',
    abbreviation: 'PR'
}, {
    name: 'Rhode Island',
    abbreviation: 'RI'
}, {
    name: 'South Carolina',
    abbreviation: 'SC'
}, {
    name: 'South Dakota',
    abbreviation: 'SD'
}, {
    name: 'Tennessee',
    abbreviation: 'TN'
}, {
    name: 'Texas',
    abbreviation: 'TX'
}, {
    name: 'Utah',
    abbreviation: 'UT'
}, {
    name: 'Vermont',
    abbreviation: 'VT'
}, {
    name: 'Virgin Islands',
    abbreviation: 'VI'
}, {
    name: 'Virginia',
    abbreviation: 'VA'
}, {
    name: 'Washington',
    abbreviation: 'WA'
}, {
    name: 'West Virginia',
    abbreviation: 'WV'
}, {
    name: 'Wisconsin',
    abbreviation: 'WI'
}, {
    name: 'Wyoming',
    abbreviation: 'WY'
}];

/**
 * Generate an ammortization table from existing data
 *
 * @param  {Object} table
 * @return {Object}
 */
var generateAmmortizationTable = function generateAmmortizationTable(table) {
    return {
        column_limit: 7,
        data: table.data.map(function (obj) {
            return {
                data: obj.data,
                format: 'currency',
                is_bold: false,
                is_subtotal: table.subtotals.includes(obj.name),
                is_total: table.totals.includes(obj.name),
                label: obj.name
            };
        }),
        index: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(table, 'data[0].index', []),
        label: table.label,
        sub_label: null,
        type: 'financial_timeseries_table'
    };
};

var mergeObject = function mergeObject(originalObj, newObj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(originalObj)) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["assign"])(originalObj, newObj);
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])(originalObj, newObj);
    }
};

/***/ }),

/***/ "RDYn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rlrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Route Dependencies
 */
var Account = function Account(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("JMXf"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MyProfile = function MyProfile(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("xHFR"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AccountSettings = function AccountSettings(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("/sOY"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AccountPreferences = function AccountPreferences(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("S2vY"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AccountSubscription = function AccountSubscription(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("c0gX"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AccountUserManagement = function AccountUserManagement(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("DKZf"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AccountPasswordManagement = function AccountPasswordManagement(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("WkIY"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Account Routes
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    path: 'account',
    component: Account,
    children: [{
        path: '',
        name: 'account',
        component: MyProfile
    }, {
        path: 'settings',
        name: 'account.settings',
        component: AccountSettings
    }, {
        path: 'preferences',
        name: 'account.preferences',
        component: AccountPreferences
    }, {
        path: 'subscription',
        name: 'account.subscription',
        component: AccountSubscription
    }, {
        path: 'change-password',
        name: 'account.passwordManagement',
        component: AccountPasswordManagement
    }, {
        path: 'user-management',
        name: 'account.users',
        component: AccountUserManagement
    }]
});

/***/ }),

/***/ "SGRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authenticate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return validateToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sendResetEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkResetToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return requestPasswordChange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_paths__ = __webpack_require__("Pxfh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HttpService__ = __webpack_require__("VOtV");

/**
 * Service Dependencies
 */



/**
 * Attempt to authenticate the user
 *
 * @param  {Object} credentials
 * @return {Promise}
 */
var authenticate = function authenticate(credentials) {
    return __WEBPACK_IMPORTED_MODULE_2__HttpService__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_1__router_paths__["b" /* LOGIN_URL */], credentials).then(function (res) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data.token);
    }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });
};

/**
 * Validate a JWT token that exists in local storage
 *
 * @return {Promise}
 */
var validateToken = function validateToken() {
    return __WEBPACK_IMPORTED_MODULE_2__HttpService__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_1__router_paths__["a" /* JWT_CHECK_URL */], {
        token: window.localStorage.getItem('id_token')
    });
};

/**
 * Save the JWT to local storage
 *
 * @param  {String} token
 * @return {Void}
 */
var setToken = function setToken(token) {
    window.localStorage.setItem('id_token', token);
};

/**
 * Remove the JWT in local storage
 *
 * @return {Void}
 */
var removeToken = function removeToken() {
    window.localStorage.removeItem('id_token');
};

/**
 * Change the user's password
 *
 * @param  {Object} payload
 * @return {Promise}
 */
var changePassword = function changePassword() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_2__HttpService__["a" /* default */].post('auth/change-password/', payload);
};

/**
 * Request a password reset email from the API
 *
 * @param  {String} email
 * @return {Promise}
 */
var sendResetEmail = function sendResetEmail() {
    var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return __WEBPACK_IMPORTED_MODULE_2__HttpService__["a" /* default */].post('auth/password-reset/', {
        email: email
    });
};

/**
 * Check the validity of a password reset token
 *
 * @param  {String} token
 * @return {Promise}
 */
var checkResetToken = function checkResetToken() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return __WEBPACK_IMPORTED_MODULE_2__HttpService__["a" /* default */].get('auth/confirm-password-reset/' + token + '/');
};

/**
 * Change the user's password
 *
 * @param  {Object} payload
 * @param  {String} token
 * @return {Promise}
 */
var requestPasswordChange = function requestPasswordChange() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return __WEBPACK_IMPORTED_MODULE_2__HttpService__["a" /* default */].post('auth/confirm-password-reset/' + token + '/', payload);
};

/***/ }),

/***/ "ULaz":
/***/ (function(module, exports) {



/***/ }),

/***/ "VOtV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setAuthorizationHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeAuthorizationHeader; });
/* unused harmony export get */
/* unused harmony export del */
/* unused harmony export head */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return post; });
/* unused harmony export put */
/* unused harmony export patch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/**
 * Service Dependencies
 */


/**
 * Configure HTTP Adapter
 */
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = "https://api.lucroapp.com";

/**
 * Set default authorization token for every request
 *
 * @param  {String} token
 * @return {Void}
 */
var setAuthorizationHeader = function setAuthorizationHeader(token) {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common = {
    'Authorization': 'Bearer ' + window.localStorage.getItem('id_token')
  };
};

/**
 * Remove default authorization token from requests
 *
 * @return {Void}
 */
var removeAuthorizationHeader = function removeAuthorizationHeader() {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common = {};
};

/**
 * GET Request
 *
 * @param  {String} url
 * @param  {Object} config
 * @return {Promise}
 */
var get = function get(url, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url || '', config || {});
};

/**
 * DELETE Request
 *
 * @param  {String} url
 * @param  {Object} config
 * @return {Promise}
 */
var del = function del(url, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(url || '', config || {});
};

/**
 * HEAD Request
 *
 * @param  {String} url
 * @param  {Object} config
 * @return {Promise}
 */
var head = function head(url, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.head(url || '', config || {});
};

/**
 * POST Request
 *
 * @param  {String} url
 * @param  {Object} data
 * @param  {Object} config
 * @return {Promise}
 */
var post = function post(url, data, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url || '', data || {}, config || {});
};

/**
 * PUT Request
 *
 * @param  {String} url
 * @param  {Object} data
 * @param  {Object} config
 * @return {Promise}
 */
var put = function put(url, data, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(url || '', data || {}, config || {});
};

/**
 * PATCH Request
 *
 * @param  {String} url
 * @param  {Object} data
 * @param  {Object} config
 * @return {Promise}
 */
var patch = function patch(url, data, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch(url || '', data || {}, config || {});
};

/**
 * HTTP Service Declaration
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  put: put,
  del: del,
  post: post,
  head: head,
  patch: patch
});

/***/ }),

/***/ "VRwF":
/***/ (function(module, exports) {



/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_store__ = __webpack_require__("ZiWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__projects__ = __webpack_require__("+sBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account__ = __webpack_require__("Rlrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__war_rooms__ = __webpack_require__("aVT4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboard__ = __webpack_require__("0IxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__portfolios__ = __webpack_require__("FYRO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_project__ = __webpack_require__("EsF4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__deal_pipeline__ = __webpack_require__("Mk6z");
/**
 * Router Dependencies
 */











/**
 * Async Route Components
 */
var Login = function Login(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("kvsw"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Dashboard = function Dashboard(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(9)]).then((function () {
        return r(__webpack_require__("YAPR"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Register = function Register(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("pAGS"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ResetPassword = function ResetPassword(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("ZDis"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ViewProject = function ViewProject(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("BNlT"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SharedProject = function SharedProject(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("Rvbd"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SharedProjectIndex = function SharedProjectIndex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function () {
        return r(__webpack_require__("C8D5"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var InviteRegistration = function InviteRegistration(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("Xcd3"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SharedProjectLogin = function SharedProjectLogin(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("wGVF"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CollaborationInvitation = function CollaborationInvitation(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("zwlu"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ResetPasswordConfirmation = function ResetPasswordConfirmation(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("2VsV"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ViewProjectInvitation = function ViewProjectInvitation(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("fBwt"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SharedProjectRegister = function SharedProjectRegister(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("5S0Q"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SharedProjectChallenge = function SharedProjectChallenge(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function () {
        return r(__webpack_require__("Vwbd"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Debt Servicing Routes
 */
var DebtServicing = function DebtServicing(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(8)]).then((function () {
        return r(__webpack_require__("qEJH"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DebtServicingIndex = function DebtServicingIndex(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(8)]).then((function () {
        return r(__webpack_require__("I1qc"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Digital OM Components
 */
var DigitalOM = function DigitalOM(r) {
    return Promise.all/* require.ensure */([__webpack_require__.e(1), __webpack_require__.e(0)]).then((function () {
        return r(__webpack_require__("05Ng"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Vue Plugins
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/**
 * Check the authentication status when entering the route
 *
 * @param  {Object}   to
 * @param  {Object}   from
 * @param  {Function} next
 * @return {Router}
 */
var checkAuth = function checkAuth(to, from, next) {
    var loggedIn = __WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].state.user.isLoggedIn;
    var token = window.localStorage.getItem('id_token');

    if (!loggedIn && token) {
        __WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].dispatch('user/checkAuthentication').then(next).catch(function () {
            return next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        });
    } else if (!loggedIn && !token) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    } else {
        next();
    }
};

/**
 * Check the auth status of an incoming user and validate
 * the token/authenticate the user if possible
 * while still allowing access to the route
 *
 * @param  {Function}   to
 * @param  {Function}   from
 * @param  {Function} next
 * @return {Router}
 */
var guestAuthCheck = function guestAuthCheck(to, from, next) {
    var loggedIn = __WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].state.user.isLoggedIn;
    var token = window.localStorage.getItem('id_token');

    if (!loggedIn && token) {
        __WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].dispatch('user/checkAuthentication').then(function () {
            return next();
        }).catch(function () {
            return next();
        });
    } else {
        next();
    }
};

/**
 * Redirect the user if they are already authenticated
 *
 * @return {[type]} [description]
 */
var redirectIfAuthenticated = function redirectIfAuthenticated(to, from, next) {
    var loggedIn = __WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].state.user.isLoggedIn;
    var token = window.localStorage.getItem('id_token');

    if (!loggedIn && token) {
        __WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].dispatch('user/checkAuthentication').then(next('/')).catch(function () {
            return next();
        });
    } else {
        next();
    }
};

/**
 * Router definition
 *
 * @type {Router}
 */
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    base: __dirname,
    routes: [{
        path: '/login',
        name: 'login',
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: redirectIfAuthenticated
    }, {
        path: '/reset-password',
        name: 'reset',
        component: ResetPassword,
        meta: { requiresAuth: false }
    }, {
        path: '/account/password-reset',
        name: 'reset.form',
        component: ResetPasswordConfirmation,
        meta: { requiresAuth: false }
    }, {
        path: '/projects/:projectId/digital-om',
        name: 'projects.show.dom',
        component: DigitalOM,
        meta: { requiresAuth: true },
        beforeEnter: checkAuth
    }, {
        path: '/shared-projects/:projectKey',
        component: SharedProject,
        children: [{
            path: '',
            name: 'guest.shared',
            component: SharedProjectIndex
        }, {
            path: 'authenticate',
            name: 'guest.shared.login',
            component: SharedProjectLogin
        }, {
            path: 'register',
            name: 'guest.shared.register',
            component: SharedProjectRegister
        }, {
            path: 'access',
            name: 'guest.shared.challenge',
            component: SharedProjectChallenge
        }],
        beforeEnter: guestAuthCheck
    }, {
        path: '/register',
        name: 'register',
        component: Register,
        beforeEnter: redirectIfAuthenticated
    }, {
        path: '/register/:token/collaboration-invite',
        name: 'collaboration_invitation',
        component: CollaborationInvitation,
        beforeEnter: redirectIfAuthenticated
    }, {
        path: '/auth/register/:token/company-user-register-invite',
        name: 'company_invite_registration',
        component: InviteRegistration,
        beforeEnter: redirectIfAuthenticated
    }, {
        path: '/invitations/direct/:token',
        name: 'view_invitation',
        component: ViewProjectInvitation,
        beforeEnter: redirectIfAuthenticated
    }, {
        path: '/',
        component: Dashboard,
        meta: { requiresAuth: true },
        children: [__WEBPACK_IMPORTED_MODULE_5__war_rooms__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__projects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__portfolios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__deal_pipeline__["a" /* default */]],
        beforeEnter: checkAuth
    }, {
        path: '/debt-servicing',
        component: DebtServicing,
        meta: { requiresAuth: true },
        children: [{
            path: '',
            name: 'debt_servicing',
            component: DebtServicingIndex
        }],
        beforeEnter: checkAuth
    }, {
        path: '/view-project/:projectId',
        component: ViewProject,
        meta: { requiresAuth: true },
        children: __WEBPACK_IMPORTED_MODULE_8__view_project__["a" /* default */],
        beforeEnter: checkAuth
    }, { path: '*', redirect: '/' }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ "ZiWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/state/state.js
/**
 * Dependencies
 */


/**
 * Root State
 *
 * @type {Object}
 */
var state_state = {
  notifications: []
};

var state_getState = function getState() {
  return Object(lodash["cloneDeep"])(state_state);
};

/* harmony default export */ var src_state_state = (state_getState());
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./src/state/actions.js

/**
 * Trigger a notification with a given payload
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var addNotification = function addNotification(_ref, payload) {
    var commit = _ref.commit;

    commit('ADD_NOTIFICATION', payload);
};

/**
 * Remove a notification from the queue
 *
 * @param  {Function} options.commit
 * @param  {Object} notification
 * @return {Void}
 */
var removeNotification = function removeNotification(_ref2, notification) {
    var commit = _ref2.commit;

    commit('REMOVE_NOTIFICATION', notification);
};

var actions_resetApplicationState = function resetApplicationState(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    return new promise_default.a(function (resolve, reject) {
        dispatch('projects/single/resetState');
        dispatch('projects/form/resetState');
        dispatch('projects/resetState');
        dispatch('portfolios/resetState');
        dispatch('user/resetState');
        commit('RESET_STATE');
        resolve();
    });
};

/* harmony default export */ var actions = ({
    addNotification: addNotification,
    removeNotification: removeNotification,
    resetApplicationState: actions_resetApplicationState
});
// CONCATENATED MODULE: ./src/state/modules/user/state.js
/**
 * Dependencies
 */


/**
 * User State
 *
 * @type {Object}
 */
var user_state_state = {
  pending: false,
  isLoggedIn: false,
  first_run: false,
  profile: {
    loaded: false,
    pending: false,
    data: {}
  }

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var user_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(user_state_state);
};

/* harmony default export */ var user_state = (user_state_getState());
// CONCATENATED MODULE: ./src/state/modules/user/getters.js
/**
 * Getter Dependencies
 */


/**
 * Authentication Status
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var isLoggedIn = function isLoggedIn(state) {
  return state.isLoggedIn;
};

/**
 * Determine whether the application is loading
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var userLoading = function userLoading(state) {
  return state.pending;
};

/**
 * Retrieve the user profile
 *
 * @param  {Object} state
 * @return {Object}
 */
var userProfile = function userProfile(state) {
  return state.profile;
};

/**
 * Return the user's company name
 *
 * @param  {Object} state
 * @return {String}
 */
var userFullName = function userFullName(state) {
  var name = '';
  name += state.profile.data.first_name || '';
  name += state.profile.data.last_name ? ' ' + state.profile.data.last_name : '';

  return name;
};

/**
 * Get the user's initials derived from the full name
 *
 * @param  {Object} state
 * @return {String}
 */
var userInitials = function userInitials(state, getters) {
  var initials = getters.userFullName.match(/\b\w/g) || [];
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();

  return initials;
};

/**
 * Return the user's full company name
 *
 * @param  {Object} state
 * @return {String}
 */
var getters_userCompanyName = function userCompanyName(state) {
  return Object(lodash["get"])(state, 'profile.data.company.name', null);
};

/**
 * Determine whether the profile has been loaded from the API
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_userProfileLoaded = function userProfileLoaded(state) {
  return Object(lodash["get"])(state, 'profile.loaded', null);
};

/**
 * Return the user's admin status
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_isCompanyAdmin = function isCompanyAdmin(state) {
  return Object(lodash["get"])(state, 'profile.data.is_company_admin', false);
};

/**
 * Return the user's super admin status
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_isSuperAdmin = function isSuperAdmin(state) {
  return Object(lodash["get"])(state, 'profile.data.is_company_superuser', false);
};

/**
 * Return the user's preferences from the user state
 *
 * @param  {Object} state
 * @return {Object}
 */
var getters_userPreferences = function userPreferences(state) {
  return Object(lodash["get"])(state, 'profile.data.preferences', {});
};

/* harmony default export */ var user_getters = ({
  isLoggedIn: isLoggedIn,
  userLoading: userLoading,
  userProfile: userProfile,
  isSuperAdmin: getters_isSuperAdmin,
  userFullName: userFullName,
  userInitials: userInitials,
  isCompanyAdmin: getters_isCompanyAdmin,
  userPreferences: getters_userPreferences,
  userCompanyName: getters_userCompanyName,
  userProfileLoaded: getters_userProfileLoaded
});
// EXTERNAL MODULE: ./src/services/HttpService.js
var HttpService = __webpack_require__("VOtV");

// EXTERNAL MODULE: ./src/services/AuthService.js
var AuthService = __webpack_require__("SGRL");

// CONCATENATED MODULE: ./src/state/modules/user/actions.js

/**
 * Action Dependencies
 */




/**
 * Attempt user login with provided credentials
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_attemptLogin = function attemptLogin(_ref, credentials) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('LOGIN');
    return Object(AuthService["a" /* authenticate */])(credentials).then(function (token) {
        Object(AuthService["g" /* setToken */])(token);
        Object(HttpService["d" /* setAuthorizationHeader */])(token);
        commit('LOGIN_SUCCESS');
        return promise_default.a.resolve(token);
    }).catch(function (err) {
        Object(AuthService["d" /* removeToken */])();
        commit('LOGIN_FAILURE');
        return promise_default.a.reject(err.response.data);
    });
};

/**
 * Set up successful authentication context
 *
 * @param  {Function} options.commit
 * @param  {Object} response
 * @return {Promise}
 */
var actions_handleSuccessfullLogin = function handleSuccessfullLogin(_ref2, token) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
        window.localStorage.setItem('token', token);
        HttpService["a" /* default */].defaults.headers.common = {
            'Authorization': 'Bearer ' + token
        };
        commit('LOGIN_SUCCESS');
        resolve(token);
    });
};

/**
 * Handle a failed login
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_handleFailedLogin = function handleFailedLogin(_ref3) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
        window.localStorage.removeItem('token');
        commit('LOGIN_FAILURE');
    });
};

/**
 * Check existing JWT against the API
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_checkAuthentication = function checkAuthentication(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return Object(AuthService["h" /* validateToken */])().then(function (res) {
        return new promise_default.a(function (resolve, reject) {
            Object(HttpService["d" /* setAuthorizationHeader */])();
            commit('LOGIN_SUCCESS');
            resolve(res);
        });
    }).catch(function (err) {
        return new promise_default.a(function (resolve, reject) {
            Object(AuthService["d" /* removeToken */])();
            Object(HttpService["c" /* removeAuthorizationHeader */])();
            reject(err);
        });
    });
};

/**
 * Process the log out action
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_logout = function logout(_ref5) {
    var commit = _ref5.commit;

    return new promise_default.a(function (resolve, reject) {
        window.localStorage.removeItem('id_token');
        Object(HttpService["c" /* removeAuthorizationHeader */])();
        commit('LOGOUT');
        return resolve('logged out');
    });
};

/**
 * Retrieve the user profile
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_getUserProfile = function getUserProfile(_ref6) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    commit('GET_USER_PROFILE');
    return HttpService["a" /* default */].get('auth/account-information/').then(function (res) {
        return new promise_default.a(function (resolve, reject) {
            var payload = res.data;
            var company = payload.company;
            var preferences = payload.preferences;
            var subscription = payload.subscription;
            delete payload.company;
            delete payload.subscription;
            delete payload.preferences;
            commit('SET_USER_PROFILE', payload);
            dispatch('company/setCompanyData', company, { root: true });
            dispatch('preferences/setPreferences', preferences);
            dispatch('subscription/setSubscription', subscription);
            resolve(res);
        });
    }).catch(function (err) {
        return new promise_default.a(function (resolve, reject) {
            commit('GET_USER_PROFILE_FAIL', err);
            reject(err);
        });
    });
};

/**
 * Update the user's password
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_updatePassword = function updatePassword(_ref7, payload) {
    var commit = _ref7.commit;

    return Object(AuthService["b" /* changePassword */])(payload);
};

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var resetState = function resetState(_ref8) {
    var commit = _ref8.commit;
    return commit('RESET_STATE');
};

/**
 * Set the first run state variable
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var setFirstRun = function setFirstRun(_ref9) {
    var commit = _ref9.commit;
    return commit('SET_FIRST_RUN');
};

/**
 * Reset the first run state variable
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var resetFirstRun = function resetFirstRun(_ref10) {
    var commit = _ref10.commit;
    return commit('RESET_FIRST_RUN');
};

/* harmony default export */ var user_actions = ({
    logout: actions_logout,
    resetState: resetState,
    setFirstRun: setFirstRun,
    attemptLogin: actions_attemptLogin,
    resetFirstRun: resetFirstRun,
    updatePassword: actions_updatePassword,
    getUserProfile: actions_getUserProfile,
    handleFailedLogin: actions_handleFailedLogin,
    checkAuthentication: actions_checkAuthentication,
    handleSuccessfullLogin: actions_handleSuccessfullLogin
});
// CONCATENATED MODULE: ./src/state/modules/user/mutations.js
/**
 * Dependencies
 */



/**
 * Attempt the login process, set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var LOGIN = function LOGIN(state) {
  state.pending = true;
};

/**
 * Set the login states after a successful authentication
 *
 * @param  {Object} state
 * @return {Void}
 */
var LOGIN_SUCCESS = function LOGIN_SUCCESS(state) {
  state.isLoggedIn = true;
  state.pending = false;
};

/**
 * Set successful login state
 *
 * @param  {Object} state
 * @return {Void}
 */
var FINISHED = function FINISHED(state) {
  state.isLoggedIn = true;
};

/**
 * Handle the failed login attempt
 *
 * @param  {Object} state
 * @return {Void}
 */
var LOGIN_FAILURE = function LOGIN_FAILURE(state) {
  state.pending = false;
};

/**
 * Set the logged in status on successful log out
 *
 * @param  {Object} state
 * @return {Void}
 */
var LOGOUT = function LOGOUT(state) {
  state.isLoggedIn = false;
};

/**
 * Set up the user profile
 *
 * @param  {Object} state
 * @param  {Object} profile
 * @return {Void}
 */
var SET_USER_PROFILE = function SET_USER_PROFILE(state, profile) {
  state.profile.data = profile;
  state.profile.loaded = true;
  state.profile.pending = false;
};

/**
 * Set profile request state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_USER_PROFILE = function GET_USER_PROFILE(state) {
  state.profile.pending = true;
};

/**
 * Handle profile retrieval failure
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_USER_PROFILE_FAIL = function GET_USER_PROFILE_FAIL(state, err) {
  console.log(err);
  state.profile.pending = false;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_RESET_STATE = function RESET_STATE(state) {
  var originalState = user_state_getState();
  for (var prop in originalState) {
    vue_esm["a" /* default */].set(state, prop, originalState[prop]);
  }
};

/**
 * Set the first run state attribute
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_FIRST_RUN = function SET_FIRST_RUN(state) {
  state.first_run = true;
};

/**
 * Reset the first run state attribute
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_FIRST_RUN = function RESET_FIRST_RUN(state) {
  state.first_run = false;
};

/**
 * Export Mutations
 */
/* harmony default export */ var mutations = ({
  LOGIN: LOGIN,
  LOGOUT: LOGOUT,
  FINISHED: FINISHED,
  RESET_STATE: mutations_RESET_STATE,
  LOGIN_SUCCESS: LOGIN_SUCCESS,
  LOGIN_FAILURE: LOGIN_FAILURE,
  SET_FIRST_RUN: SET_FIRST_RUN,
  RESET_FIRST_RUN: RESET_FIRST_RUN,
  GET_USER_PROFILE: GET_USER_PROFILE,
  SET_USER_PROFILE: SET_USER_PROFILE,
  GET_USER_PROFILE_FAIL: GET_USER_PROFILE_FAIL
});
// CONCATENATED MODULE: ./src/state/modules/user/preferences/state.js
/**
 * Dependencies
 */


/**
 * User Preferences State
 *
 * @type {Object}
 */
var preferences_state_state = {
  data: {},
  options: {
    decimals: [0, 1, 2],
    monetaryUnits: ['dollars', 'thousands', 'millions']
  },
  selectedDecimalPreference: 2,
  selectedUnitPreference: 'dollars'

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var preferences_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(preferences_state_state);
};

/* harmony default export */ var preferences_state = (preferences_state_getState());
// CONCATENATED MODULE: ./src/state/modules/user/preferences/getters.js
/**
 * Dependencies
 */


/**
 * Get the selected KPIs from the state
 *
 * @param  {Object} state [description]
 * @return {Array}       [description]
 */
var getters_selectedKpis = function selectedKpis(state) {
  return Object(lodash["get"])(state.data, 'project_display_kpis.data', []).filter(function (item) {
    return item.selected;
  }).map(function (item) {
    return item.key;
  });
};

/* harmony default export */ var preferences_getters = ({
  selectedKpis: getters_selectedKpis
});
// CONCATENATED MODULE: ./src/services/UserService.js
/**
 * Dependencies
 */


/**
 * Update a user's preferences on the API
 *
 * @param  {Object} payload
 * @return {Promise}
 */
var UserService_sync = function sync(payload) {
  return HttpService["a" /* default */].put('auth/user-preferences/', payload);
};
// CONCATENATED MODULE: ./src/state/modules/user/preferences/actions.js


/**
 * Set the user preferences object
 *
 * @param  {Function} options.commit
 * @param  {Object} preferences
 * @return {Void}
 */
var setPreferences = function setPreferences(_ref, preferences) {
    var commit = _ref.commit;

    commit('SET_PREFERENCES', preferences);
};

/**
 * Update a user's preferences
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_syncPreferences = function syncPreferences(_ref2, payload) {
    var commit = _ref2.commit;

    UserService_sync(payload);
};

/**
 * Update the local pereference
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateUserPreference = function updateUserPreference(_ref3, payload) {
    var commit = _ref3.commit;

    commit('UPDATE_LOCAL_PREFERENCE', payload);
};

/**
 * Update the unit/decimal preference
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateCurrencyPreference = function updateCurrencyPreference(_ref4, payload) {
    var commit = _ref4.commit;

    commit('UPDATE_CURRENCY_PREFERENCE', payload);
};

/* harmony default export */ var preferences_actions = ({
    setPreferences: setPreferences,
    syncPreferences: actions_syncPreferences,
    updateUserPreference: updateUserPreference,
    updateCurrencyPreference: updateCurrencyPreference
});
// CONCATENATED MODULE: ./src/state/modules/user/preferences/mutations.js
/**
 * Dependencies
 */



/**
 * Apply the preferences state object
 *
 * @param  {Object} state
 * @param  {Object} preferences
 * @return {Void}
 */
var SET_PREFERENCES = function SET_PREFERENCES(state, preferences) {
    state.data = preferences;
};

/**
 * Update the state's selected prefernces
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_LOCAL_PREFERENCE = function UPDATE_LOCAL_PREFERENCE(state, payload) {
    var target = state.data[payload.parent].data.find(function (item) {
        return item.key === payload.key;
    });

    if (target) {
        target.selected = payload.selected;
    }
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var preferences_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = preferences_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Update the unit/decimal state objects
 *
 * @param  {Object} state
 * @return {Void}
 */
var UPDATE_CURRENCY_PREFERENCE = function UPDATE_CURRENCY_PREFERENCE(state, payload) {
    state[payload.type] = payload.value;

    if (payload.type === 'selectedUnitPreference' && payload.value !== 'dollars') {
        state['selectedDecimalPreference'] = 2;
    }
};

/* harmony default export */ var preferences_mutations = ({
    RESET_STATE: preferences_mutations_RESET_STATE,
    SET_PREFERENCES: SET_PREFERENCES,
    UPDATE_LOCAL_PREFERENCE: UPDATE_LOCAL_PREFERENCE,
    UPDATE_CURRENCY_PREFERENCE: UPDATE_CURRENCY_PREFERENCE
});
// CONCATENATED MODULE: ./src/state/modules/user/preferences/index.js
/**
 * Module Dependencies
 */





/**
 * User Preferences Module Declaration
 *
 * @type {Object}
 */
var preferences_module = {
  namespaced: true,
  state: preferences_state,
  getters: preferences_getters,
  mutations: preferences_mutations,
  actions: preferences_actions
};

/* harmony default export */ var preferences = (preferences_module);
// CONCATENATED MODULE: ./src/state/modules/user/subscription/state.js
/**
 * Dependencies
 */


/**
 * User Subscription State
 *
 * @type {Object}
 */
var subscription_state_state = {
  data: {},
  plans: [],
  planUpdateOptions: [],
  licenses: [],
  loadingPlans: false,
  preview: {
    loading: false,
    licenses: 0,
    error: false,
    data: {}
  }

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var subscription_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(subscription_state_state);
};

/* harmony default export */ var subscription_state = (subscription_state_getState());
// CONCATENATED MODULE: ./src/state/modules/user/subscription/getters.js
/**
 * Dependencies
 */


/**
 * Get the current user's plan ID
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_currentPlanId = function currentPlanId(state) {
    var plan = state.plans.find(function (plan) {
        return plan.name === Object(lodash["get"])(state.data, 'name', null);
    });

    return plan ? plan.id : null;
};

/**
 * Get the current plan billing period
 *
 * @param  {Object} state
 * @return {Number}
 */
var currentBillingPeriod = function currentBillingPeriod(state) {
    return state.data.name ? state.data.name.includes('Monthly') ? 0 : 1 : null;
};

/**
 * Determine if the plans have been loaded from the API
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var plansLoaded = function plansLoaded(state) {
    return state.plans.length > 0;
};

/**
 * Determine if there is a pending subscription
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasPendingSubscription = function hasPendingSubscription(state) {
    return state.data.pending_subscription !== null;
};

/**
 * Determine if the user has a basic plan
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasBasicPlan = function hasBasicPlan(state) {
    return state.data.name === 'Basic Monthly' || state.data.name === 'Basic Annually';
};

/**
 * Total licenses
 *
 * @return {Number}
 */
var totalLicenses = function totalLicenses(state) {
    return state.licenses.length;
};

/**
 * Total available licenses
 *
 * @param  {Object} state
 * @return {Number}
 */
var licenseCount = function licenseCount(state) {
    return state.licenses.reduce(function (result, item) {
        !item.user ? result.available++ : result.used++;
        return result;
    }, { available: 0, used: 0 });
};

/**
 * Determine whether the user has requested additional licenses
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var isRequestingAdditionalLicenses = function isRequestingAdditionalLicenses(state) {
    return state.preview.licenses > 0;
};

/* harmony default export */ var subscription_getters = ({
    plansLoaded: plansLoaded,
    licenseCount: licenseCount,
    hasBasicPlan: hasBasicPlan,
    currentPlanId: getters_currentPlanId,
    totalLicenses: totalLicenses,
    currentBillingPeriod: currentBillingPeriod,
    hasPendingSubscription: hasPendingSubscription,
    isRequestingAdditionalLicenses: isRequestingAdditionalLicenses
});
// CONCATENATED MODULE: ./src/state/modules/user/subscription/actions.js

/**
 * Dependencies
 */


/**
 * Set the user subscription object
 *
 * @param  {Function} options.commit
 * @param  {Object} subscription
 * @return {Void}
 */
var setSubscription = function setSubscription(_ref, subscription) {
    var commit = _ref.commit;

    commit('SET_SUBSCRIPTION', subscription);
};

/**
 * Get the available plans
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_getPlans = function getPlans(_ref2) {
    var commit = _ref2.commit;

    HttpService["a" /* default */].get('information/plans').then(function (res) {
        return commit('SET_PLANS', res.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Get the licenses associated with a subscription
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @return {Void}
 */
var actions_getLicenses = function getLicenses(_ref3) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;

    HttpService["a" /* default */].get('accounts/companies/' + rootState.company.data.id + '/licenses/').then(function (res) {
        return commit('SET_LICENSES', res.data.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Get the update options for a given user's plan
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @return {Promise}
 */
var actions_getPlanUpdateOptions = function getPlanUpdateOptions(_ref4) {
    var commit = _ref4.commit,
        rootState = _ref4.rootState;

    return HttpService["a" /* default */].get('accounts/companies/' + rootState.company.data.id + '/subscription-update').then(function (res) {
        return commit('SET_UPDATE_OPTIONS', res.data);
    }).catch(function (err) {
        return err.response;
    });
};

/**
 * Get the subscription details
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @return {Promise}
 */
var actions_getSubscriptionDetails = function getSubscriptionDetails(_ref5) {
    var commit = _ref5.commit,
        rootState = _ref5.rootState;

    return HttpService["a" /* default */].get('accounts/companies/' + rootState.company.data.id + '/subscription').then(function (res) {
        return commit('SET_SUBSCRIPTION', res.data);
    }).catch(function (err) {
        return err.response;
    });
};

/**
 * Update the payment method
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Function} options.dispatch
 * @param  {String} token
 * @return {Promise}
 */
var actions_updatePaymentMethod = function updatePaymentMethod(_ref6, token) {
    var commit = _ref6.commit,
        rootState = _ref6.rootState,
        dispatch = _ref6.dispatch;

    var url = 'accounts/companies/' + rootState.company.data.id + '/subscription/payment/';
    return new promise_default.a(function (resolve, reject) {
        return HttpService["a" /* default */].patch(url, { payment_token: token }).then(function (res) {
            dispatch('getSubscriptionDetails');
            return resolve(res);
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Update an existing subscription
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Object} plan
 * @return {Void}
 */
var actions_updateSubscription = function updateSubscription(_ref7, plan) {
    var commit = _ref7.commit,
        rootState = _ref7.rootState;

    var url = 'accounts/companies/' + rootState.company.data.id + '/subscription/';

    return HttpService["a" /* default */].patch(url, { lucro_plan: plan });
};

/**
 * Attempt to upgrade an account from a basic account
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Object} data
 * @return {Promise}
 */
var actions_upgradeSubscriptionFromBasic = function upgradeSubscriptionFromBasic(_ref8, data) {
    var commit = _ref8.commit,
        rootState = _ref8.rootState,
        dispatch = _ref8.dispatch;

    var url = 'accounts/companies/' + rootState.company.data.id + '/subscription/';
    return HttpService["a" /* default */].patch(url, data).then(function (res) {
        return commit('UPGRADE_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('UPGRADE_FAILURE', err);
    });
};

/**
 * Add new licenses to an existing subscription
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_addLicenses = function addLicenses(_ref9, emails) {
    var commit = _ref9.commit,
        rootState = _ref9.rootState,
        dispatch = _ref9.dispatch,
        state = _ref9.state;

    var url = 'accounts/companies/' + rootState.company.data.id + '/licenses/';
    return new promise_default.a(function (resolve, reject) {
        return HttpService["a" /* default */].post(url, {
            num_licenses: state.preview.licenses,
            emails: emails
        }).then(function (res) {
            dispatch('getSubscriptionDetails');
            dispatch('getLicenses');
            dispatch('getPlanUpdateOptions');
            return resolve(res);
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Remove an existing license
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_removeLicense = function removeLicense(_ref10, payload) {
    var commit = _ref10.commit,
        rootState = _ref10.rootState;

    var emails = payload.emails;
    var count = payload.license_count;
    var id = rootState.company.data.id;
    return HttpService["a" /* default */].del('accounts/companies/' + id + '/licenses/?num_licenses=' + count + '&emails=' + emails);
};

/**
 * Set the additional licenses the user wants to previes
 *
 * @param  {Number} value
 * @return {Void}
 */
var setAdditionalLicenses = function setAdditionalLicenses(_ref11, value) {
    var commit = _ref11.commit;
    return commit('UPDATE_PREVIEW_LICENSES', value);
};

/**
 * Get the preview data for the additional license request
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @return {Promise}
 */
var actions_getPreview = function getPreview(_ref12) {
    var commit = _ref12.commit,
        rootState = _ref12.rootState,
        state = _ref12.state;

    var url = 'accounts/companies/' + rootState.company.data.id + '/licenses/preview/?num_licenses=' + state.preview.licenses;
    commit('RESET_PREVIEW_ERROR');
    commit('SET_PREVIEW_LOADING');
    HttpService["a" /* default */].get(url).then(function (res) {
        return commit('SET_PREVIEW_DATA', res.data);
    }).catch(function () {
        return commit('SET_PREVIEW_ERROR');
    });
};

/**
 * Reset the preview state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var resetPreview = function resetPreview(_ref13) {
    var commit = _ref13.commit;
    return commit('RESET_PREVIEW_DATA');
};

/**
 * Make request to copy a project and start a free trial
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_startFreeTrial = function startFreeTrial(_ref14, payload) {
    var commit = _ref14.commit;

    var url = 'accounts/guest-user-signup/?project_id=' + payload.id;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post(url, payload.form).then(function (res) {
            resolve(res.data);
        }).catch(function (err) {
            reject(err);
        });
    });
};

/* harmony default export */ var subscription_actions = ({
    getPlans: actions_getPlans,
    getPreview: actions_getPreview,
    addLicenses: actions_addLicenses,
    getLicenses: actions_getLicenses,
    resetPreview: resetPreview,
    removeLicense: actions_removeLicense,
    startFreeTrial: actions_startFreeTrial,
    setSubscription: setSubscription,
    updateSubscription: actions_updateSubscription,
    updatePaymentMethod: actions_updatePaymentMethod,
    getPlanUpdateOptions: actions_getPlanUpdateOptions,
    setAdditionalLicenses: setAdditionalLicenses,
    getSubscriptionDetails: actions_getSubscriptionDetails,
    upgradeSubscriptionFromBasic: actions_upgradeSubscriptionFromBasic
});
// CONCATENATED MODULE: ./src/state/modules/user/subscription/mutations.js
/**
 * Dependencies
 */



/**
 * Apply the subscription state object
 *
 * @param  {Object} state
 * @param  {Object} subscription
 * @return {Promise}
 */
var SET_SUBSCRIPTION = function SET_SUBSCRIPTION(state, subscription) {
  state.data = subscription;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var subscription_mutations_RESET_STATE = function RESET_STATE(state) {
  var originalState = subscription_state_getState();
  for (var prop in originalState) {
    vue_esm["a" /* default */].set(state, prop, originalState[prop]);
  }
};

/**
 * Set the licenses on the state object
 *
 * @param  {Object} state
 * @param  {Array} licenses
 * @return {Promise}
 */
var SET_LICENSES = function SET_LICENSES(state, licenses) {
  state.licenses = licenses;
};

/**
 * Set the available plans on the state object
 *
 * @param  {Object} state
 * @param  {Array} plans
 * @return {Promise}
 */
var SET_PLANS = function SET_PLANS(state, plans) {
  state.plans = plans;
};

/**
 * Set the upgrade options on the state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var SET_UPDATE_OPTIONS = function SET_UPDATE_OPTIONS(state, plans) {
  state.planUpdateOptions = plans;
};

/**
 * Successful upgrade
 *
 * @param  {Object} state
 * @param  {Object} data
 * @return {Promise}
 */
var UPGRADE_SUCCESS = function UPGRADE_SUCCESS(state, data) {};

/**
 * Failed upgrade
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Promise}
 */
var UPGRADE_FAILURE = function UPGRADE_FAILURE(state, err) {
  console.log(err);
};

/**
 * Change the license preview total
 *
 * @param  {Object} state
 * @param  {Number} total
 * @return {Promise}
 */
var UPDATE_PREVIEW_LICENSES = function UPDATE_PREVIEW_LICENSES(state, total) {
  state.preview.licenses = total;
};

/**
 * Set the license update preview data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var SET_PREVIEW_DATA = function SET_PREVIEW_DATA(state, payload) {
  state.preview.data = payload;
  state.preview.loading = false;
};

/**
 * Set the additional licenses preview loading state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var SET_PREVIEW_LOADING = function SET_PREVIEW_LOADING(state) {
  state.preview.loading = true;
};

/**
 * Reset the preview data to its original state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var RESET_PREVIEW_DATA = function RESET_PREVIEW_DATA(state) {
  state.preview.licenses = 0;
  state.preview.data = {};
  state.preview.error = false;
  state.preview.loading = false;
};

/**
 * Set the license preview error state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var SET_PREVIEW_ERROR = function SET_PREVIEW_ERROR(state) {
  state.preview.error = true;
  state.preview.loading = false;
};

/**
 * Reset the license preview error state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var RESET_PREVIEW_ERROR = function RESET_PREVIEW_ERROR(state) {
  state.preview.error = false;
};

/* harmony default export */ var subscription_mutations = ({
  SET_PLANS: SET_PLANS,
  RESET_STATE: subscription_mutations_RESET_STATE,
  SET_LICENSES: SET_LICENSES,
  UPGRADE_SUCCESS: UPGRADE_SUCCESS,
  UPGRADE_FAILURE: UPGRADE_FAILURE,
  SET_PREVIEW_DATA: SET_PREVIEW_DATA,
  SET_SUBSCRIPTION: SET_SUBSCRIPTION,
  SET_PREVIEW_ERROR: SET_PREVIEW_ERROR,
  RESET_PREVIEW_DATA: RESET_PREVIEW_DATA,
  SET_UPDATE_OPTIONS: SET_UPDATE_OPTIONS,
  SET_PREVIEW_LOADING: SET_PREVIEW_LOADING,
  RESET_PREVIEW_ERROR: RESET_PREVIEW_ERROR,
  UPDATE_PREVIEW_LICENSES: UPDATE_PREVIEW_LICENSES
});
// CONCATENATED MODULE: ./src/state/modules/user/subscription/index.js
/**
 * Module Dependencies
 */





/**
 * User Subscription Module Declaration
 *
 * @type {Object}
 */
var subscription_module = {
  namespaced: true,
  state: subscription_state,
  getters: subscription_getters,
  mutations: subscription_mutations,
  actions: subscription_actions
};

/* harmony default export */ var subscription = (subscription_module);
// CONCATENATED MODULE: ./src/state/modules/user/index.js
/**
 * Module Dependencies
 */







/**
 * User Module Declaration
 *
 * @type {Object}
 */
var user_module = {
    namespaced: true,
    state: user_state,
    getters: user_getters,
    mutations: mutations,
    actions: user_actions,
    modules: {
        preferences: preferences,
        subscription: subscription
    }
};

/* harmony default export */ var user = (user_module);
// CONCATENATED MODULE: ./src/state/mutations.js
/**
 * Dependencies
 */



/**
 * Trigger a given notification
 *
 * @param  {Object} state
 * @return {Void}
 */
var ADD_NOTIFICATION = function ADD_NOTIFICATION(state, notification) {
    state.notifications.unshift(notification);
};

/**
 * Remove a given notification
 *
 * @param  {Object} state
 * @return {Void}
 */
var REMOVE_NOTIFICATION = function REMOVE_NOTIFICATION(state, notification) {
    state.notifications.splice(state.notifications.indexOf(notification), 1);
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var state_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/* harmony default export */ var state_mutations = ({
    RESET_STATE: state_mutations_RESET_STATE,
    ADD_NOTIFICATION: ADD_NOTIFICATION,
    REMOVE_NOTIFICATION: REMOVE_NOTIFICATION
});
// CONCATENATED MODULE: ./src/state/modules/shared/state.js
/**
 * Dependencies
 */


var shared_state_state = {
  success: false,
  error: null,
  loading: false,
  key: null,
  accepted_ca: false,
  conf_agreement: null,
  email: null,
  pin: null

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var shared_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(shared_state_state);
};

/* harmony default export */ var shared_state = (shared_state_getState());
// CONCATENATED MODULE: ./src/state/modules/shared/actions.js

/**
 * Dependencies
 */


/**
 * Check to verify if a given key is valid for a shared project link
 *
 * @return {Promise}
 */
var actions_checkSharedProjectKey = function checkSharedProjectKey(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    var key = rootState.route.params.projectKey;
    commit('KEY_VALIDATION_LOADING');
    return HttpService["a" /* default */].get('auth/' + key + '/').then(function (res) {
        commit('KEY_VALIDATION_SUCCESS', res.data);
        return promise_default.a.resolve(res.data);
    }).catch(function (err) {
        commit('KEY_VALIDATION_FAILURE');
        return promise_default.a.reject(err);
    });
};

/**
 * Attempt to validate a PIN
 *
 * @param  {Object} options.rootState
 * @param  {Object} form
 * @return {Promise}
 */
var actions_accessProject = function accessProject(_ref2) {
    var rootState = _ref2.rootState;
    var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return HttpService["a" /* default */].post('auth/' + rootState.route.params.projectKey + '/', form);
};

/* harmony default export */ var shared_actions = ({
    accessProject: actions_accessProject,
    checkSharedProjectKey: actions_checkSharedProjectKey
});
// EXTERNAL MODULE: ./src/state/modules/shared/getters.js
var shared_getters = __webpack_require__("+agw");
var getters_default = /*#__PURE__*/__webpack_require__.n(shared_getters);

// CONCATENATED MODULE: ./src/state/modules/shared/mutations.js
/**
 * Begin the key validation check
 *
 * @param  {Object} state
 * @return {Void}
 */
var KEY_VALIDATION_LOADING = function KEY_VALIDATION_LOADING(state) {
    state.loading = true;
};

/**
 * Handle the key validation success state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var KEY_VALIDATION_SUCCESS = function KEY_VALIDATION_SUCCESS(state, payload) {
    state.conf_agreement = payload.conf_agreement;
    state.loading = false;
    state.success = true;
};

/**
 * Handle the key validation failure
 *
 * @param  {Object} state
 * @return {Void}
 */
var KEY_VALIDATION_FAILURE = function KEY_VALIDATION_FAILURE(state) {
    state.error = 'There was a problem with your request. Please try again.';
    state.loading = false;
};

/* harmony default export */ var shared_mutations = ({
    KEY_VALIDATION_LOADING: KEY_VALIDATION_LOADING,
    KEY_VALIDATION_SUCCESS: KEY_VALIDATION_SUCCESS,
    KEY_VALIDATION_FAILURE: KEY_VALIDATION_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/shared/index.js
/**
 * Module Dependencies
 */





/**
 * Portfolio Module Declaration
 *
 * @type {Object}
 */
var shared_module = {
  state: shared_state,
  getters: getters_default.a,
  actions: shared_actions,
  mutations: shared_mutations,
  namespaced: true
};

/* harmony default export */ var shared = (shared_module);
// CONCATENATED MODULE: ./src/state/modules/profile/state.js
/**
 * Dependencies
 */


/**
 * War Room State
 *
 * @type {Object}
 */
var profile_state_state = {
  loading: false,
  error: {},
  message: null,
  data: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var profile_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(profile_state_state);
};

/* harmony default export */ var profile_state = (profile_state_getState());
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// CONCATENATED MODULE: ./src/state/modules/profile/getters.js

/**
 * Transform the errors to string messages
 *
 * @param  {Object} state
 * @return {Object}
 */
var getters_errors = function errors(state) {
    return keys_default()(state.error).reduce(function (result, i) {
        result[i] = state.error[i].join(', ');
        return result;
    }, {});
};

/* harmony default export */ var profile_getters = ({
    errors: getters_errors
});
// CONCATENATED MODULE: ./src/state/modules/profile/actions.js

/**
 * Dependencies
 */


/**
 * Profile URL
 *
 * @type {String}
 */
var PROFILE_URL = 'auth/user-info/';

/**
 * Get the user profile
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_getProfile = function getProfile(_ref) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
        commit('SET_LOADING');
        HttpService["a" /* default */].get(PROFILE_URL).then(function (res) {
            commit('SET_PROFILE_SUCCESS', res.data);
            commit('RESET_LOADING');
            resolve(res.data);
        }).catch(function (err) {
            commit('SET_PROFILE_FAILURE', err.response.data);
            reject(err);
        });
    });
};

/**
 * Update the user profile
 *
 * @param  {Function} options.commit
 * @param  {Object} profile
 * @return {Void}
 */
var actions_updateProfile = function updateProfile(_ref2, profile) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit('SET_LOADING');
    HttpService["a" /* default */].patch(PROFILE_URL, profile).then(function (res) {
        commit('SET_MESSAGE', res.data.message);
        commit('SET_PROFILE_SUCCESS', profile);
        dispatch('user/getUserProfile', null, { root: true });
        commit('RESET_LOADING');
    }).catch(function (err) {
        commit('SET_PROFILE_FAILURE', err.response.data.message);
        commit('RESET_LOADING');
    });
};

/**
 * Reset message
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var resetMessage = function resetMessage(_ref3) {
    var commit = _ref3.commit;
    return commit('RESET_MESSAGE');
};

/* harmony default export */ var profile_actions = ({
    getProfile: actions_getProfile,
    resetMessage: resetMessage,
    updateProfile: actions_updateProfile
});
// CONCATENATED MODULE: ./src/state/modules/profile/mutations.js
var SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
    state.error = {};
};

var RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

var SET_PROFILE_SUCCESS = function SET_PROFILE_SUCCESS(state, payload) {
    state.data = payload;
};

var SET_PROFILE_FAILURE = function SET_PROFILE_FAILURE(state, error) {
    state.error = error;
};

var SET_MESSAGE = function SET_MESSAGE(state, message) {
    state.message = message;
};

var RESET_MESSAGE = function RESET_MESSAGE(state) {
    state.message = null;
};

/* harmony default export */ var profile_mutations = ({
    SET_MESSAGE: SET_MESSAGE,
    SET_LOADING: SET_LOADING,
    RESET_LOADING: RESET_LOADING,
    RESET_MESSAGE: RESET_MESSAGE,
    SET_PROFILE_SUCCESS: SET_PROFILE_SUCCESS,
    SET_PROFILE_FAILURE: SET_PROFILE_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/profile/index.js
/**
 * Module Dependencies
 */





/**
 * War Room Module Declaration
 *
 * @type {Object}
 */
var profile_module = {
  namespaced: true,
  state: profile_state,
  getters: profile_getters,
  mutations: profile_mutations,
  actions: profile_actions
};

/* harmony default export */ var modules_profile = (profile_module);
// CONCATENATED MODULE: ./src/state/modules/company/state.js
/**
 * Dependencies
 */


/**
 * State Definition
 *
 * @type {Object}
 */
var company_state_state = {
    data: {},
    users: [],
    outbound_invitations: {
        data: [],
        meta: {}
    },
    inbound_invitations: {
        data: [],
        meta: {}
    }

    /**
     * Return a state copy
     *
     * @return {Object}
     */
};var company_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(company_state_state);
};

/* harmony default export */ var company_state = (company_state_getState());
// EXTERNAL MODULE: ./src/services/CompanyService.js
var CompanyService = __webpack_require__("B9gh");

// CONCATENATED MODULE: ./src/state/modules/company/actions.js

/**
 * Dependencies
 */



/**
 * Set the company data state object
 *
 * @param  {Function} options.commit
 * @param  {Object} company
 * @return {Void}
 */
var setCompanyData = function setCompanyData(_ref, company) {
    var commit = _ref.commit;

    commit('SET_COMPANY_DATA', company);
};

/**
 * Set the company's user list
 *
 * @param  {Function} options.commit
 * @param  {Array} users
 * @return {Void}
 */
var setCompanyUsers = function setCompanyUsers(_ref2, users) {
    var commit = _ref2.commit;

    commit('SET_COMPANY_USERS', users);
};

/**
 * Retrieve a list of company users
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_getCompanyUsers = function getCompanyUsers(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    return Object(CompanyService["a" /* getUsers */])(state.data.id).then(function (res) {
        return commit('SET_COMPANY_USERS_SUCCESS', res.data.data);
    }).catch(function (err) {
        return commit('SET_COMPANY_USERS_FAILURE', err);
    });
};

/**
 * Update a user's privilege status for a company
 *
 * @param  {Function} options.commit
 * @param  {Object} user
 * @return {Void}
 */
var actions_updateUserDetails = function updateUserDetails(_ref4, payload) {
    var commit = _ref4.commit;

    Object(CompanyService["b" /* updateUserAdminStatus */])(payload.company, payload.user, payload.privilege);
};

/**
 * Remove a single user from a given company
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_removeCompanyUser = function removeCompanyUser(_ref5, id) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;

    return HttpService["a" /* default */].del('auth/companies/' + state.data.id + '/users/' + id + '/').then(function (res) {
        return commit('REMOVE_COMPANY_USER_SUCCESS', res);
    }).then(function () {
        return dispatch('getCompanyUsers');
    }).then(function () {
        return dispatch('addNotification', {
            title: 'User Removed from Company',
            type: 'success',
            text: 'The user was successfully removed',
            timeout: true
        }, { root: true });
    }).catch(function (err) {
        return commit('REMVE_COMPANY_USER_FAILURE', err);
    });
};

/**
 * Update company data
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_updateCompanyInformation = function updateCompanyInformation(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        state = _ref6.state;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].patch('auth/companies/' + state.data.id + '/', payload).then(function (res) {
            commit('UPDATE_COMPANY_INFO_SUCCESS', res.data.data);
            dispatch('addNotification', {
                title: 'Company Successfully Updated',
                type: 'success',
                text: res.data.message,
                timeout: true
            }, { root: true });
            resolve(res);
        }).catch(function (err) {
            commit('UPDATE_COMPANY_INFO_FAILURE', err);
            dispatch('addNotification', {
                title: 'Company failed to update',
                type: 'error',
                text: 'Your company information was not saved.',
                timeout: true
            }, { root: true });
            reject(err);
        });
    });
};

/**
 * Get the outbound invitation data
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_getOutboundInvitations = function getOutboundInvitations(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state;

    HttpService["a" /* default */].get('auth/companies/' + state.data.id + '/company-user-invitations/').then(function (res) {
        return commit('OUTBOUND_INVITES_SUCCESS', res.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Get the inbound invitation data
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_getInboundInvitations = function getInboundInvitations(_ref8) {
    var commit = _ref8.commit;

    HttpService["a" /* default */].get('auth/company-invitations/').then(function (res) {
        return commit('INBOUND_INVITES_SUCCESS', res.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Handle inbound invite acceptance
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_acceptInboundCompanyInvitation = function acceptInboundCompanyInvitation(_ref9, id) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    HttpService["a" /* default */].put('auth/company-invitations/' + id + '/').then(function () {
        return dispatch('addNotification', {
            title: 'Success',
            type: 'success',
            text: 'You have successfully accepted the company\'s invitation.',
            timeout: true
        }, { root: true });
    }).then(function () {
        return dispatch('getInboundInvitations');
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Handle inbound invite rejection
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_rejectInboundCompanyInvitation = function rejectInboundCompanyInvitation(_ref10, id) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    HttpService["a" /* default */].del('auth/company-invitations/' + id + '/').then(function () {
        return dispatch('getInboundInvitations');
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Invite users to company by an array of emails
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Array} emails
 * @return {Promise}
 */
var actions_inviteUsersToCompany = function inviteUsersToCompany(_ref11, emails) {
    var commit = _ref11.commit,
        state = _ref11.state,
        dispatch = _ref11.dispatch;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].patch('auth/companies/' + state.data.id + '/users/?action=add', { emails: emails }).then(function (res) {
            dispatch('getOutboundInvitations');
            resolve(res.data.message[0]);
        }).catch(function (err) {
            reject(err);
        });
    });
};

/**
 * Remove an outbound company invitation
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Void}
 */
var actions_removeOutboundInvitation = function removeOutboundInvitation(_ref12, id) {
    var commit = _ref12.commit,
        state = _ref12.state,
        dispatch = _ref12.dispatch;

    HttpService["a" /* default */].del('auth/companies/' + state.data.id + '/invitations/' + id + '/').then(function () {
        return dispatch('getOutboundInvitations');
    }).then(function () {
        return dispatch('addNotification', {
            title: 'Success',
            type: 'success',
            text: 'Invitation successfully revoked.',
            timeout: true
        }, { root: true });
    }).catch(function (err) {
        return dispatch('addNotification', {
            title: 'Error',
            type: 'error',
            text: err.response.data.message,
            timeout: true
        }, { root: true });
    });
};

/**
 * Update the email of an existing outbound invitation
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_updateOutboundInvitation = function updateOutboundInvitation(_ref13, payload) {
    var commit = _ref13.commit,
        state = _ref13.state;

    return HttpService["a" /* default */].patch('auth/companies/' + state.data.id + '/invitations/' + payload.id + '/', {
        email: payload.email
    });
};

/**
 * Update the invite state with the new email address
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_modifyOutboundInviteState = function modifyOutboundInviteState(_ref14, payload) {
    var commit = _ref14.commit;

    return new promise_default.a(function (resolve, reject) {
        commit('UPDATE_INVITE_EMAIL', payload);
        resolve();
    });
};

/**
 * Set the branding for a company
 *
 * @param  {Function} options.commit
 * @param  {FormData} data
 * @return {Promise}
 */
var actions_setBranding = function setBranding(_ref15, data) {
    var commit = _ref15.commit,
        state = _ref15.state;
    return new promise_default.a(function (resolve, reject) {
        return HttpService["a" /* default */].post('auth/companies/' + state.data.id + '/branding/', data);
    });
};

/* harmony default export */ var company_actions = ({
    setBranding: actions_setBranding,
    getCompanyUsers: actions_getCompanyUsers,
    setCompanyUsers: setCompanyUsers,
    updateUserDetails: actions_updateUserDetails,
    removeCompanyUser: actions_removeCompanyUser,
    setCompanyData: setCompanyData,
    inviteUsersToCompany: actions_inviteUsersToCompany,
    getInboundInvitations: actions_getInboundInvitations,
    getOutboundInvitations: actions_getOutboundInvitations,
    updateCompanyInformation: actions_updateCompanyInformation,
    removeOutboundInvitation: actions_removeOutboundInvitation,
    updateOutboundInvitation: actions_updateOutboundInvitation,
    modifyOutboundInviteState: actions_modifyOutboundInviteState,
    acceptInboundCompanyInvitation: actions_acceptInboundCompanyInvitation,
    rejectInboundCompanyInvitation: actions_rejectInboundCompanyInvitation
});
// CONCATENATED MODULE: ./src/state/modules/company/getters.js
/**
 * Determine whether company users exist
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasCompanyUsers = function hasCompanyUsers(state) {
  return state.users.length > 0;
};

/**
 * Return a boolean to determine if user has inbound company invites
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasInboundInvitations = function hasInboundInvitations(state) {
  return state.inbound_invitations.data.length > 0;
};

/**
 * Return whether or not the outbound invitation list is empty
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasOutboundInvitations = function hasOutboundInvitations(state) {
  return state.outbound_invitations.data.length > 0;
};

/* harmony default export */ var company_getters = ({
  hasCompanyUsers: hasCompanyUsers,
  hasInboundInvitations: hasInboundInvitations,
  hasOutboundInvitations: hasOutboundInvitations
});
// CONCATENATED MODULE: ./src/state/modules/company/mutations.js
/**
 * Dependencies
 */



/**
 * Set the company state
 *
 * @param  {Object} state
 * @param  {Object} company
 * @return {Void}
 */
var SET_COMPANY_DATA = function SET_COMPANY_DATA(state, company) {
    state.data = company;
};

/**
 * Set the company's users state
 *
 * @param  {Object} state
 * @param  {Array} users
 * @return {Void}
 */
var SET_COMPANY_USERS_SUCCESS = function SET_COMPANY_USERS_SUCCESS(state, users) {
    state.users = users;
};

/**
 * Handle a failed company user request
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_COMPANY_USERS_FAILURE = function SET_COMPANY_USERS_FAILURE(state) {
    state.users = [];
};

/**
 * Remove a user from the company user's state array
 *
 * @param  {Object} state
 * @return {Void}
 */
var REMOVE_COMPANY_USER_SUCCESS = function REMOVE_COMPANY_USER_SUCCESS(state) {};

/**
 * Handle failed user deletion request
 *
 * @param  {Object} state
 * @return {Void}
 */
var REMOVE_COMPANY_USER_FAILURE = function REMOVE_COMPANY_USER_FAILURE(state, err) {
    console.log(err);
};

/**
 * Set the company info request state
 *
 * @param  {Object} state
 * @param  {Object} result
 * @return {Void}
 */
var UPDATE_COMPANY_INFO = function UPDATE_COMPANY_INFO(state, result) {};

/**
 * Handle company update success
 *
 * @param  {Object} state
 * @param  {Object} result
 * @return {Void}
 */
var UPDATE_COMPANY_INFO_SUCCESS = function UPDATE_COMPANY_INFO_SUCCESS(state, company) {
    state.data = company;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var company_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = company_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Handle failed request to update company data
 *
 * @param  {Object} state
 * @param  {Object} result
 * @return {Void}
 */
var UPDATE_COMPANY_INFO_FAILURE = function UPDATE_COMPANY_INFO_FAILURE(state, error) {};

/**
 * Set the inbound invitations state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var INBOUND_INVITES_SUCCESS = function INBOUND_INVITES_SUCCESS(state, payload) {
    if (payload.data) {
        state.inbound_invitations = payload;
    } else {
        state.inbound_invitations.data = payload;
    }
};

/**
 * Handle oubtound invite success response
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var OUTBOUND_INVITES_SUCCESS = function OUTBOUND_INVITES_SUCCESS(state, payload) {
    if (payload.data) {
        state.outbound_invitations = payload;
    } else {
        state.outbound_invitations.data = payload;
    }
};

/**
 * Update an existing invite record in the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_INVITE_EMAIL = function UPDATE_INVITE_EMAIL(state, payload) {
    var inv = state.outbound_invitations.data.find(function (invite) {
        return invite.id === payload.id;
    });
    inv.invitee_email = payload.email;
};

/* harmony default export */ var company_mutations = ({
    RESET_STATE: company_mutations_RESET_STATE,
    SET_COMPANY_DATA: SET_COMPANY_DATA,
    SET_COMPANY_USERS_SUCCESS: SET_COMPANY_USERS_SUCCESS,
    SET_COMPANY_USERS_FAILURE: SET_COMPANY_USERS_FAILURE,
    REMOVE_COMPANY_USER_SUCCESS: REMOVE_COMPANY_USER_SUCCESS,
    REMOVE_COMPANY_USER_FAILURE: REMOVE_COMPANY_USER_FAILURE,
    UPDATE_COMPANY_INFO: UPDATE_COMPANY_INFO,
    UPDATE_COMPANY_INFO_SUCCESS: UPDATE_COMPANY_INFO_SUCCESS,
    UPDATE_COMPANY_INFO_FAILURE: UPDATE_COMPANY_INFO_FAILURE,
    INBOUND_INVITES_SUCCESS: INBOUND_INVITES_SUCCESS,
    OUTBOUND_INVITES_SUCCESS: OUTBOUND_INVITES_SUCCESS,
    UPDATE_INVITE_EMAIL: UPDATE_INVITE_EMAIL
});
// CONCATENATED MODULE: ./src/state/modules/company/index.js
/**
 * Module Dependencies
 */





/**
 * Company Module Declaration
 *
 * @type {Object}
 */
var company_module = {
  namespaced: true,
  state: company_state,
  actions: company_actions,
  getters: company_getters,
  mutations: company_mutations
};

/* harmony default export */ var company = (company_module);
// CONCATENATED MODULE: ./src/state/modules/war-room/state.js
/**
 * Dependencies
 */


/**
 * War Room State
 *
 * @type {Object}
 */
var war_room_state_state = {
  pending: false,
  data: {
    files: []
  },
  selected: []

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var war_room_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(war_room_state_state);
};

/* harmony default export */ var war_room_state = (war_room_state_getState());
// CONCATENATED MODULE: ./src/state/modules/war-room/getters.js
/**
 * Dependencies
 */


/**
 * Determine if the war room has files
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasFiles = function hasFiles(state) {
  return state.data.files.length > 0;
};

/**
 * Check if all files are selected
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_allFilesChecked = function allFilesChecked(state) {
  var selected = state.selected.sort();
  var files = state.data.files.map(function (file) {
    return file.id;
  }).sort();

  return Object(lodash["isEqual"])(selected, files);
};

/**
 * Check if the selected queue is empty
 *
 * @param  {Object} state [description]
 * @return {Boolean}       [description]
 */
var getters_noFilesSelected = function noFilesSelected(state) {
  return Object(lodash["isEmpty"])(state.selected);
};

/* harmony default export */ var war_room_getters = ({
  hasFiles: hasFiles,
  noFilesSelected: getters_noFilesSelected,
  allFilesChecked: getters_allFilesChecked
});
// EXTERNAL MODULE: ./src/services/WarRoomService.js
var WarRoomService = __webpack_require__("EyoL");

// CONCATENATED MODULE: ./src/state/modules/war-room/actions.js

/**
 * Dependencies
 */


/**
 * Retrieve a war room by ID
 *
 * @param  {Number} id
 * @return {Promise}
 */
var actions_getWarRoomById = function getWarRoomById(_ref, id) {
    var commit = _ref.commit;

    commit('SET_PENDING');
    return Object(WarRoomService["e" /* getWarRoom */])(id).then(function (res) {
        commit('GET_WAR_ROOM_SUCCESS', res.data);
        return promise_default.a.resolve(res.data);
    }).catch(function (err) {
        commit('GET_WAR_ROOM_FAILURE', err);
        return promise_default.a.reject(err);
    });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_resetState = function resetState(_ref2) {
    var commit = _ref2.commit;

    commit('RESET_STATE');
};

/**
 * [description]
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
var fileAddedToQueue = function fileAddedToQueue(_ref3, payload) {
    var commit = _ref3.commit;

    commit('QUEUE_FILE', payload);
};

/**
 * [description]
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
var uploadProgress = function uploadProgress(_ref4, payload) {
    var commit = _ref4.commit;

    console.log('upload progress', payload);
};

/**
 * [description]
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
var fileCompleted = function fileCompleted(_ref5, payload) {
    var commit = _ref5.commit;

    console.log('file completed', payload);
};

/**
 * [description]
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
var totalUploadProgress = function totalUploadProgress(_ref6, payload) {
    var commit = _ref6.commit;

    console.log('total upload progress', payload);
};

/**
 * All done notification
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
var notifyAllCompleted = function notifyAllCompleted(_ref7) {
    var commit = _ref7.commit;

    console.log('all completed');
};

/**
 * Add a file to the wor room
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
var addFileToWarRoom = function addFileToWarRoom(_ref8, file) {
    var commit = _ref8.commit;

    commit('ADD_FILE', file);
};

/**
 * Remove a single file from a war room
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Number} fileId
 * @return {Promise}
 */
var actions_deleteSingleFile = function deleteSingleFile(_ref9, fileId) {
    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;

    return Object(WarRoomService["a" /* deleteFile */])(state.data.id, fileId).then(function (res) {
        commit('FILE_DELETED_SUCCESS', fileId);
        dispatch('addNotification', {
            title: 'File successfully deleted',
            type: 'success',
            text: 'The file was successfully removed from the war room.',
            timeout: true
        }, { root: true });
        return promise_default.a.resolve(res.data);
    }).catch(function (err) {
        dispatch('addNotification', {
            title: 'File not deleted',
            type: 'error',
            text: 'There was a problem deleting your file. Please try again.',
            timeout: true
        }, { root: true });
        return promise_default.a.resolve(err);
    });
};

/**
 * Select a file
 *
 * @param  {Function} options.commit
 * @param  {Number} file.id
 * @return {Void}
 */
var selectFile = function selectFile(_ref10, id) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var idx = state.selected.indexOf(id);
    idx > -1 ? commit('DESELECT_FILE', idx) : commit('SELECT_FILE', id);
};

/**
 * Select all files
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
var selectAllFiles = function selectAllFiles(_ref11, checked) {
    var commit = _ref11.commit,
        state = _ref11.state;

    checked ? commit('SELECT_ALL_FILES') : commit('DESELECT_ALL_FILES');
};

/**
 * Delete multiple files
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Promise}
 */
var actions_deleteSelectedFiles = function deleteSelectedFiles(_ref12) {
    var commit = _ref12.commit,
        state = _ref12.state,
        dispatch = _ref12.dispatch;

    return Object(WarRoomService["b" /* deleteMultipleFiles */])(state.data.id, state.selected.join(',')).then(function () {
        commit('REMOVE_MULTIPLE_FILES');
        commit('DESELECT_ALL_FILES');
        dispatch('addNotification', {
            title: 'Files Removed',
            type: 'success',
            text: 'The selected files were removed from the war room.',
            timeout: true
        }, { root: true });
        return promise_default.a.resolve();
    }).catch(function (err) {
        return promise_default.a.reject(err);
    });
};

/**
 * Replace a war room file object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_replaceFileObject = function replaceFileObject(_ref13, payload) {
    var commit = _ref13.commit;

    return new promise_default.a(function (resolve, reject) {
        commit('REPLACE_FILE', payload);
        resolve(payload);
    });
};

/**
 * Retrieve a file by ID
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var actions_getFileById = function getFileById(_ref14, id) {
    var commit = _ref14.commit,
        state = _ref14.state;

    return Object(WarRoomService["d" /* getFile */])(state.data.id, id);
};

/* harmony default export */ var war_room_actions = ({
    selectFile: selectFile,
    resetState: actions_resetState,
    getFileById: actions_getFileById,
    fileCompleted: fileCompleted,
    selectAllFiles: selectAllFiles,
    getWarRoomById: actions_getWarRoomById,
    uploadProgress: uploadProgress,
    addFileToWarRoom: addFileToWarRoom,
    deleteSingleFile: actions_deleteSingleFile,
    fileAddedToQueue: fileAddedToQueue,
    replaceFileObject: actions_replaceFileObject,
    notifyAllCompleted: notifyAllCompleted,
    totalUploadProgress: totalUploadProgress,
    deleteSelectedFiles: actions_deleteSelectedFiles
});
// CONCATENATED MODULE: ./src/state/modules/war-room/mutations.js
/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_PENDING = function SET_PENDING(state) {
    state.pending = true;
};

/**
 * Handle the successful GET request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_WAR_ROOM_SUCCESS = function GET_WAR_ROOM_SUCCESS(state, payload) {
    state.data = payload;
    state.pending = false;
};

/**
 * Handle the failed GET request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_WAR_ROOM_FAILURE = function GET_WAR_ROOM_FAILURE(state, error) {
    state.data = {};
    state.pending = false;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var war_room_mutations_RESET_STATE = function RESET_STATE(state) {
    state.data = {
        files: []
    };
    state.pending = false;
};

/**
 * Handle successful DELETE request to a file
 *
 * @param  {[type]} state
 * @return {[type]}
 */
var FILE_DELETED_SUCCESS = function FILE_DELETED_SUCCESS(state, id) {
    state.data.files.splice(state.data.files.findIndex(function (item) {
        return item.id === id;
    }), 1);
};

/**
 * Add a file to the files array
 *
 * @param  {Object} state
 * @param  {Object} file
 * @return {Void}
 */
var ADD_FILE = function ADD_FILE(state, file) {
    state.data.files.push(file);
};

/**
 * Add file to selected state object
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Void}
 */
var SELECT_FILE = function SELECT_FILE(state, id) {
    state.selected.push(id);
};

/**
 * Remove file from selected state object
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Void}
 */
var DESELECT_FILE = function DESELECT_FILE(state, index) {
    state.selected.splice(index, 1);
};

/**
 * Select all files
 *
 * @param  {Object} state
 * @return {Void}
 */
var SELECT_ALL_FILES = function SELECT_ALL_FILES(state) {
    state.selected = state.data.files.map(function (file) {
        return file.id;
    });
};

/**
 * Deselect all files
 *
 * @param  {Object} state
 * @return {Void}
 */
var DESELECT_ALL_FILES = function DESELECT_ALL_FILES(state) {
    state.selected = [];
};

/**
 * Remove multiple files from the war room
 *
 * @param  {Object} state
 * @return {Void}
 */
var REMOVE_MULTIPLE_FILES = function REMOVE_MULTIPLE_FILES(state) {
    state.data.files = state.data.files.filter(function (file) {
        return !state.selected.includes(file.id);
    });
};

/**
 * Replace a file in the war room
 *
 * @param  {Object} state
 * @return {[type]}
 */
var REPLACE_FILE = function REPLACE_FILE(state, payload) {
    var idx = state.data.files.findIndex(function (file) {
        return file.id === payload.id;
    });

    state.data.files.splice(idx, 1, payload);
};

/* harmony default export */ var war_room_mutations = ({
    ADD_FILE: ADD_FILE,
    RESET_STATE: war_room_mutations_RESET_STATE,
    SET_PENDING: SET_PENDING,
    SELECT_FILE: SELECT_FILE,
    REPLACE_FILE: REPLACE_FILE,
    DESELECT_FILE: DESELECT_FILE,
    SELECT_ALL_FILES: SELECT_ALL_FILES,
    DESELECT_ALL_FILES: DESELECT_ALL_FILES,
    FILE_DELETED_SUCCESS: FILE_DELETED_SUCCESS,
    GET_WAR_ROOM_SUCCESS: GET_WAR_ROOM_SUCCESS,
    GET_WAR_ROOM_FAILURE: GET_WAR_ROOM_FAILURE,
    REMOVE_MULTIPLE_FILES: REMOVE_MULTIPLE_FILES
});
// CONCATENATED MODULE: ./src/state/modules/war-room/index.js
/**
 * Module Dependencies
 */





/**
 * War Room Module Declaration
 *
 * @type {Object}
 */
var war_room_module = {
  namespaced: true,
  state: war_room_state,
  getters: war_room_getters,
  mutations: war_room_mutations,
  actions: war_room_actions
};

/* harmony default export */ var war_room = (war_room_module);
// CONCATENATED MODULE: ./src/state/modules/activity/state.js
/**
 * Dependencies
 */


/**
 * Root State
 *
 * @type {Object}
 */
var activity_state_state = {
    pending: false,
    error: false,
    popup: {
        show: false,
        data: {}
    },
    data: [],
    showActivity: false
};

var activity_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(activity_state_state);
};

/* harmony default export */ var activity_state = (activity_state_getState());
// CONCATENATED MODULE: ./src/state/modules/activity/actions.js
/**
 * Dependencies
 */


/**
 * Get activity
 */
var actions_getActivity = function getActivity(_ref) {
  var commit = _ref.commit;

  commit('GET_ACTIVITY');
  HttpService["a" /* default */].get('activity/').then(function (res) {
    return commit('GET_ACTIVITY_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_ACTIVITY_FAILURE');
  });
};

/**
 * Toggle the activity state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var toggleActivity = function toggleActivity(_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      state = _ref2.state;

  commit('TOGGLE_ACTIVITY');
  if (state.showIndicator) {
    dispatch('disableActivityIndicator');
  }
};

/**
 * Disable the alert indicator
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var disableActivityIndicator = function disableActivityIndicator(_ref3) {
  var commit = _ref3.commit;
  return commit('DISABLE_INDICATOR');
};

/**
 * Disable the activity feed
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var closeActivity = function closeActivity(_ref4) {
  var commit = _ref4.commit;
  return commit('CLOSE_ACTIVITY');
};

/**
 * Mark a single item as read
 *
 * @return {Void}
 */
var actions_markActivityAsRead = function markActivityAsRead(_ref5, id) {
  var commit = _ref5.commit;

  HttpService["a" /* default */].patch('activity/' + id).then(function () {
    return commit('MARK_ITEM_READ', id);
  }).catch(function (err) {
    return console.log(err);
  });
};

/**
 * Mark all items as read
 *
 * @return {Void}
 */
var actions_markAllActivityAsRead = function markAllActivityAsRead(_ref6) {
  var commit = _ref6.commit;

  HttpService["a" /* default */].patch('activity/').then(function () {
    return commit('MARK_ALL_READ');
  }).catch(function (err) {
    return console.log(err);
  });
};

/**
 * Handle new activity
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var prependNewActivity = function prependNewActivity(_ref7, activity) {
  var commit = _ref7.commit;
  return commit('PREPEND_ACTIVITY', activity);
};

/**
 * Send popup notification
 *
 * @param  {Function} options.commit
 * @param  {Object} activity
 * @return {Void}
 */
var sendPopupNotification = function sendPopupNotification(_ref8, activity) {
  var commit = _ref8.commit;

  commit('SEND_ACTIVITY_POPUP', activity);
};

var resetActivityPopup = function resetActivityPopup(_ref9) {
  var commit = _ref9.commit;
  return commit('RESET_ACTIVITY_POPUP');
};

/* harmony default export */ var activity_actions = ({
  getActivity: actions_getActivity,
  closeActivity: closeActivity,
  toggleActivity: toggleActivity,
  prependNewActivity: prependNewActivity,
  resetActivityPopup: resetActivityPopup,
  markActivityAsRead: actions_markActivityAsRead,
  sendPopupNotification: sendPopupNotification,
  markAllActivityAsRead: actions_markAllActivityAsRead,
  disableActivityIndicator: disableActivityIndicator
});
// CONCATENATED MODULE: ./src/state/modules/activity/getters.js
/**
 * Function to determine whether there are unread items in the list
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasUnreadNotifications = function hasUnreadNotifications(state) {
  return state.data.some(function (item) {
    return item.read === false;
  });
};

/**
 * Get the unread notification count
 *
 * @param  {Object} state
 * @return {Number}
 */
var unreadNotificationsCount = function unreadNotificationsCount(state) {
  return state.data.filter(function (item) {
    return item.read === false;
  }).length;
};

/* harmony default export */ var activity_getters = ({
  hasUnreadNotifications: hasUnreadNotifications,
  unreadNotificationsCount: unreadNotificationsCount
});
// CONCATENATED MODULE: ./src/state/modules/activity/mutations.js
/**
 * Toggle the activity notifications pane
 *
 * @param  {Object} state
 * @return {Void}
 */
var TOGGLE_ACTIVITY = function TOGGLE_ACTIVITY(state) {
    state.showActivity = !state.showActivity;
};

/**
 * Reset the indicator state
 *
 * @param  {Object} state
 * @return {Void}
 */
var DISABLE_INDICATOR = function DISABLE_INDICATOR(state) {
    state.showIndicator = false;
};

/**
 * Reset the activity state
 *
 * @param  {Object} state
 * @return {Void}
 */
var CLOSE_ACTIVITY = function CLOSE_ACTIVITY(state) {
    state.showActivity = false;
};

var GET_ACTIVITY = function GET_ACTIVITY(state) {
    state.error = false;
    state.pending = true;
};

var GET_ACTIVITY_SUCCESS = function GET_ACTIVITY_SUCCESS(state, data) {
    state.data = data;
    state.pending = false;
};

var GET_ACTIVITY_FAILURE = function GET_ACTIVITY_FAILURE(state, err) {
    state.error = true;
    state.pending = false;
};

var MARK_ITEM_READ = function MARK_ITEM_READ(state, id) {
    var item = state.data.find(function (i) {
        return i.id === id;
    });
    if (item) {
        item.read = true;
    }
};

var MARK_ALL_READ = function MARK_ALL_READ(state) {
    state.data = state.data.map(function (item) {
        item.read = true;
        return item;
    });
};

var PREPEND_ACTIVITY = function PREPEND_ACTIVITY(state, activity) {
    return state.data.unshift(activity);
};

var SEND_ACTIVITY_POPUP = function SEND_ACTIVITY_POPUP(state, activity) {
    state.popup.data = activity;
    state.popup.show = true;
};

var RESET_ACTIVITY_POPUP = function RESET_ACTIVITY_POPUP(state) {
    state.popup.show = false;
    state.activity = {};
};

/* harmony default export */ var activity_mutations = ({
    GET_ACTIVITY: GET_ACTIVITY,
    GET_ACTIVITY_SUCCESS: GET_ACTIVITY_SUCCESS,
    GET_ACTIVITY_FAILURE: GET_ACTIVITY_FAILURE,
    CLOSE_ACTIVITY: CLOSE_ACTIVITY,
    TOGGLE_ACTIVITY: TOGGLE_ACTIVITY,
    DISABLE_INDICATOR: DISABLE_INDICATOR,
    MARK_ITEM_READ: MARK_ITEM_READ,
    MARK_ALL_READ: MARK_ALL_READ,
    PREPEND_ACTIVITY: PREPEND_ACTIVITY,
    RESET_ACTIVITY_POPUP: RESET_ACTIVITY_POPUP,
    SEND_ACTIVITY_POPUP: SEND_ACTIVITY_POPUP
});
// CONCATENATED MODULE: ./src/state/modules/activity/index.js
/**
 * Module Dependencies
 */





/**
 * Activity Module Declaration
 *
 * @type {Object}
 */
var activity_module = {
  namespaced: true,
  state: activity_state,
  actions: activity_actions,
  getters: activity_getters,
  mutations: activity_mutations
};

/* harmony default export */ var activity = (activity_module);
// CONCATENATED MODULE: ./src/state/modules/projects/links/state.js
/**
 * Dependencies
 */


/**
 * Project Links State
 *
 * @type {Object}
 */
var state_base = {
  pending: false,
  searchTerm: '',
  data: []

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var links_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(state_base);
};

/* harmony default export */ var links_state = (links_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/links/getters.js
/**
 * Return a filtered list based on a filter query
 *
 * @param  {Object} state
 * @return {Array}
 */
var filteredProjects = function filteredProjects(state) {
    var term = state.searchTerm ? state.searchTerm.toLowerCase() : '';
    if (state.data) {
        return state.data.filter(function (project) {
            var name = project.project_name.toLowerCase();
            return name.includes(term);
        });
    }
    return [];
};

/* harmony default export */ var links_getters = ({
    filteredProjects: filteredProjects
});
// EXTERNAL MODULE: ./src/services/ProjectService.js
var ProjectService = __webpack_require__("c5pT");

// CONCATENATED MODULE: ./src/state/modules/projects/links/actions.js
/**
 * Action Dependencies
 */



/**
 * Get the links generated for a projcect
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_getLinks = function getLinks(_ref) {
    var commit = _ref.commit;

    Object(ProjectService["k" /* getProjectLinks */])().then(function (res) {
        var grouped = Object(lodash["groupBy"])(res.data, function (x) {
            return x.project_name;
        });
        var links = grouped.map(function (value, key) {
            return {
                project_name: key,
                links: value.map(function (project) {
                    project.copied = false;
                    return project;
                })
            };
        });
        commit('GET_PROJECT_LINKS_SUCCESS', links);
    }).catch(function (res) {
        return commit('GET_PROJECT_LINKS_FAILURE');
    });
};

/**
 * Modify the project link active status
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_updateProjectLinkStatus = function updateProjectLinkStatus(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    Object(ProjectService["w" /* updateProjectLink */])(payload.id, payload.active).then(function (res) {
        state.data.every(function (item, idx) {
            var found = item.links.findIndex(function (link) {
                return link.id === payload.id;
            });
            if (found !== -1) {
                commit('UPDATE_LINK_STATUS', {
                    parentIndex: idx,
                    childIndex: found,
                    status: payload.active
                });
                return false;
            }
            return true;
        });
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Update the search value
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var updateSearchValue = function updateSearchValue(_ref3, value) {
    var commit = _ref3.commit;

    commit('UPDATE_SEARCH_VALUE', value);
};

/**
 * Remove a shared link
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var actions_deleteProjectLink = function deleteProjectLink(_ref4, id) {
    var commit = _ref4.commit;

    return Object(ProjectService["o" /* removeLink */])(id).then(function (res) {
        return commit('LINK_REMOVED_SUCCESS', id);
    }).catch(function (err) {
        return commit('LINK_REMOVED_FAILURE', err);
    });
};

/**
 * Trigger the state reset
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var links_actions_resetState = function resetState(_ref5) {
    var commit = _ref5.commit;

    commit('RESET_STATE');
};

/* harmony default export */ var links_actions = ({
    getLinks: actions_getLinks,
    resetState: links_actions_resetState,
    updateSearchValue: updateSearchValue,
    deleteProjectLink: actions_deleteProjectLink,
    updateProjectLinkStatus: actions_updateProjectLinkStatus
});
// CONCATENATED MODULE: ./src/state/modules/projects/links/mutations.js
/**
 * Dependencies
 */



/**
 * Set the project links
 *
 * @param  {Object} state
 * @param  {Array} links
 * @return {Void}
 */
var GET_PROJECT_LINKS_SUCCESS = function GET_PROJECT_LINKS_SUCCESS(state, links) {
    state.data = links;
};

/**
 * Handle a failed request for project links
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PROJECT_LINKS_FAILURE = function GET_PROJECT_LINKS_FAILURE(state) {
    state.data = [];
};

/**
 * Update a link item's status
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_LINK_STATUS = function UPDATE_LINK_STATUS(state, payload) {
    state.data[payload.parentIndex].links[payload.childIndex].active = payload.status;
};

/**
 * Update the search value
 *
 * @param  {Object} state
 * @param  {String} value
 * @return {Void}
 */
var UPDATE_SEARCH_VALUE = function UPDATE_SEARCH_VALUE(state, value) {
    state.searchTerm = value;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var links_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = links_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Remove a link from the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var LINK_REMOVED_SUCCESS = function LINK_REMOVED_SUCCESS(state, id) {
    var parentIdx = null;
    var idx = null;
    state.data.forEach(function (obj, parentIndex) {
        var found = obj.links.findIndex(function (link) {
            return link.id === id;
        });
        if (found > -1) {
            idx = found;
            parentIdx = parentIndex;
        }
    });

    if (parentIdx !== null && idx !== null) {
        state.data[parentIdx].links.splice(idx, 1);
        if (state.data[parentIdx].links.length === 0) {
            state.data.splice(parentIdx, 1);
        }
    }
};

/**
 * Handle failed link removal
 *
 * @param  {Object} state
 * @return {Void}
 */
var LINK_REMOVED_FAILURE = function LINK_REMOVED_FAILURE(state, err) {
    console.log(err);
};

/* harmony default export */ var links_mutations = ({
    RESET_STATE: links_mutations_RESET_STATE,
    UPDATE_LINK_STATUS: UPDATE_LINK_STATUS,
    UPDATE_SEARCH_VALUE: UPDATE_SEARCH_VALUE,
    LINK_REMOVED_SUCCESS: LINK_REMOVED_SUCCESS,
    LINK_REMOVED_FAILURE: LINK_REMOVED_FAILURE,
    GET_PROJECT_LINKS_SUCCESS: GET_PROJECT_LINKS_SUCCESS,
    GET_PROJECT_LINKS_FAILURE: GET_PROJECT_LINKS_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/links/index.js
/**
 * Module Dependencies
 */





/**
 * Project Links Module Declaration
 *
 * @type {Object}
 */
var links_module = {
  namespaced: true,
  state: links_state,
  getters: links_getters,
  mutations: links_mutations,
  actions: links_actions
};

/* harmony default export */ var projects_links = (links_module);
// CONCATENATED MODULE: ./src/state/modules/projects/state.js
/**
 * Dependencies
 */


/**
 * Projects State
 *
 * @type {Object}
 */
var projects_state_base = {
  loaded: false,
  pending: false,
  data: [],
  meta: {},
  cardLayout: true

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var projects_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(projects_state_base);
};

/* harmony default export */ var projects_state = (projects_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/inbox/state.js
/**
 * Dependencies
 */


/**
 * Base State
 */
var inbox_state_base = {
  pending: false,
  data: [],
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var inbox_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(inbox_state_base);
};

/* harmony default export */ var inbox_state = (inbox_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/inbox/actions.js
/**
 * Dependencies
 */


/**
 * Get the projects scoped with the inbox query parameter
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_getProjects = function getProjects(_ref) {
  var commit = _ref.commit;

  commit('SET_PENDING');
  HttpService["a" /* default */].get('projects/?scope=inbox').then(function (res) {
    return commit('GET_PROJECTS_SUCCESS', res.data);
  }).catch(function (err) {
    return commit('GET_PROJECTS_FAILURE', err);
  });
};

/* harmony default export */ var inbox_actions = ({
  getProjects: actions_getProjects
});
// CONCATENATED MODULE: ./src/state/modules/projects/inbox/getters.js
/**
 * Determine if the data state is empty
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasProjects = function hasProjects(state) {
    return state.data.length > 0;
};

/* harmony default export */ var inbox_getters = ({
    hasProjects: hasProjects
});
// CONCATENATED MODULE: ./src/state/modules/projects/inbox/mutations.js
/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var inbox_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = inbox_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_SET_PENDING = function SET_PENDING(state) {
    state.pending = true;
};

/**
 * Handle successful payload request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_PROJECTS_SUCCESS = function GET_PROJECTS_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
    state.pending = false;
};

/**
 * Handle failed payload request
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PROJECTS_FAILURE = function GET_PROJECTS_FAILURE(state) {
    state.pending = false;
};

/* harmony default export */ var inbox_mutations = ({
    RESET_STATE: inbox_mutations_RESET_STATE,
    SET_PENDING: mutations_SET_PENDING,
    GET_PROJECTS_SUCCESS: GET_PROJECTS_SUCCESS,
    GET_PROJECTS_FAILURE: GET_PROJECTS_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/inbox/index.js
/**
 * Module Dependencies
 */





/**
 * Project Share Module Declaration
 *
 * @type {Object}
 */
var inbox_module = {
  namespaced: true,
  state: inbox_state,
  getters: inbox_getters,
  mutations: inbox_mutations,
  actions: inbox_actions
};

/* harmony default export */ var inbox = (inbox_module);
// CONCATENATED MODULE: ./src/state/modules/projects/form/capex/state.js
/**
 * Dependencies
 */


/**
 * CAPEX modal state
 *
 * @type {Object}
 */
var capex_state_state = {
    fresh: false,
    showModal: false,
    saving: false,
    form: {},
    errors: {},
    options: {
        amount_unit: [{ key: 0, label: 'Total $ Amount' }, { key: 1, label: '$ per SQFT' }, { key: 2, label: '$ per Unit' }, { key: 3, label: '% of Project Costs' }, { key: 4, label: '% of Acquisition Costs' }, { key: 5, label: '% of Hard Costs' }, { key: 6, label: '% of Soft Costs' }, { key: 7, label: '% of Financing Costs' }, { key: 8, label: '% of Custom Group' }],
        dep_type: [{ key: 'LC', label: 'Land' }, { key: 'BC', label: 'Buildings' }, { key: 'LI', label: 'Land Improvement' }, { key: 'PP', label: 'Personal Property' }]
    },
    existingContext: {
        serializer: null,
        index: null
    },
    currentTab: 'general'

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var capex_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(capex_state_state);
};

/* harmony default export */ var capex_state = (capex_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/form/capex/getters.js
/**
 * Dependencies
 */


/**
 * Return an augmented set of objects based on spread index/data
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_calculatedSpread = function calculatedSpread(state) {
    if (Object(lodash["has"])(state.form, 'spread.data')) {
        return state.form.spread.data.map(function (value, idx) {
            return {
                index: idx,
                period: state.form.spread.index[idx],
                value: value
            };
        });
    }
    return [];
};

/**
 * Get the total of the spread data values
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_totalSpreadPercentage = function totalSpreadPercentage(state) {
    var total = Object(lodash["sum"])(Object(lodash["get"])(state, 'form.spread.data', []));

    // Round with a precision of 4
    return Object(lodash["round"])(total, 4);
};

/**
* Determine if a custom group is selected
*
* @param  {Object} state
* @return {Boolean}
*/
var isCustomGroupSelected = function isCustomGroupSelected(state) {
    return state.form.amount_unit === 8;
};

/* harmony default export */ var capex_getters = ({
    calculatedSpread: getters_calculatedSpread,
    totalSpreadPercentage: getters_totalSpreadPercentage,
    isCustomGroupSelected: isCustomGroupSelected
});
// CONCATENATED MODULE: ./src/state/modules/projects/form/capex/actions.js




/**
 * Handle the execution of setting up the CAPEX modal context
 *
 * @param  {Function} options.commit Object
 * @param  {Object} payload
 * @return {Void}
 */
var setUpCapexModal = function setUpCapexModal(_ref, payload) {
    var commit = _ref.commit;

    commit('SETUP_CAPEX_MODAL', payload);
};

/**
 * Reset to the initial state
 *
 * @param  {Function} options.commit Object
 * @return {Void}
 */
var tearDownCapexModal = function tearDownCapexModal(_ref2) {
    var commit = _ref2.commit;

    commit('RESET_STATE');
};

/**
 * Reset the form model to continue adding CAPEX objects
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
var resetCapexForm = function resetCapexForm(_ref3, model) {
    var commit = _ref3.commit;

    commit('RESET_FORM', model);
};

/**
 * Update a CAPEX form value
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateCapexFormValue = function updateCapexFormValue(_ref4, payload) {
    var commit = _ref4.commit;

    commit('UPDATE_FORM_VALUE', payload);
};

/**
 * Change the CAPEX form tab context
 *
 * @param  {Function} options.commit
 * @param  {String} tab
 * @return {Void}
 */
var changeCapexTab = function changeCapexTab(_ref5, tab) {
    var commit = _ref5.commit;

    commit('CHANGE_TAB', tab);
};

/**
 * Add a cost to a relative capex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var addRelativeCost = function addRelativeCost(_ref6, id) {
    var commit = _ref6.commit;

    commit('ADD_RELATIVE_COST', id);
};

var removeRelativeCost = function removeRelativeCost(_ref7, id) {
    var commit = _ref7.commit;

    commit('REMOVE_RELATIVE_COST', id);
};

/**
 * Calculate the initial spread values
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_calculateSpread = function calculateSpread(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var start = state.form.start_period || 0;
    var duration = state.form.duration || 0;
    var dataArray = new Array(duration);
    var equalPercentage = Number(parseFloat(100 / duration, 2).toFixed(8));

    commit('CALCULATE_NEW_SPREAD', {
        index: Object(lodash["range"])(start, duration + start),
        data: Object(lodash["fill"])(dataArray, equalPercentage)
    });
};

/**
 * Update a spread value based on its index
 *
 * @param  {Function} options.commit
 * @param  {object} payload
 * @return {Promise}
 */
var updateSpreadValue = function updateSpreadValue(_ref9, payload) {
    var commit = _ref9.commit;
    return commit('UPDATE_SPREAD_VALUE', payload);
};

/**
 * Add a new Capex
 *
 * @param {Function} options.commit
 * @param {Object} options.rootState
 * @return {Void}
 */
var actions_createCost = function createCost(_ref10) {
    var commit = _ref10.commit,
        rootState = _ref10.rootState,
        state = _ref10.state,
        dispatch = _ref10.dispatch;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return new promise_default.a(function (resolve, reject) {
        commit('SET_SAVING');
        commit('RESET_FORM_ERRORS');
        HttpService["a" /* default */].post('projects/' + rootState.route.params.projectId + '/capex/', payload || state.form).then(function (res) {
            commit('RESET_SAVING');
            resolve(res.data);
        }).catch(function (err) {
            if (err.response) {
                commit('SET_FORM_ERRORS', err.response.data);
            }
            commit('RESET_SAVING');
            reject(err);
        });
    });
};

var clearErrors = function clearErrors(_ref11, key) {
    var commit = _ref11.commit;
    return commit('CLEAR_ERRORS', key);
};

var actions_updateCapex = function updateCapex(_ref12) {
    var commit = _ref12.commit,
        rootState = _ref12.rootState,
        state = _ref12.state,
        dispatch = _ref12.dispatch;
    return new promise_default.a(function (resolve, reject) {
        commit('SET_SAVING');
        commit('RESET_FORM_ERRORS');
        HttpService["a" /* default */].put('modelling/capex/' + state.form.id + '/', state.form).then(function (res) {
            dispatch('projects/form/replaceCapex', {
                type: state.existingContext.serializer,
                id: state.form.id,
                data: res.data
            }, { root: true });
            commit('RESET_SAVING');
            resolve(res.data);
        }).catch(function (err) {
            if (err.response) {
                commit('SET_FORM_ERRORS', err.response.data);
            }
            commit('RESET_SAVING');
            reject(err);
        });
    });
};

/* harmony default export */ var capex_actions = ({
    createCost: actions_createCost,
    updateCapex: actions_updateCapex,
    clearErrors: clearErrors,
    changeCapexTab: changeCapexTab,
    resetCapexForm: resetCapexForm,
    addRelativeCost: addRelativeCost,
    setUpCapexModal: setUpCapexModal,
    calculateSpread: actions_calculateSpread,
    updateSpreadValue: updateSpreadValue,
    removeRelativeCost: removeRelativeCost,
    tearDownCapexModal: tearDownCapexModal,
    updateCapexFormValue: updateCapexFormValue
});
// CONCATENATED MODULE: ./src/state/modules/projects/form/capex/mutations.js

/**
 * Dependencies
 */




/**
 * Set up the CAPEX modal context
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_SETUP_CAPEX_MODAL = function SETUP_CAPEX_MODAL(state, payload) {
    vue_esm["a" /* default */].set(state, 'form', payload.model);
    vue_esm["a" /* default */].set(state, 'fresh', payload.fresh);
    state.existingContext.serializer = payload.type;
    state.existingContext.index = payload.index;
    state.showModal = true;
};

/**
 * Update a CAPEX Form value
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_UPDATE_FORM_VALUE = function UPDATE_FORM_VALUE(state, payload) {
    var base = Object(lodash["get"])(state, payload.base);
    base[payload.target] = payload.value;
};

/**
 * Update the currently selected tab
 *
 * @param  {Object} state
 * @param  {String} tab
 * @return {Void}
 */
var CHANGE_TAB = function CHANGE_TAB(state, tab) {
    state.currentTab = tab;
};

/**
 * Reset the form model back to its original attributes
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var RESET_FORM = function RESET_FORM(state, payload) {
    state.form = payload;
    state.fresh = true;
    state.showModal = true;
};

/**
 * Add a cost to a relative capex item's state
 *
 * @param  {Obect} state
 * @param  {Obect} payload
 * @return {Void}
 */
var ADD_RELATIVE_COST = function ADD_RELATIVE_COST(state, id) {
    if (!state.form.target_costs.includes(id)) {
        state.form.target_costs.push(id);
    }
};

/**
 * Remove a cost from a relative capex item's state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var REMOVE_RELATIVE_COST = function REMOVE_RELATIVE_COST(state, id) {
    var idx = state.form.target_costs.findIndex(function (cost) {
        return cost === id;
    });

    state.form.target_costs.splice(idx, 1);
};

/**
 * Replace spread object with new context
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var CALCULATE_NEW_SPREAD = function CALCULATE_NEW_SPREAD(state, payload) {
    state.form.spread = payload;
};

/**
 * Modify a spread data value at a given index
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_SPREAD_VALUE = function UPDATE_SPREAD_VALUE(state, payload) {
    state.form.spread.data.splice(payload.index, 1, payload.value);
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var capex_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = capex_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

var SET_SAVING = function SET_SAVING(state) {
    state.saving = true;
};

var RESET_SAVING = function RESET_SAVING(state) {
    state.saving = false;
};

var SET_FORM_ERRORS = function SET_FORM_ERRORS(state, errors) {
    state.errors = errors;
};

var RESET_FORM_ERRORS = function RESET_FORM_ERRORS(state) {
    state.errors = {};
};

var mutations_CLEAR_ERRORS = function CLEAR_ERRORS(state, key) {
    state.errors = keys_default()(state.errors).reduce(function (sum, e) {
        if (e !== key) {
            sum[e] = state.errors[e];
        }
        return sum;
    }, {});
};

/* harmony default export */ var capex_mutations = ({
    CHANGE_TAB: CHANGE_TAB,
    RESET_FORM: RESET_FORM,
    RESET_STATE: capex_mutations_RESET_STATE,
    SET_SAVING: SET_SAVING,
    CLEAR_ERRORS: mutations_CLEAR_ERRORS,
    RESET_SAVING: RESET_SAVING,
    SET_FORM_ERRORS: SET_FORM_ERRORS,
    RESET_FORM_ERRORS: RESET_FORM_ERRORS,
    ADD_RELATIVE_COST: ADD_RELATIVE_COST,
    UPDATE_FORM_VALUE: mutations_UPDATE_FORM_VALUE,
    SETUP_CAPEX_MODAL: mutations_SETUP_CAPEX_MODAL,
    UPDATE_SPREAD_VALUE: UPDATE_SPREAD_VALUE,
    REMOVE_RELATIVE_COST: REMOVE_RELATIVE_COST,
    CALCULATE_NEW_SPREAD: CALCULATE_NEW_SPREAD
});
// CONCATENATED MODULE: ./src/state/modules/projects/form/capex/index.js
/**
 * Module Dependencies
 */





/**
 * CAPEX Module Declaration
 *
 * @type {Object}
 */
var capex_module = {
  namespaced: true,
  state: capex_state,
  getters: capex_getters,
  mutations: capex_mutations,
  actions: capex_actions
};

/* harmony default export */ var capex = (capex_module);
// CONCATENATED MODULE: ./src/state/modules/projects/form/state.js
/**
 * Dependencies
 */


/**
 * Base State
 *
 * @type {Object}
 */
var form_state_base = {
    capex_loading: false,
    loaded: false,
    pending: false,
    dirty: false,
    success: false,
    data: {},
    options: {},
    errors: {},
    tabs: [],
    draft: {},
    meta: {},
    saving_draft: false,
    activeTab: 'project',
    attemptingSave: false,
    projectChoices: {
        selected: {
            primary: null,
            secondary: null
        },
        options: {
            residential: {
                title: 'Residential',
                key: 'residential',
                options: {
                    single_family: {
                        title: 'Single Family',
                        key: 'single_family',
                        options: {
                            spec_house: {
                                title: 'Spec House',
                                form_type: 'R_SF_spec_house',
                                selected: false
                            },
                            fix_and_flip: {
                                title: 'Fix and Flip',
                                form_type: 'R_SF_fix_and_flip',
                                selected: false
                            },
                            buy_and_hold: {
                                title: 'Buy and Hold',
                                form_type: 'R_SF_buy_and_hold',
                                selected: false
                            }
                        }
                    },
                    multi_family: {
                        title: 'Multi Family',
                        key: 'multi_family',
                        options: {
                            apartment_development: {
                                title: 'Apartment Development',
                                form_type: 'R_MF_apartment_development',
                                disabled: false
                            },
                            condo_development: {
                                title: 'Condo Development',
                                form_type: 'R_MF_condo_development',
                                disabled: false
                            },
                            value_add: {
                                title: 'Value Add',
                                form_type: 'R_MF_value_add',
                                disabled: "production" === 'production'
                            },
                            buy_hold: {
                                title: 'Buy and Hold',
                                form_type: 'R_MF_buy_and_hold',
                                disabled: false
                            }
                        }
                    },
                    student_housing: {
                        title: 'Student Housing',
                        key: 'student_housing',
                        options: {
                            development: {
                                title: 'Development',
                                form_type: 'R_SH_development',
                                selected: false
                            },
                            buy_and_hold: {
                                title: 'Buy and Hold',
                                form_type: 'R_SH_buy_and_hold',
                                selected: false
                            },
                            value_add: {
                                title: 'Value Add',
                                form_type: 'R_SH_value_add',
                                selected: false,
                                disabled: true
                            }
                        }
                    }
                }
            },
            commercial: {
                title: 'Commercial',
                key: 'commercial',
                options: {
                    office: {
                        title: 'Office',
                        key: 'office',
                        disabled: true,
                        options: {
                            development: {
                                title: 'Development',
                                form_type: 'C_O_development',
                                selected: false
                            },
                            value_add: {
                                title: 'Value Add',
                                form_type: 'C_O_value_add',
                                selected: false
                            },
                            buy_hold: {
                                title: 'Buy Hold',
                                form_type: 'C_O_buy_and_hold',
                                selected: false
                            },
                            land_development: {
                                title: 'Land Development',
                                form_type: 'C_O_land_development',
                                selected: false
                            }
                        }
                    },
                    industrial: {
                        title: 'Industrial',
                        key: 'industrial',
                        disabled: true,
                        options: {
                            development: {
                                title: 'Development',
                                form_type: 'C_I_development',
                                selected: false
                            },
                            value_add: {
                                title: 'Value Add',
                                form_type: 'C_I_value_add',
                                selected: false
                            },
                            buy_hold: {
                                title: 'Buy Hold',
                                form_type: 'C_I_buy_and_hold',
                                selected: false
                            }
                        }
                    },
                    retail: {
                        title: 'Retail',
                        key: 'retail',
                        disabled: true,
                        options: {
                            development: {
                                title: 'Development',
                                form_type: 'C_R_development',
                                selected: false
                            },
                            value_add: {
                                title: 'Value Add',
                                form_type: 'C_R_value_add',
                                selected: false
                            },
                            buy_hold: {
                                title: 'Buy Hold',
                                form_type: 'C_R_buy_and_hold',
                                selected: false
                            }
                        }
                    },
                    medical: {
                        title: 'Medical',
                        key: 'medical',
                        disabled: true,
                        options: {
                            development: {
                                title: 'Development',
                                form_type: 'C_M_development',
                                selected: false
                            },
                            value_add: {
                                title: 'Value Add',
                                form_type: 'C_M_value_add',
                                selected: false
                            },
                            buy_hold: {
                                title: 'Buy Hold',
                                form_type: 'C_M_buy_and_hold',
                                selected: false
                            }
                        }
                    },
                    hospitality: {
                        title: 'Hospitality',
                        key: 'hospitality',
                        disabled: true,
                        options: {
                            development: {
                                title: 'Development',
                                form_type: 'C_H_development',
                                selected: false
                            },
                            value_add: {
                                title: 'Value Add',
                                form_type: 'C_H_value_add',
                                selected: false
                            },
                            buy_hold: {
                                title: 'Buy Hold',
                                form_type: 'C_H_buy_and_hold',
                                selected: false
                            }
                        }
                    },
                    mixed_use: {
                        title: 'Mixed Use',
                        key: 'mixed_use',
                        disabled: true,
                        options: {
                            development: {
                                title: 'Development',
                                form_type: 'C_MU_development',
                                selected: false
                            },
                            value_add: {
                                title: 'Value Add',
                                form_type: 'C_MU_value_add',
                                selected: false
                            },
                            buy_hold: {
                                title: 'Buy Hold',
                                form_type: 'C_MU_buy_and_hold',
                                selected: false
                            }
                        }
                    }
                }
            },
            land: {
                title: 'Land / Natural Resources',
                key: 'land',
                disabled: true,
                options: {}
            }
        }
    }

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var form_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(form_state_base);
};

/* harmony default export */ var form_state = (form_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/form/getters.js

/**
 * Dependencies
 */


/**
 * Retrieve the primary project options list
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_primaryOptions = function primaryOptions(state) {
    return keys_default()(state.projectChoices.options).map(function (item) {
        return {
            label: state.projectChoices.options[item].title,
            key: state.projectChoices.options[item].key,
            disabled: state.projectChoices.options[item].disabled
        };
    });
};

/**
 * Retrieve the secondary project options list
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_secondaryOptions = function secondaryOptions(state) {
    if (!state.projectChoices.selected.primary) return [];
    var base = state.projectChoices.options[state.projectChoices.selected.primary].options;
    return keys_default()(base).map(function (item) {
        return {
            label: base[item].title,
            key: base[item].key,
            disabled: base[item].disabled
        };
    });
};

/**
 * Retrieve the tertiary project options list
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_tertiaryOptions = function tertiaryOptions(state) {
    if (!state.projectChoices.selected.primary || !state.projectChoices.selected.secondary) return [];
    var base = state.projectChoices.options[state.projectChoices.selected.primary].options[state.projectChoices.selected.secondary].options;
    return keys_default()(base).map(function (item) {
        return {
            label: base[item].title,
            type: base[item].form_type,
            disabled: base[item].disabled
        };
    });
};

/**
 * Retrieve the selected options object
 *
 * @param  {Object} state
 * @return {Object}
 */
var selectedOptions = function selectedOptions(state) {
    return state.projectChoices.selected;
};

/**
 * Determine whether the project contains errors
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_hasErrors = function hasErrors(state) {
    return !Object(lodash["isEmpty"])(state.errors);
};

/**
 * Return an array of CAPEX type strings
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_capexTypes = function capexTypes(state) {
    if (state.data.capex) {
        return keys_default()(state.data.capex);
    }
    return [];
};

/**
 * Return the total CAPEX Costs Value
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_totalCapexCosts = function totalCapexCosts(state, getters) {
    if (state.data.capex) {
        var total = 0;
        var capexItems = keys_default()(state.data.capex).filter(function (item) {
            return item !== 'WorkingCapitalSerializer';
        });
        capexItems.forEach(function (set) {
            total += Object(lodash["sumBy"])(state.data.capex[set], function (item) {
                // if (item.relativity.is_relative) {
                //     let relativeTotal = sumBy(item.relativity.relative_to, 'amount')
                //     return relativeTotal * (item.amount / 100)
                // }
                if (item.amount_unit === 2) {
                    return (item.amount || 0) * getters.unitTotal;
                }
                return item.amount_unit === 1 ? item.amount * (state.data.project.building_sqft || 0) : item.amount || 0;
            });
        });
        total += state.data.capex['WorkingCapitalSerializer'] ? state.data.capex['WorkingCapitalSerializer'].amount || 0 : 0;
        return total;
    }
    return 0;
};

/**
 * Return only the CAPEX items that are repeatables and should be iterated upon
 *
 * @param  {Object} state
 * @return {Array}
 */
var qualifiedCapexItems = function qualifiedCapexItems(state) {
    if (state.data.capex) {
        var capex = [{
            key: 'AcquisitionCostSerializer',
            label: 'Acquisition Costs',
            items: state.data.capex.AcquisitionCostSerializer
        }, {
            key: 'SoftCostSerializer',
            label: 'Soft Costs',
            items: state.data.capex.SoftCostSerializer
        }, {
            key: 'HardCostSerializer',
            label: 'Hard Costs',
            items: state.data.capex.HardCostSerializer
        }];

        return capex.filter(function (item) {
            return item.items !== undefined;
        });
    }
    return [];
};

/**
 * Get the row total for each of the CAPEX categories
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_totalCostsCount = function totalCostsCount(state) {
    if (state.data.capex) {
        var total = 0;
        var fields = keys_default()(state.data.capex).filter(function (item) {
            return item !== 'WorkingCapitalSerializer';
        });

        fields.forEach(function (set) {
            total += state.data.capex[set].length;
        });

        return total;
    }

    return 0;
};

/**
 * Get the calculated year count based on the no_months input on the project tab
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_totalYears = function totalYears(state) {
    return Math.ceil(Object(lodash["get"])(state.data, 'project.no_months', 0) / 12);
};

/**
 * Check if the draft state object is empty
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_hasDraft = function hasDraft(state) {
    return !Object(lodash["isEmpty"])(state.draft);
};

/**
 * Get the draft leaf if applicable
 *
 * @param  {Object} state
 * @return {String|Null}
 */
var getters_draftLeaf = function draftLeaf(state) {
    return Object(lodash["get"])(state.draft, 'project.leaf', null);
};

/**
 * Get the sum of the units
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_unitTotal = function unitTotal(state) {
    var units = Object(lodash["get"])(state.data.unit, state.meta.unit_path, []);

    return units.reduce(function (sum, i) {
        sum += i.quantity || i.quant;
        return sum;
    }, 0);
};

/* harmony default export */ var form_getters = ({
    hasDraft: getters_hasDraft,
    draftLeaf: getters_draftLeaf,
    hasErrors: getters_hasErrors,
    unitTotal: getters_unitTotal,
    capexTypes: getters_capexTypes,
    totalYears: getters_totalYears,
    primaryOptions: getters_primaryOptions,
    secondaryOptions: getters_secondaryOptions,
    tertiaryOptions: getters_tertiaryOptions,
    selectedOptions: selectedOptions,
    totalCapexCosts: getters_totalCapexCosts,
    totalCostsCount: getters_totalCostsCount,
    qualifiedCapexItems: qualifiedCapexItems
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/random-string/lib/random-string.js
var random_string = __webpack_require__("/8pc");
var random_string_default = /*#__PURE__*/__webpack_require__.n(random_string);

// CONCATENATED MODULE: ./src/state/modules/projects/form/actions.js




/**
 * Action Dependencies
 */





/**
 * Select a project options
 *
 * @param  {Function} options.commit
 * @param  {Object}
 * @return {Void}
 */
var selectOption = function selectOption(_ref, payload) {
    var commit = _ref.commit;
    return commit('PROJECT_MAKE_SELECTION', payload);
};

/**
 * Update form tab
 *
 * @param  {Function} options.commit
 * @param  {String} tab
 * @return {Void}
 */
var changeFormTab = function changeFormTab(_ref2, tab) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState,
        dispatch = _ref2.dispatch;

    commit('CHANGE_FORM_TAB', tab);
    if (rootState.route.name === 'projects.create') {
        dispatch('saveDraft');
    }
};

/**
 * Reset the project choice context
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var projectChoicesReset = function projectChoicesReset(_ref3, payload) {
    var commit = _ref3.commit;
    return commit('PROJECT_CHOICES_RESET');
};

/**
 * Update a form value
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateFormValue = function updateFormValue(_ref4, payload) {
    var commit = _ref4.commit;
    return commit('UPDATE_PROJECT_VALUE', payload);
};

/**
 * Add a repeatable value to the form
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_addRepeatableObject = function addRepeatableObject(_ref5, payload) {
    var commit = _ref5.commit;

    return new promise_default.a(function (resolve, reject) {
        commit('ADD_REPEATABLE_PROJECT_VALUE', payload);
        resolve();
    });
};

/**
 * Remove a repeater object from a given key
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var removeRepeatableObject = function removeRepeatableObject(_ref6, payload) {
    var commit = _ref6.commit,
        state = _ref6.state;
    return commit('REMOVE_REPEATABLE_PROJECT_VALUE', payload);
};

/**
 * Update the position of an item within a repeater
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_updateRepeatableObjectPosition = function updateRepeatableObjectPosition(_ref7, payload) {
    var commit = _ref7.commit,
        state = _ref7.state;

    commit('UPDATE_REPEATABLE_PROJECT_VALUE_POSITION', payload);
    var errors = Object(lodash["get"])(state.errors, payload.base, false);
    if (errors) {
        var errorIndex1 = errors.findIndex(function (item) {
            return item.index === payload.oldIndex;
        });
        var errorIndex2 = errors.findIndex(function (item) {
            return item.index === payload.newIndex;
        });
        if (errorIndex1 > -1) {
            commit('UPDATE_ERROR_INDEX', {
                base: payload.base,
                currentIndex: errorIndex1,
                newIndex: payload.newIndex
            });
        }
        if (errorIndex2 > -1) {
            commit('UPDATE_ERROR_INDEX', {
                base: payload.base,
                currentIndex: errorIndex2,
                newIndex: payload.oldIndex
            });
        }
    }
};

/**
 * Update a value inside a repeatable object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateRepeatableObjectValue = function updateRepeatableObjectValue(_ref8, payload) {
    var commit = _ref8.commit;
    return commit('UPDATE_REPEATABLE_OBJECT_VALUE', payload);
};

/**
 * Update a capex value
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateCapexValue = function updateCapexValue(_ref9, payload) {
    var commit = _ref9.commit;
    return commit('UPDATE_CAPEX_VALUE', payload);
};

/**
 * Trigger the form reset action
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var resetForm = function resetForm(_ref10) {
    var commit = _ref10.commit;
    return commit('RESET_FORM');
};

var actions_setUpProjectForm = function setUpProjectForm(_ref11, payload) {
    var commit = _ref11.commit;

    commit('GET_PROJECT_FORM');
    return new promise_default.a(function (resolve, reject) {
        commit('SET_PROJECT_FORM', payload);
        resolve();
    });
};

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var form_actions_resetState = function resetState(_ref12) {
    var commit = _ref12.commit;
    return commit('RESET_STATE');
};

/**
 * Update relative amount values when a dependent object changes
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
var updateRelativeAmounts = function updateRelativeAmounts(_ref13, payload) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var _loop = function _loop(prop) {
        if (state.data.capex[prop]) {
            state.data.capex[prop].forEach(function (item, capexItemIndex) {
                var idx = item.relativity.relative_to.findIndex(function (relativeItem) {
                    return relativeItem.hash === payload.hash;
                });
                if (idx > -1) {
                    commit('UPDATE_RELATIVE_VALUE', {
                        index: idx,
                        base: 'capex.' + prop + '[' + capexItemIndex + '].relativity.relative_to',
                        value: payload.newValue
                    });
                }
            });
        }
    };

    for (var prop in state.data.capex) {
        _loop(prop);
    }
};

/**
 * Submit the project form data to the API
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
var actions_submitProjectForm = function submitProjectForm(_ref14) {
    var commit = _ref14.commit,
        state = _ref14.state,
        dispatch = _ref14.dispatch,
        rootState = _ref14.rootState;
    return new promise_default.a(function (resolve, reject) {
        commit('PROJECT_SAVE');
        Object(ProjectService["r" /* saveProject */])(state.data).then(function (res) {
            commit('PROJECT_SAVE_SUCCESS');
            resolve(res);
        }).catch(function (error) {
            var serverError = error.response.status === 500;
            var message = serverError ? 'Something\'s gone wrong on our end. Please try again later or report this to a system administrator.' : 'There were problems with your project submission. Please make your corrections and resubmit your project.';
            dispatch('addNotification', {
                title: 'Error Creating Project',
                type: 'error',
                text: message,
                timeout: true
            }, { root: true });
            commit('PROJECT_SAVE_FAILURE', serverError ? {} : error.response.data);
            reject(error);
        });
    });
};

/**
 * Attempt to update an existing project
 *
 * @param  {Function} options.state
 * @param  {Object} options.dispatch
 * @param  {Number} id
 * @return {Promise}
 */
var actions_submitProjectEditForm = function submitProjectEditForm(_ref15, id) {
    var commit = _ref15.commit,
        state = _ref15.state,
        dispatch = _ref15.dispatch;

    commit('PROJECT_SAVE');
    return Object(ProjectService["v" /* updateProject */])(id, state.data).then(function (res) {
        commit('PROJECT_SAVE_SUCCESS');
        return promise_default.a.resolve(res.data);
    }).catch(function (error) {
        var serverError = error.response.status === 500;
        var message = serverError ? 'Something\'s gone wrong on our end. Please try again later or report this to a system administrator.' : 'There were problems with your project submission. Please make your corrections and resubmit your project.';
        dispatch('addNotification', {
            title: 'Error Creating Project',
            type: 'error',
            text: message,
            timeout: true
        }, { root: true });
        commit('PROJECT_SAVE_FAILURE', serverError ? {} : error.response.data);
        return promise_default.a.reject(error);
    });
};

/**
 * Add a new debt object
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
var addNewDebt = function addNewDebt(_ref16, payload) {
    var commit = _ref16.commit;
    return commit('ADD_NEW_DEBT', payload);
};

/**
 * Update an existing debt cost
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var updateExistingDebt = function updateExistingDebt(_ref17, payload) {
    var commit = _ref17.commit;
    return commit('UPDATE_EXISTING_DEBT', payload);
};

/**
 * Update an existing CAPEX object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateExistingCapexObject = function updateExistingCapexObject(_ref18, payload) {
    var commit = _ref18.commit;
    return commit('UPDATE_EXISTING_CAPEX', payload);
};

/**
 * Add a new equity object to the state
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var addNewEquity = function addNewEquity(_ref19, payload) {
    var commit = _ref19.commit;
    return commit('ADD_NEW_EQUITY', payload);
};

/**
 * Remove and equity object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var removeExistingEquity = function removeExistingEquity(_ref20, payload) {
    var commit = _ref20.commit;
    return commit('REMOVE_EQUITY', payload);
};

/**
 * Add a new equity object to the state
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateExistingEquity = function updateExistingEquity(_ref21, payload) {
    var commit = _ref21.commit;
    return commit('UPDATE_EXISTING_EQUITY', payload);
};

/**
 * Remove a key from the errors object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var clearFormError = function clearFormError(_ref22, payload) {
    var commit = _ref22.commit;
    return commit('REMOVE_ERROR_KEY', payload);
};

/**
 * Copy an existing capex and insert it the clone after the original
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_copyAndInsertCapex = function copyAndInsertCapex(_ref23, payload) {
    var commit = _ref23.commit,
        dispatch = _ref23.dispatch;
    return new promise_default.a(function (resolve, reject) {
        var clone = Object(lodash["cloneDeep"])(payload.capex);
        commit('SET_CAPEX_LOADING');
        clone.name = clone.name + ' copy';
        clone.amount = 0;
        clone.id = null;
        clone.hash = random_string_default()();
        dispatch('projects/form/capex/createCost', clone, { root: true }).then(function (item) {
            commit('ADD_CAPEX_CLONE', {
                clone: item,
                index: payload.index + 1,
                type: payload.type
            });
            dispatch('setCapexOrder');
            dispatch('addNotification', {
                title: 'Copy successful',
                type: 'success',
                text: 'The capital expense has been successfully copied.',
                timeout: true
            }, { root: true });
            commit('RESET_CAPEX_LOADING');
            resolve({
                id: item.id,
                index: payload.index + 1
            });
        }).catch(function (err) {
            commit('RESET_CAPEX_LOADING');
            dispatch('addNotification', {
                title: 'Copy Failed',
                type: 'error',
                text: 'There was a problem creating a copy of the capital expense.',
                timeout: true
            }, { root: true });
            reject(err);
        });
    });
};

/**
 * Set the edit payload
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_setProjectData = function setProjectData(_ref24, payload) {
    var commit = _ref24.commit;
    return commit('SET_EDIT_PAYLOAD', payload);
};

/**
 * Remove a capex item and remove the references to it from associated relative costs
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_removeCapexObject = function removeCapexObject(_ref25, payload) {
    var commit = _ref25.commit,
        state = _ref25.state;

    commit('REMOVE_REPEATABLE_PROJECT_VALUE', payload);
    var keys = keys_default()(state.data.capex);
    values_default()(state.data.capex).forEach(function (arr) {
        if (arr) {
            arr.forEach(function (capex, idx) {
                if (capex.relativity.is_relative) {
                    var relativeIndex = capex.relativity.relative_to.map(function (o) {
                        return o.hash;
                    }).indexOf(payload.hash);
                    if (relativeIndex > -1) {
                        commit('REMOVE_DELETED_RELATIVE_VALUE', {
                            path: 'data.capex.' + keys[idx] + '[' + idx + '].relativity.relative_to',
                            index: relativeIndex
                        });
                    }
                }
            });
        }
    });
    if (Object(lodash["has"])(state.errors, 'capex.' + payload.type)) {
        var idx = state.errors.capex[payload.type].findIndex(function (item) {
            return item.index === payload.index;
        });
        if (idx > -1) {
            commit('REMOVE_CAPEX_ERROR', {
                type: payload.type,
                index: payload.index
            });
        }
    }
};

/**
 * Set the working capital model on the capex state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_setWorkingCapitalModel = function setWorkingCapitalModel(_ref26, form) {
    var commit = _ref26.commit;
    return commit('SET_WORKING_CAPITAL_MODEL', JSON.parse(stringify_default()(form)));
};

/**
 * Tear down the working captial model
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var removeWorkingCapitalModel = function removeWorkingCapitalModel(_ref27) {
    var commit = _ref27.commit;
    return commit('REMOVE_WORKING_CAPITAL_MODEL');
};

/**
 * Trigger a replace of a repeater object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var replaceRepeaterObject = function replaceRepeaterObject(_ref28, payload) {
    var commit = _ref28.commit;
    return commit('REPLACE_REPEATER_OBJECT', payload);
};

/**
 * Trigger a replace of a repeater object
 *
 * @param  {Function} options.commit
 * @param  {Object|Null} payload
 * @return {Void}
 */
var setDebtObject = function setDebtObject(_ref29, payload) {
    var commit = _ref29.commit;
    return commit('SET_DEBT_OBJECT', payload);
};

/**
 * Save a draft of the current project form
 *
 * @param  {Object} options.state
 * @return {Promise}
 */
var actions_saveDraft = function saveDraft(_ref30) {
    var commit = _ref30.commit,
        state = _ref30.state;

    commit('SAVING_DRAFT');
    return HttpService["a" /* default */].post('projects/draft/', state.data).then(function () {
        return commit('RESET_SAVING_DRAFT');
    }).catch(function () {
        return commit('RESET_SAVING_DRAFT');
    });
};

/**
 * Restore the latest saved form draft
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var restoreDraft = function restoreDraft(_ref31) {
    var commit = _ref31.commit,
        dispatch = _ref31.dispatch;

    commit('RESTORE_DRAFT');
    dispatch('addNotification', {
        title: 'Draft Restored',
        type: 'success',
        text: 'The project has been restored to the latest draft.',
        timeout: true
    }, { root: true });
};

/**
 * Get the draft state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_getDraft = function getDraft(_ref32) {
    var commit = _ref32.commit;

    HttpService["a" /* default */].get('projects/draft/').then(function (res) {
        return commit('GET_DRAFT_SUCCESS', res.data);
    }).catch(function () {
        return commit('GET_DRAFT_FAILURE');
    });
};

/**
 * Reset the success state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var resetSuccessState = function resetSuccessState(_ref33) {
    var commit = _ref33.commit;
    return commit('RESET_SAVE_SUCCESS');
};

/**
 * Update the form's unit values dynamically
 *
 * @param  {Function} options.commit
 * @param  {Object} data
 * @return {Void}
 */
var updateUnitValues = function updateUnitValues(_ref34, data) {
    var commit = _ref34.commit;
    return commit('IMPORT_UNIT_VALUES', data);
};

/**
 * Update the opex via the importer
 *
 * @param  {Function} options.commit
 * @param  {Array} data
 * @return {Void}
 */
var ingestOpexValues = function ingestOpexValues(_ref35, data) {
    var commit = _ref35.commit;
    return commit('INGEST_OPEX', data);
};

/*
 * Update either the rent roll or opex file ID
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateFileId = function updateFileId(_ref36, payload) {
    var commit = _ref36.commit;
    return commit('UPDATE_FILE_ID', payload);
};

/**
 * Update all AGR values in the rental income repeater
 *
 * @param  {Function} options.commit
 * @param  {Number} value
 * @return {void}
 */
var updateAllAGR = function updateAllAGR(_ref37, value) {
    var commit = _ref37.commit;
    return commit('UPDATE_ALL_AGR', value);
};

/**
 * Update all AGR values in the rental opex repeater
 *
 * @param  {Function} options.commit
 * @param  {Number} value
 * @return {void}
 */
var actions_updateAllOpexAGR = function updateAllOpexAGR(_ref38, value) {
    var commit = _ref38.commit;
    return new promise_default.a(function (resolve, reject) {
        commit('UPDATE_ALL_OPEX_AGR', value);
        resolve();
    });
};

/**
 * Set the global form meta
 *
 * @param  {Function} options.commit
 * @param  {Object} meta
 * @return {Promise}
 */
var setFormMeta = function setFormMeta(_ref39, meta) {
    var commit = _ref39.commit;
    return commit('SET_FORM_META', meta);
};

/**
 * Delete a capex object
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_deleteCapex = function deleteCapex(_ref40, payload) {
    var commit = _ref40.commit,
        dispatch = _ref40.dispatch;

    commit('SET_CAPEX_LOADING');
    HttpService["a" /* default */].del('modelling/capex/' + payload.id + '/').then(function (res) {
        commit('REMOVE_CAPEX', payload);
        commit('RESET_CAPEX_LOADING');
        dispatch('addNotification', {
            title: 'Success',
            type: 'success',
            text: res.data,
            timeout: true
        }, { root: true });
    }).catch(function () {
        commit('RESET_CAPEX_LOADING');
        dispatch('addNotification', {
            title: 'Failed',
            type: 'error',
            text: 'The capital expense failed to delete.',
            timeout: true
        }, { root: true });
    });
};

var form_actions_updateCapex = function updateCapex(_ref41, payload) {
    var commit = _ref41.commit,
        dispatch = _ref41.dispatch;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].put('modelling/capex/' + payload.id + '/', payload.data).then(function (res) {
            commit('UPDATE_CAPEX', payload);
            dispatch('addNotification', {
                title: 'Success',
                type: 'success',
                text: 'Capex has been updated successfully.',
                timeout: true
            }, { root: true });
            resolve();
        }).catch(function (err) {
            return reject(err.response.data);
        });
    });
};

var replaceCapex = function replaceCapex(_ref42, payload) {
    var commit = _ref42.commit;
    return commit('UPDATE_CAPEX', payload);
};

var actions_setCapexOrder = function setCapexOrder(_ref43) {
    var state = _ref43.state,
        rootState = _ref43.rootState;
    return new promise_default.a(function (resolve, reject) {
        var order = keys_default()(state.data.capex).reduce(function (result, i) {
            if (Array.isArray(state.data.capex[i])) {
                result[i] = state.data.capex[i].map(function (item) {
                    return item.id;
                });
            }
            return result;
        }, {});
        HttpService["a" /* default */].put('projects/' + rootState.route.params.projectId + '/capex/', order).then(function (res) {
            return resolve();
        }).catch(function () {
            return resolve();
        });
    });
};

var replaceCapexRepeater = function replaceCapexRepeater(_ref44, payload) {
    var commit = _ref44.commit;
    return commit('REPLACE_CAPEX_REPEATER', payload);
};

var addCapex = function addCapex(_ref45, payload) {
    var commit = _ref45.commit;
    return commit('ADD_CAPEX', payload);
};

/* harmony default export */ var form_actions = ({
    addCapex: addCapex,
    getDraft: actions_getDraft,
    saveDraft: actions_saveDraft,
    setCapexOrder: actions_setCapexOrder,
    replaceCapex: replaceCapex,
    resetForm: resetForm,
    addNewDebt: addNewDebt,
    resetState: form_actions_resetState,
    updateCapex: form_actions_updateCapex,
    deleteCapex: actions_deleteCapex,
    setFormMeta: setFormMeta,
    updateAllAGR: updateAllAGR,
    updateFileId: updateFileId,
    addNewEquity: addNewEquity,
    selectOption: selectOption,
    restoreDraft: restoreDraft,
    changeFormTab: changeFormTab,
    setDebtObject: setDebtObject,
    clearFormError: clearFormError,
    setProjectData: actions_setProjectData,
    updateFormValue: updateFormValue,
    updateAllOpexAGR: actions_updateAllOpexAGR,
    ingestOpexValues: ingestOpexValues,
    updateCapexValue: updateCapexValue,
    setUpProjectForm: actions_setUpProjectForm,
    updateUnitValues: updateUnitValues,
    resetSuccessState: resetSuccessState,
    submitProjectForm: actions_submitProjectForm,
    removeCapexObject: actions_removeCapexObject,
    copyAndInsertCapex: actions_copyAndInsertCapex,
    updateExistingDebt: updateExistingDebt,
    addRepeatableObject: actions_addRepeatableObject,
    projectChoicesReset: projectChoicesReset,
    updateExistingEquity: updateExistingEquity,
    removeExistingEquity: removeExistingEquity,
    replaceRepeaterObject: replaceRepeaterObject,
    replaceCapexRepeater: replaceCapexRepeater,
    submitProjectEditForm: actions_submitProjectEditForm,
    updateRelativeAmounts: updateRelativeAmounts,
    setWorkingCapitalModel: actions_setWorkingCapitalModel,
    removeRepeatableObject: removeRepeatableObject,
    removeWorkingCapitalModel: removeWorkingCapitalModel,
    updateExistingCapexObject: updateExistingCapexObject,
    updateRepeatableObjectValue: updateRepeatableObjectValue,
    updateRepeatableObjectPosition: actions_updateRepeatableObjectPosition
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("RRo+");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// CONCATENATED MODULE: ./src/state/modules/projects/form/mutations.js



/**
 * Mutation Dependencies
 */




/**
 * Handle a user selected option on the project choice wizard
 *
 * @param  {Object} state
 * @return {Void}
 */
var PROJECT_MAKE_SELECTION = function PROJECT_MAKE_SELECTION(state, params) {
    if (params.target === 'primary') {
        state.projectChoices.selected.secondary = null;
    }
    var context = state.projectChoices.selected[params.target];
    state.projectChoices.selected[params.target] = context === params.value ? null : params.value;
};

/**
 * Update the form tab
 *
 * @param  {Object} state
 * @param  {String} tab
 * @return {Void}
 */
var CHANGE_FORM_TAB = function CHANGE_FORM_TAB(state, tab) {
    state.activeTab = tab;
};

/**
 * Reset the project choice wizard to its default state
 *
 * @param  {Object} state
 * @return {Void}
 */
var PROJECT_CHOICES_RESET = function PROJECT_CHOICES_RESET(state) {
    state.projectChoices.selected.secondary = null;
    state.projectChoices.selected.primary = null;
};

/**
 * Update a value on the form state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_UPDATE_PROJECT_VALUE = function UPDATE_PROJECT_VALUE(state, payload) {
    var target = Object(lodash["get"])(state.data, payload.base, false);
    if (target) {
        if (!state.dirty) {
            state.dirty = true;
        }
        target[payload.target] = payload.value;
    }
};

/**
 * Handle failed entry
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_PROJECT_VALUE_FAILED = function UPDATE_PROJECT_VALUE_FAILED(state, payload) {
    console.log(payload);
};

/**
 * Set the project loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PROJECT_FORM = function GET_PROJECT_FORM(state) {
    state.pending = true;
};

/**
 * Push a new debt object to the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var ADD_NEW_DEBT = function ADD_NEW_DEBT(state, payload) {
    state.data.debt.debt.push(payload);
};

/**
 * Update the state of an existing debt record
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_EXISTING_DEBT = function UPDATE_EXISTING_DEBT(state, payload) {
    state.data.debt.debt.splice(payload.index, 1, payload.value);
};

/**
 * Successful project form retrieval
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_SET_PROJECT_FORM = function SET_PROJECT_FORM(state, payload) {
    vue_esm["a" /* default */].set(state, 'options', payload.options);
    vue_esm["a" /* default */].set(state, 'data', payload.model);
    vue_esm["a" /* default */].set(state, 'tabs', payload.tabs);
    if (!state.data.meta) {
        vue_esm["a" /* default */].set(state.data, 'meta', {
            rentroll_file_id: null,
            pnl_file_id: null
        });
    }
    state.pending = false;
    state.loaded = true;
};

/**
 * Failed form retrieval
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PROJECT_FORM_FAILURE = function GET_PROJECT_FORM_FAILURE(state) {
    state.pending = false;
    state.loaded = false;
};

/**
 * Reset the form
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_RESET_FORM = function RESET_FORM(state) {
    state.data = {};
    state.errors = {};
    state.options = {};
    state.tabs = [];
    state.activeTab = 'project';
    state.dirty = false;
    state.pending = false;
    state.success = false;
    state.loaded = false;
};

/**
 * Push a new object to a repeatable form array
 *
 * @param  {Object} payload
 * @param  {Object} state
 * @return {Void}
 */
var mutations_ADD_REPEATABLE_PROJECT_VALUE = function ADD_REPEATABLE_PROJECT_VALUE(state, obj) {
    var base = Object(lodash["get"])(state.data, obj.base, false);
    if (base) {
        if (!state.dirty) {
            state.dirty = true;
        }
        if (obj.insertAfter !== undefined) {
            base[obj.target].splice(obj.insertAfter + 1, 0, obj.payload);
        } else {
            base[obj.target].push(obj.payload);
        }
    }
};

/**
 * TODO
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_REPEATABLE_PROJECT_VALUE = function UPDATE_REPEATABLE_PROJECT_VALUE(state, payload) {};

/**
 * Remove a repeater object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_REMOVE_REPEATABLE_PROJECT_VALUE = function REMOVE_REPEATABLE_PROJECT_VALUE(state, payload) {
    var target = Object(lodash["get"])(state.data, payload.base, false);
    if (target) {
        target.splice(payload.index, 1);
    }
};

/**
 * Modify the position of a repeater object in the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_UPDATE_REPEATABLE_PROJECT_VALUE_POSITION = function UPDATE_REPEATABLE_PROJECT_VALUE_POSITION(state, payload) {
    var target = Object(lodash["get"])(state.data, payload.base, false);
    if (target) {
        target.splice(payload.newIndex, 0, target.splice(payload.oldIndex, 1)[0]);
    }
};

/**
 * Update an error's array index value to match the new index
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_UPDATE_ERROR_INDEX = function UPDATE_ERROR_INDEX(state, payload) {
    var target = Object(lodash["get"])(state.errors, payload.base, false);
    if (target) {
        target[payload.currentIndex].index = payload.newIndex;
    }
};

/**
 * Updte an existing CAPEX state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_UPDATE_EXISTING_CAPEX = function UPDATE_EXISTING_CAPEX(state, payload) {
    var target = Object(lodash["get"])(state.data.capex, payload.base, false);
    if (target) {
        target.splice(payload.index, 1, payload.value);
    }
};

/**
 * Update the state of a repeatable object value
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_UPDATE_REPEATABLE_OBJECT_VALUE = function UPDATE_REPEATABLE_OBJECT_VALUE(state, payload) {
    var target = Object(lodash["get"])(state.data, payload.base, false);
    if (target) {
        target[payload.target] = payload.value;
    }
};

/**
 * Replace an entire repeater object with a new one
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_REPLACE_REPEATER_OBJECT = function REPLACE_REPEATER_OBJECT(state, payload) {
    var target = Object(lodash["get"])(state.data, payload.base, false);
    if (target) {
        target.splice(payload.index, 1, payload.value);
    }
};

/**
 * Add a new equity object to the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var ADD_NEW_EQUITY = function ADD_NEW_EQUITY(state, payload) {
    state.data.equity[payload.key].push(payload.data);
};

/**
 * Update an existing equity object in the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_EXISTING_EQUITY = function UPDATE_EXISTING_EQUITY(state, payload) {
    state.data.equity[payload.key].splice(payload.index, 1, payload.value);
};

/**
 * Remove an existing equity object from the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {object}
 */
var REMOVE_EQUITY = function REMOVE_EQUITY(state, payload) {
    state.data.equity[payload.key].splice(payload.index, 1);
};

/**
 * Set the pending state of the project form
 *
 * @param  {Object} state
 * @return {Void}
 */
var PROJECT_SAVE = function PROJECT_SAVE(state) {
    state.attemptingSave = true;
};

/**
 * Set the success parameters on the state object.
 *
 * @param  {Object} state
 * @return {Void}
 */
var PROJECT_SAVE_SUCCESS = function PROJECT_SAVE_SUCCESS(state) {
    state.success = true;
    state.attemptingSave = false;
};

/**
 * Reset the success params
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_SAVE_SUCCESS = function RESET_SAVE_SUCCESS(state) {
    state.success = false;
    state.attemptingSave = false;
};

/**
 * Handle a failed POST request and assign the state errors
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var PROJECT_SAVE_FAILURE = function PROJECT_SAVE_FAILURE(state, errors) {
    state.errors = errors;
    state.attemptingSave = false;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var form_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = form_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Remove an error key in the errors object state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_REMOVE_ERROR_KEY = function REMOVE_ERROR_KEY(state, payload) {
    var base = Object(lodash["get"])(state.errors, payload.base, null);

    if (is_integer_default()(payload.index) && payload.type !== undefined) {
        var idx = state.errors[payload.base][payload.type].findIndex(function (error) {
            return error.index === payload.index;
        });

        if (idx > -1) {
            vue_esm["a" /* default */].delete(state.errors[payload.base][payload.type][idx], payload.key);
            var objectKeys = keys_default()(state.errors[payload.base][payload.type][idx]);
            if (objectKeys.length === 1 && objectKeys[0] === 'index') {
                state.errors[payload.base][payload.type].splice(idx, 1);
            }
        }

        if (state.errors[payload.base][payload.type].length === 0) {
            vue_esm["a" /* default */].delete(state.errors[payload.base], payload.type);
        }
    } else {
        vue_esm["a" /* default */].delete(base, payload.key);
    }

    if (Object(lodash["isEmpty"])(base)) {
        var split = payload.base.split('.');
        if (split.length > 1) {
            for (var i = split.length - 1; i >= 0; i--) {
                if (i > 0) {
                    if (Object(lodash["isEmpty"])(state.errors[split[0]][split[i]])) {
                        vue_esm["a" /* default */].delete(state.errors[split[0]], split[i]);
                    }
                }
            }
            if (Object(lodash["isEmpty"])(state.errors[split[0]])) {
                vue_esm["a" /* default */].delete(state.errors, split[0]);
            }
        } else {
            vue_esm["a" /* default */].delete(state.errors, payload.base);
        }
    }
};

/**
 * Remove a non-relative object from a relative capex item when the non-relative item has been removed
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_REMOVE_DELETED_RELATIVE_VALUE = function REMOVE_DELETED_RELATIVE_VALUE(state, payload) {
    var target = Object(lodash["get"])(state, payload.path);
    if (target) {
        target.splice(payload.index, 1);
    }
};

/**
 * Remove an error in the capex
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_REMOVE_CAPEX_ERROR = function REMOVE_CAPEX_ERROR(state, payload) {
    state.errors.capex[payload.type].splice(payload.index, 1);
    if (state.errors.capex[payload.type].length === 0) {
        vue_esm["a" /* default */].delete(state.errors.capex, payload.type);
    }
    if (Object(lodash["isEmpty"])(state.errors.capex)) {
        vue_esm["a" /* default */].delete(state.errors, 'capex');
    }
};

/**
 * Insert the cloned capex into the capex array
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var ADD_CAPEX_CLONE = function ADD_CAPEX_CLONE(state, payload) {
    state.data.capex[payload.type].splice(payload.index, 0, payload.clone);
};

/**
 * Update a capex value
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_UPDATE_RELATIVE_VALUE = function UPDATE_RELATIVE_VALUE(state, payload) {
    var relativeItems = Object(lodash["get"])(state.data, payload.base);
    relativeItems[payload.index].amount = payload.value;
};

/**
 * Apply a fresh working capital model to the appropriate serializer key
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_SET_WORKING_CAPITAL_MODEL = function SET_WORKING_CAPITAL_MODEL(state, payload) {
    vue_esm["a" /* default */].set(state.data.capex, 'WorkingCapitalSerializer', payload);
};

/**
 * Nullify the working capital model key
 *
 * @param  {Object} state
 * @return {Void}
 */
var REMOVE_WORKING_CAPITAL_MODEL = function REMOVE_WORKING_CAPITAL_MODEL(state) {
    state.data.capex['WorkingCapitalSerializer'] = null;
};

/**
 * Update the base debt object
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_DEBT_OBJECT = function SET_DEBT_OBJECT(state, payload) {
    state.data.debt = payload;
};

/**
 * Restore a draft state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_DRAFT_SUCCESS = function GET_DRAFT_SUCCESS(state, payload) {
    state.draft = payload;
};

/**
 * Reset the draft state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_DRAFT_FAILURE = function GET_DRAFT_FAILURE(state) {
    state.draft = {};
};

/**
 * Restore a project to the draft state
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_RESTORE_DRAFT = function RESTORE_DRAFT(state) {
    if (!Object(lodash["isEmpty"])(state.draft)) {
        vue_esm["a" /* default */].set(state, 'data', Object(lodash["cloneDeep"])(state.draft));
    }
};

/**
 * Set the edit state from new data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_SET_EDIT_PAYLOAD = function SET_EDIT_PAYLOAD(state, payload) {
    vue_esm["a" /* default */].set(state, 'data', Object(lodash["cloneDeep"])(payload.data));
    vue_esm["a" /* default */].set(state, 'meta', Object(lodash["cloneDeep"])(payload.meta));
};

/**
 * Set the draft state
 *
 * @param  {Object} state
 * @return {Void}
 */
var SAVING_DRAFT = function SAVING_DRAFT(state) {
    state.saving_draft = true;
};

/**
 * Reset the draft state
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_SAVING_DRAFT = function RESET_SAVING_DRAFT(state) {
    state.saving_draft = false;
};

/**
 * Set the unit values on the state's form object
 *
 * @param  {Object} state
 * @param  {Object} data
 * @return {Void}
 */
var mutations_IMPORT_UNIT_VALUES = function IMPORT_UNIT_VALUES(state, data) {
    keys_default()(data).forEach(function (key) {
        if (state.data.unit[key]) {
            state.data.unit[key] = data[key];
        }
    });
};

/**
 * Set the OPEX values
 *
 * @param  {Object} state
 * @param  {Array} data
 * @return {Void}
 */
var INGEST_OPEX = function INGEST_OPEX(state, data) {
    state.data.opex['OperatingExpenseSerializer'] = data['OperatingExpenseSerializer'];
    state.data.unit['MiscellaneousIncomePerUnitSerializer'] = data['MiscellaneousIncomePerUnitSerializer'];
};

/*
 * Update a uploaded file ID
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_FILE_ID = function UPDATE_FILE_ID(state, payload) {
    state.data.meta[payload.type] = payload.id;
};

/**
 * Update the AGR values on all rental income
 *
 * @param  {Object} state
 * @param  {Number} value
 * @return {Void}
 */
var UPDATE_ALL_AGR = function UPDATE_ALL_AGR(state, value) {
    state.data.unit.UnitResidentialSerializer = state.data.unit.UnitResidentialSerializer.map(function (i) {
        i.rental_annual_growth_rate = value;
        return i;
    });
};

/**
 * Update the AGR values on all rental income
 *
 * @param  {Object} state
 * @param  {Number} value
 * @return {Void}
 */
var UPDATE_ALL_OPEX_AGR = function UPDATE_ALL_OPEX_AGR(state, value) {
    state.data.opex.OperatingExpenseSerializer = state.data.opex.OperatingExpenseSerializer.map(function (i) {
        i.terminal_agr = value;
        return i;
    });
};

/**
 * Set the form metadata
 *
 * @param  {Object} state
 * @param  {Object} meta
 * @return {Void}
 */
var SET_FORM_META = function SET_FORM_META(state, meta) {
    state.meta = meta;
};

var REMOVE_CAPEX = function REMOVE_CAPEX(state, payload) {
    state.data.capex[payload.type] = state.data.capex[payload.type].filter(function (i) {
        return i.id !== payload.id;
    });
};

var SET_CAPEX_LOADING = function SET_CAPEX_LOADING(state) {
    state.capex_loading = true;
};

var RESET_CAPEX_LOADING = function RESET_CAPEX_LOADING(state) {
    state.capex_loading = false;
};

var mutations_UPDATE_CAPEX = function UPDATE_CAPEX(state, payload) {
    var idx = state.data.capex[payload.type].findIndex(function (i) {
        return i.id === payload.id;
    });
    state.data.capex[payload.type].splice(idx, 1, JSON.parse(stringify_default()(payload.data)));
};

var REPLACE_CAPEX_REPEATER = function REPLACE_CAPEX_REPEATER(state, payload) {
    var abbr = null;
    switch (payload.type) {
        case 'AcquisitionCostSerializer':
            abbr = 'AC';
            break;
        case 'HardCostSerializer':
            abbr = 'HC';
            break;
        case 'SoftCostSerializer':
            abbr = 'SC';
            break;
        default:
            abbr = null;
    }
    state.data.capex[payload.type] = payload.data.map(function (i) {
        i.capex_type = abbr;
        return i;
    });
};

var ADD_CAPEX = function ADD_CAPEX(state, payload) {
    state.data.capex[payload.type].push(payload.data);
};

/* harmony default export */ var form_mutations = ({
    ADD_CAPEX: ADD_CAPEX,
    UPDATE_CAPEX: mutations_UPDATE_CAPEX,
    REPLACE_CAPEX_REPEATER: REPLACE_CAPEX_REPEATER,
    SET_CAPEX_LOADING: SET_CAPEX_LOADING,
    RESET_CAPEX_LOADING: RESET_CAPEX_LOADING,
    RESET_FORM: mutations_RESET_FORM,
    INGEST_OPEX: INGEST_OPEX,
    RESET_STATE: form_mutations_RESET_STATE,
    SAVING_DRAFT: SAVING_DRAFT,
    PROJECT_SAVE: PROJECT_SAVE,
    ADD_NEW_DEBT: ADD_NEW_DEBT,
    REMOVE_CAPEX: REMOVE_CAPEX,
    SET_FORM_META: SET_FORM_META,
    RESTORE_DRAFT: mutations_RESTORE_DRAFT,
    REMOVE_EQUITY: REMOVE_EQUITY,
    ADD_NEW_EQUITY: ADD_NEW_EQUITY,
    UPDATE_FILE_ID: UPDATE_FILE_ID,
    UPDATE_ALL_AGR: UPDATE_ALL_AGR,
    SET_DEBT_OBJECT: SET_DEBT_OBJECT,
    CHANGE_FORM_TAB: CHANGE_FORM_TAB,
    ADD_CAPEX_CLONE: ADD_CAPEX_CLONE,
    SET_PROJECT_FORM: mutations_SET_PROJECT_FORM,
    GET_PROJECT_FORM: GET_PROJECT_FORM,
    REMOVE_ERROR_KEY: mutations_REMOVE_ERROR_KEY,
    GET_DRAFT_FAILURE: GET_DRAFT_FAILURE,
    GET_DRAFT_SUCCESS: GET_DRAFT_SUCCESS,
    IMPORT_UNIT_VALUES: mutations_IMPORT_UNIT_VALUES,
    RESET_SAVING_DRAFT: RESET_SAVING_DRAFT,
    RESET_SAVE_SUCCESS: RESET_SAVE_SUCCESS,
    UPDATE_ERROR_INDEX: mutations_UPDATE_ERROR_INDEX,
    REMOVE_CAPEX_ERROR: mutations_REMOVE_CAPEX_ERROR,
    UPDATE_ALL_OPEX_AGR: UPDATE_ALL_OPEX_AGR,
    PROJECT_SAVE_SUCCESS: PROJECT_SAVE_SUCCESS,
    PROJECT_SAVE_FAILURE: PROJECT_SAVE_FAILURE,
    UPDATE_PROJECT_VALUE: mutations_UPDATE_PROJECT_VALUE,
    UPDATE_EXISTING_DEBT: UPDATE_EXISTING_DEBT,
    UPDATE_RELATIVE_VALUE: mutations_UPDATE_RELATIVE_VALUE,
    PROJECT_CHOICES_RESET: PROJECT_CHOICES_RESET,
    UPDATE_EXISTING_CAPEX: mutations_UPDATE_EXISTING_CAPEX,
    PROJECT_MAKE_SELECTION: PROJECT_MAKE_SELECTION,
    UPDATE_EXISTING_EQUITY: UPDATE_EXISTING_EQUITY,
    REPLACE_REPEATER_OBJECT: mutations_REPLACE_REPEATER_OBJECT,
    GET_PROJECT_FORM_FAILURE: GET_PROJECT_FORM_FAILURE,
    SET_EDIT_PAYLOAD: mutations_SET_EDIT_PAYLOAD,
    SET_WORKING_CAPITAL_MODEL: mutations_SET_WORKING_CAPITAL_MODEL,
    UPDATE_PROJECT_VALUE_FAILED: UPDATE_PROJECT_VALUE_FAILED,
    REMOVE_WORKING_CAPITAL_MODEL: REMOVE_WORKING_CAPITAL_MODEL,
    ADD_REPEATABLE_PROJECT_VALUE: mutations_ADD_REPEATABLE_PROJECT_VALUE,
    REMOVE_DELETED_RELATIVE_VALUE: mutations_REMOVE_DELETED_RELATIVE_VALUE,
    UPDATE_REPEATABLE_OBJECT_VALUE: mutations_UPDATE_REPEATABLE_OBJECT_VALUE,
    UPDATE_REPEATABLE_PROJECT_VALUE: UPDATE_REPEATABLE_PROJECT_VALUE,
    REMOVE_REPEATABLE_PROJECT_VALUE: mutations_REMOVE_REPEATABLE_PROJECT_VALUE,
    UPDATE_REPEATABLE_PROJECT_VALUE_POSITION: mutations_UPDATE_REPEATABLE_PROJECT_VALUE_POSITION
});
// CONCATENATED MODULE: ./src/state/modules/projects/form/lease-up-schedules/state.js
/**
 * Dependencies
 */


/**
 * CAPEX modal state
 *
 * @type {Object}
 */
var lease_up_schedules_state_state = {
  loading: false,
  errors: [],
  data: [],
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var lease_up_schedules_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(lease_up_schedules_state_state);
};

/* harmony default export */ var lease_up_schedules_state = (lease_up_schedules_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/form/lease-up-schedules/getters.js
/**
 * Return a list of selectable schedule options
 *
 * @param  {Object} state
 * @return {Array}
 */
var scheduleOptions = function scheduleOptions(state) {
    return state.data.map(function (i) {
        return {
            key: i.id,
            label: i.name
        };
    });
};

/**
 * Determine if there are schedules in the dataset
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasAvailableSchedules = function hasAvailableSchedules(state) {
    return state.data.length > 0;
};

/* harmony default export */ var lease_up_schedules_getters = ({
    scheduleOptions: scheduleOptions,
    hasAvailableSchedules: hasAvailableSchedules
});
// CONCATENATED MODULE: ./src/state/modules/projects/form/lease-up-schedules/actions.js

/**
 * Dependencies
 */


/**
 * Reset the module state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var lease_up_schedules_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;
    return commit('RESET_STATE');
};

/**
 * Retrieve the lease up schedules
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Promise}
 */
var actions_getSchedules = function getSchedules(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/lease-up-schedules/').then(function (res) {
            commit('SET_DATA', res.data);
            resolve(res.data);
        }).catch(function (err) {
            commit('SET_ERROR', err.response.data);
            reject(err);
        });
    });
};

/**
 * Create a new schedule
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Promise}
 */
var actions_createSchedule = function createSchedule(_ref3, form) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;
    return new promise_default.a(function (resolve, reject) {
        commit('RESET_ERRORS');
        HttpService["a" /* default */].post('projects/' + rootState.route.params.projectId + '/lease-up-schedules/', form).then(function (res) {
            commit('ADD_DATA', res.data);
            resolve();
        }).catch(function (err) {
            commit('SET_ERRORS', err.response.data.steps);
            reject(err);
        });
    });
};

/* harmony default export */ var lease_up_schedules_actions = ({
    resetState: lease_up_schedules_actions_resetState,
    getSchedules: actions_getSchedules,
    createSchedule: actions_createSchedule
});
// CONCATENATED MODULE: ./src/state/modules/projects/form/lease-up-schedules/mutations.js
/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var lease_up_schedules_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = lease_up_schedules_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the data state
 *
 * @param  {Object} state
 * @param  {Array} data
 * @return {Void}
 */
var SET_DATA = function SET_DATA(state, data) {
    state.data = data;
};

/**
 * Set the state error
 *
 * @param  {Object} state
 * @param  {String|Promise} error
 * @return {Void}
 */
var SET_ERRORS = function SET_ERRORS(state, errors) {
    state.errors = errors;
};

var RESET_ERRORS = function RESET_ERRORS(state) {
    state.errors = [];
};

/**
 * Add a schedule to the dataset
 *
 * @param  {Objcet} state
 * @param  {Object} item
 * @return {Void}
 */
var ADD_DATA = function ADD_DATA(state, item) {
    state.data.push(item);
};

/* harmony default export */ var lease_up_schedules_mutations = ({
    ADD_DATA: ADD_DATA,
    SET_DATA: SET_DATA,
    SET_ERRORS: SET_ERRORS,
    RESET_STATE: lease_up_schedules_mutations_RESET_STATE,
    RESET_ERRORS: RESET_ERRORS
});
// CONCATENATED MODULE: ./src/state/modules/projects/form/lease-up-schedules/index.js
/**
 * Module Dependencies
 */





/**
 * CAPEX Module Declaration
 *
 * @type {Object}
 */
var lease_up_schedules_module = {
  namespaced: true,
  state: lease_up_schedules_state,
  getters: lease_up_schedules_getters,
  mutations: lease_up_schedules_mutations,
  actions: lease_up_schedules_actions
};

/* harmony default export */ var lease_up_schedules = (lease_up_schedules_module);
// CONCATENATED MODULE: ./src/state/modules/projects/form/index.js
/**
 * Module Dependencies
 */







/**
 * Project Form Module Declaration
 *
 * @type {Object}
 */
var form_module = {
    namespaced: true,
    state: form_state,
    getters: form_getters,
    mutations: form_mutations,
    actions: form_actions,
    modules: {
        capex: capex,
        leaseUpSchedules: lease_up_schedules
    }
};

/* harmony default export */ var projects_form = (form_module);
// CONCATENATED MODULE: ./src/state/modules/projects/actions.js

/**
 * Action Dependencies
 */


/**
 * Retrieve the projects from the API
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var projects_actions_getProjects = function getProjects(_ref) {
    var commit = _ref.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    commit('GET_PROJECTS');
    setTimeout(function () {
        return Object(ProjectService["e" /* fetchProjects */])(params).then(function (res) {
            commit('GET_PROJECTS_SUCCESS', res.data);
            return res.data;
        }).catch(function (err) {
            commit('GET_PROJECTS_FAILED');
            return err;
        });
    }, 500);
};

/**
 * Reset the project list
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_resetProjects = function resetProjects(_ref2) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
        commit('RESET_PROJECT_LIST_DATA');
        resolve('reset');
    });
};

/**
 * Set the project data
 *
 * @param  {Object} options.commit
 * @param  {Object} data
 * @return {Promise}
 */
var projects_actions_setProjectData = function setProjectData(_ref3, data) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
        commit('SET_PROJECT_LIST', data);
        setTimeout(function () {
            commit('RESET_PENDING_PROJECTS');
            resolve(data);
        }, 3000);
    });
};

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var projects_actions_resetState = function resetState(_ref4) {
    var commit = _ref4.commit;

    commit('RESET_STATE');
};

/**
 * Replace the project data
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {object} payload
 * @return {Void}
 */
var replaceProjectData = function replaceProjectData(_ref5, payload) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var target = state.data[payload.index];
    if (target && target.id === payload.project.id) {
        commit('REPLACE_PROJECT_DATA', payload);
    }
};

/**
 * Change the layout rendering engine
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var toggleLayout = function toggleLayout(_ref6, payload) {
    var commit = _ref6.commit;

    commit('UPDATE_LAYOUT', payload);
};

/* harmony default export */ var projects_actions = ({
    resetState: projects_actions_resetState,
    getProjects: projects_actions_getProjects,
    toggleLayout: toggleLayout,
    resetProjects: actions_resetProjects,
    setProjectData: projects_actions_setProjectData,
    replaceProjectData: replaceProjectData
});
// CONCATENATED MODULE: ./src/state/modules/projects/getters.js
/**
 * Retrieve the project list data
 *
 * @param  {Object} state
 * @return {Object}
 */
var projectList = function projectList(state) {
    return state.data;
};

/**
 * Determine if the project list has been loaded
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasLoaded = function hasLoaded(state) {
    return state.loaded;
};

/**
 * Retrieve the project list meta
 *
 * @param  {Object} state
 * @return {Object}
 */
var projectMeta = function projectMeta(state) {
    return state.meta;
};

/**
 * Retrieve the entire project list object
 *
 * @param  {Object} state
 * @return {Object}
 */
var projectData = function projectData(state) {
    return {
        data: state.data,
        meta: state.meta
    };
};

/* harmony default export */ var projects_getters = ({
    hasLoaded: hasLoaded,
    projectMeta: projectMeta,
    projectList: projectList
});
// CONCATENATED MODULE: ./src/state/modules/projects/share/state.js
/**
 * Dependencies
 */


/**
 * State Declaration
 *
 * @type {Object}
 */
var share_state_base = {
    project: {},
    form: {
        pending: false,
        successMessage: null,
        email: '',
        level: null,
        error: null
    },
    showDialog: false,
    link: {
        pending: false,
        url: null,
        pin: null
    }
};

var share_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(share_state_base);
};

/* harmony default export */ var share_state = (share_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/share/actions.js
/**
 * Dependencies
 */


/**
 * Update the project share form email
 *
 * @param  {Function} options.commit
 * @param  {String} value
 * @return {Void}
 */
var updateShareFormEmail = function updateShareFormEmail(_ref, value) {
    var commit = _ref.commit,
        state = _ref.state;

    commit('SET_SHARE_EMAIL', value);
    if (state.form.error) {
        commit('REMOVE_ERROR_MESSAGE');
    }
};

/**
 * Reset the share form
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var resetShareForm = function resetShareForm(_ref2) {
    var commit = _ref2.commit;

    commit('RESET_SHARE_FORM');
};

/**
 * Update the selected project share level
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var updateSelectedLevel = function updateSelectedLevel(_ref3, value) {
    var commit = _ref3.commit;

    commit('SET_SHARE_LEVEL', value);
};

/**
 * Make request to share a given project
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
var actions_shareProject = function shareProject(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('SUBMIT_SHARE_FORM');
    setTimeout(function () {
        Object(ProjectService["s" /* shareProjectWithUser */])(state.form.email, state.form.level, state.project.id).then(function (res) {
            return commit('PROJECT_SHARED_SUCCESS', res.data);
        }).catch(function (err) {
            return commit('PROJECT_SHARED_FAILURE', err);
        });
    }, 500);
};

/**
 * Set up the sharing dialog
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var setUpShareDialog = function setUpShareDialog(_ref5, project) {
    var commit = _ref5.commit;

    commit('SET_SHARE_DIALOG', project);
};

/**
 * Reset the sharing dialog
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var tearDownShareDialog = function tearDownShareDialog(_ref6) {
    var commit = _ref6.commit;

    commit('RESET_SHARE_DIALOG');
    setTimeout(function () {
        commit('RESET_STATE');
    }, 300);
};

/**
 * Get a shareable link from the API
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
var actions_generateShareLink = function generateShareLink(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state;

    commit('CREATE_LINK');
    return Object(ProjectService["c" /* createProjectLink */])(state.project.id).then(function (res) {
        return commit('CREATE_LINK_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('CREATE_LINK_FAILURE', err);
    });
};

/* harmony default export */ var share_actions = ({
    shareProject: actions_shareProject,
    resetShareForm: resetShareForm,
    setUpShareDialog: setUpShareDialog,
    generateShareLink: actions_generateShareLink,
    tearDownShareDialog: tearDownShareDialog,
    updateSelectedLevel: updateSelectedLevel,
    updateShareFormEmail: updateShareFormEmail
});
// CONCATENATED MODULE: ./src/state/modules/projects/share/getters.js
/**
 * Check the validity of the share form
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var shareFormIsValid = function shareFormIsValid(state) {
    var format = /[^\s@]+@[^\s@]+\.[^\s@]+/;

    return format.test(state.form.email) && state.form.level !== null;
};

/* harmony default export */ var share_getters = ({
    shareFormIsValid: shareFormIsValid
});
// CONCATENATED MODULE: ./src/state/modules/projects/share/mutations.js
/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var share_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = share_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Apply share dialog data and set the state
 *
 * @param  {Object} state
 * @param  {Object} project
 * @return {Void}
 */
var SET_SHARE_DIALOG = function SET_SHARE_DIALOG(state, project) {
    state.project = project;
    state.showDialog = true;
};

/**
 * Reset the shared project state
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_RESET_SHARED_PROJECT = function RESET_SHARED_PROJECT(state) {
    var originalState = share_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Reset the share dialog and state parameters
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_SHARE_DIALOG = function RESET_SHARE_DIALOG(state) {
    state.project = {};
    state.showDialog = false;
    state.form.successMessage = null;
    state.form.email = '';
    state.form.level = null;
    state.form.pending = false;
    state.link.pending = false;
    state.link.url = null;
    state.link.pin = null;
};

/**
 * Set the share form email
 *
 * @param  {Object} state
 * @param  {String} email
 * @return {Void}
 */
var SET_SHARE_EMAIL = function SET_SHARE_EMAIL(state, email) {
    state.form.email = email;
};

/**
 * Set the share form level
 *
 * @param  {Object} state
 * @param  {Number} level
 * @return {Void}
 */
var SET_SHARE_LEVEL = function SET_SHARE_LEVEL(state, level) {
    state.form.level = level;
};

/**
 * Reset the share form
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_SHARE_FORM = function RESET_SHARE_FORM(state) {
    state.form.successMessage = null;
    state.form.email = '';
    state.form.level = null;
    state.form.pending = false;
};

/**
 * Handle successful project share request
 *
 * @param  {Object} state
 * @return {Void}
 */
var PROJECT_SHARED_FAILURE = function PROJECT_SHARED_FAILURE(state, err) {
    state.form.error = err.response.data;
    state.form.pending = false;
};

/**
 * Set the share form submission state
 *
 * @param  {Object} state
 * @return {Void}
 */
var SUBMIT_SHARE_FORM = function SUBMIT_SHARE_FORM(state) {
    state.form.pending = true;
};

/**
 * Handle successful project share request
 *
 * @param  {Object} state
 * @return {Void}
 */
var PROJECT_SHARED_SUCCESS = function PROJECT_SHARED_SUCCESS(state, message) {
    state.form.successMessage = message;
    state.form.pending = false;
};

var CREATE_LINK = function CREATE_LINK(state) {
    state.link.pending = true;
};

/**
 * Set the successful link generation state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var CREATE_LINK_SUCCESS = function CREATE_LINK_SUCCESS(state, payload) {
    state.link.pending = false;
    state.link.url = payload.url;
    state.link.pin = payload.pin;
};

/**
 * Set the failed link generation state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var CREATE_LINK_FAILURE = function CREATE_LINK_FAILURE(state, payload) {
    state.link.pending = false;
    state.link.url = null;
    state.link.pin = null;
};

var REMOVE_ERROR_MESSAGE = function REMOVE_ERROR_MESSAGE(state) {
    state.form.error = null;
};

/* harmony default export */ var share_mutations = ({
    CREATE_LINK: CREATE_LINK,
    RESET_STATE: share_mutations_RESET_STATE,
    SET_SHARE_EMAIL: SET_SHARE_EMAIL,
    SET_SHARE_LEVEL: SET_SHARE_LEVEL,
    RESET_SHARE_FORM: RESET_SHARE_FORM,
    SET_SHARE_DIALOG: SET_SHARE_DIALOG,
    SUBMIT_SHARE_FORM: SUBMIT_SHARE_FORM,
    RESET_SHARE_DIALOG: RESET_SHARE_DIALOG,
    CREATE_LINK_SUCCESS: CREATE_LINK_SUCCESS,
    CREATE_LINK_FAILURE: CREATE_LINK_FAILURE,
    RESET_SHARED_PROJECT: mutations_RESET_SHARED_PROJECT,
    PROJECT_SHARED_FAILURE: PROJECT_SHARED_FAILURE,
    PROJECT_SHARED_SUCCESS: PROJECT_SHARED_SUCCESS,
    REMOVE_ERROR_MESSAGE: REMOVE_ERROR_MESSAGE
});
// CONCATENATED MODULE: ./src/state/modules/projects/share/index.js
/**
 * Module Dependencies
 */





/**
 * Project Share Module Declaration
 *
 * @type {Object}
 */
var share_module = {
  namespaced: true,
  state: share_state,
  getters: share_getters,
  mutations: share_mutations,
  actions: share_actions
};

/* harmony default export */ var share = (share_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/gaap/state.js
/**
 * Dependencies
 */


var gaap_state_base = {
  loaded: false,
  data: {},
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var gaap_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(gaap_state_base);
};

/* harmony default export */ var gaap_state = (gaap_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/gaap/actions.js
/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var gaap_actions_resetState = function resetState(_ref) {
  var commit = _ref.commit;

  commit('RESET_STATE');
};

/**
 * Get the tearsheet for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var actions_getData = function getData(_ref2) {
  var commit = _ref2.commit,
      rootState = _ref2.rootState;

  HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/gaap/').then(function (res) {
    return commit('GET_DATA_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_DATA_FAILURE');
  });
};

/* harmony default export */ var gaap_actions = ({
  getData: actions_getData,
  resetState: gaap_actions_resetState
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/gaap/getters.js
var gaap_getters = __webpack_require__("xHDB");
var gaap_getters_default = /*#__PURE__*/__webpack_require__.n(gaap_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/gaap/mutations.js
/**
 * Dependencies
 */



/**
 * Set the tearsheet data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data.data;
    state.loaded = true;
};

/**
 * Set the tearsheet failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var gaap_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = gaap_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/* harmony default export */ var gaap_mutations = ({
    RESET_STATE: gaap_mutations_RESET_STATE,
    GET_DATA_SUCCESS: GET_DATA_SUCCESS,
    GET_DATA_FAILURE: GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/gaap/index.js
/**
 * Module Dependencies
 */





/**
 * Project GAAP
 *
 * @type {Object}
 */
var gaap_module = {
  namespaced: true,
  state: gaap_state,
  getters: gaap_getters_default.a,
  mutations: gaap_mutations,
  actions: gaap_actions
};

/* harmony default export */ var gaap = (gaap_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/debt/state.js
/**
 * Dependencies
 */


var debt_state_base = {
  loaded: false,
  data: {},
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var debt_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(debt_state_base);
};

/* harmony default export */ var debt_state = (debt_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/debt/actions.js
/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var debt_actions_resetState = function resetState(_ref) {
  var commit = _ref.commit;

  commit('RESET_STATE');
};

/**
 * Get the debt for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var debt_actions_getData = function getData(_ref2) {
  var commit = _ref2.commit,
      rootState = _ref2.rootState;

  HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/debt/').then(function (res) {
    return commit('GET_DATA_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_DATA_FAILURE');
  });
};

/* harmony default export */ var debt_actions = ({
  resetState: debt_actions_resetState,
  getData: debt_actions_getData
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/debt/getters.js
var debt_getters = __webpack_require__("PKBW");
var debt_getters_default = /*#__PURE__*/__webpack_require__.n(debt_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/debt/mutations.js
/**
 * Dependencies
 */



/**
 * Set the tearsheet data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.loaded = true;
};

/**
 * Set the tearsheet failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var debt_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = debt_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/* harmony default export */ var debt_mutations = ({
    RESET_STATE: debt_mutations_RESET_STATE,
    GET_DATA_SUCCESS: mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/debt/index.js
/**
 * Module Dependencies
 */





/**
 * Project Tearsheet
 *
 * @type {Object}
 */
var debt_module = {
  namespaced: true,
  state: debt_state,
  getters: debt_getters_default.a,
  mutations: debt_mutations,
  actions: debt_actions
};

/* harmony default export */ var debt = (debt_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/capex/state.js
/**
 * Dependencies
 */


var capex_state_base = {
  loaded: false,
  data: {},
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var single_capex_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(capex_state_base);
};

/* harmony default export */ var single_capex_state = (single_capex_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/capex/actions.js
/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var capex_actions_resetState = function resetState(_ref) {
  var commit = _ref.commit;

  commit('RESET_STATE');
};

/**
 * Get the capex for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var capex_actions_getData = function getData(_ref2) {
  var commit = _ref2.commit,
      rootState = _ref2.rootState;

  HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/capex/').then(function (res) {
    return commit('GET_DATA_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_DATA_FAILURE');
  });
};

/* harmony default export */ var single_capex_actions = ({
  getData: capex_actions_getData,
  resetState: capex_actions_resetState
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/capex/getters.js
var single_capex_getters = __webpack_require__("7A7I");
var capex_getters_default = /*#__PURE__*/__webpack_require__.n(single_capex_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/capex/mutations.js
/**
 * Dependencies
 */



/**
 * Set the tearsheet data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var capex_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data.data;
    state.loaded = true;
};

/**
 * Set the tearsheet failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var capex_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var single_capex_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = single_capex_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/* harmony default export */ var single_capex_mutations = ({
    RESET_STATE: single_capex_mutations_RESET_STATE,
    GET_DATA_SUCCESS: capex_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: capex_mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/capex/index.js
/**
 * Module Dependencies
 */





/**
 * Project CAPEX
 *
 * @type {Object}
 */
var single_capex_module = {
  namespaced: true,
  state: single_capex_state,
  getters: capex_getters_default.a,
  mutations: single_capex_mutations,
  actions: single_capex_actions
};

/* harmony default export */ var single_capex = (single_capex_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/state.js
/**
 * Dependencies
 */


var single_state_base = {
    excel_pending: false,
    excel_spreadsheet_url: null,
    excel_spreadsheet_downloaded: false,
    pending: false,
    copy_id: null,
    copy_saving: false,
    copy_name: '',
    copy_pending: false,
    copy_success: false,
    copy_message: null,
    management: {
        privileges: [],
        invites: []
    },
    versions: {
        current_version: null,
        data: [],
        managementeta: {}
    },
    data: {},
    meta: {
        tabs: []
    }

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var single_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(single_state_base);
};

/* harmony default export */ var single_state = (single_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/equity/state.js
/**
 * Dependencies
 */


var equity_state_base = {
  loaded: false,
  data: {},
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var equity_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(equity_state_base);
};

/* harmony default export */ var equity_state = (equity_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/equity/actions.js
/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var equity_actions_resetState = function resetState(_ref) {
  var commit = _ref.commit;

  commit('RESET_STATE');
};

/**
 * Get the equity for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var equity_actions_getData = function getData(_ref2) {
  var commit = _ref2.commit,
      rootState = _ref2.rootState;

  HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/equity/').then(function (res) {
    return commit('GET_DATA_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_DATA_FAILURE');
  });
};

/* harmony default export */ var equity_actions = ({
  resetState: equity_actions_resetState,
  getData: equity_actions_getData
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/equity/getters.js
var equity_getters = __webpack_require__("v+Uo");
var equity_getters_default = /*#__PURE__*/__webpack_require__.n(equity_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/equity/mutations.js
/**
 * Dependencies
 */



/**
 * Set the tearsheet data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var equity_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.loaded = true;
};

/**
 * Set the tearsheet failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var equity_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var equity_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = equity_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/* harmony default export */ var equity_mutations = ({
    RESET_STATE: equity_mutations_RESET_STATE,
    GET_DATA_SUCCESS: equity_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: equity_mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/equity/index.js
/**
 * Module Dependencies
 */





/**
 * Project Tearsheet
 *
 * @type {Object}
 */
var equity_module = {
  namespaced: true,
  state: equity_state,
  getters: equity_getters_default.a,
  mutations: equity_mutations,
  actions: equity_actions
};

/* harmony default export */ var equity = (equity_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/income/state.js
/**
 * Dependencies
 */


var income_state_base = {
  loaded: false,
  data: {},
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var income_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(income_state_base);
};

/* harmony default export */ var income_state = (income_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/income/actions.js
/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var income_actions_resetState = function resetState(_ref) {
  var commit = _ref.commit;

  commit('RESET_STATE');
};

/**
 * Get the tearsheet for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var income_actions_getData = function getData(_ref2) {
  var commit = _ref2.commit,
      rootState = _ref2.rootState;

  HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/income/').then(function (res) {
    return commit('GET_DATA_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_DATA_FAILURE');
  });
};

/* harmony default export */ var income_actions = ({
  resetState: income_actions_resetState,
  getData: income_actions_getData
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/income/getters.js
var income_getters = __webpack_require__("mPSx");
var income_getters_default = /*#__PURE__*/__webpack_require__.n(income_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/income/mutations.js
/**
 * Dependencies
 */



/**
 * Set the tearsheet data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var income_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data.data;
    state.loaded = true;
};

/**
 * Set the tearsheet failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var income_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var income_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = income_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/* harmony default export */ var income_mutations = ({
    RESET_STATE: income_mutations_RESET_STATE,
    GET_DATA_SUCCESS: income_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: income_mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/income/index.js
/**
 * Module Dependencies
 */





/**
 * Project Income
 *
 * @type {Object}
 */
var income_module = {
  namespaced: true,
  state: income_state,
  getters: income_getters_default.a,
  mutations: income_mutations,
  actions: income_actions
};

/* harmony default export */ var income = (income_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/actions.js




/**
 * Retrieve a single project
 *
 * @param  {Function} options.commit
 * @param  {Integer|String} projectId
 * @return {Promise}
 */
var actions_getProject = function getProject(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    var id = rootState.route.params.projectId;
    commit('GET_PROJECT');
    return HttpService["a" /* default */].get('projects/' + id + '/').then(function (res) {
        return commit('GET_PROJECT_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('GET_PROJECT_FAILED', err);
    });
};

/**
 * Retrieve the marketing payload for a given project
 *
 * @param  {Function} options.commit
 * @param  {Integer|String} projectId
 * @return {Promise}
 */
var actions_getMarketingProject = function getMarketingProject(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    var id = rootState.route.params.projectId;
    commit('GET_PROJECT');
    return HttpService["a" /* default */].get('projects/' + id + '/marketing/').then(function (res) {
        return commit('GET_PROJECT_SUCCESS', res.data);
    }).catch(function (err) {
        commit('GET_PROJECT_FAILED', err);
        return promise_default.a.reject(err);
    });
};

/**
 * Set the project state
 *
 * @param  {Function} options.commit
 * @param  {Object} project
 * @return {Promise}
 */
var actions_setProject = function setProject(_ref3, project) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
        commit('GET_PROJECT_SUCCESS', project);
        resolve();
    });
};

/**
 * Reset the project data
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_resetProject = function resetProject(_ref4) {
    var commit = _ref4.commit;

    return new promise_default.a(function (resolve, reject) {
        commit('RESET_PROJECT');
        resolve('reset');
    });
};

/**
 * Create a dynamic download URL and access the file
 *
 * @param  {Function} options.commit
 * @param  {Number} projectId
 * @return {Void}
 */
var actions_downloadExcelFile = function downloadExcelFile(_ref5, projectId) {
    var commit = _ref5.commit;
    return new promise_default.a(function (resolve, reject) {
        commit('DOWNLOAD_KEY_GET');
        Object(ProjectService["g" /* generateDownloadKey */])(projectId).then(function (res) {
            commit('DOWNLOAD_KEY_SUCCESS');
            commit('DOWNLOAD_EXCEL_SUCCESS', {
                filename: res.data.filename,
                url: res.data.url
            });
            resolve(res.data.url);
        }).catch(function (err) {
            return commit('DOWNLOAD_KEY_FAILED', err);
        });
    });
};

/**
 * Reset the state params for excel downloading
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var resetExcelContext = function resetExcelContext(_ref6) {
    var commit = _ref6.commit;

    commit('RESET_EXCEL_CONTEXT');
};

/**
 * Trigger the download success action
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var excelFileDownloadCompleted = function excelFileDownloadCompleted(_ref7) {
    var commit = _ref7.commit;

    commit('EXCEL_FILE_DOWNLOADED');
};

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var single_actions_resetState = function resetState(_ref8) {
    var commit = _ref8.commit;

    commit('RESET_STATE');
};

/**
 * Get the copied project name from the server and set the state property
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Void}
 */
var actions_setCopyName = function setCopyName(_ref9, id) {
    var commit = _ref9.commit;

    commit('GET_COPY_NAME');
    setTimeout(function () {
        Object(ProjectService["m" /* getSuggestedCopiedProjectName */])(id).then(function (res) {
            return commit('GET_COPY_NAME_SUCCESS', res.data.data.name);
        }).catch(function (err) {
            return commit('GET_COPY_NAME_FAILURE', err);
        });
    }, 1000);
};

/**
 * Reset the copy name state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var resetCopyName = function resetCopyName(_ref10) {
    var commit = _ref10.commit;

    commit('RESET_COPY_NAME');
};

/**
 * Update the copied project name
 *
 * @param  {Function} options.commit
 * @param  {String} updatedName
 * @return {Void}
 */
var updateName = function updateName(_ref11, updatedName) {
    var commit = _ref11.commit;

    commit('UPDATE_COPY_NAME', updatedName);
};

/**
 * Create a copy of an existing project
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_createCopy = function createCopy(_ref12, id) {
    var commit = _ref12.commit,
        state = _ref12.state;

    commit('SAVING_COPY');
    Object(ProjectService["b" /* createProjectCopy */])(id, state.copy_name).then(function (res) {
        return commit('SAVING_COPY_SUCCESS', res);
    }).catch(function () {
        return commit('SAVING_COPY_FAILURE');
    });
};

/**
 * Reset the state
 *
 * @param  {Object} options.commit
 * @return {Void}
 */
var resetCopyState = function resetCopyState(_ref13) {
    var commit = _ref13.commit;

    commit('RESET_COPY_STATE');
};

/**
 * Retrieve the user management data
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_getUserManagementData = function getUserManagementData(_ref14, id) {
    var commit = _ref14.commit;

    return Object(ProjectService["n" /* getUserDataForProject */])(id).then(function (res) {
        var data = res.data;
        commit('USER_MANAGEMENT_GET_SUCCESS', data);
        return promise_default.a.resolve(data);
    }).catch(function (err) {
        console.log(err);
        return promise_default.a.reject(err);
    });
};

/**
 * Update a privilege for a given user for a given project
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_updateUserPrivilege = function updateUserPrivilege(_ref15, payload) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    var level = payload.level;
    var privilege = payload.privilegeId;
    var project = payload.projectId;

    Object(ProjectService["u" /* updatePrivilege */])(project, privilege, level).then(commit('PRIVILEGE_UPDATED_SUCCESS', payload)).then(function () {
        dispatch('addNotification', {
            type: 'success',
            title: 'Success',
            text: 'User prviilege has been successfully updated.',
            timeout: true
        }, { root: true });
    }).catch(function (err) {
        return console.log(err);
    });
};

var actions_revokeUserPrivilege = function revokeUserPrivilege(_ref16, payload) {
    var commit = _ref16.commit;

    var privilege = payload.privilegeId;
    var project = payload.projectId;
    var confirmed = window.confirm('Are you sure you want to revoke this user\'s privilege?');

    if (confirmed) {
        Object(ProjectService["q" /* revokePrivilege */])(project, privilege).then(commit('PRIVILEGE_REVOKED_SUCCESS', privilege)).catch(function (err) {
            return console.log(err);
        });
    }
};

/**
 * Generate a new project privilege
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_createProjectPrivilege = function createProjectPrivilege(_ref17, payload) {
    var commit = _ref17.commit;

    return Object(ProjectService["a" /* createPrivilege */])(payload.projectId, payload.data).then(function (res) {
        commit('NEW_PRIVILEGE_SUCCESS', payload);
        return res;
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Revoke a invitation
 *
 * @param  {Function} options.commit
 * @param  {Number} inviteId
 * @return {Promise}
 */
var actions_revokeInvitation = function revokeInvitation(_ref18, inviteId) {
    var commit = _ref18.commit;

    var confirmed = window.confirm('Are you sure you want to revoke this invitation?');
    if (confirmed) {
        return Object(ProjectService["p" /* revokeInvite */])(inviteId).then(function (res) {
            commit('INVITE_REMOVED_SUCCESS', inviteId);
            return res;
        }).catch(function (err) {
            return console.log(err);
        });
    }
};

/**
 * Request the invitation level be modified
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_updateInvitation = function updateInvitation(_ref19, payload) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;

    Object(ProjectService["t" /* updateInvite */])(payload.invitationId, payload.level).then(function (res) {
        return commit('UPDATE_INVITE_LEVEL', payload);
    }).then(function () {
        dispatch('addNotification', {
            type: 'success',
            title: 'Success',
            text: 'User\'s invitation privilege has been successfully updated.',
            timeout: true
        }, { root: true });
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Get all versions of a given project.
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @return {Void}
 */
var actions_getVersionHistory = function getVersionHistory(_ref20) {
    var commit = _ref20.commit,
        rootState = _ref20.rootState;

    var id = rootState.route.params.projectId;
    HttpService["a" /* default */].get('projects/' + id + '/versions/').then(function (res) {
        return commit('GET_HISTORY_SUCCESS', res.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Get the current version of a project
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @return {Void}
 */
var actions_getCurrentVersion = function getCurrentVersion(_ref21) {
    var commit = _ref21.commit,
        rootState = _ref21.rootState;

    var id = rootState.route.params.projectId;
    HttpService["a" /* default */].get('projects/' + id + '/versions/current/').then(function (res) {
        return commit('GET_CURRENT_VERSION', res.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Change the current project version
 *
 * @param  {Function} options.commit
 * @param  {Object} version
 * @return {Void}
 */
var actions_changeProjectVersion = function changeProjectVersion(_ref22, version) {
    var commit = _ref22.commit,
        rootState = _ref22.rootState,
        dispatch = _ref22.dispatch;

    var id = rootState.route.params.projectId;
    HttpService["a" /* default */].patch('projects/' + id + '/versions/current/?version=' + version).then(function () {
        return dispatch('getProject');
    }).then(function () {
        return dispatch('getCurrentVersion');
    }).then(function () {
        return dispatch('getVersionHistory');
    }).then(function () {
        dispatch('addNotification', {
            type: 'success',
            title: 'Success',
            text: 'Project version successfully changed.',
            timeout: true
        }, { root: true });
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Update the project name
 *
 * @param  {Function} options.commit
 * @param  {String} name
 * @return {Void}
 */
var updateProjectName = function updateProjectName(_ref23, name) {
    var commit = _ref23.commit;
    return commit('UPDATE_PROJECT_NAME', name);
};

/* harmony default export */ var single_actions = ({
    getProject: actions_getProject,
    updateName: updateName,
    setProject: actions_setProject,
    resetState: single_actions_resetState,
    createCopy: actions_createCopy,
    setCopyName: actions_setCopyName,
    resetProject: actions_resetProject,
    resetCopyName: resetCopyName,
    resetCopyState: resetCopyState,
    updateInvitation: actions_updateInvitation,
    revokeInvitation: actions_revokeInvitation,
    getCurrentVersion: actions_getCurrentVersion,
    downloadExcelFile: actions_downloadExcelFile,
    resetExcelContext: resetExcelContext,
    getVersionHistory: actions_getVersionHistory,
    updateProjectName: updateProjectName,
    getMarketingProject: actions_getMarketingProject,
    updateUserPrivilege: actions_updateUserPrivilege,
    revokeUserPrivilege: actions_revokeUserPrivilege,
    changeProjectVersion: actions_changeProjectVersion,
    getUserManagementData: actions_getUserManagementData,
    createProjectPrivilege: actions_createProjectPrivilege,
    excelFileDownloadCompleted: excelFileDownloadCompleted
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/getters.js

/**
 * Getter Dependencies
 */


/**
 * Retrieve the currently bound project
 *
 * @param  {Object} state
 * @return {Object}
 */
var currentProject = function currentProject(state) {
  return state.data;
};

/**
 * Get the pending state for the project
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var isPending = function isPending(state) {
  return state.pending;
};

/**
 * Return the tab count
 *
 * @param  {Object} state
 * @return {Integer}
 */
var getters_tabCount = function tabCount(state) {
  return keys_default()(Object(lodash["get"])(state.data, 'summary_context.tabs', {})).length;
};

/**
 * Return the project labels
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_projectLabels = function projectLabels(state) {
  return Object(lodash["get"])(state.data, 'summary_context.labels', []);
};

/**
 * Return the project tabs
 *
 * @param  {Object} state
 * @return {Object}
 */
var getters_projectTabs = function projectTabs(state) {
  return Object(lodash["get"])(state.data, 'summary_context.tabs', {});
};

/**
 * Determine if the privileges array is empty
 *
 * @return {Boolean}
 */
var hasPrivileges = function hasPrivileges(state) {
  return state.management.privileges.length > 0;
};

/**
 * Determine if the invites array is empty
 *
 * @return {Boolean}
 */
var hasInvites = function hasInvites(state) {
  return state.management.invites.length > 0;
};

/**
 * Get the invitation count
 *
 * @param  {Object} state
 * @return {Number}
 */
var inviteCount = function inviteCount(state) {
  return state.management.invites.length;
};

/**
 * Return the privilege count
 *
 * @param  {Object} state
 * @return {Number}
 */
var privilegeCount = function privilegeCount(state) {
  return state.management.privileges.length;
};

/**
 * Determine if the property type is multifamily
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var isMultiFamilyDeal = function isMultiFamilyDeal(state) {
  return state.data.property_type === 'MF';
};

/**
 * Determine if the leaf is a R_MF_buy_and_hold
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var isRMFBuyHoldDeal = function isRMFBuyHoldDeal(state) {
  return state.data.leaf === 'R_MF_buy_and_hold';
};

/* harmony default export */ var single_getters = ({
  tabCount: getters_tabCount,
  isPending: isPending,
  hasInvites: hasInvites,
  projectTabs: getters_projectTabs,
  inviteCount: inviteCount,
  projectLabels: getters_projectLabels,
  hasPrivileges: hasPrivileges,
  currentProject: currentProject,
  privilegeCount: privilegeCount,
  isRMFBuyHoldDeal: isRMFBuyHoldDeal,
  isMultiFamilyDeal: isMultiFamilyDeal
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/activity/state.js
/**
 * Dependencies
 */


var activity_state_base = {
    loaded: false,
    context: ['owner', 'editor', 'viewer'],
    activity: {
        data: [],
        meta: {}
    },
    topUsers: [],
    histogram: {
        type: 'day',
        options: [{ key: 'week', label: 'By Week', format: 'W' }, { key: 'day', label: 'By Day', format: 'M/D/YYYY' }, { key: 'month', label: 'By Month', format: 'MMM' }, { key: 'year', label: 'By Year', format: 'YYYY' }, { key: 'hour', label: 'By Hour', format: 'h:ms a' }, { key: 'minute', label: 'By Minute', format: 'm' }, { key: 'second', label: 'By Second', format: 's' }],
        data: {}
    },
    geolocation: []

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var single_activity_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(activity_state_base);
};

/* harmony default export */ var single_activity_state = (single_activity_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/activity/actions.js

/**
 * Dependencies
 */


/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var activity_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;

    commit('RESET_STATE');
};

/**
 * Get the project data from the API
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_getProjectData = function getProjectData(_ref2, id) {
    var commit = _ref2.commit,
        getters = _ref2.getters;

    promise_default.a.all([HttpService["a" /* default */].get('projects/' + id + '/activity/?type=top_users&scope=' + getters.contextQueryString), HttpService["a" /* default */].get('projects/' + id + '/activity/?type=geolocation&scope=' + getters.contextQueryString), HttpService["a" /* default */].get('projects/' + id + '/activity/?scope=' + getters.contextQueryString)]).then(function (res) {
        commit('SET_TOP_USERS', res[0].data);
        commit('SET_GEOLOCATION', res[1].data.filter(function (point) {
            return point.location.lat && point.location.lon;
        }));
        commit('SET_ACTIVITY', res[2].data);
        commit('LOADING_COMPLETED');
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Get the histogram data for a project
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Number} id
 * @return {Void}
 */
var actions_getHistogramData = function getHistogramData(_ref3, id) {
    var commit = _ref3.commit,
        state = _ref3.state,
        getters = _ref3.getters;

    return HttpService["a" /* default */].get('projects/' + id + '/activity/?type=histogram&bin=' + state.histogram.type + '&scope=' + getters.contextQueryString).then(function (res) {
        commit('SET_HISTOGRAM', res.data);
        return res.data;
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Change histogram key
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var changeHistogramKey = function changeHistogramKey(_ref4, key) {
    var commit = _ref4.commit;

    commit('CHANGE_HISTOGRAM_KEY', key);
};

/**
 * Update the activity context
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
var updateActivityContext = function updateActivityContext(_ref5, payload) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var context = state.context;

    if (state.context.includes(payload.type) && !payload.checked) {
        commit('UPDATE_CONTEXT', context.filter(function (item) {
            return item !== payload.type;
        }));
    }

    if (!state.context.includes(payload.type) && payload.checked) {
        context.push(payload.type);
        commit('UPDATE_CONTEXT', context);
    }
};

/* harmony default export */ var single_activity_actions = ({
    resetState: activity_actions_resetState,
    getProjectData: actions_getProjectData,
    getHistogramData: actions_getHistogramData,
    changeHistogramKey: changeHistogramKey,
    updateActivityContext: updateActivityContext
});
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/state/modules/projects/single/activity/getters.js

/**
 * Dependencies
 */


/**
 * Return the date format
 *
 * @param  {Object} state
 * @return {String]}
 */
var dateFormat = function dateFormat(state) {
    switch (state.histogram.type) {
        case 'week':
            return 'W';
        case 'day':
            return 'M-D-YYYY';
        case 'month':
            return 'MMM';
        case 'year':
            return 'YYYY';
        case 'hour':
            return 'h:ms a';
        case 'minute':
            return 'm';
        case 'second':
            return 's';
        default:
            return 'M-D-YYYY';
    }
};

var buildDataContext = function buildDataContext(label, data, idx) {
    var colors = ['255,99,132', '75,192,192', '230,126,34', '142,68,173', '22,160,133', '255,206,86', '54,162,235'];

    return {
        label: label,
        fill: true,
        lineTension: 0.1,
        backgroundColor: 'rgba(' + colors[idx] + ',0.4)',
        borderColor: 'rgba(' + colors[idx] + ',0.7)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(' + colors[idx] + ',1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(' + colors[idx] + ',1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: data.map(function (item) {
            return item.num_events;
        }),
        spanGaps: false
    };
};

/**
 * Transform API data into chart-renderable context
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_histogramChartData = function histogramChartData(state) {
    var data = state.histogram.data;
    var format = state.histogram.options.find(function (item) {
        return item.key === state.histogram.type;
    }).format;

    return keys_default()(data).reduce(function (payload, key, idx) {
        var labels = data[key].map(function (item) {
            return moment_default()(item.datetime).format(format);
        });
        var context = buildDataContext(key, data[key], idx);

        if (labels.length > 0) {
            payload.labels = labels;
        }

        payload.datasets.push(context);

        return payload;
    }, { labels: [], datasets: [] });
};

/**
 * Selected Type
 *
 * @param  {Object} state
 * @return {String}
 */
var selectedType = function selectedType(state) {
    return state.histogram.options.find(function (item) {
        return item.key === state.histogram.type;
    }).label;
};

/**
 * Concatenated list of selected activity contexts suitable for HTTP payload
 *
 * @param  {Object} state
 * @return {String}
 */
var contextQueryString = function contextQueryString(state) {
    return state.context.join(',');
};

/**
 * Check to see if geolocation array is empty
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasHeatMapData = function hasHeatMapData(state) {
    return state.geolocation.length > 0;
};

/* harmony default export */ var single_activity_getters = ({
    dateFormat: dateFormat,
    selectedType: selectedType,
    hasHeatMapData: hasHeatMapData,
    histogramChartData: getters_histogramChartData,
    contextQueryString: contextQueryString
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/activity/mutations.js
/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var activity_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = single_activity_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Update the top users
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_TOP_USERS = function SET_TOP_USERS(state, data) {
    state.topUsers = data;
};

/**
 * Update the geolocation data
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_GEOLOCATION = function SET_GEOLOCATION(state, data) {
    state.geolocation = data;
};

/**
 * Set the histogram data
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_HISTOGRAM = function SET_HISTOGRAM(state, data) {
    state.histogram.data = data;
};

/**
 * Set the general activity data
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_ACTIVITY = function SET_ACTIVITY(state, data) {
    state.activity.data = data.data;
    state.activity.meta = data.meta;
};

/**
 * Set the histogram key
 *
 * @param  {Object} state
 * @param  {String} key
 * @return {Void}
 */
var CHANGE_HISTOGRAM_KEY = function CHANGE_HISTOGRAM_KEY(state, key) {
    state.histogram.type = key;
};

/**
 * Set the load state
 *
 * @param  {Object} state
 * @return {Void}
 */
var LOADING_COMPLETED = function LOADING_COMPLETED(state) {
    state.loaded = true;
};

/**
 * Update the context state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_CONTEXT = function UPDATE_CONTEXT(state, payload) {
    state.context = payload;
};

/* harmony default export */ var single_activity_mutations = ({
    RESET_STATE: activity_mutations_RESET_STATE,
    SET_ACTIVITY: SET_ACTIVITY,
    SET_TOP_USERS: SET_TOP_USERS,
    SET_HISTOGRAM: SET_HISTOGRAM,
    UPDATE_CONTEXT: UPDATE_CONTEXT,
    SET_GEOLOCATION: SET_GEOLOCATION,
    LOADING_COMPLETED: LOADING_COMPLETED,
    CHANGE_HISTOGRAM_KEY: CHANGE_HISTOGRAM_KEY
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/activity/index.js
/**
 * Module Dependencies
 */





/**
 * Project Module Declaration
 *
 * @type {Object}
 */
var single_activity_module = {
  namespaced: true,
  state: single_activity_state,
  getters: single_activity_getters,
  mutations: single_activity_mutations,
  actions: single_activity_actions
};

/* harmony default export */ var single_activity = (single_activity_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/overview/state.js
/**
 * Dependencies
 */


var overview_state_base = {
  error: null,
  loaded: false,
  data: [],
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var overview_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(overview_state_base);
};

/* harmony default export */ var overview_state = (overview_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/overview/actions.js

/**
 * Dependencies
 */


/**
 * Get the exit assumption data
 *
 * @param {Function} commit
 * @return Void
 */
var overview_actions_getData = function getData(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    commit('SET_LOADING');
    HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/overview/').then(function (res) {
        commit('GET_DATA_SUCCESS', res.data);
        commit('RESET_LOADING');
    }).catch(function (err) {
        commit('GET_DATA_FAILURE', err.response.data);
        commit('RESET_LOADING');
    });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var overview_actions_resetState = function resetState(_ref2) {
    var commit = _ref2.commit;

    commit('RESET_STATE');
};

/**
 * Save the model
 *
 * @param {Function} commit
 */
var actions_saveModel = function saveModel(_ref3, payload) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].patch(payload.url, payload.value).then(function (res) {
            commit('GET_DATA_SUCCESS', res.data);
            resolve();
        }).catch(function (err) {
            reject(err);
        });
    });
};

/* harmony default export */ var overview_actions = ({
    getData: overview_actions_getData,
    saveModel: actions_saveModel,
    resetState: overview_actions_resetState
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/overview/getters.js
/**
 * Determine if the dataset contains any editable fields
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasEditableFields = function hasEditableFields(state) {
  return state.data.some(function (i) {
    return i.url;
  });
};

/* harmony default export */ var overview_getters = ({
  hasEditableFields: hasEditableFields
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/overview/mutations.js
/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var overview_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = overview_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the loading state
 *
 * @param {Object} state
 */
var mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
    state.error = null;
};

/**
 * Reset the loading state
 *
 * @param {Object} state
 */
var mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/**
 * Handle the data response
 *
 * @param {Object} state
 * @param {Object} payload
 */
var overview_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
};

/**
 * Handle the data failure
 *
 * @param {Object} state
 * @param {Object} error
 */
var overview_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state, error) {
    state.error = error;
};

/* harmony default export */ var overview_mutations = ({
    RESET_STATE: overview_mutations_RESET_STATE,
    SET_LOADING: mutations_SET_LOADING,
    RESET_LOADING: mutations_RESET_LOADING,
    GET_DATA_SUCCESS: overview_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: overview_mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/overview/index.js
/**
 * Module Dependencies
 */





/**
 * Project Exit Assumptions
 *
 * @type {Object}
 */
var overview_module = {
  namespaced: true,
  state: overview_state,
  getters: overview_getters,
  mutations: overview_mutations,
  actions: overview_actions
};

/* harmony default export */ var overview = (overview_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/cash-flow/state.js
/**
 * Dependencies
 */


var cash_flow_state_base = {
  data: [],
  meta: {},
  loaded: false,
  timeSample: 'fiscal'

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var cash_flow_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(cash_flow_state_base);
};

/* harmony default export */ var cash_flow_state = (cash_flow_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/cash-flow/actions.js
/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var cash_flow_actions_resetState = function resetState(_ref) {
  var commit = _ref.commit;

  commit('RESET_STATE');
};

/**
 * Get the cashflow for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var cash_flow_actions_getData = function getData(_ref2) {
  var commit = _ref2.commit,
      state = _ref2.state,
      rootState = _ref2.rootState;

  HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/cash-flow-schedule/?time_sample=' + state.timeSample).then(function (res) {
    return commit('GET_DATA_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_DATA_FAILURE');
  });
};

/**
 * Update the time sample
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var changeTimeSample = function changeTimeSample(_ref3, payload) {
  var commit = _ref3.commit;

  commit('CHANGE_TIME_SAMPLE', payload);
};

/* harmony default export */ var cash_flow_actions = ({
  getData: cash_flow_actions_getData,
  resetState: cash_flow_actions_resetState,
  changeTimeSample: changeTimeSample
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/cash-flow/getters.js
var cash_flow_getters = __webpack_require__("lr7X");
var cash_flow_getters_default = /*#__PURE__*/__webpack_require__.n(cash_flow_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/cash-flow/mutations.js
/**
 * Dependencies
 */



/**
 * Set the data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var cash_flow_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
    state.loaded = true;
};

/**
 * Set the failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var cash_flow_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var cash_flow_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = cash_flow_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the time sample state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var CHANGE_TIME_SAMPLE = function CHANGE_TIME_SAMPLE(state, payload) {
    state.timeSample = payload;
};

/* harmony default export */ var cash_flow_mutations = ({
    RESET_STATE: cash_flow_mutations_RESET_STATE,
    GET_DATA_SUCCESS: cash_flow_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: cash_flow_mutations_GET_DATA_FAILURE,
    CHANGE_TIME_SAMPLE: CHANGE_TIME_SAMPLE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/cash-flow/index.js
/**
 * Module Dependencies
 */





/**
 * Project Tearsheet
 *
 * @type {Object}
 */
var cash_flow_module = {
  namespaced: true,
  state: cash_flow_state,
  getters: cash_flow_getters_default.a,
  mutations: cash_flow_mutations,
  actions: cash_flow_actions
};

/* harmony default export */ var cash_flow = (cash_flow_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/rent-roll/state.js
/**
 * Dependencies
 */


var rent_roll_state_base = {
    loading: false,
    summary: {
        data: [],
        meta: {
            index: []
        }
    },
    proForma: {
        data: [],
        meta: {
            index: []
        }
    },
    schedule: {
        data: [],
        meta: {
            index: []
        }
    },
    meta: {}

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var rent_roll_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(rent_roll_state_base);
};

/* harmony default export */ var rent_roll_state = (rent_roll_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/rent-roll/actions.js
/**
 * Dependencies
 */


var getDataType = function getDataType(type) {
    if (type === 'summary') {
        return 'summary';
    } else if (type === 'proForma') {
        return 'current-vs-proforma';
    } else if (type === 'schedule') {
        return 'schedule';
    } else {
        return 'summary';
    }
};

/**
 * Fetch the other income data
 *
 * @param  {Object} options.commit
 * @param  {String} type
 * @return {void}
 */
var rent_roll_actions_getData = function getData(_ref, obj) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    commit('SET_LOADING');
    var url = 'projects/' + rootState.route.params.projectId + '/rentroll/?scope=' + getDataType(obj.type);
    if (obj.timesample) {
        url += '&time_sample=' + obj.timesample;
    }
    HttpService["a" /* default */].get(url).then(function (res) {
        commit('SET_DATA', {
            type: obj.type,
            data: obj.type === 'schedule' ? res.data.data.units : res.data.data.rentroll,
            meta: res.data.meta
        });
        commit('RESET_LOADING');
    }).catch(function () {
        commit('RESET_LOADING');
    });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {void}
 */
var rent_roll_actions_resetState = function resetState(_ref2) {
    var commit = _ref2.commit;
    return commit('RESET_STATE');
};

/* harmony default export */ var rent_roll_actions = ({
    getData: rent_roll_actions_getData,
    resetState: rent_roll_actions_resetState
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/rent-roll/getters.js
var rent_roll_getters = __webpack_require__("w/Np");
var rent_roll_getters_default = /*#__PURE__*/__webpack_require__.n(rent_roll_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/rent-roll/mutations.js
/**
 * Dependencies
 */



/**
 * Set the data payload
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var mutations_SET_DATA = function SET_DATA(state, payload) {
    state[payload.type].data = payload.data;
    state[payload.type].meta = payload.meta;
};

/**
 * Set the loading state
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var rent_roll_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var rent_roll_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = rent_roll_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Reset the loading state
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var rent_roll_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/* harmony default export */ var rent_roll_mutations = ({
    SET_DATA: mutations_SET_DATA,
    SET_LOADING: rent_roll_mutations_SET_LOADING,
    RESET_STATE: rent_roll_mutations_RESET_STATE,
    RESET_LOADING: rent_roll_mutations_RESET_LOADING
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/rent-roll/index.js
/**
 * Module Dependencies
 */





/**
 * Other Income
 *
 * @type {Object}
 */
var rent_roll_module = {
  namespaced: true,
  state: rent_roll_state,
  getters: rent_roll_getters_default.a,
  mutations: rent_roll_mutations,
  actions: rent_roll_actions
};

/* harmony default export */ var rent_roll = (rent_roll_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/tearsheet/state.js
/**
 * Dependencies
 */


var tearsheet_state_base = {
  loaded: false,
  data: {},
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var tearsheet_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(tearsheet_state_base);
};

/* harmony default export */ var tearsheet_state = (tearsheet_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/tearsheet/actions.js
/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var tearsheet_actions_resetState = function resetState(_ref) {
  var commit = _ref.commit;

  commit('RESET_STATE');
};

/**
 * Get the tearsheet for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var tearsheet_actions_getData = function getData(_ref2) {
  var commit = _ref2.commit,
      rootState = _ref2.rootState;

  HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/tearsheet/').then(function (res) {
    return commit('GET_DATA_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_DATA_FAILURE');
  });
};

/* harmony default export */ var tearsheet_actions = ({
  resetState: tearsheet_actions_resetState,
  getData: tearsheet_actions_getData
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/tearsheet/getters.js
var tearsheet_getters = __webpack_require__("0u5z");
var tearsheet_getters_default = /*#__PURE__*/__webpack_require__.n(tearsheet_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/tearsheet/mutations.js
/**
 * Dependencies
 */



/**
 * Set the tearsheet data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var tearsheet_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data.data;
    state.loaded = true;
};

/**
 * Set the tearsheet failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var tearsheet_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var tearsheet_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = tearsheet_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/* harmony default export */ var tearsheet_mutations = ({
    RESET_STATE: tearsheet_mutations_RESET_STATE,
    GET_DATA_SUCCESS: tearsheet_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: tearsheet_mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/tearsheet/index.js
/**
 * Module Dependencies
 */





/**
 * Project Tearsheet
 *
 * @type {Object}
 */
var tearsheet_module = {
  namespaced: true,
  state: tearsheet_state,
  getters: tearsheet_getters_default.a,
  mutations: tearsheet_mutations,
  actions: tearsheet_actions
};

/* harmony default export */ var tearsheet = (tearsheet_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/devbudget/state.js
/**
 * Dependencies
 */


var devbudget_state_base = {
  loaded: false,
  data: {},
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var devbudget_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(devbudget_state_base);
};

/* harmony default export */ var devbudget_state = (devbudget_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/devbudget/actions.js
/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var devbudget_actions_resetState = function resetState(_ref) {
  var commit = _ref.commit;

  commit('RESET_STATE');
};

/**
 * Get the devbudget for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var devbudget_actions_getData = function getData(_ref2) {
  var commit = _ref2.commit,
      rootState = _ref2.rootState;

  HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/devbudget/').then(function (res) {
    return commit('GET_DATA_SUCCESS', res.data);
  }).catch(function () {
    return commit('GET_DATA_FAILURE');
  });
};

/* harmony default export */ var devbudget_actions = ({
  getData: devbudget_actions_getData,
  resetState: devbudget_actions_resetState
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/devbudget/getters.js
var devbudget_getters = __webpack_require__("N5e3");
var devbudget_getters_default = /*#__PURE__*/__webpack_require__.n(devbudget_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/devbudget/mutations.js
/**
 * Dependencies
 */



/**
 * Set the data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var devbudget_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data.data;
    state.loaded = true;
};

/**
 * Set the failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var devbudget_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var devbudget_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = devbudget_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/* harmony default export */ var devbudget_mutations = ({
    RESET_STATE: devbudget_mutations_RESET_STATE,
    GET_DATA_SUCCESS: devbudget_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: devbudget_mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/devbudget/index.js
/**
 * Module Dependencies
 */





/**
 * Project Tearsheet
 *
 * @type {Object}
 */
var devbudget_module = {
  namespaced: true,
  state: devbudget_state,
  getters: devbudget_getters_default.a,
  mutations: devbudget_mutations,
  actions: devbudget_actions
};

/* harmony default export */ var devbudget = (devbudget_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/mutations.js
/**
 * Dependencies
 */



/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PROJECT = function GET_PROJECT(state) {
    state.pending = true;
};

/**
 * Set the retrieved project data
 *
 * @param  {Object} state
 * @param  {Object} data
 * @return {Void}
 */
var GET_PROJECT_SUCCESS = function GET_PROJECT_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
};

/**
 * Handle the failed project action
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PROJECT_FAILED = function GET_PROJECT_FAILED(state) {
    state.data = {};
    state.pending = false;
};

/**
 * Reset the project context
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_PROJECT = function RESET_PROJECT(state) {
    state.data = {};
    state.pending = false;
    state.copy_name = '';
    state.copy_pending = false;
    state.copy_success = false;
    state.copy_id = null;
    state.copy_message = null;
    state.copy_success = false;
};

/**
 * Reset the copy state
 *
 * @param  {[type]} state
 * @return {[type]}
 */
var RESET_COPY_STATE = function RESET_COPY_STATE(state) {
    state.copy_id = null;
    state.copy_saving = false;
    state.copy_name = '';
    state.copy_pending = false;
    state.copy_success = false;
    state.copy_message = null;
};

/**
 * Set the downlod pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var DOWNLOAD_KEY_GET = function DOWNLOAD_KEY_GET(state) {
    state.excel_pending = true;
};

/**
 * Set the pending state when a key is successfully downloaded
 *
 * @param  {Object} state
 * @return {Void}
 */
var DOWNLOAD_KEY_SUCCESS = function DOWNLOAD_KEY_SUCCESS(state) {
    state.excel_pending = false;
};

/**
 * Set the pending state whent the key fails to download
 *
 * @param  {Object} state
 * @return {Void}
 */
var DOWNLOAD_KEY_FAILED = function DOWNLOAD_KEY_FAILED(state) {
    state.excel_pending = false;
};

/**
 * Reset the Excel download context
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_EXCEL_CONTEXT = function RESET_EXCEL_CONTEXT(state) {
    state.excel_pending = false;
    state.excel_spreadsheet_url = null;
    state.excel_spreadsheet_downloaded = false;
};

/**
 * Set the download context state on successful download
 *
 * @param  {Object} state
 * @return {Void}
 */
var DOWNLOAD_EXCEL_SUCCESS = function DOWNLOAD_EXCEL_SUCCESS(state, payload) {
    state.excel_spreadsheet_url = "https://api.lucroapp.com" + '/projects' + payload.url;
};

/**
 * Set the action state based on a successful file download
 *
 * @param  {Object} state
 * @return {Void}
 */
var EXCEL_FILE_DOWNLOADED = function EXCEL_FILE_DOWNLOADED(state) {
    state.excel_spreadsheet_downloaded = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var single_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = single_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the pending state retrieving a copied project name
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_COPY_NAME = function GET_COPY_NAME(state) {
    state.copy_pending = true;
};

/**
 * Set the pending state retrieving a copied project name
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_COPY_NAME_SUCCESS = function GET_COPY_NAME_SUCCESS(state, payload) {
    state.copy_name = payload;
    state.copy_success = true;
    state.copy_pending = false;
};

/**
 * Set the pending state retrieving a copied project name
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_COPY_NAME_FAILURE = function GET_COPY_NAME_FAILURE(state) {
    state.copy_name = '';
    state.copy_success = false;
    state.copy_pending = false;
    state.copy_saving = false;
    state.copy_id = null;
};

/**
 * Reset copy name state
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_COPY_NAME = function RESET_COPY_NAME(state) {
    state.copy_name = '';
    state.copy_success = false;
    state.copy_pending = false;
    state.copy_saving = false;
    state.copy_id = null;
};

/**
 * Update the copied project name state
 *
 * @param  {Object} state
 * @param  {String} payload
 * @return {Void}
 */
var UPDATE_COPY_NAME = function UPDATE_COPY_NAME(state, payload) {
    state.copy_name = payload;
};

var SAVING_COPY = function SAVING_COPY(state) {
    state.copy_saving = true;
};

var SAVING_COPY_SUCCESS = function SAVING_COPY_SUCCESS(state, payload) {
    state.copy_message = payload.data.data.message;
    state.copy_saving = false;
    state.copy_id = payload.data.data.id;
    state.copy_success = true;
};

var SAVING_COPY_FAILURE = function SAVING_COPY_FAILURE(state) {
    state.copy_saving = false;
    state.copy_id = null;
};

/**
 * Set the project user management context
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var USER_MANAGEMENT_GET_SUCCESS = function USER_MANAGEMENT_GET_SUCCESS(state, payload) {
    state.management = payload;
};

/**
 * Update the privilege leve for a user in the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var PRIVILEGE_UPDATED_SUCCESS = function PRIVILEGE_UPDATED_SUCCESS(state, payload) {
    var found = state.management.privileges.find(function (privilege) {
        return privilege.id === payload.privilegeId;
    });

    if (found) found.level = Number(payload.level);
};

/**
 * Revise the privilege state
 *
 * @param  {Object} state
 * @param  {Number} privilegeId
 * @return {Void}
 */
var PRIVILEGE_REVOKED_SUCCESS = function PRIVILEGE_REVOKED_SUCCESS(state, privilegeId) {
    state.management.privileges = state.management.privileges.filter(function (privilege) {
        return privilege.id !== Number(privilegeId);
    });
};

/**
 * Augment the state to include new privilege object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var NEW_PRIVILEGE_SUCCESS = function NEW_PRIVILEGE_SUCCESS(state, payload) {};

/**
 * Remove an invite from the state
 *
 * @param  {Object} state
 * @param  {Number} inviteId
 * @return {Void}
 */
var INVITE_REMOVED_SUCCESS = function INVITE_REMOVED_SUCCESS(state, inviteId) {
    state.management.invites = state.management.invites.filter(function (invite) {
        return invite.id !== inviteId;
    });
};

/**
 * Change the invite state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_INVITE_LEVEL = function UPDATE_INVITE_LEVEL(state, payload) {
    var invite = state.management.invites.find(function (item) {
        return payload.invitationId === item.id;
    });

    if (invite) invite.privilege_level = payload.level;
};

/**
 * Set the history request data on the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_HISTORY_SUCCESS = function GET_HISTORY_SUCCESS(state, payload) {
    state.versions.data = payload.data;
    state.versions.meta = payload.meta;
};

/**
 * Get the current version of a project
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_CURRENT_VERSION = function GET_CURRENT_VERSION(state, payload) {
    state.versions.current_version = payload;
};

/**
 * Update the project name
 *
 * @param  {Object} state
 * @param  {String} name
 * @return {Void}
 */
var UPDATE_PROJECT_NAME = function UPDATE_PROJECT_NAME(state, name) {
    state.data.name = name;
};

/* harmony default export */ var single_mutations = ({
    RESET_STATE: single_mutations_RESET_STATE,
    GET_PROJECT: GET_PROJECT,
    GET_COPY_NAME: GET_COPY_NAME,
    RESET_PROJECT: RESET_PROJECT,
    RESET_COPY_NAME: RESET_COPY_NAME,
    UPDATE_COPY_NAME: UPDATE_COPY_NAME,
    DOWNLOAD_KEY_GET: DOWNLOAD_KEY_GET,
    GET_PROJECT_FAILED: GET_PROJECT_FAILED,
    RESET_EXCEL_CONTEXT: RESET_EXCEL_CONTEXT,
    DOWNLOAD_KEY_FAILED: DOWNLOAD_KEY_FAILED,
    GET_PROJECT_SUCCESS: GET_PROJECT_SUCCESS,
    RESET_COPY_STATE: RESET_COPY_STATE,
    GET_HISTORY_SUCCESS: GET_HISTORY_SUCCESS,
    DOWNLOAD_KEY_SUCCESS: DOWNLOAD_KEY_SUCCESS,
    GET_COPY_NAME_FAILURE: GET_COPY_NAME_FAILURE,
    GET_COPY_NAME_SUCCESS: GET_COPY_NAME_SUCCESS,
    EXCEL_FILE_DOWNLOADED: EXCEL_FILE_DOWNLOADED,
    DOWNLOAD_EXCEL_SUCCESS: DOWNLOAD_EXCEL_SUCCESS,
    SAVING_COPY: SAVING_COPY,
    GET_CURRENT_VERSION: GET_CURRENT_VERSION,
    SAVING_COPY_SUCCESS: SAVING_COPY_SUCCESS,
    SAVING_COPY_FAILURE: SAVING_COPY_FAILURE,
    USER_MANAGEMENT_GET_SUCCESS: USER_MANAGEMENT_GET_SUCCESS,
    PRIVILEGE_UPDATED_SUCCESS: PRIVILEGE_UPDATED_SUCCESS,
    PRIVILEGE_REVOKED_SUCCESS: PRIVILEGE_REVOKED_SUCCESS,
    NEW_PRIVILEGE_SUCCESS: NEW_PRIVILEGE_SUCCESS,
    INVITE_REMOVED_SUCCESS: INVITE_REMOVED_SUCCESS,
    UPDATE_INVITE_LEVEL: UPDATE_INVITE_LEVEL,
    UPDATE_PROJECT_NAME: UPDATE_PROJECT_NAME
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/other-income/state.js
/**
 * Dependencies
 */


var other_income_state_base = {
    loading: false,
    summary: {
        data: [],
        meta: {
            index: []
        }
    },
    proForma: {
        data: [],
        meta: {
            index: []
        }
    },
    schedule: {
        data: [],
        meta: {
            index: []
        }
    },
    meta: {}

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var other_income_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(other_income_state_base);
};

/* harmony default export */ var other_income_state = (other_income_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/other-income/actions.js
/**
 * Dependencies
 */


var actions_getDataType = function getDataType(type) {
    if (type === 'summary') {
        return 'summary';
    } else if (type === 'proForma') {
        return 't12-vs-proforma';
    } else if (type === 'schedule') {
        return 'schedule';
    } else {
        return 'summary';
    }
};

/**
 * Fetch the other income data
 *
 * @param  {Object} options.commit
 * @param  {String} type
 * @return {void}
 */
var other_income_actions_getData = function getData(_ref, obj) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    var url = 'projects/' + rootState.route.params.projectId + '/misc-inc/?scope=' + actions_getDataType(obj.type);
    if (obj.timesample) {
        url += '&time_sample=' + obj.timesample;
    }
    commit('SET_LOADING');
    HttpService["a" /* default */].get(url).then(function (res) {
        commit('SET_DATA', {
            type: obj.type,
            data: res.data.data.miscinc,
            meta: res.data.meta
        });
        commit('RESET_LOADING');
    }).catch(function () {
        commit('RESET_LOADING');
    });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {void}
 */
var other_income_actions_resetState = function resetState(_ref2) {
    var commit = _ref2.commit;
    return commit('RESET_STATE');
};

/* harmony default export */ var other_income_actions = ({
    getData: other_income_actions_getData,
    resetState: other_income_actions_resetState
});
// EXTERNAL MODULE: ./src/state/modules/projects/single/other-income/getters.js
var other_income_getters = __webpack_require__("ulap");
var other_income_getters_default = /*#__PURE__*/__webpack_require__.n(other_income_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/single/other-income/mutations.js
/**
 * Dependencies
 */



/**
 * Set the data payload
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var other_income_mutations_SET_DATA = function SET_DATA(state, payload) {
    state[payload.type].data = payload.data;
    state[payload.type].meta = payload.meta;
};

/**
 * Set the loading state
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var other_income_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var other_income_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = other_income_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Reset the loading state
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var other_income_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/* harmony default export */ var other_income_mutations = ({
    SET_DATA: other_income_mutations_SET_DATA,
    SET_LOADING: other_income_mutations_SET_LOADING,
    RESET_STATE: other_income_mutations_RESET_STATE,
    RESET_LOADING: other_income_mutations_RESET_LOADING
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/other-income/index.js
/**
 * Module Dependencies
 */





/**
 * Other Income
 *
 * @type {Object}
 */
var other_income_module = {
  namespaced: true,
  state: other_income_state,
  getters: other_income_getters_default.a,
  mutations: other_income_mutations,
  actions: other_income_actions
};

/* harmony default export */ var other_income = (other_income_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/net-proceeds/state.js
/**
 * Dependencies
 */


var net_proceeds_state_base = {
  error: null,
  loaded: false,
  data: [],
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var net_proceeds_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(net_proceeds_state_base);
};

/* harmony default export */ var net_proceeds_state = (net_proceeds_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/net-proceeds/actions.js

/**
 * Dependencies
 */


/**
 * Get the exit assumption data
 *
 * @param {Function} commit
 * @return Void
 */
var net_proceeds_actions_getData = function getData(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    commit('SET_LOADING');
    HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/net-proceeds/').then(function (res) {
        commit('GET_DATA_SUCCESS', res.data);
        commit('RESET_LOADING');
    }).catch(function (err) {
        commit('GET_DATA_FAILURE', err.response.data);
        commit('RESET_LOADING');
    });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var net_proceeds_actions_resetState = function resetState(_ref2) {
    var commit = _ref2.commit;

    commit('RESET_STATE');
};

/**
 * Save the model
 *
 * @param {Function} commit
 */
var net_proceeds_actions_saveModel = function saveModel(_ref3, payload) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].patch(payload.url, payload.value).then(function (res) {
            commit('GET_DATA_SUCCESS', res.data);
            resolve();
        }).catch(function (err) {
            reject(err);
        });
    });
};

/* harmony default export */ var net_proceeds_actions = ({
    getData: net_proceeds_actions_getData,
    saveModel: net_proceeds_actions_saveModel,
    resetState: net_proceeds_actions_resetState
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/net-proceeds/getters.js
/**
 * Determine if the dataset contains any editable fields
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_hasEditableFields = function hasEditableFields(state) {
  return state.data.some(function (i) {
    return i.url;
  });
};

/* harmony default export */ var net_proceeds_getters = ({
  hasEditableFields: getters_hasEditableFields
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/net-proceeds/mutations.js
/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var net_proceeds_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = net_proceeds_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the loading state
 *
 * @param {Object} state
 */
var net_proceeds_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
    state.error = null;
};

/**
 * Reset the loading state
 *
 * @param {Object} state
 */
var net_proceeds_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/**
 * Handle the data response
 *
 * @param {Object} state
 * @param {Object} payload
 */
var net_proceeds_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
};

/**
 * Handle the data failure
 *
 * @param {Object} state
 * @param {Object} error
 */
var net_proceeds_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state, error) {
    state.error = error;
};

/* harmony default export */ var net_proceeds_mutations = ({
    RESET_STATE: net_proceeds_mutations_RESET_STATE,
    SET_LOADING: net_proceeds_mutations_SET_LOADING,
    RESET_LOADING: net_proceeds_mutations_RESET_LOADING,
    GET_DATA_SUCCESS: net_proceeds_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: net_proceeds_mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/net-proceeds/index.js
/**
 * Module Dependencies
 */





/**
 * Project Net Proceeds
 *
 * @type {Object}
 */
var net_proceeds_module = {
  namespaced: true,
  state: net_proceeds_state,
  getters: net_proceeds_getters,
  mutations: net_proceeds_mutations,
  actions: net_proceeds_actions
};

/* harmony default export */ var net_proceeds = (net_proceeds_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-summary/state.js
/**
 * Dependencies
 */


var opex_summary_state_base = {
  showForm: false,
  loaded: false,
  data: [],
  meta: {
    index: []
  },
  searchTerm: '',
  pageLimit: 8,
  currentPage: 1,
  loadingData: false,
  updating: false

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var opex_summary_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(opex_summary_state_base);
};

/* harmony default export */ var opex_summary_state = (opex_summary_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-summary/actions.js

/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var opex_summary_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;
    return commit('RESET_STATE');
};

/**
 * Get the opex for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var opex_summary_actions_getData = function getData(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState,
        state = _ref2.state;

    var id = rootState.route.params.projectId;

    commit('LOAD_DATA');
    HttpService["a" /* default */].get('projects/' + id + '/opex-summary/').then(function (res) {
        return commit('GET_DATA_SUCCESS', {
            data: res.data.data['opex-summaries'],
            meta: res.data.meta
        });
    }).catch(function () {
        return commit('GET_DATA_FAILURE');
    });
};

/**
 * Update the search term
 *
 * @param  {Function} options.commit
 * @param  {String} term
 * @return {Promise}
 */
var updateSearchTerm = function updateSearchTerm(_ref3, term) {
    var commit = _ref3.commit;
    return commit('UPDATE_SEARCH_TERM', term);
};

/**
 * Paginate the dataset forward
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var nextPage = function nextPage(_ref4) {
    var commit = _ref4.commit;
    return commit('UPDATE_PAGE_NEXT');
};

/**
 * Paginate the dataset backward
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var prevPage = function prevPage(_ref5) {
    var commit = _ref5.commit;
    return commit('UPDATE_PAGE_PREV');
};

/**
 * Toggle the create form
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var toggleCreateForm = function toggleCreateForm(_ref6) {
    var commit = _ref6.commit;
    return commit('TOGGLE_CREATE_FORM');
};

/**
 * Generate new operating expense
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Object} data
 * @return {Promise}
 */
var actions_createNewRelativeOpex = function createNewRelativeOpex(_ref7, data) {
    var commit = _ref7.commit,
        rootState = _ref7.rootState;

    var url = 'projects/' + rootState.route.params.projectId + '/relative-opex/';
    commit('SET_UPDATING');
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post(url, data).then(function (res) {
            commit('NEW_OPEX_SUCCESS', res.data);
            commit('RESET_UPDATING');
            resolve(res.data);
        }).catch(function (err) {
            commit('NEW_OPEX_FAILURE', err);
            commit('RESET_UPDATING');
            reject(err);
        });
    });
};

var actions_createNewRegularOpex = function createNewRegularOpex(_ref8, data) {
    var commit = _ref8.commit,
        rootState = _ref8.rootState;

    var url = 'projects/' + rootState.route.params.projectId + '/regular-opex/';
    commit('SET_UPDATING');
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post(url, data).then(function (res) {
            commit('NEW_OPEX_SUCCESS', res.data);
            commit('RESET_UPDATING');
            resolve(res.data);
        }).catch(function (err) {
            commit('NEW_OPEX_FAILURE', err);
            commit('RESET_UPDATING');
            reject(err);
        });
    });
};

/**
 * Update an existing opex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_updateOpex = function updateOpex(_ref9, payload) {
    var commit = _ref9.commit;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].put(payload.url, payload.data).then(function (res) {
            commit('REPLACE_OPEX', res.data);
            resolve(res.data);
        }).catch(function (err) {
            reject(err.response.data);
        });
    });
};

/**
 * Delete an existing opex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_deleteOpex = function deleteOpex(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].del('modelling/' + payload.type + '/' + payload.id + '/').then(function (res) {
            commit('DELETE_OPEX', payload.id);
            resolve(payload.id);
        }).catch(function (err) {
            return reject(err.response.data);
        });
    });
};

/* harmony default export */ var opex_summary_actions = ({
    getData: opex_summary_actions_getData,
    nextPage: nextPage,
    prevPage: prevPage,
    deleteOpex: actions_deleteOpex,
    updateOpex: actions_updateOpex,
    resetState: opex_summary_actions_resetState,
    toggleCreateForm: toggleCreateForm,
    updateSearchTerm: updateSearchTerm,
    createNewRegularOpex: actions_createNewRegularOpex,
    createNewRelativeOpex: actions_createNewRelativeOpex
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-summary/getters.js

/**
 * Dependencies
 */


/**
 * Output the OPEX data grouped by category
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Object}
 */
var getters_groupedData = function groupedData(state, getters) {
    return Object(lodash["groupBy"])(getters.filteredDataset.map(function (row) {
        return {
            id: row.id,
            name: row.name,
            category: row.category,
            data: row.data,
            url: row.url,
            showForm: false
        };
    }), 'category');
};

/**
 * Get the generated colors palette
 *
 * @return {Array}
 */
var chartColors = function chartColors(state, getters) {
    return ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'];
};

/**
 * Lower case search term
 *
 * @param  {Object} state
 * @return {String}
 */
var formattedSearchTerm = function formattedSearchTerm(state) {
    return state.searchTerm.toLowerCase();
};

/**
 * Filtered dataset by user input string
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
var filteredDataset = function filteredDataset(state, getters) {
    return state.data.filter(function (row) {
        return row.name.toLowerCase().includes(getters.formattedSearchTerm);
    });
};

/**
 * Return the appropriate dataset
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Object}
 */
var getters_paginatedDataset = function paginatedDataset(state, getters) {
    var keys = keys_default()(getters.groupedData);
    return keys.reduce(function (result, item, idx, arr) {
        result[item] = getters.groupedData[item].map(function (row) {
            return row.data;
        }).reduce(function (r, a) {
            a.forEach(function (b, i) {
                var val = r[i] ? r[i].value : 0;
                if (r[i]) {
                    r[i].value = val + b.value;
                } else {
                    r.push({
                        value: b.value,
                        value_type: b.value_type
                    });
                }
            });
            return r;
        }, []);
        return result;
    }, {});
};

/**
 * Calculate the total number of pages
 *
 * @param  {Object} state
 * @return {Number}
 */
var totalPages = function totalPages(state) {
    var max = (state.meta.index.length + 1) / (state.pageLimit || 1);

    return state.pageLimit ? Math.ceil(max) : null;
};

/**
 * Calculate the data offset to use
 *
 * @param  {Object} state
 * @return {Number}
 */
var offset = function offset(state) {
    return state.pageLimit ? (state.currentPage - 1) * state.pageLimit : null;
};

/**
 * Determine whether the user can paginate the dataset
 *
 * @return {Boolean}
 */
var canPaginate = function canPaginate(state, getters) {
    return state.pageLimit !== null && getters.totalPages > 1;
};

/**
 * Trasform the dataset into a chart-renederable object
 *
 * @return {Object}
 */
var getters_chartData = function chartData(state, getters) {
    var keys = keys_default()(getters.paginatedDataset);
    return {
        labels: keys,
        datasets: [{
            borderWidth: 1,
            borderColor: '#76acd4',
            backgroundColor: getters.chartColors,
            data: keys.map(function (key) {
                return getters.paginatedDataset[key][3].value;
            })
        }]
    };
};

/**
 * Trasform the dataset into a chart-renederable object
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_totals = function totals(state) {
    return state.data.reduce(function (result, item) {
        item.data.forEach(function (i, idx) {
            if (typeof result[idx] === 'undefined') {
                result[idx] = {
                    value: i.value,
                    value_type: i.value_type
                };
            } else {
                result[idx].value += i.value;
            }
        });
        return result;
    }, []);
};

/* harmony default export */ var opex_summary_getters = ({
    totals: getters_totals,
    offset: offset,
    chartData: getters_chartData,
    totalPages: totalPages,
    canPaginate: canPaginate,
    groupedData: getters_groupedData,
    chartColors: chartColors,
    filteredDataset: filteredDataset,
    paginatedDataset: getters_paginatedDataset,
    formattedSearchTerm: formattedSearchTerm
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-summary/mutations.js
/**
 * Dependencies
 */



/**
 * Set the opex summary data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var opex_summary_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
    state.loaded = true;
    state.currentPage = 1;
    state.loadingData = false;
};

/**
 * Set the opex summary failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_summary_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_summary_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = opex_summary_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Update the search term in the state object
 *
 * @param  {Object} state
 * @param  {String} term
 * @return {Void}
 */
var UPDATE_SEARCH_TERM = function UPDATE_SEARCH_TERM(state, term) {
    state.searchTerm = term;
};

/**
 * Go forward a page
 *
 * @param  {Object} state
 * @return {Void}
 */
var UPDATE_PAGE_NEXT = function UPDATE_PAGE_NEXT(state) {
    state.currentPage++;
};

/**
 * Go backward a page
 *
 * @param  {Object} state
 * @return {Void}
 */
var UPDATE_PAGE_PREV = function UPDATE_PAGE_PREV(state) {
    state.currentPage--;
};

/**
 * Set the data loading attribute
 *
 * @param  {Object} state
 * @return {Void}
 */
var LOAD_DATA = function LOAD_DATA(state) {
    state.loadingData = true;
};

/**
 * Show / hide the form
 *
 * @param  {Object} state
 * @return {Promise}
 */
var TOGGLE_CREATE_FORM = function TOGGLE_CREATE_FORM(state) {
    state.showForm = !state.showForm;
};

/**
 * Handle new opex success
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var NEW_OPEX_SUCCESS = function NEW_OPEX_SUCCESS(state, payload) {
    state.data.push(payload);
};

/**
 * Set the updating indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var SET_UPDATING = function SET_UPDATING(state) {
    state.updating = true;
};

/**
 * Reset the updating indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var RESET_UPDATING = function RESET_UPDATING(state) {
    state.updating = false;
};

/**
 * Handle new opex failure
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Promise}
 */
var NEW_OPEX_FAILURE = function NEW_OPEX_FAILURE(state, err) {};

/**
 * Handle updating a successful opex modification request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var REPLACE_OPEX = function REPLACE_OPEX(state, payload) {
    var idx = state.data.findIndex(function (i) {
        return i.id === payload.id;
    });

    if (idx > -1) {
        state.data.splice(idx, 1, payload);
    }
};

/**
 * Delete an operating expense from the dataset
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Promise}
 */
var DELETE_OPEX = function DELETE_OPEX(state, id) {
    console.log(id);
    state.data = state.data.filter(function (i) {
        return i.id !== id;
    });
};

/* harmony default export */ var opex_summary_mutations = ({
    LOAD_DATA: LOAD_DATA,
    RESET_STATE: opex_summary_mutations_RESET_STATE,
    DELETE_OPEX: DELETE_OPEX,
    SET_UPDATING: SET_UPDATING,
    REPLACE_OPEX: REPLACE_OPEX,
    RESET_UPDATING: RESET_UPDATING,
    UPDATE_PAGE_NEXT: UPDATE_PAGE_NEXT,
    UPDATE_PAGE_PREV: UPDATE_PAGE_PREV,
    GET_DATA_SUCCESS: opex_summary_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: opex_summary_mutations_GET_DATA_FAILURE,
    NEW_OPEX_SUCCESS: NEW_OPEX_SUCCESS,
    NEW_OPEX_FAILURE: NEW_OPEX_FAILURE,
    TOGGLE_CREATE_FORM: TOGGLE_CREATE_FORM,
    UPDATE_SEARCH_TERM: UPDATE_SEARCH_TERM
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-summary/index.js
/**
 * Module Dependencies
 */





/**
 * Opex Summary
 *
 * @type {Object}
 */
var opex_summary_module = {
  namespaced: true,
  state: opex_summary_state,
  getters: opex_summary_getters,
  mutations: opex_summary_mutations,
  actions: opex_summary_actions
};

/* harmony default export */ var opex_summary = (opex_summary_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-schedule/state.js
/**
 * Dependencies
 */


var opex_schedule_state_base = {
  showForm: false,
  loaded: false,
  data: [],
  meta: {
    index: []
  },
  selectedTab: 'monthly',
  searchTerm: '',
  pageLimit: 12,
  currentPage: 1,
  loadingData: false,
  updating: false

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var opex_schedule_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(opex_schedule_state_base);
};

/* harmony default export */ var opex_schedule_state = (opex_schedule_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-schedule/actions.js

/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var opex_schedule_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;

    commit('RESET_STATE');
};

/**
 * Get the opex for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var opex_schedule_actions_getData = function getData(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState,
        state = _ref2.state;

    var id = rootState.route.params.projectId;
    var timeSample = state.selectedTab;

    commit('LOAD_DATA');
    HttpService["a" /* default */].get('projects/' + id + '/opex-schedule/?time_sample=' + timeSample).then(function (res) {
        return commit('GET_DATA_SUCCESS', {
            data: res.data.data['opex-schedules'],
            meta: res.data.meta
        });
    }).catch(function () {
        return commit('GET_DATA_FAILURE');
    });
};

/**
 * Update the search term
 *
 * @param  {Function} options.commit
 * @param  {String} term
 * @return {Promise}
 */
var actions_updateSearchTerm = function updateSearchTerm(_ref3, term) {
    var commit = _ref3.commit;
    return commit('UPDATE_SEARCH_TERM', term);
};

/**
 * Paginate the dataset forward
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_nextPage = function nextPage(_ref4) {
    var commit = _ref4.commit;
    return commit('UPDATE_PAGE_NEXT');
};

/**
 * Paginate the dataset backward
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_prevPage = function prevPage(_ref5) {
    var commit = _ref5.commit;
    return commit('UPDATE_PAGE_PREV');
};

/**
 * Update the active tab
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var updateActiveTab = function updateActiveTab(_ref6, tab) {
    var commit = _ref6.commit;
    return commit('UPDATE_ACTIVE_TAB', tab);
};

/**
 * Toggle the create form
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_toggleCreateForm = function toggleCreateForm(_ref7) {
    var commit = _ref7.commit;
    return commit('TOGGLE_CREATE_FORM');
};

/**
 * Generate new operating expense
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Object} data
 * @return {Promise}
 */
var opex_schedule_actions_createNewRelativeOpex = function createNewRelativeOpex(_ref8, data) {
    var commit = _ref8.commit,
        rootState = _ref8.rootState,
        state = _ref8.state;

    var url = 'projects/' + rootState.route.params.projectId + '/relative-opex/?scope=schedule&time_sample=' + state.selectedTab;
    commit('SET_UPDATING');
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post(url, data).then(function (res) {
            commit('NEW_OPEX_SUCCESS', res.data);
            commit('RESET_UPDATING');
            resolve(res.data);
        }).catch(function (err) {
            commit('NEW_OPEX_FAILURE', err);
            commit('RESET_UPDATING');
            reject(err);
        });
    });
};

/**
 * Generate new operating expense
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Object} data
 * @return {Promise}
 */
var opex_schedule_actions_createNewRegularOpex = function createNewRegularOpex(_ref9, data) {
    var commit = _ref9.commit,
        rootState = _ref9.rootState,
        state = _ref9.state;

    var url = 'projects/' + rootState.route.params.projectId + '/regular-opex/?scope=schedule&time_sample=' + state.selectedTab;
    commit('SET_UPDATING');
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post(url, data).then(function (res) {
            commit('NEW_OPEX_SUCCESS', res.data);
            commit('RESET_UPDATING');
            resolve(res.data);
        }).catch(function (err) {
            commit('NEW_OPEX_FAILURE', err);
            commit('RESET_UPDATING');
            reject(err);
        });
    });
};

/**
 * Update an existing opex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var opex_schedule_actions_updateOpex = function updateOpex(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].put(payload.url + '?scope=schedule&time_sample=' + state.selectedTab, payload.data).then(function (res) {
            commit('REPLACE_OPEX', res.data);
            resolve(res.data);
        }).catch(function (err) {
            reject(err.response.data);
        });
    });
};

/**
 * Delete an existing opex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var opex_schedule_actions_deleteOpex = function deleteOpex(_ref11, payload) {
    var commit = _ref11.commit,
        state = _ref11.state;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].del('modelling/' + payload.type + '/' + payload.id + '/').then(function (res) {
            commit('DELETE_OPEX', payload.id);
            resolve(payload.id);
        }).catch(function (err) {
            return reject(err.response.data);
        });
    });
};

/* harmony default export */ var opex_schedule_actions = ({
    getData: opex_schedule_actions_getData,
    nextPage: actions_nextPage,
    prevPage: actions_prevPage,
    deleteOpex: opex_schedule_actions_deleteOpex,
    updateOpex: opex_schedule_actions_updateOpex,
    resetState: opex_schedule_actions_resetState,
    updateActiveTab: updateActiveTab,
    updateSearchTerm: actions_updateSearchTerm,
    toggleCreateForm: actions_toggleCreateForm,
    createNewRegularOpex: opex_schedule_actions_createNewRegularOpex,
    createNewRelativeOpex: opex_schedule_actions_createNewRelativeOpex
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-schedule/getters.js

/**
 * Dependencies
 */


/**
 * Output the OPEX data grouped by category
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Object}
 */
var opex_schedule_getters_groupedData = function groupedData(state, getters) {
    return Object(lodash["groupBy"])(getters.filteredDataset.map(function (row) {
        return {
            id: row.id,
            name: row.name,
            category: row.category,
            data: row.data.slice(getters.offset, state.pageLimit * state.currentPage),
            url: row.url
        };
    }), 'category');
};

/**
 * Get the generated colors palette
 *
 * @return {Array}
 */
var getters_chartColors = function chartColors(state, getters) {
    return ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'];
};

/**
 * Paginated index
 *
 * @return {Array}
 */
var paginatedIndex = function paginatedIndex(state, getters) {
    var total = state.pageLimit * state.currentPage;

    return state.meta.index.map(function (i, idx) {
        return getters.isMonthly ? { original_index: idx, value: i } : i;
    }).slice(getters.offset, total);
};

/**
 * Lower case search term
 *
 * @param  {Object} state
 * @return {String}
 */
var getters_formattedSearchTerm = function formattedSearchTerm(state) {
    return state.searchTerm.toLowerCase();
};

/**
 * Filtered dataset by user input string
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
var getters_filteredDataset = function filteredDataset(state, getters) {
    return state.data.filter(function (row) {
        return row.name.toLowerCase().includes(getters.formattedSearchTerm);
    });
};

/**
 * Return the appropriate dataset
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Object}
 */
var opex_schedule_getters_paginatedDataset = function paginatedDataset(state, getters) {
    var keys = keys_default()(getters.groupedData);
    return keys.reduce(function (result, item, idx, arr) {
        result[item] = getters.groupedData[item].map(function (row) {
            return row.data;
        }).reduce(function (r, a) {
            a.forEach(function (b, i) {
                r[i] = (r[i] || 0) + b;
            });
            return r;
        }, []);
        return result;
    }, {});
};

/**
 * Calculate the total number of pages
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_totalPages = function totalPages(state) {
    var max = (state.meta.index.length + 1) / (state.pageLimit || 1);

    return state.pageLimit ? Math.ceil(max) : null;
};

/**
 * Calculate the data offset to use
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_offset = function offset(state) {
    return state.pageLimit ? (state.currentPage - 1) * state.pageLimit : null;
};

/**
 * Determine whether the user can paginate the dataset
 *
 * @return {Boolean}
 */
var getters_canPaginate = function canPaginate(state, getters) {
    return state.pageLimit !== null && getters.totalPages > 1;
};

/**
 * Trasform the dataset into a chart-renederable object
 *
 * @return {Object}
 */
var opex_schedule_getters_chartData = function chartData(state, getters) {
    return {
        labels: getters.paginatedIndex,
        datasets: keys_default()(getters.paginatedDataset).reduce(function (result, item, idx, arr) {
            result.push({
                label: item,
                backgroundColor: getters.chartColors[idx],
                data: getters.paginatedDataset[item],
                borderWidth: 0
            });

            return result;
        }, [])
    };
};

/**
 * Trasform the dataset into a chart-renederable object
 *
 * @param  {Object} state
 * @return {Array}
 */
var opex_schedule_getters_totals = function totals(state, getters) {
    return keys_default()(getters.paginatedDataset).reduce(function (result, item) {
        getters.paginatedDataset[item].forEach(function (i, idx) {
            if (typeof result[idx] === 'undefined') {
                result[idx] = {
                    value: i,
                    value_type: 'currency'
                };
            } else {
                result[idx].value += i;
            }
        });
        return result;
    }, []);
};

/**
 * Determine if the index headers are by month
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var isMonthly = function isMonthly(state) {
    return state.meta.index.every(function (i) {
        return (/(\d{4})-(\d{2})-(\d{2})/.test(i)
        );
    });
};

/* harmony default export */ var opex_schedule_getters = ({
    totals: opex_schedule_getters_totals,
    offset: getters_offset,
    isMonthly: isMonthly,
    chartData: opex_schedule_getters_chartData,
    totalPages: getters_totalPages,
    canPaginate: getters_canPaginate,
    groupedData: opex_schedule_getters_groupedData,
    chartColors: getters_chartColors,
    paginatedIndex: paginatedIndex,
    filteredDataset: getters_filteredDataset,
    paginatedDataset: opex_schedule_getters_paginatedDataset,
    formattedSearchTerm: getters_formattedSearchTerm
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-schedule/mutations.js
/**
 * Dependencies
 */



/**
 * Set the tearsheet data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var opex_schedule_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
    state.loaded = true;
    state.currentPage = 1;
    state.loadingData = false;
};

/**
 * Set the tearsheet failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_schedule_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_schedule_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = opex_schedule_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Update the search term in the state object
 *
 * @param  {Object} state
 * @param  {String} term
 * @return {Void}
 */
var mutations_UPDATE_SEARCH_TERM = function UPDATE_SEARCH_TERM(state, term) {
    state.searchTerm = term;
};

/**
 * Go forward a page
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_UPDATE_PAGE_NEXT = function UPDATE_PAGE_NEXT(state) {
    state.currentPage++;
};

/**
 * Go backward a page
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_UPDATE_PAGE_PREV = function UPDATE_PAGE_PREV(state) {
    state.currentPage--;
};

/**
 * Change the active tab
 *
 * @param  {Object} state
 * @param  {Number} tab
 * @return {Void}
 */
var UPDATE_ACTIVE_TAB = function UPDATE_ACTIVE_TAB(state, tab) {
    state.selectedTab = tab;
};

/**
 * Set the data loading attribute
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_LOAD_DATA = function LOAD_DATA(state) {
    state.loadingData = true;
};

/**
 * Show / hide the form
 *
 * @param  {Object} state
 * @return {Promise}
 */
var mutations_TOGGLE_CREATE_FORM = function TOGGLE_CREATE_FORM(state) {
    state.showForm = !state.showForm;
};

/**
 * Handle new opex success
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var mutations_NEW_OPEX_SUCCESS = function NEW_OPEX_SUCCESS(state, payload) {
    state.data.push(payload);
};

/**
 * Set the updating indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var mutations_SET_UPDATING = function SET_UPDATING(state) {
    state.updating = true;
};

/**
 * Reset the updating indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var mutations_RESET_UPDATING = function RESET_UPDATING(state) {
    state.updating = false;
};

/**
 * Handle new opex failure
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Promise}
 */
var mutations_NEW_OPEX_FAILURE = function NEW_OPEX_FAILURE(state, err) {};

/**
 * Handle updating a successful opex modification request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var mutations_REPLACE_OPEX = function REPLACE_OPEX(state, payload) {
    var idx = state.data.findIndex(function (i) {
        return i.id === payload.id;
    });

    if (idx > -1) {
        state.data.splice(idx, 1, payload);
    }
};

/**
 * Delete an operating expense from the dataset
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Promise}
 */
var mutations_DELETE_OPEX = function DELETE_OPEX(state, id) {
    state.data = state.data.filter(function (i) {
        return i.id !== id;
    });
};

/* harmony default export */ var opex_schedule_mutations = ({
    LOAD_DATA: mutations_LOAD_DATA,
    DELETE_OPEX: mutations_DELETE_OPEX,
    RESET_STATE: opex_schedule_mutations_RESET_STATE,
    SET_UPDATING: mutations_SET_UPDATING,
    REPLACE_OPEX: mutations_REPLACE_OPEX,
    RESET_UPDATING: mutations_RESET_UPDATING,
    NEW_OPEX_SUCCESS: mutations_NEW_OPEX_SUCCESS,
    NEW_OPEX_FAILURE: mutations_NEW_OPEX_FAILURE,
    UPDATE_PAGE_NEXT: mutations_UPDATE_PAGE_NEXT,
    UPDATE_PAGE_PREV: mutations_UPDATE_PAGE_PREV,
    GET_DATA_SUCCESS: opex_schedule_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: opex_schedule_mutations_GET_DATA_FAILURE,
    UPDATE_ACTIVE_TAB: UPDATE_ACTIVE_TAB,
    UPDATE_SEARCH_TERM: mutations_UPDATE_SEARCH_TERM,
    TOGGLE_CREATE_FORM: mutations_TOGGLE_CREATE_FORM
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-schedule/index.js
/**
 * Module Dependencies
 */





/**
 * Project Tearsheet
 *
 * @type {Object}
 */
var opex_schedule_module = {
  namespaced: true,
  state: opex_schedule_state,
  getters: opex_schedule_getters,
  mutations: opex_schedule_mutations,
  actions: opex_schedule_actions
};

/* harmony default export */ var opex_schedule = (opex_schedule_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-pro-forma/state.js
/**
 * Dependencies
 */


var opex_pro_forma_state_base = {
  showForm: false,
  loaded: false,
  data: [],
  meta: {
    index: []
  },
  searchTerm: '',
  pageLimit: 8,
  currentPage: 1,
  loadingData: false,
  updating: false

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var opex_pro_forma_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(opex_pro_forma_state_base);
};

/* harmony default export */ var opex_pro_forma_state = (opex_pro_forma_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-pro-forma/actions.js

/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var opex_pro_forma_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;
    return commit('RESET_STATE');
};

/**
 * Get the opex for a project
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Void}
 */
var opex_pro_forma_actions_getData = function getData(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState,
        state = _ref2.state;

    var id = rootState.route.params.projectId;

    commit('LOAD_DATA');
    HttpService["a" /* default */].get('projects/' + id + '/opex-summary/?scope=t12-vs-proforma').then(function (res) {
        return commit('GET_DATA_SUCCESS', {
            data: res.data.data['opex-summaries'],
            meta: res.data.meta
        });
    }).catch(function () {
        return commit('GET_DATA_FAILURE');
    });
};

/**
 * Update the search term
 *
 * @param  {Function} options.commit
 * @param  {String} term
 * @return {Promise}
 */
var opex_pro_forma_actions_updateSearchTerm = function updateSearchTerm(_ref3, term) {
    var commit = _ref3.commit;
    return commit('UPDATE_SEARCH_TERM', term);
};

/**
 * Paginate the dataset forward
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var opex_pro_forma_actions_nextPage = function nextPage(_ref4) {
    var commit = _ref4.commit;
    return commit('UPDATE_PAGE_NEXT');
};

/**
 * Paginate the dataset backward
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var opex_pro_forma_actions_prevPage = function prevPage(_ref5) {
    var commit = _ref5.commit;
    return commit('UPDATE_PAGE_PREV');
};

/**
 * Toggle the create form
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var opex_pro_forma_actions_toggleCreateForm = function toggleCreateForm(_ref6) {
    var commit = _ref6.commit;
    return commit('TOGGLE_CREATE_FORM');
};

/**
 * Generate new operating expense
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @param  {Object} data
 * @return {Promise}
 */
var opex_pro_forma_actions_createNewRelativeOpex = function createNewRelativeOpex(_ref7, data) {
    var commit = _ref7.commit,
        rootState = _ref7.rootState;

    var url = 'projects/' + rootState.route.params.projectId + '/relative-opex/?scope=t12-vs-proforma';
    commit('SET_UPDATING');
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post(url, data).then(function (res) {
            commit('NEW_OPEX_SUCCESS', res.data);
            commit('RESET_UPDATING');
            resolve(res.data);
        }).catch(function (err) {
            commit('NEW_OPEX_FAILURE', err);
            commit('RESET_UPDATING');
            reject(err);
        });
    });
};

var opex_pro_forma_actions_createNewRegularOpex = function createNewRegularOpex(_ref8, data) {
    var commit = _ref8.commit,
        rootState = _ref8.rootState;

    var url = 'projects/' + rootState.route.params.projectId + '/regular-opex/?scope=t12-vs-proforma';
    commit('SET_UPDATING');
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post(url, data).then(function (res) {
            commit('NEW_OPEX_SUCCESS', res.data);
            commit('RESET_UPDATING');
            resolve(res.data);
        }).catch(function (err) {
            commit('NEW_OPEX_FAILURE', err);
            commit('RESET_UPDATING');
            reject(err);
        });
    });
};

/**
 * Update an existing opex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var opex_pro_forma_actions_updateOpex = function updateOpex(_ref9, payload) {
    var commit = _ref9.commit;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].put(payload.url, payload.data).then(function (res) {
            commit('REPLACE_OPEX', res.data);
            resolve(res.data);
        }).catch(function (err) {
            reject(err.response.data);
        });
    });
};

/**
 * Delete an existing opex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var opex_pro_forma_actions_deleteOpex = function deleteOpex(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].del('modelling/' + payload.type + '/' + payload.id + '/').then(function (res) {
            commit('DELETE_OPEX', payload.id);
            resolve(payload.id);
        }).catch(function (err) {
            return reject(err.response.data);
        });
    });
};

/* harmony default export */ var opex_pro_forma_actions = ({
    getData: opex_pro_forma_actions_getData,
    nextPage: opex_pro_forma_actions_nextPage,
    prevPage: opex_pro_forma_actions_prevPage,
    deleteOpex: opex_pro_forma_actions_deleteOpex,
    updateOpex: opex_pro_forma_actions_updateOpex,
    resetState: opex_pro_forma_actions_resetState,
    toggleCreateForm: opex_pro_forma_actions_toggleCreateForm,
    updateSearchTerm: opex_pro_forma_actions_updateSearchTerm,
    createNewRegularOpex: opex_pro_forma_actions_createNewRegularOpex,
    createNewRelativeOpex: opex_pro_forma_actions_createNewRelativeOpex
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-pro-forma/getters.js

/**
 * Dependencies
 */


/**
 * Output the OPEX data grouped by category
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Object}
 */
var opex_pro_forma_getters_groupedData = function groupedData(state, getters) {
    return Object(lodash["groupBy"])(getters.filteredDataset.map(function (row) {
        return {
            id: row.id,
            name: row.name,
            category: row.category,
            data: row.data,
            url: row.url,
            showForm: false
        };
    }), 'category');
};

/**
 * Get the generated colors palette
 *
 * @return {Array}
 */
var opex_pro_forma_getters_chartColors = function chartColors(state, getters) {
    return ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'];
};

/**
 * Lower case search term
 *
 * @param  {Object} state
 * @return {String}
 */
var opex_pro_forma_getters_formattedSearchTerm = function formattedSearchTerm(state) {
    return state.searchTerm.toLowerCase();
};

/**
 * Filtered dataset by user input string
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
var opex_pro_forma_getters_filteredDataset = function filteredDataset(state, getters) {
    return state.data.filter(function (row) {
        return row.name.toLowerCase().includes(getters.formattedSearchTerm);
    });
};

/**
 * Return the appropriate dataset
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Object}
 */
var opex_pro_forma_getters_paginatedDataset = function paginatedDataset(state, getters) {
    var keys = keys_default()(getters.groupedData);
    return keys.reduce(function (result, item, idx, arr) {
        result[item] = getters.groupedData[item].map(function (row) {
            return row.data;
        }).reduce(function (r, a) {
            a.forEach(function (b, i) {
                var val = r[i] ? r[i].value : 0;
                if (r[i]) {
                    r[i].value = val + b.value;
                } else {
                    r.push({
                        value: b.value,
                        value_type: b.value_type
                    });
                }
            });
            return r;
        }, []);
        return result;
    }, {});
};

/**
 * Calculate the total number of pages
 *
 * @param  {Object} state
 * @return {Number}
 */
var opex_pro_forma_getters_totalPages = function totalPages(state) {
    var max = (state.meta.index.length + 1) / (state.pageLimit || 1);

    return state.pageLimit ? Math.ceil(max) : null;
};

/**
 * Calculate the data offset to use
 *
 * @param  {Object} state
 * @return {Number}
 */
var opex_pro_forma_getters_offset = function offset(state) {
    return state.pageLimit ? (state.currentPage - 1) * state.pageLimit : null;
};

/**
 * Determine whether the user can paginate the dataset
 *
 * @return {Boolean}
 */
var opex_pro_forma_getters_canPaginate = function canPaginate(state, getters) {
    return state.pageLimit !== null && getters.totalPages > 1;
};

/**
 * Trasform the dataset into a chart-renederable object
 *
 * @return {Object}
 */
var opex_pro_forma_getters_chartData = function chartData(state, getters) {
    var keys = keys_default()(getters.paginatedDataset);
    return {
        labels: keys,
        datasets: [{
            borderWidth: 1,
            borderColor: '#76acd4',
            backgroundColor: getters.chartColors,
            data: keys.map(function (key) {
                return getters.paginatedDataset[key][1].value;
            })
        }]
    };
};

/**
 * Trasform the dataset into a chart-renederable object
 *
 * @param  {Object} state
 * @return {Array}
 */
var opex_pro_forma_getters_totals = function totals(state) {
    return state.data.reduce(function (result, item) {
        item.data.forEach(function (i, idx) {
            if (typeof result[idx] === 'undefined') {
                result[idx] = {
                    value: i.value,
                    value_type: i.value_type
                };
            } else {
                result[idx].value += i.value;
            }
        });
        return result;
    }, []);
};

/* harmony default export */ var opex_pro_forma_getters = ({
    totals: opex_pro_forma_getters_totals,
    offset: opex_pro_forma_getters_offset,
    chartData: opex_pro_forma_getters_chartData,
    totalPages: opex_pro_forma_getters_totalPages,
    canPaginate: opex_pro_forma_getters_canPaginate,
    groupedData: opex_pro_forma_getters_groupedData,
    chartColors: opex_pro_forma_getters_chartColors,
    filteredDataset: opex_pro_forma_getters_filteredDataset,
    paginatedDataset: opex_pro_forma_getters_paginatedDataset,
    formattedSearchTerm: opex_pro_forma_getters_formattedSearchTerm
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-pro-forma/mutations.js
/**
 * Dependencies
 */



/**
 * Set the opex summary data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var opex_pro_forma_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
    state.loaded = true;
    state.currentPage = 1;
    state.loadingData = false;
};

/**
 * Set the opex summary failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_pro_forma_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state) {
    state.error = true;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_pro_forma_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = opex_pro_forma_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Update the search term in the state object
 *
 * @param  {Object} state
 * @param  {String} term
 * @return {Void}
 */
var opex_pro_forma_mutations_UPDATE_SEARCH_TERM = function UPDATE_SEARCH_TERM(state, term) {
    state.searchTerm = term;
};

/**
 * Go forward a page
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_pro_forma_mutations_UPDATE_PAGE_NEXT = function UPDATE_PAGE_NEXT(state) {
    state.currentPage++;
};

/**
 * Go backward a page
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_pro_forma_mutations_UPDATE_PAGE_PREV = function UPDATE_PAGE_PREV(state) {
    state.currentPage--;
};

/**
 * Set the data loading attribute
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_pro_forma_mutations_LOAD_DATA = function LOAD_DATA(state) {
    state.loadingData = true;
};

/**
 * Show / hide the form
 *
 * @param  {Object} state
 * @return {Promise}
 */
var opex_pro_forma_mutations_TOGGLE_CREATE_FORM = function TOGGLE_CREATE_FORM(state) {
    state.showForm = !state.showForm;
};

/**
 * Handle new opex success
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var opex_pro_forma_mutations_NEW_OPEX_SUCCESS = function NEW_OPEX_SUCCESS(state, payload) {
    state.data.push(payload);
};

/**
 * Set the updating indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var opex_pro_forma_mutations_SET_UPDATING = function SET_UPDATING(state) {
    state.updating = true;
};

/**
 * Reset the updating indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var opex_pro_forma_mutations_RESET_UPDATING = function RESET_UPDATING(state) {
    state.updating = false;
};

/**
 * Handle new opex failure
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Promise}
 */
var opex_pro_forma_mutations_NEW_OPEX_FAILURE = function NEW_OPEX_FAILURE(state, err) {};

/**
 * Handle updating a successful opex modification request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var opex_pro_forma_mutations_REPLACE_OPEX = function REPLACE_OPEX(state, payload) {
    var idx = state.data.findIndex(function (i) {
        return i.id === payload.id;
    });

    if (idx > -1) {
        state.data.splice(idx, 1, payload);
    }
};

/**
 * Delete an operating expense from the dataset
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Promise}
 */
var opex_pro_forma_mutations_DELETE_OPEX = function DELETE_OPEX(state, id) {
    console.log(id);
    state.data = state.data.filter(function (i) {
        return i.id !== id;
    });
};

/* harmony default export */ var opex_pro_forma_mutations = ({
    LOAD_DATA: opex_pro_forma_mutations_LOAD_DATA,
    RESET_STATE: opex_pro_forma_mutations_RESET_STATE,
    DELETE_OPEX: opex_pro_forma_mutations_DELETE_OPEX,
    SET_UPDATING: opex_pro_forma_mutations_SET_UPDATING,
    REPLACE_OPEX: opex_pro_forma_mutations_REPLACE_OPEX,
    RESET_UPDATING: opex_pro_forma_mutations_RESET_UPDATING,
    UPDATE_PAGE_NEXT: opex_pro_forma_mutations_UPDATE_PAGE_NEXT,
    UPDATE_PAGE_PREV: opex_pro_forma_mutations_UPDATE_PAGE_PREV,
    GET_DATA_SUCCESS: opex_pro_forma_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: opex_pro_forma_mutations_GET_DATA_FAILURE,
    NEW_OPEX_SUCCESS: opex_pro_forma_mutations_NEW_OPEX_SUCCESS,
    NEW_OPEX_FAILURE: opex_pro_forma_mutations_NEW_OPEX_FAILURE,
    TOGGLE_CREATE_FORM: opex_pro_forma_mutations_TOGGLE_CREATE_FORM,
    UPDATE_SEARCH_TERM: opex_pro_forma_mutations_UPDATE_SEARCH_TERM
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/opex-pro-forma/index.js
/**
 * Module Dependencies
 */





/**
 * Opex Summary
 *
 * @type {Object}
 */
var opex_pro_forma_module = {
  namespaced: true,
  state: opex_pro_forma_state,
  getters: opex_pro_forma_getters,
  mutations: opex_pro_forma_mutations,
  actions: opex_pro_forma_actions
};

/* harmony default export */ var opex_pro_forma = (opex_pro_forma_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/exit-assumptions/state.js
/**
 * Dependencies
 */


var exit_assumptions_state_base = {
  error: null,
  loaded: false,
  data: [],
  meta: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var exit_assumptions_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(exit_assumptions_state_base);
};

/* harmony default export */ var exit_assumptions_state = (exit_assumptions_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/exit-assumptions/actions.js

/**
 * Dependencies
 */


/**
 * Get the exit assumption data
 *
 * @param {Function} commit
 * @return Void
 */
var exit_assumptions_actions_getData = function getData(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    commit('SET_LOADING');
    HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/exit-assumptions/').then(function (res) {
        commit('GET_DATA_SUCCESS', res.data);
        commit('RESET_LOADING');
    }).catch(function (err) {
        commit('GET_DATA_FAILURE', err.response.data);
        commit('RESET_LOADING');
    });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var exit_assumptions_actions_resetState = function resetState(_ref2) {
    var commit = _ref2.commit;

    commit('RESET_STATE');
};

/**
 * Save the model
 *
 * @param {Function} commit
 */
var exit_assumptions_actions_saveModel = function saveModel(_ref3, payload) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].patch(payload.url, payload.value).then(function (res) {
            commit('GET_DATA_SUCCESS', res.data);
            resolve();
        }).catch(function (err) {
            reject(err);
        });
    });
};

/* harmony default export */ var exit_assumptions_actions = ({
    getData: exit_assumptions_actions_getData,
    saveModel: exit_assumptions_actions_saveModel,
    resetState: exit_assumptions_actions_resetState
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/exit-assumptions/getters.js
/**
 * Determine if the dataset contains any editable fields
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var exit_assumptions_getters_hasEditableFields = function hasEditableFields(state) {
  return state.data.some(function (i) {
    return i.url;
  });
};

/* harmony default export */ var exit_assumptions_getters = ({
  hasEditableFields: exit_assumptions_getters_hasEditableFields
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/exit-assumptions/mutations.js
/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var exit_assumptions_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = exit_assumptions_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the loading state
 *
 * @param {Object} state
 */
var exit_assumptions_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
    state.error = null;
};

/**
 * Reset the loading state
 *
 * @param {Object} state
 */
var exit_assumptions_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/**
 * Handle the data response
 *
 * @param {Object} state
 * @param {Object} payload
 */
var exit_assumptions_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data = payload.data;
    state.meta = payload.meta;
};

/**
 * Handle the data failure
 *
 * @param {Object} state
 * @param {Object} error
 */
var exit_assumptions_mutations_GET_DATA_FAILURE = function GET_DATA_FAILURE(state, error) {
    state.error = error;
};

/* harmony default export */ var exit_assumptions_mutations = ({
    RESET_STATE: exit_assumptions_mutations_RESET_STATE,
    SET_LOADING: exit_assumptions_mutations_SET_LOADING,
    RESET_LOADING: exit_assumptions_mutations_RESET_LOADING,
    GET_DATA_SUCCESS: exit_assumptions_mutations_GET_DATA_SUCCESS,
    GET_DATA_FAILURE: exit_assumptions_mutations_GET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/exit-assumptions/index.js
/**
 * Module Dependencies
 */





/**
 * Project Exit Assumptions
 *
 * @type {Object}
 */
var exit_assumptions_module = {
  namespaced: true,
  state: exit_assumptions_state,
  getters: exit_assumptions_getters,
  mutations: exit_assumptions_mutations,
  actions: exit_assumptions_actions
};

/* harmony default export */ var exit_assumptions = (exit_assumptions_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/sensitivity-analysis/state.js
/**
 * Dependencies
 */


var sensitivity_analysis_state_base = {
  loading: false,
  data: {},
  errors: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var sensitivity_analysis_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(sensitivity_analysis_state_base);
};

/* harmony default export */ var sensitivity_analysis_state = (sensitivity_analysis_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/single/sensitivity-analysis/actions.js

/**
 * Dependencies
 */


/**
 * Get the sensitivity data
 *
 * @param  {Function} options.commit
 * @param  {Object} options.rootState
 * @return {Promise}
 */
var sensitivity_analysis_actions_getData = function getData(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    commit('SET_LOADING');
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/sensitivity/').then(function (res) {
            commit('SET_DATA', res.data);
            commit('RESET_LOADING');
            resolve();
        }).catch(function (err) {
            if (err.response) {
                commit('SET_ERRORS', err.response.data);
            }
            commit('RESET_LOADING');
            reject(err);
        });
    });
};

/* harmony default export */ var sensitivity_analysis_actions = ({
    getData: sensitivity_analysis_actions_getData
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/sensitivity-analysis/getters.js

/**
 * Determine if the state contains errors
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var sensitivity_analysis_getters_hasErrors = function hasErrors(state) {
  return keys_default()(state.errors).length > 0;
};

/* harmony default export */ var sensitivity_analysis_getters = ({
  hasErrors: sensitivity_analysis_getters_hasErrors
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/sensitivity-analysis/mutations.js
/**
 * Set the laoding indicator
 *
 * @param  {Object} state
 * @return {Void}
 */
var sensitivity_analysis_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

/**
 * Set the laoding indicator
 *
 * @param  {Object} state
 * @return {Void}
 */
var sensitivity_analysis_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/**
 * Set the data payload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var sensitivity_analysis_mutations_SET_DATA = function SET_DATA(state, payload) {
    state.data = payload;
};

/**
 * Set the errors
 *
 * @param  {Object} state
 * @param  {Object} errors
 * @return {Void}
 */
var mutations_SET_ERRORS = function SET_ERRORS(state, errors) {
    state.errors = errors;
};

/* harmony default export */ var sensitivity_analysis_mutations = ({
    SET_DATA: sensitivity_analysis_mutations_SET_DATA,
    SET_ERRORS: mutations_SET_ERRORS,
    SET_LOADING: sensitivity_analysis_mutations_SET_LOADING,
    RESET_LOADING: sensitivity_analysis_mutations_RESET_LOADING
});
// CONCATENATED MODULE: ./src/state/modules/projects/single/sensitivity-analysis/index.js
/**
 * Module Dependencies
 */





/**
 * Project Module Declaration
 *
 * @type {Object}
 */
var sensitivity_analysis_module = {
  namespaced: true,
  state: sensitivity_analysis_state,
  getters: sensitivity_analysis_getters,
  mutations: sensitivity_analysis_mutations,
  actions: sensitivity_analysis_actions
};

/* harmony default export */ var sensitivity_analysis = (sensitivity_analysis_module);
// CONCATENATED MODULE: ./src/state/modules/projects/single/index.js
/**
 * Module Dependencies
 */























/**
 * Project Module Declaration
 *
 * @type {Object}
 */
var single_module = {
    namespaced: true,
    state: single_state,
    getters: single_getters,
    mutations: single_mutations,
    actions: single_actions,
    modules: {
        debt: debt,
        gaap: gaap,
        capex: single_capex,
        equity: equity,
        income: income,
        rentRoll: rent_roll,
        overview: overview,
        cashflow: cash_flow,
        activity: single_activity,
        tearsheet: tearsheet,
        devbudget: devbudget,
        otherIncome: other_income,
        netProceeds: net_proceeds,
        opexSummary: opex_summary,
        opexSchedule: opex_schedule,
        opexProForma: opex_pro_forma,
        exitAssumptions: exit_assumptions,
        sensitivityAnalysis: sensitivity_analysis
    }
};

/* harmony default export */ var single = (single_module);
// CONCATENATED MODULE: ./src/state/modules/projects/mutations.js

/**
 * Dependencies
 */



/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PROJECTS = function GET_PROJECTS(state) {
    state.pending = true;
};

/**
 * Set the retrieved project data
 *
 * @param  {Object} state
 * @param  {Object} data
 * @return {Void}
 */
var mutations_GET_PROJECTS_SUCCESS = function GET_PROJECTS_SUCCESS(state, data) {
    state.data = data.data;
    state.meta = data.meta;
    state.pending = false;
    state.loaded = true;
};

var GET_PROJECTS_FAILED = function GET_PROJECTS_FAILED(state) {
    state.data = [];
    state.meta = {};
    state.pending = false;
    state.loaded = false;
};

/**
 * Reset the base project list data
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_PROJECT_LIST_DATA = function RESET_PROJECT_LIST_DATA(state) {
    state.data = [];
    state.meta = {};
    state.pending = false;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var projects_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = projects_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Replace the data for a project in the list state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_REPLACE_PROJECT_DATA = function REPLACE_PROJECT_DATA(state, payload) {
    var project = state.data[payload.index];
    keys_default()(payload.project).forEach(function (key) {
        project[key] = payload.project[key];
    });
};

/**
 * Update the layout state
 *
 * @param  {Object} state
 * @param  {Boolean} payload
 * @return {Void}
 */
var UPDATE_LAYOUT = function UPDATE_LAYOUT(state, payload) {
    state.cardLayout = payload;
};

/* harmony default export */ var projects_mutations = ({
    RESET_STATE: projects_mutations_RESET_STATE,
    GET_PROJECTS: GET_PROJECTS,
    UPDATE_LAYOUT: UPDATE_LAYOUT,
    GET_PROJECTS_FAILED: GET_PROJECTS_FAILED,
    GET_PROJECTS_SUCCESS: mutations_GET_PROJECTS_SUCCESS,
    REPLACE_PROJECT_DATA: mutations_REPLACE_PROJECT_DATA,
    RESET_PROJECT_LIST_DATA: RESET_PROJECT_LIST_DATA
});
// CONCATENATED MODULE: ./src/state/modules/projects/templates/state.js
/**
 * Dependencies
 */


/**
 * State Declaration
 *
 * @type {Object}
 */
var templates_state_state = {
  data: [],
  created: false,
  error: null,
  pending: false

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var templates_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(templates_state_state);
};

/* harmony default export */ var templates_state = (templates_state_getState());
// CONCATENATED MODULE: ./src/state/modules/projects/templates/actions.js

/**
 * Dependencies
 */


/**
 * Create a template from an existing project
 *
 * @param  {Object} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_createTemplate = function createTemplate(_ref, payload) {
    var commit = _ref.commit;

    commit('SET_PENDING');
    return Object(ProjectService["d" /* createTemplateFromProject */])(payload).then(function (res) {
        commit('TEMPLATE_CREATE_SUCCESS', res.data);
        return promise_default.a.resolve(res.data);
    }).catch(function (err) {
        commit('TEMPLATE_CREATE_FAILURE', err);
        return promise_default.a.reject(err);
    });
};

/**
 * Get the template list
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_getTemplates = function getTemplates(_ref2) {
    var commit = _ref2.commit;

    return Object(ProjectService["l" /* getProjectTemplates */])().then(function (res) {
        commit('TEMPLATES_GET_SUCCESS', res.data);
        return promise_default.a.resolve(res.data);
    }).catch(function (err) {
        commit('TEMPLATES_GET_FAILURE', err);
        return promise_default.a.reject(err);
    });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var templates_actions_resetState = function resetState(_ref3) {
    var commit = _ref3.commit;

    commit('RESET_STATE');
};

/* harmony default export */ var templates_actions = ({
    resetState: templates_actions_resetState,
    getTemplates: actions_getTemplates,
    createTemplate: actions_createTemplate
});
// EXTERNAL MODULE: ./src/state/modules/projects/templates/getters.js
var templates_getters = __webpack_require__("8xdo");
var templates_getters_default = /*#__PURE__*/__webpack_require__.n(templates_getters);

// CONCATENATED MODULE: ./src/state/modules/projects/templates/mutations.js
/**
 * Dependencies
 */



/**
 * Set the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
var templates_mutations_SET_PENDING = function SET_PENDING(state) {
    state.pending = true;
};

/**
 * Handle successful template creation
 *
 * @param  {[type]} state
 * @return {Void}
 */
var TEMPLATE_CREATE_SUCCESS = function TEMPLATE_CREATE_SUCCESS(state) {
    state.created = true;
    state.error = null;
    state.pending = false;
};

/**
 * Handle failed template creation
 *
 * @param  {[type]} state
 * @return {Void}
 */
var TEMPLATE_CREATE_FAILURE = function TEMPLATE_CREATE_FAILURE(state, error) {
    state.created = false;
    state.error = error.message;
    state.pending = false;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var templates_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = templates_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Handle template retrieval success
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var TEMPLATES_GET_SUCCESS = function TEMPLATES_GET_SUCCESS(state, data) {
    state.data = data;
    state.pending = false;
};

/**
 * Handle template retrieval failure
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var TEMPLATES_GET_FAILURE = function TEMPLATES_GET_FAILURE(state, error) {
    console.log(error);
    state.pending = false;
};

/* harmony default export */ var templates_mutations = ({
    RESET_STATE: templates_mutations_RESET_STATE,
    SET_PENDING: templates_mutations_SET_PENDING,
    TEMPLATES_GET_SUCCESS: TEMPLATES_GET_SUCCESS,
    TEMPLATES_GET_FAILURE: TEMPLATES_GET_FAILURE,
    TEMPLATE_CREATE_SUCCESS: TEMPLATE_CREATE_SUCCESS,
    TEMPLATE_CREATE_FAILURE: TEMPLATE_CREATE_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/projects/templates/index.js
/**
 * Module Dependencies
 */





/**
 * Project Templates Declaration
 *
 * @type {Object}
 */
var templates_module = {
  namespaced: true,
  state: templates_state,
  getters: templates_getters_default.a,
  mutations: templates_mutations,
  actions: templates_actions
};

/* harmony default export */ var templates = (templates_module);
// CONCATENATED MODULE: ./src/state/modules/projects/invitations/state.js
/**
 * Dependencies
 */


/**
 * Base State
 */
var invitations_state_base = {
    pending: false,
    myInvites: {
        data: [],
        meta: {}
    },
    sentInvites: {
        data: [],
        meta: {}
    },
    agreementModal: {
        success: false,
        accepted: false,
        show: false,
        data: null
    }

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var invitations_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(invitations_state_base);
};

/* harmony default export */ var invitations_state = (invitations_state_getState());
// CONCATENATED MODULE: ./src/services/InvitationService.js
/**
 * Dependencies
 */


/**
 * Get the project invitation data
 *
 * @return {Promise}
 */
var InvitationService_getInvitationList = function getInvitationList() {
    return HttpService["a" /* default */].get('projects/invitations/');
};

/**
 * Get the sent invitaton list
 *
 * @return {Promise}
 */
var InvitationService_getSentInvitationList = function getSentInvitationList() {
    return HttpService["a" /* default */].get('projects/collaborate');
};

/**
 * API call to accept invite
 *
 * @param  {Number} id
 * @return {Promise}
 */
var InvitationService_acceptProjectInvite = function acceptProjectInvite(id) {
    return HttpService["a" /* default */].put('projects/invitations/' + id);
};

/**
 * API call to accept invite
 *
 * @param  {Number} id
 * @return {Promise}
 */
var InvitationService_rejectProjectInvite = function rejectProjectInvite(id) {
    return HttpService["a" /* default */].del('projects/invitations/' + id);
};

/**
 * Update an invitation privilege level
 *
 * @param  {Object} payload
 * @return {Promise}
 */
var InvitationService_updatePrivilege = function updatePrivilege(payload) {
    return HttpService["a" /* default */].patch('projects/collaborate/' + payload.id, {
        privilege_level: payload.level
    });
};

/**
 * Delete a sent invitation
 *
 * @param  {Number} id
 * @return {Promise}
 */
var InvitationService_removeInvite = function removeInvite(id) {
    return HttpService["a" /* default */].del('projects/collaborate/' + id);
};

/**
 * Get the CA for a given invite
 *
 * @param  {Number} id
 * @return {Promise}
 */
var InvitationService_getConfidentialityAgreement = function getConfidentialityAgreement(id) {
    return HttpService["a" /* default */].get('projects/invitations/' + id);
};

/**
 * Accept the CA and invitation
 *
 * @param  {Number} id
 * @return {Promise}
 */
var InvitationService_acceptAgreementAndInvitation = function acceptAgreementAndInvitation(id) {
    return HttpService["a" /* default */].post('projects/invitations/' + id, {
        accepts_ca: true
    });
};
// CONCATENATED MODULE: ./src/state/modules/projects/invitations/actions.js

/**
 * Dependencies
 */


/**
 * Get the invite list from the API
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_getInvitations = function getInvitations(_ref) {
    var commit = _ref.commit;

    commit('SET_PENDING');
    return promise_default.a.all([InvitationService_getInvitationList(), InvitationService_getSentInvitationList()]).then(function (res) {
        commit('GET_INVITES_SUCCESS', res[0].data);
        commit('GET_SENT_INVITES_SUCCESS', res[1].data);
    }).catch(function (err) {
        return promise_default.a.reject(err);
    });
};

/**
 * Send request to accept invitation by ID
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var actions_acceptInvite = function acceptInvite(_ref2, id) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    return InvitationService_acceptProjectInvite(id).then(function (res) {
        commit('ACCEPT_INVITE', id);
        dispatch('addNotification', {
            title: 'Invitation Accepted',
            type: 'success',
            text: 'The invitation was accepted and the project is now available on your dashboard.',
            timeout: true
        }, { root: true });
        promise_default.a.resolve(id);
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Send request to reject invitation by ID
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var actions_rejectInvite = function rejectInvite(_ref3, id) {
    var commit = _ref3.commit;

    if (window.confirm('Are you sure you want to reject this invitation?')) {
        return InvitationService_rejectProjectInvite(id).then(function (res) {
            return commit('REJECT_INVITE', id);
        }).catch(function (err) {
            return console.log(err);
        });
    }
};

/**
 * Trigger the state reset
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var invitations_actions_resetState = function resetState(_ref4) {
    var commit = _ref4.commit;

    commit('RESET_STATE');
};

/**
 * Update a privilege level on a given invitation
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_updatePrivilegeLevel = function updatePrivilegeLevel(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    InvitationService_updatePrivilege(payload).then(function (res) {
        return commit('UPDATE_PRIVILEGE_LEVEL', payload);
    }).then(function () {
        return dispatch('addNotification', {
            title: 'Invitation updated',
            type: 'success',
            text: 'The user\'s invitation level has been updated successfully.',
            timeout: true
        }, { root: true });
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Delete a sent invitation
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var actions_removeSentInvite = function removeSentInvite(_ref6, id) {
    var commit = _ref6.commit;

    if (window.confirm('Do you want to remove this invitation?')) {
        return InvitationService_removeInvite(id).then(function (res) {
            commit('REMOVE_INVITE', id);
            return res.data;
        }).catch(function (err) {
            return err;
        });
    }
};

/**
 * Trigger the confidentiality agreement modal
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_launchAgreementDialog = function launchAgreementDialog(_ref7, id) {
    var commit = _ref7.commit;

    return InvitationService_getConfidentialityAgreement(id).then(function (res) {
        commit('SHOW_AGREEMENT_MODAL', {
            id: id,
            conf_agreement: res.data.conf_agreement
        });
        promise_default.a.resolve(res.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Tear down the agreement modal
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var tearDownAgreementDialog = function tearDownAgreementDialog(_ref8) {
    var commit = _ref8.commit;

    commit('CLOSE_AGREEMENT_MODAL');
};

/**
 * Reject the CA and invite
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_acceptAgreement = function acceptAgreement(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;

    var id = state.agreementModal.id;
    InvitationService_acceptAgreementAndInvitation(id).then(function (res) {
        commit('ACCEPT_INVITE', id);
        commit('ACCEPT_AGREEMENT_AND_INVITE');
    });
};

/**
 * Accept the CA and invite
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var rejectAgreement = function rejectAgreement(_ref10) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch,
        state = _ref10.state;

    var id = state.agreementModal.id;
    dispatch('rejectInvite', id).then(function (res) {
        commit('CLOSE_AGREEMENT_MODAL');
    });
};

/**
 * Update the agreement status
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var changeAgreementStatus = function changeAgreementStatus(_ref11, checked) {
    var commit = _ref11.commit;

    commit('UPDATE_AGREEMENT_VALUE', checked);
};

/* harmony default export */ var invitations_actions = ({
    resetState: invitations_actions_resetState,
    acceptInvite: actions_acceptInvite,
    rejectInvite: actions_rejectInvite,
    getInvitations: actions_getInvitations,
    acceptAgreement: actions_acceptAgreement,
    rejectAgreement: rejectAgreement,
    removeSentInvite: actions_removeSentInvite,
    updatePrivilegeLevel: actions_updatePrivilegeLevel,
    launchAgreementDialog: actions_launchAgreementDialog,
    tearDownAgreementDialog: tearDownAgreementDialog,
    changeAgreementStatus: changeAgreementStatus
});
// CONCATENATED MODULE: ./src/state/modules/projects/invitations/getters.js
/**
 * Check if the user has any pending invitations
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasInvitations = function hasInvitations(state) {
    return state.myInvites.data.length > 0;
};

/**
 * Determine if the state contains sent invitatins
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasSentInvitations = function hasSentInvitations(state) {
    return state.sentInvites.data.length > 0;
};

/**
 * My invitation count
 *
 * @param  {Object} state
 * @return {Number}
 */
var invitationCount = function invitationCount(state) {
    return state.myInvites.data.length;
};

/**
 * My sent invitation count
 *
 * @param  {Object} state
 * @return {Number}
 */
var sentInvitationCount = function sentInvitationCount(state) {
    return state.sentInvites.data.length;
};

/* harmony default export */ var invitations_getters = ({
    hasInvitations: hasInvitations,
    invitationCount: invitationCount,
    hasSentInvitations: hasSentInvitations,
    sentInvitationCount: sentInvitationCount
});
// CONCATENATED MODULE: ./src/state/modules/projects/invitations/mutations.js
/**
 * Dependencies
 */



/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var invitations_mutations_SET_PENDING = function SET_PENDING(state) {
    state.pending = true;
};

/**
 * Reset the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_PENDING = function RESET_PENDING(state) {
    state.pending = false;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var invitations_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = invitations_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Hydrate the invitations state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_INVITES_SUCCESS = function GET_INVITES_SUCCESS(state, payload) {
    state.myInvites.data = payload.data;
    state.myInvites.meta = payload.meta;
};

/**
 * Hydrate the sent invitations list
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_SENT_INVITES_SUCCESS = function GET_SENT_INVITES_SUCCESS(state, payload) {
    state.sentInvites.data = payload.data;
    state.sentInvites.meta = payload.meta;
};

/**
 * Handle invitation acceptance
 *
 * @param  {Object} state
 * @return {[type]}
 */
var ACCEPT_INVITE = function ACCEPT_INVITE(state, id) {
    var inviteIndex = state.myInvites.data.findIndex(function (invite) {
        return invite.invitation_id === id;
    });

    if (inviteIndex > -1) {
        state.myInvites.data.splice(inviteIndex, 1);
    }
};

/**
 * Remove single invite from state
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Void}
 */
var REJECT_INVITE = function REJECT_INVITE(state, id) {
    var inviteIndex = state.myInvites.data.findIndex(function (invite) {
        return invite.invitation_id === id;
    });

    if (inviteIndex > -1) {
        state.myInvites.data.splice(inviteIndex, 1);
    }
};

/**
 * Update invite data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_PRIVILEGE_LEVEL = function UPDATE_PRIVILEGE_LEVEL(state, payload) {
    var invite = state.sentInvites.data.find(function (item) {
        return item.invitation_id === payload.id;
    });

    if (invite) {
        invite.privilege_level = payload.level;
    }
};

/**
 * Remove a sent invite
 *
 * @param  {Object} state
 * @return {Void}
 */
var REMOVE_INVITE = function REMOVE_INVITE(state, id) {
    state.sentInvites.data = state.sentInvites.data.filter(function (item) {
        return item.invitation_id !== id;
    });
};

/**
 * Show the agreement modal
 *
 * @param  {Object} state
 * @return {Void}
 */
var SHOW_AGREEMENT_MODAL = function SHOW_AGREEMENT_MODAL(state, payload) {
    state.agreementModal.id = payload.id;
    state.agreementModal.data = payload.conf_agreement;
    state.agreementModal.show = true;
};

/**
 * Show the agreement modal
 *
 * @param  {Object} state
 * @return {Void}
 */
var CLOSE_AGREEMENT_MODAL = function CLOSE_AGREEMENT_MODAL(state) {
    state.agreementModal.success = false;
    state.agreementModal.id = null;
    state.agreementModal.accepted = false;
    state.agreementModal.show = false;
    state.agreementModal.data = null;
};

/**
 * Change the accepted state
 *
 * @param  {Object} state
 * @param  {Boolean} checked
 * @return {Void}
 */
var UPDATE_AGREEMENT_VALUE = function UPDATE_AGREEMENT_VALUE(state, checked) {
    state.agreementModal.accepted = checked;
};

/**
 * Change the success state
 *
 * @param  {Object} state
 * @return {Void}
 */
var ACCEPT_AGREEMENT_AND_INVITE = function ACCEPT_AGREEMENT_AND_INVITE(state) {
    state.agreementModal.success = true;
};

/* harmony default export */ var invitations_mutations = ({
    SET_PENDING: invitations_mutations_SET_PENDING,
    RESET_PENDING: RESET_PENDING,
    RESET_STATE: invitations_mutations_RESET_STATE,
    ACCEPT_INVITE: ACCEPT_INVITE,
    REJECT_INVITE: REJECT_INVITE,
    REMOVE_INVITE: REMOVE_INVITE,
    GET_INVITES_SUCCESS: GET_INVITES_SUCCESS,
    UPDATE_PRIVILEGE_LEVEL: UPDATE_PRIVILEGE_LEVEL,
    GET_SENT_INVITES_SUCCESS: GET_SENT_INVITES_SUCCESS,
    SHOW_AGREEMENT_MODAL: SHOW_AGREEMENT_MODAL,
    CLOSE_AGREEMENT_MODAL: CLOSE_AGREEMENT_MODAL,
    UPDATE_AGREEMENT_VALUE: UPDATE_AGREEMENT_VALUE,
    ACCEPT_AGREEMENT_AND_INVITE: ACCEPT_AGREEMENT_AND_INVITE
});
// CONCATENATED MODULE: ./src/state/modules/projects/invitations/index.js
/**
 * Dependencies
 */





/**
 * Invitations Vuex Module
 *
 * @type {Object}
 */
var invitations_module = {
  namespaced: true,
  state: invitations_state,
  getters: invitations_getters,
  mutations: invitations_mutations,
  actions: invitations_actions
};

/* harmony default export */ var invitations = (invitations_module);
// CONCATENATED MODULE: ./src/state/modules/projects/index.js
/**
 * Module Dependencies
 */












/**
 * Project Module Declaration
 *
 * @type {Object}
 */
var projects_module = {
    namespaced: true,
    state: projects_state,
    getters: projects_getters,
    mutations: projects_mutations,
    actions: projects_actions,
    modules: {
        form: projects_form,
        links: projects_links,
        share: share,
        inbox: inbox,
        single: single,
        templates: templates,
        invitations: invitations
    }
};

/* harmony default export */ var projects = (projects_module);
// CONCATENATED MODULE: ./src/state/modules/portfolios/single/state.js
/**
 * Dependencies
 */


var single_state_state = {
  pending: false,
  data: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var portfolios_single_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(single_state_state);
};

/* harmony default export */ var portfolios_single_state = (portfolios_single_state_getState());
// CONCATENATED MODULE: ./src/state/modules/portfolios/single/getters.js

/**
 * Dependencies
 */


/**
 * Return the tab count
 *
 * @param  {Object} state
 * @return {Integer}
 */
var single_getters_tabCount = function tabCount(state) {
  return keys_default()(Object(lodash["get"])(state.data, 'summary_context.tabs', {})).length;
};

/**
 * Return the portfolio labels
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_portfolioLabels = function portfolioLabels(state) {
  return Object(lodash["get"])(state.data, 'summary_context.labels', []);
};

/**
 * Portfolio Tabs
 *
 * @param  {Object} state
 * @return {Object}
 */
var getters_portfolioTabs = function portfolioTabs(state) {
  return Object(lodash["get"])(state.data, 'summary_context.tabs', {});
};

/* harmony default export */ var portfolios_single_getters = ({
  tabCount: single_getters_tabCount,
  portfolioTabs: getters_portfolioTabs,
  portfolioLabels: getters_portfolioLabels
});
// CONCATENATED MODULE: ./src/state/modules/portfolios/single/mutations.js
/**
 * Mutation Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var portfolios_single_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = portfolios_single_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the portfolio data on the state object
 *
 * @param  {Object} state
 * @return {Void}
 */
var SET_PORTFOLIO = function SET_PORTFOLIO(state, payload) {
    state.data = payload;
};

/**
 * Set the error object
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Void}
 */
var SET_ERROR = function SET_ERROR(state, err) {
    state.error = err.response;
};

/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var single_mutations_SET_PENDING = function SET_PENDING(state) {
    state.pending = true;
};

/**
 * Reset pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_RESET_PENDING = function RESET_PENDING(state) {
    state.pending = false;
};

/* harmony default export */ var portfolios_single_mutations = ({
    SET_ERROR: SET_ERROR,
    SET_PENDING: single_mutations_SET_PENDING,
    RESET_STATE: portfolios_single_mutations_RESET_STATE,
    SET_PORTFOLIO: SET_PORTFOLIO,
    RESET_PENDING: mutations_RESET_PENDING
});
// CONCATENATED MODULE: ./src/state/modules/portfolios/single/actions.js
/**
 * Dependencies
 */


/**
 * Reset the portfolio context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var portfolios_single_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;

    commit('RESET_STATE');
};

/**
 * Get the single portfolio
 *
 * @param  {[type]} options.commit    [description]
 * @param  {[type]} options.rootState [description]
 * @return {[type]}                   [description]
 */
var actions_getPortfolio = function getPortfolio(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    commit('SET_PENDING');
    HttpService["a" /* default */].get('portfolios/' + rootState.route.params.portfolioId + '/').then(function (res) {
        return commit('SET_PORTFOLIO', res.data);
    }).then(function (res) {
        return commit('RESET_PENDING');
    }).catch(function (err) {
        commit('SET_ERROR', err);
        commit('RESET_PENDING');
    });
};

/* harmony default export */ var portfolios_single_actions = ({
    resetState: portfolios_single_actions_resetState,
    getPortfolio: actions_getPortfolio
});
// CONCATENATED MODULE: ./src/state/modules/portfolios/single/index.js
/**
 * Module Dependencies
 */





/**
 * Single Portfolio Module Declaration
 *
 * @type {Object}
 */
var portfolios_single_module = {
  namespaced: true,
  state: portfolios_single_state,
  getters: portfolios_single_getters,
  mutations: portfolios_single_mutations,
  actions: portfolios_single_actions
};

/* harmony default export */ var portfolios_single = (portfolios_single_module);
// CONCATENATED MODULE: ./src/state/modules/portfolios/state.js
/**
 * Dependencies
 */


var portfolios_state_state = {
    data: [],
    meta: {},
    pending: false,
    loaded: false,
    projects: {
        pending: false,
        data: [],
        meta: {}
    },
    form: {
        pending: false,
        created: false,
        portfolioName: '',
        selectedProjects: [],
        errors: {}
    }

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var portfolios_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(portfolios_state_state);
};

/* harmony default export */ var portfolios_state = (portfolios_state_getState());
// CONCATENATED MODULE: ./src/state/modules/portfolios/getters.js
/**
 * Return the portfolio list context
 *
 * @param  {Object} state
 * @return {Object}
 */
var portfolios = function portfolios(state) {
  return {
    data: state.data,
    meta: state.meta
  };
};

/**
 * Determine if the portfolio list is empty
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasPortfolios = function hasPortfolios(state) {
  return state.data.length > 0;
};

/**
 * Return the portfolio project list context
 *
 * @param  {Object} state
 * @return {Object}
 */
var portfolioProjects = function portfolioProjects(state) {
  return {
    data: state.projects.data,
    meta: state.projects.meta
  };
};

/**
 * Determine whether the portfolio form has selected projects
 *
 * @return {Boolean} [description]
 */
var hasSelectedProjects = function hasSelectedProjects(state) {
  return state.form.selectedProjects.length > 0;
};

/**
 * Return the list of selected Project IDs for the form
 *
 * @param  {Object} state
 * @return {Array}
 */
var selectedProjects = function selectedProjects(state) {
  return state.form.selectedProjects;
};

/**
 * Get the selected project ID list
 *
 * @param  {Object} state
 * @return {Array}
 */
var selectedProjectIds = function selectedProjectIds(state) {
  return state.form.selectedProjects.map(function (project) {
    return project.id;
  });
};

/* harmony default export */ var portfolios_getters = ({
  portfolios: portfolios,
  hasPortfolios: hasPortfolios,
  selectedProjects: selectedProjects,
  portfolioProjects: portfolioProjects,
  selectedProjectIds: selectedProjectIds,
  hasSelectedProjects: hasSelectedProjects
});
// CONCATENATED MODULE: ./src/state/modules/portfolios/mutations.js
/**
 * Mutation Dependencies
 */



/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PORTFOLIOS = function GET_PORTFOLIOS(state) {
    state.pending = true;
};

/**
 * Set the portfolio list data
 *
 * @param  {Object} state
 * @param  {Object} portfolios
 * @return {Void}
 */
var PORTFOLIOS_GET_SUCCESS = function PORTFOLIOS_GET_SUCCESS(state, portfolios) {
    state.data = portfolios.data;
    state.meta = portfolios.meta;
    state.pending = false;
    state.loaded = true;
};

/**
 * Handle a failed portfolio list request
 *
 * @param  {Object} state
 * @return {Void}
 */
var PORTFOLIOS_GET_FAILED = function PORTFOLIOS_GET_FAILED(state, error) {
    state.pending = false;
    state.loaded = false;
};

/**
 * Reset the portfolio state
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_PORTFOLIOS = function RESET_PORTFOLIOS(state) {
    state.data = [];
    state.meta = {};
    state.pending = false;
    state.loaded = false;
};

/**
 * Set the pending state for portfolio project list
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PROJECT_LIST = function GET_PROJECT_LIST(state) {
    state.projects.pending = true;
};

/**
 * Set the portfolio project list
 *
 * @param  {Object} state
 * @param  {Object} projects
 * @return {Void}
 */
var SET_PORTFOLIO_PROJECTS = function SET_PORTFOLIO_PROJECTS(state, projects) {
    state.projects.data = projects.data;
    state.projects.meta = projects.meta;
    state.projects.pending = false;
};

/**
 * Handle the failed project list request
 *
 * @param  {Object} state
 * @param  {Object} projects
 * @return {Void}
 */
var SET_PORTFOLIO_PROJECTS_FAILED = function SET_PORTFOLIO_PROJECTS_FAILED(state, projects) {
    state.projects.data = [];
    state.projects.meta = {};
    state.projects.pending = false;
};

/**
 * Reset the portfolio project list context
 *
 * @param  {Object} state
 * @param  {Object} projects
 * @return {Void}
 */
var RESET_PORTFOLIO_PROJECTS = function RESET_PORTFOLIO_PROJECTS(state, projects) {
    state.projects.data = [];
    state.projects.meta = {};
    state.projects.pending = false;
};

/**
 * Add a project to the portfolio form
 *
 * @param  {Object} state
 * @param  {Integer} id
 * @return {Void}
 */
var ADD_PROJECT_TO_FORM = function ADD_PROJECT_TO_FORM(state, id) {
    state.form.selectedProjects.push(id);
};

/**
 * Remove a project from the portfolio form
 *
 * @param  {Object} state
 * @param  {Integer} id
 * @param  {Integer} index
 * @return {Void}
 */
var REMOVE_PROJECT_FROM_FORM = function REMOVE_PROJECT_FROM_FORM(state, index) {
    state.form.selectedProjects.splice(index, 1);
};

/**
 * Handle a successful portfolio creation
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var PORTFOLIO_CREATED_SUCCESS = function PORTFOLIO_CREATED_SUCCESS(state, payload) {
    state.form.pending = false;
    state.form.created = true;
};

/**
 * Handle a failed portfolio creation
 *
 * @param  {Object} state
 * @param  {Object} error
 * @return {Void}
 */
var PORTFOLIO_CREATED_FAILURE = function PORTFOLIO_CREATED_FAILURE(state, error) {
    state.form.errors = error;
    state.form.pending = false;
};

/**
 * Update the project form name state
 *
 * @param  {Object} state
 * @param  {String} payload
 * @return {Void}
 */
var mutations_UPDATE_PORTFOLIO_NAME = function UPDATE_PORTFOLIO_NAME(state, payload) {
    state.form.portfolioName = payload;
    if (state.form.errors.name) {
        vue_esm["a" /* default */].delete(state.form.errors, 'name');
    }
};

/**
 * Set the form pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
var PREPARE_PORTFOLIO_SUBMISSION = function PREPARE_PORTFOLIO_SUBMISSION(state) {
    state.form.pending = true;
};

/**
 * Reset the form state
 *
 * @param  {Object} state
 * @return {Void}
 */
var RESET_PORTFOLIO_FORM = function RESET_PORTFOLIO_FORM(state) {
    state.form.pending = false;
    state.form.created = false;
    state.form.portfolioName = '';
    state.form.selectedProjects = [];
    state.form.errors = {};
};

/**
 * Set the pending state when a portfolio is being accessed
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_EDIT_PORTFOLIO = function GET_EDIT_PORTFOLIO(state) {
    state.form.pending = true;
};

/**
 * Handle successful portfolio retrieval
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_EDIT_PORTFOLIO_SUCCESS = function GET_EDIT_PORTFOLIO_SUCCESS(state, payload) {
    state.form.portfolioName = payload.name;
    state.form.selectedProjects = payload.projects;
    state.form.pending = false;
};

/**
 * Handle failed portfolio retrieval
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Void}
 */
var GET_EDIT_PORTFOLIO_FAILURE = function GET_EDIT_PORTFOLIO_FAILURE(state, err) {
    state.form.pending = false;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var portfolios_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = portfolios_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Handle updated portfolio state
 *
 * @param  {Object} state
 * @param  {Object} res
 * @return {Void}
 */
var PORTFOLIO_UPDATED_SUCCESS = function PORTFOLIO_UPDATED_SUCCESS(state, res) {
    state.form.pending = false;
    state.form.created = true;
};

var PORTFOLIO_UPDATED_FAILURE = function PORTFOLIO_UPDATED_FAILURE(state, err) {
    console.log(err);
};

/* harmony default export */ var portfolios_mutations = ({
    RESET_STATE: portfolios_mutations_RESET_STATE,
    GET_PORTFOLIOS: GET_PORTFOLIOS,
    PORTFOLIOS_GET_SUCCESS: PORTFOLIOS_GET_SUCCESS,
    PORTFOLIOS_GET_FAILED: PORTFOLIOS_GET_FAILED,
    RESET_PORTFOLIOS: RESET_PORTFOLIOS,
    SET_PORTFOLIO_PROJECTS: SET_PORTFOLIO_PROJECTS,
    SET_PORTFOLIO_PROJECTS_FAILED: SET_PORTFOLIO_PROJECTS_FAILED,
    RESET_PORTFOLIO_PROJECTS: RESET_PORTFOLIO_PROJECTS,
    GET_PROJECT_LIST: GET_PROJECT_LIST,
    ADD_PROJECT_TO_FORM: ADD_PROJECT_TO_FORM,
    REMOVE_PROJECT_FROM_FORM: REMOVE_PROJECT_FROM_FORM,
    PORTFOLIO_CREATED_SUCCESS: PORTFOLIO_CREATED_SUCCESS,
    PORTFOLIO_CREATED_FAILURE: PORTFOLIO_CREATED_FAILURE,
    PREPARE_PORTFOLIO_SUBMISSION: PREPARE_PORTFOLIO_SUBMISSION,
    UPDATE_PORTFOLIO_NAME: mutations_UPDATE_PORTFOLIO_NAME,
    RESET_PORTFOLIO_FORM: RESET_PORTFOLIO_FORM,
    GET_EDIT_PORTFOLIO: GET_EDIT_PORTFOLIO,
    GET_EDIT_PORTFOLIO_SUCCESS: GET_EDIT_PORTFOLIO_SUCCESS,
    GET_EDIT_PORTFOLIO_FAILURE: GET_EDIT_PORTFOLIO_FAILURE,
    PORTFOLIO_UPDATED_SUCCESS: PORTFOLIO_UPDATED_SUCCESS,
    PORTFOLIO_UPDATED_FAILURE: PORTFOLIO_UPDATED_FAILURE
});
// EXTERNAL MODULE: ./src/router/paths.js
var paths = __webpack_require__("Pxfh");

// CONCATENATED MODULE: ./src/services/PortfolioService.js
/**
 * Service Dependencies
 */



/**
 * Retrieve the user's portfolios
 *
 * @param  {Object} params
 * @return {Promise}
 */
var PortfolioService_fetchPortfolios = function fetchPortfolios() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return HttpService["a" /* default */].get(paths["d" /* PORTFOLIO_LIST_URL */], params);
};

/**
 * Attempt to create a new portfolio object
 *
 * @param  {Object} form
 * @return {Promise}
 */
var PortfolioService_createPortfolio = function createPortfolio() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return HttpService["a" /* default */].post(paths["c" /* PORTFOLIO_CREATE_URL */], form);
};

/**
 * Fetch the portfolio data for editing
 *
 * @param  {Number} id
 * @return {Promise}
 */
var PortfolioService_fetchEditablePortfolio = function fetchEditablePortfolio() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  return HttpService["a" /* default */].get('portfolios/' + id + '/?edit=true');
};

/**
 * Create request to update an existing portfolio
 *
 * @param  {Number} id
 * @param  {Object} payload
 * @return {Promise}
 */
var PortfolioService_updatePortfolio = function updatePortfolio() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var payload = arguments[1];

  return HttpService["a" /* default */].put('portfolios/' + id + '/', payload);
};
// CONCATENATED MODULE: ./src/state/modules/portfolios/actions.js

/**
 * Action Dependencies
 */



/**
 * Retrieve the portfolio list
 *
 * @param  {Function} options.commit
 * @param  {Object} params
 * @return {Void}
 */
var actions_getPortfolioList = function getPortfolioList(_ref) {
    var commit = _ref.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    commit('GET_PORTFOLIOS');
    PortfolioService_fetchPortfolios(params).then(function (res) {
        return commit('PORTFOLIOS_GET_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('PORTFOLIOS_GET_FAILED', err);
    });
};

/**
 * Get and set the project list for the portfolio context
 *
 * @param  {Function} options.commit
 * @param  {Object} params
 * @return {Void}
 */
var actions_getProjectList = function getProjectList(_ref2) {
    var commit = _ref2.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    commit('GET_PROJECT_LIST');
    Object(ProjectService["e" /* fetchProjects */])(params).then(function (res) {
        return commit('SET_PORTFOLIO_PROJECTS', res.data);
    }).catch(function (err) {
        return commit('SET_PORTFOLIO_PROJECTS_FAILED', err);
    });
};

/**
 * Set or remove the project id from the portfolio form
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Object} action
 * @return {[type]}
 */
var updateSelectedProjects = function updateSelectedProjects(_ref3, project) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var projectIndex = state.form.selectedProjects.findIndex(function (item) {
        return item.id === project.id;
    });
    if (projectIndex === -1) {
        commit('ADD_PROJECT_TO_FORM', {
            id: project.id,
            name: project.name,
            picture: project.picture
        });
    } else {
        commit('REMOVE_PROJECT_FROM_FORM', projectIndex);
    }
};

/**
 * Attempt to create a new portfolio
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_createNewPortfolio = function createNewPortfolio(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('PREPARE_PORTFOLIO_SUBMISSION');
    return PortfolioService_createPortfolio({
        name: state.form.portfolioName,
        project_ids: state.form.selectedProjects.map(function (item) {
            return item.id;
        })
    }).then(function (res) {
        return commit('PORTFOLIO_CREATED_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('PORTFOLIO_CREATED_FAILURE', err.response.data);
    });
};

/**
 * Update an existing portfolio
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Number} id
 * @return {Promise}
 */
var actions_updateExistingPortfolio = function updateExistingPortfolio(_ref5, portfolioId) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit('PREPARE_PORTFOLIO_SUBMISSION');
    return PortfolioService_updatePortfolio(portfolioId, {
        name: state.form.portfolioName,
        project_ids: state.form.selectedProjects.map(function (item) {
            return item.id;
        })
    }).then(function (res) {
        return commit('PORTFOLIO_UPDATED_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('PORTFOLIO_UPDATED_FAILURE', err.response.data);
    });
};

/**
 * Update the project name
 *
 * @param  {Function} options.commit
 * @param  {String} value
 * @return {Void}
 */
var updatePortfolioName = function updatePortfolioName(_ref6, value) {
    var commit = _ref6.commit;

    commit('UPDATE_PORTFOLIO_NAME', value);
};

/**
 * Reset the portfolio form
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_resetForm = function resetForm(_ref7) {
    var commit = _ref7.commit;

    commit('RESET_PORTFOLIO_FORM');
};

/**
 * Retrieve a portfolio for editing and manage the state
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var actions_getEditPortfolio = function getEditPortfolio(_ref8, id) {
    var commit = _ref8.commit;

    commit('GET_EDIT_PORTFOLIO');
    return PortfolioService_fetchEditablePortfolio(id).then(function (res) {
        return new promise_default.a(function (resolve, reject) {
            commit('GET_EDIT_PORTFOLIO_SUCCESS', res.data);
            resolve();
        });
    }).catch(function (err) {
        return new promise_default.a(function (resolve, reject) {
            commit('GET_EDIT_PORTFOLIO_FAILURE', err);
            reject(err);
        });
    });
};

/**
 * Remove a project from a portfolio
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Void}
 */
var removeProject = function removeProject(_ref9, id) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var projectIndex = state.form.selectedProjects.findIndex(function (item) {
        return item.id === id;
    });

    if (projectIndex > -1) {
        commit('REMOVE_PROJECT_FROM_FORM', projectIndex);
    }
};

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var portfolios_actions_resetState = function resetState(_ref10) {
    var commit = _ref10.commit;

    commit('RESET_STATE');
};

/* harmony default export */ var portfolios_actions = ({
    resetForm: actions_resetForm,
    resetState: portfolios_actions_resetState,
    removeProject: removeProject,
    getProjectList: actions_getProjectList,
    getEditPortfolio: actions_getEditPortfolio,
    getPortfolioList: actions_getPortfolioList,
    createNewPortfolio: actions_createNewPortfolio,
    updatePortfolioName: updatePortfolioName,
    updateSelectedProjects: updateSelectedProjects,
    updateExistingPortfolio: actions_updateExistingPortfolio
});
// CONCATENATED MODULE: ./src/state/modules/portfolios/index.js
/**
 * Module Dependencies
 */






/**
 * Portfolio Module Declaration
 *
 * @type {Object}
 */
var portfolios_module = {
    namespaced: true,
    state: portfolios_state,
    getters: portfolios_getters,
    mutations: portfolios_mutations,
    actions: portfolios_actions,
    modules: {
        single: portfolios_single
    }
};

/* harmony default export */ var modules_portfolios = (portfolios_module);
// CONCATENATED MODULE: ./src/state/modules/deal-pipeline/state.js
/**
 * Dependencies
 */


/**
 * Deal Pipeline State
 *
 * @type {Object}
 */
var deal_pipeline_state_base = {
  loading: false,
  error: false,
  data: [],
  projects: {
    data: [],
    meta: {}
  }

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var deal_pipeline_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(deal_pipeline_state_base);
};

/* harmony default export */ var deal_pipeline_state = (deal_pipeline_state_getState());
// CONCATENATED MODULE: ./src/services/DealPipelineService.js
/**
 * Service Dependencies
 */


/**
 * Get the pipeline and associated projects
 *
 * @return {Promise}
 */
var DealPipelineService_fetchData = function fetchData() {
  return HttpService["a" /* default */].get('projects/pipeline/');
};

/**
 * Update a given project's stage
 *
 * @param  {Number} projectId
 * @param  {Number} newStage
 * @return {Promise}
 */
var DealPipelineService_updateStage = function updateStage(projectId, newStage) {
  return HttpService["a" /* default */].patch('projects/' + projectId + '/stage/', {
    id: projectId,
    stage: newStage
  });
};
// CONCATENATED MODULE: ./src/state/modules/deal-pipeline/actions.js
/**
 * Action Dependencies
 */



/**
 * Fetch pipeline data
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_fetchDealPipeline = function fetchDealPipeline(_ref) {
    var commit = _ref.commit;

    commit('GET_PIPELINE_DATA');
    DealPipelineService_fetchData().then(function (res) {
        return commit('PIPELINE_GET_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('PIPELINE_GET_FAILURE', err);
    });
};

/**
 * Update the project's stage and move the project
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_updateProjectStage = function updateProjectStage(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var pipelineIds = state.data.map(function (list) {
        return list.id;
    });
    var fromIndex = pipelineIds.indexOf(payload.from);
    var toIndex = pipelineIds.indexOf(payload.to);
    var item = state.data[fromIndex].projects.find(function (project) {
        return project.id === payload.item;
    });

    commit('REMOVE_PROJECT', {
        from: fromIndex,
        item: item
    });
    commit('ADD_PROJECT', {
        to: toIndex,
        item: item,
        newPosition: payload.newPosition
    });
    DealPipelineService_updateStage(payload.item, payload.to);
};

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var deal_pipeline_actions_resetState = function resetState(_ref3) {
    var commit = _ref3.commit;

    commit('RESET_STATE');
};

/**
 * Get a project list scoped by stage
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_getProjectsByStage = function getProjectsByStage(_ref4, stage) {
    var commit = _ref4.commit;

    return Object(ProjectService["e" /* fetchProjects */])({ stage: stage }).then(function (res) {
        return commit('GET_STAGE_DATA_SUCCESS', res.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

var updatePipelineList = function updatePipelineList(_ref5, payload) {
    var commit = _ref5.commit;
    return commit('UPDATE_LIST', payload);
};

/* harmony default export */ var deal_pipeline_actions = ({
    resetState: deal_pipeline_actions_resetState,
    fetchDealPipeline: actions_fetchDealPipeline,
    updateProjectStage: actions_updateProjectStage,
    getProjectsByStage: actions_getProjectsByStage,
    updatePipelineList: updatePipelineList
});
// EXTERNAL MODULE: ./src/state/modules/deal-pipeline/getters.js
var deal_pipeline_getters = __webpack_require__("+9ZE");
var deal_pipeline_getters_default = /*#__PURE__*/__webpack_require__.n(deal_pipeline_getters);

// CONCATENATED MODULE: ./src/state/modules/deal-pipeline/mutations.js

/**
 * Dependencies
 */



/**
 * Set the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_PIPELINE_DATA = function GET_PIPELINE_DATA(state) {
    state.loading = true;
    state.error = false;
};

/**
 * Set the project data on successful retrieval
 *
 * @param  {Object} state
 * @param  {Array} data
 * @return {Void}
 */
var PIPELINE_GET_SUCCESS = function PIPELINE_GET_SUCCESS(state, data) {
    state.data = data;
    state.loading = false;
};

/**
 * Handle the failed data retrieval
 *
 * @param  {Object} state
 * @return {Void}
 */
var PIPELINE_GET_FAILURE = function PIPELINE_GET_FAILURE(state) {
    state.error = true;
    state.loading = false;
};

/**
 * Remove a project from a pipeline
 *
 * @param  {Object} state
 * @return {Void}
 */
var REMOVE_PROJECT = function REMOVE_PROJECT(state, payload) {
    var projectIndex = state.data[payload.from].projects.map(function (project) {
        return project.id;
    }).indexOf(payload.item.id);

    state.data[payload.from].projects.splice(projectIndex, 1);
};

/**
 * Add a project to a pipeline
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_ADD_PROJECT = function ADD_PROJECT(state, payload) {
    var item = JSON.parse(stringify_default()(payload.item));

    state.data[payload.to].projects.splice(payload.newPosition, 0, item);
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var deal_pipeline_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = deal_pipeline_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Hydrate the project data for a pipeline stage
 *
 * @param  {Object} state
 * @param  {Object} data
 * @return {Void}
 */
var GET_STAGE_DATA_SUCCESS = function GET_STAGE_DATA_SUCCESS(state, data) {
    state.projects = data;
};

var UPDATE_LIST = function UPDATE_LIST(state, payload) {
    state.data[payload.idx].projects = payload.list;
};

/* harmony default export */ var deal_pipeline_mutations = ({
    RESET_STATE: deal_pipeline_mutations_RESET_STATE,
    UPDATE_LIST: UPDATE_LIST,
    GET_PIPELINE_DATA: GET_PIPELINE_DATA,
    PIPELINE_GET_SUCCESS: PIPELINE_GET_SUCCESS,
    PIPELINE_GET_FAILURE: PIPELINE_GET_FAILURE,
    REMOVE_PROJECT: REMOVE_PROJECT,
    ADD_PROJECT: mutations_ADD_PROJECT,
    GET_STAGE_DATA_SUCCESS: GET_STAGE_DATA_SUCCESS
});
// CONCATENATED MODULE: ./src/state/modules/deal-pipeline/index.js
/**
 * Module Dependencies
 */





/**
 * Deal Pipeline Module Declaration
 *
 * @type {Object}
 */
var deal_pipeline_module = {
  namespaced: true,
  state: deal_pipeline_state,
  actions: deal_pipeline_actions,
  getters: deal_pipeline_getters_default.a,
  mutations: deal_pipeline_mutations
};

/* harmony default export */ var deal_pipeline = (deal_pipeline_module);
// CONCATENATED MODULE: ./src/state/modules/pnl-importer/state.js
/**
 * Dependencies
 */


/**
 * State
 *
 * @type {Object}
 */
var pnl_importer_state_base = {
    data: {
        date: null,
        file_name: null,
        input: {
            data: {},
            meta: {}
        },
        output: {
            noi: [],
            meta: {},
            excluded: []
        },
        meta: {}
    },
    errors: {
        message: null,
        sheet_names: [],
        opex_file_id: null,
        error_type: null,
        attempted_sheet_name: null
    },
    showInputBindings: true,
    requestingHelp: false,
    helpRequested: false,
    loading: false,
    uploaded: false,
    pnl_file_id: null,
    assistanceMessage: null,
    activeTab: 'opex',
    selectedCategory: '',
    searchTerm: '',
    selectedColorIndex: null,
    success: false,
    colors: {
        opaque: ['rgba(204, 153, 102, 1)', 'rgba(255, 102, 204, 1)', 'rgba(102, 204, 153, 1)', 'rgba(255, 204, 102, 1)', 'rgba(204, 153, 204, 1)', 'rgba(255, 102, 51, 1)', 'rgba(102, 153, 51, 1)', 'rgba(102, 153, 255, 1)', 'rgba(153, 204, 255, 1)', 'rgba(255, 195, 0, 1)', 'rgba(153, 0, 204, 1)', 'rgba(102, 51, 51, 1)'],
        translucent: ['rgba(204, 153, 102, 0.2)', 'rgba(255, 102, 204, 0.2)', 'rgba(102, 204, 153, 0.2)', 'rgba(255, 204, 102, 0.2)', 'rgba(204, 153, 204, 0.2)', 'rgba(255, 102, 51, 0.2)', 'rgba(102, 153, 51, 0.2)', 'rgba(102, 153, 255, 0.2)', 'rgba(153, 204, 255, 0.2)', 'rgba(255, 195, 0, 0.2)', 'rgba(153, 0, 204, 0.2)', 'rgba(102, 51, 51, 0.2)']
    }

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var pnl_importer_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(pnl_importer_state_base);
};

/* harmony default export */ var pnl_importer_state = (pnl_importer_state_getState());
// CONCATENATED MODULE: ./src/state/modules/pnl-importer/getters.js
/**
 * Return the chart data for the output NOI
 *
 * @param  {Object} state
 * @return {Object}
 */
var outputChartData = function outputChartData(state) {
    return state.data.output.noi.reduce(function (result, i) {
        result.labels.push(i.label);
        result.data.push(i.amount);
        return result;
    }, { labels: [], data: [] });
};

/* harmony default export */ var pnl_importer_getters = ({
    outputChartData: outputChartData
});
// CONCATENATED MODULE: ./src/state/modules/pnl-importer/actions.js
/**
 * Dependencies
 */


/**
 * Return a revised value set
 *
 * @param  {Array} arr
 * @param  {Number} total
 * @return {Array}
 */
var transformValues = function transformValues(arr, total) {
    var values = new Array(total);
    for (var i = 0; i < total; i++) {
        values[i] = arr[i] ? arr[i] : null;
    }
    if (total > 2) {
        values.splice(total - 1, 0, '...');
    }
    return values;
};

/**
 * Return a revised input dataset
 *
 * @param  {Array} arr
 * @param  {Number} total
 * @return {Object}
 */
var transformInputData = function transformInputData(arr, total) {
    return arr.map(function (item) {
        return {
            file_category: item.file_category,
            is_total: item.is_total,
            label: item.label,
            lucro_category: item.lucro_category,
            values: transformValues(item.values, total),
            data: transformInputData(item.data, total)
        };
    });
};

/**
 * Transform the headers to the appropriate format
 *
 * @param  {Array} headers
 * @param  {Number} total
 * @return {Array}
 */
var transformInputHeaders = function transformInputHeaders(headers, total) {
    headers.splice(0, 0, 'Lucro Category');
    if (total > 2) {
        headers.splice(total, 0, '...');
    }
    return headers;
};

/**
 * Convert the payload to a useable format
 *
 * @param  {Object} payload
 * @return {Object}
 */
var convertPayload = function convertPayload(payload) {
    payload.output.summary.opex = payload.output.summary.opex.map(function (item, idx) {
        item.id = idx;
        return item;
    });
    payload.output.summary.income = payload.output.summary.income.map(function (item, idx) {
        item.id = idx;
        return item;
    });
    payload.output.summary.opex_category_list.push('Excluded Items');
    payload.output.summary.opex_category_list = payload.output.summary.opex_category_list.filter(function (item) {
        return item !== null;
    });
    payload.output.summary.income_category_list = payload.output.summary.income_category_list.filter(function (item) {
        return item !== null;
    });
    payload.input = {
        meta: payload.input.meta,
        data: transformInputData(payload.input.data.data, payload.input.meta.index.length)
    };
    payload.input.meta.index = transformInputHeaders(payload.input.meta.index, payload.input.meta.index.length);

    return payload;
};

/**
 * Upload a given file to the server and handle the mapping payload
 *
 * @param  {Function} options.commit
 * @param  {File} data
 * @return {Void}
 */
var actions_uploadFile = function uploadFile(_ref, data) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('SET_LOADING');
    HttpService["a" /* default */].post('data-import/import-files/pnl/', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(function (res) {
        commit('SET_DATA', res.data);
        commit('projects/form/UPDATE_FILE_ID', {
            id: res.data.meta.pnl_file_id,
            type: 'pnl_file_id'
        }, { root: true });
        commit('RESET_LOADING');
    }).catch(function (e) {
        if (e.response) {
            commit('SET_DATA_ERROR', e.response.data);
        }
        dispatch('addNotification', {
            title: 'Error',
            type: 'error',
            text: 'There was a problem uploading your file.',
            timeout: true
        }, { root: true });
        commit('RESET_LOADING');
    });
};

/**
 * Update the selected category
 *
 * @param  {Function} options.commit
 * @param  {String} category
 * @return {Void}
 */
var updateSelectedCategory = function updateSelectedCategory(_ref2, payload) {
    var commit = _ref2.commit;

    commit('UPDATE_SEARCH_TERM', null);
    commit('UPDATE_SELECTED_CATEGORY', payload);
};

/**
 * Update an item's category
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var updateItemCategory = function updateItemCategory(_ref3, payload) {
    var commit = _ref3.commit;

    commit('UPDATE_ITEM_CATEGORY', payload);
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var pnl_importer_actions_resetState = function resetState(_ref4) {
    var commit = _ref4.commit;

    commit('RESET_STATE');
};

/**
 * Update the importer active tab
 *
 * @param  {Object} options.commit
 * @param  {String} type
 * @return {Void}
 */
var updateTab = function updateTab(_ref5, type) {
    var commit = _ref5.commit;

    commit('UPDATE_TAB', type);
};

/**
 * Update the search term
 *
 * @param  {Function} options.commit
 * @param  {String} term
 * @return {Void}
 */
var pnl_importer_actions_updateSearchTerm = function updateSearchTerm(_ref6, term) {
    var commit = _ref6.commit;

    commit('UPDATE_SEARCH_TERM', term);
};

/**
 * Import the reviewed OPEX line items
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_importItems = function importItems(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch;

    commit('SET_LOADING');
    HttpService["a" /* default */].patch('data-import/import-files/' + state.data.meta.pnl_file_id + '/', {
        opex: state.data.opex,
        income: state.data.income
    }).then(function (res) {
        dispatch('projects/form/ingestOpexValues', res.data, {
            root: true
        });
        commit('RESET_LOADING');
        commit('IMPORT_SUCCESSFUL');
    }).catch(function () {
        commit('RESET_LOADING');
        commit('IMPORT_FAILED');
    });
};

/**
 * Allow the user to request assistance with a file that fails to upload properly
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var actions_requestFileAssistance = function requestFileAssistance(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;

    commit('REQUEST_FILE_ASSISTANCE');
    HttpService["a" /* default */].post('data-import/import-files/' + state.errors.opex_file_id + '/support/').then(function (res) {
        return commit('SUPPORT_REQUEST_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('SUPPORT_REQUEST_FAILURE', err.response.data);
    });
};

/**
 * Toggle the input tree table
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var toggleInputBindings = function toggleInputBindings(_ref9) {
    var commit = _ref9.commit;
    return commit('TOGGLE_INPUT_BINDINGS');
};

/**
 * Update an item's input category
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_changeCategory = function changeCategory(_ref10, payload) {
    var state = _ref10.state,
        commit = _ref10.commit;

    HttpService["a" /* default */].patch('data-import/import-files/' + state.data.meta.pnl_file_id + '/', {
        input: [{
            label: payload.item.label,
            lucro_category: payload.value,
            file_category: payload.item.file_category
        }]
    }).then(function (res) {
        return commit('SET_DATA', convertPayload(res.data));
    }).catch(function (err) {
        return console.log(err);
    });
};

/**
 * Update the category for an existing output item
 *
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
var actions_updateCategory = function updateCategory(_ref11, payload) {
    var commit = _ref11.commit,
        state = _ref11.state,
        dispatch = _ref11.dispatch;

    HttpService["a" /* default */].patch('data-import/import-files/' + state.data.meta.pnl_file_id + '/update/', payload).then(function (res) {
        commit('SET_DATA', res.data);
        dispatch('addNotification', {
            title: 'Item Reassigned',
            type: 'success',
            text: 'The line item was successfully recategorized',
            timeout: true
        }, { root: true });
    }).catch(function (e) {
        if (e.response) {
            commit('SET_DATA_ERROR', e.response.data);
        }
        dispatch('addNotification', {
            title: 'Error',
            type: 'error',
            text: 'There was a problem uploading your file.',
            timeout: true
        }, { root: true });
    });
};

var actions_importData = function importData(_ref12) {
    var state = _ref12.state,
        dispatch = _ref12.dispatch,
        commit = _ref12.commit;

    commit('SET_LOADING');
    HttpService["a" /* default */].get('data-import/import-files/' + state.data.meta.pnl_file_id + '/import/').then(function (res) {
        dispatch('projects/form/ingestOpexValues', res.data, {
            root: true
        });
        commit('RESET_LOADING');
        commit('IMPORT_SUCCESSFUL');
    }).catch(function () {
        commit('RESET_LOADING');
        commit('IMPORT_FAILED');
    });
};

/* harmony default export */ var pnl_importer_actions = ({
    updateTab: updateTab,
    importData: actions_importData,
    resetState: pnl_importer_actions_resetState,
    uploadFile: actions_uploadFile,
    importItems: actions_importItems,
    updateCategory: actions_updateCategory,
    changeCategory: actions_changeCategory,
    updateSearchTerm: pnl_importer_actions_updateSearchTerm,
    updateItemCategory: updateItemCategory,
    requestFileAssistance: actions_requestFileAssistance,
    updateSelectedCategory: updateSelectedCategory,
    toggleInputBindings: toggleInputBindings
});
// CONCATENATED MODULE: ./src/state/modules/pnl-importer/mutations.js
/**
 * Dependencies
 */



/**
 * Modify the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
var pnl_importer_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

/**
 * Modify the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
var pnl_importer_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/**
 * Set the importer payload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var pnl_importer_mutations_SET_DATA = function SET_DATA(state, payload) {
    state.data = payload;
};

/**
 * Set the importer payload errors
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var SET_DATA_ERROR = function SET_DATA_ERROR(state, errors) {
    state.errors = errors;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var pnl_importer_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = pnl_importer_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Update the active tab state
 *
 * @param  {Object} state
 * @param  {String} tab
 * @return {Void}
 */
var UPDATE_TAB = function UPDATE_TAB(state, tab) {
    state.activeTab = tab;
    state.selectedCategory = '';
    state.searchTerm = '';
};

/**
 * Change the selected category state
 *
 * @param  {Object} state
 * @param  {String} category
 * @return {Void}
 */
var UPDATE_SELECTED_CATEGORY = function UPDATE_SELECTED_CATEGORY(state, payload) {
    state.selectedCategory = payload.cat;
    state.selectedColorIndex = payload.idx;
    state.searchTerm = null;
};

/**
 * Update an item's category
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var UPDATE_ITEM_CATEGORY = function UPDATE_ITEM_CATEGORY(state, payload) {
    var item = state.data[state.activeTab].find(function (item) {
        return item.id === payload.id;
    });

    item.our_category = payload.category === 'Excluded Items' ? null : payload.category;
};

/**
 * Update the search term
 *
 * @param  {Object} state
 * @param  {String} term
 * @return {Void}
 */
var pnl_importer_mutations_UPDATE_SEARCH_TERM = function UPDATE_SEARCH_TERM(state, term) {
    state.searchTerm = term;
};

/**
 * Handle the successful import
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var IMPORT_SUCCESSFUL = function IMPORT_SUCCESSFUL(state) {
    state.success = true;
};

/**
 * Handle the failed import
 *
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
var IMPORT_FAILED = function IMPORT_FAILED(state, err) {
    state.error = true;
};

/**
 * Handle a successful request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var SUPPORT_REQUEST_SUCCESS = function SUPPORT_REQUEST_SUCCESS(state, message) {
    state.helpRequested = true;
    state.requestingHelp = false;
    state.assistanceMessage = message;
};

/**
 * Handle a failed request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var SUPPORT_REQUEST_FAILURE = function SUPPORT_REQUEST_FAILURE(state, error) {
    state.helpRequested = true;
    state.requestingHelp = false;
};

/**
 * Set the loading indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var REQUEST_FILE_ASSISTANCE = function REQUEST_FILE_ASSISTANCE(state) {
    state.requestingHelp = true;
};

/**
 * Toggle the tree tablem
 *
 * @param  {Object} state
 * @return {Void}
 */
var TOGGLE_INPUT_BINDINGS = function TOGGLE_INPUT_BINDINGS(state) {
    state.showInputBindings = !state.showInputBindings;
};

/* harmony default export */ var pnl_importer_mutations = ({
    SET_DATA: pnl_importer_mutations_SET_DATA,
    UPDATE_TAB: UPDATE_TAB,
    RESET_STATE: pnl_importer_mutations_RESET_STATE,
    SET_LOADING: pnl_importer_mutations_SET_LOADING,
    RESET_LOADING: pnl_importer_mutations_RESET_LOADING,
    IMPORT_FAILED: IMPORT_FAILED,
    SET_DATA_ERROR: SET_DATA_ERROR,
    IMPORT_SUCCESSFUL: IMPORT_SUCCESSFUL,
    UPDATE_SEARCH_TERM: pnl_importer_mutations_UPDATE_SEARCH_TERM,
    UPDATE_ITEM_CATEGORY: UPDATE_ITEM_CATEGORY,
    TOGGLE_INPUT_BINDINGS: TOGGLE_INPUT_BINDINGS,
    REQUEST_FILE_ASSISTANCE: REQUEST_FILE_ASSISTANCE,
    SUPPORT_REQUEST_SUCCESS: SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE: SUPPORT_REQUEST_FAILURE,
    UPDATE_SELECTED_CATEGORY: UPDATE_SELECTED_CATEGORY
});
// CONCATENATED MODULE: ./src/state/modules/pnl-importer/index.js
/**
 * Module Dependencies
 */





/**
 * P&L Importer Module Declaration
 *
 * @type {Object}
 */
var pnl_importer_module = {
  namespaced: true,
  state: pnl_importer_state,
  getters: pnl_importer_getters,
  mutations: pnl_importer_mutations,
  actions: pnl_importer_actions
};

/* harmony default export */ var pnl_importer = (pnl_importer_module);
// CONCATENATED MODULE: ./src/state/modules/opex-importer/state.js
/**
 * Dependencies
 */


/**
 * State
 *
 * @type {Object}
 */
var opex_importer_state_base = {
    selectedColorIndex: null,
    imported: false,
    searchTerm: null,
    selectedCategory: '',
    error: null,
    uploading: false,
    progress: 0,
    loading: false,
    saving: false,
    saved: false,
    file_name: null,
    date: null,
    category_list: [],
    mappings: [],
    meta: {},
    miscinc: [],
    helpRequested: false,
    requestingHelp: false,
    colors: {
        opaque: ['rgba(204, 153, 102, 1)', 'rgba(255, 102, 204, 1)', 'rgba(102, 204, 153, 1)', 'rgba(255, 204, 102, 1)', 'rgba(204, 153, 204, 1)', 'rgba(255, 102, 51, 1)', 'rgba(102, 153, 51, 1)', 'rgba(102, 153, 255, 1)', 'rgba(153, 204, 255, 1)', 'rgba(255, 195, 0, 1)', 'rgba(153, 0, 204, 1)', 'rgba(102, 51, 51, 1)'],
        translucent: ['rgba(204, 153, 102, 0.2)', 'rgba(255, 102, 204, 0.2)', 'rgba(102, 204, 153, 0.2)', 'rgba(255, 204, 102, 0.2)', 'rgba(204, 153, 204, 0.2)', 'rgba(255, 102, 51, 0.2)', 'rgba(102, 153, 51, 0.2)', 'rgba(102, 153, 255, 0.2)', 'rgba(153, 204, 255, 0.2)', 'rgba(255, 195, 0, 0.2)', 'rgba(153, 0, 204, 0.2)', 'rgba(102, 51, 51, 0.2)']
    }

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var opex_importer_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(opex_importer_state_base);
};

/* harmony default export */ var opex_importer_state = (opex_importer_state_getState());
// CONCATENATED MODULE: ./src/state/modules/opex-importer/getters.js
/**
 * Dependencie
 */


/**
 * Determine if the upload has completed
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var fileUploadCompleted = function fileUploadCompleted(state) {
    return state.progress === 100;
};

/**
 * Determine if the upload was successful
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var uploadSuccessful = function uploadSuccessful(state) {
    return state.progress === 100 && !state.error && state.mappings.length > 0;
};

/**
 * Get list of all categories and their summed values for reference
 *
 * @param  {Object} state
 * @return {Array}
 */
var importedOpexSummary = function importedOpexSummary(state) {
    return state.mappings.filter(function (item) {
        return item.our_category !== null;
    }).reduce(function (result, item) {
        var found = result.findIndex(function (i) {
            return i.category === item.our_category;
        });
        if (found > -1) {
            result[found].total += item.amount;
            result[found].count++;
        } else {
            result.unshift({
                category: item.our_category,
                total: item.amount,
                count: 1
            });
        }

        return result;
    }, []).sort(function (a, b) {
        var cat1 = state.category_list.indexOf(a.category);
        var cat2 = state.category_list.indexOf(b.category);

        return cat1 < cat2 ? -1 : 1;
    });
};

/**
 * Excluded items
 *
 * @param  {Object} state
 * @return {Object}
 */
var getters_excludedTotal = function excludedTotal(state) {
    var excluded = state.mappings.filter(function (item) {
        return item.our_category === null;
    });

    return Object(lodash["sumBy"])(excluded, 'amount');
};

/**
 * Filtered summary by category key
 *
 * @param  {Object} state
 * @return {Array}
 */
var filteredSummaryByCategory = function filteredSummaryByCategory(state) {
    var searchTerm = (state.searchTerm || '').toLowerCase();
    return state.mappings.filter(function (item) {
        switch (state.selectedCategory) {
            case '':
                return true;
            case 'Excluded Items':
                return item.our_category == null;
            default:
                return item.our_category === state.selectedCategory;
        }
    }).filter(function (item) {
        var matchableString = (item.name || '').toLowerCase();
        return matchableString.includes(searchTerm);
    });
};

/**
 * Get the total aggregated sum
 *
 * @param  {Object} state
 * @return {Number}
 */
var getters_aggregatedTotal = function aggregatedTotal(state) {
    return Object(lodash["sumBy"])(state.mappings, 'amount');
};

/**
 * Get the aggregated total from the miscellaneous income items
 *
 * @type {Number}
 */
var getters_miscIncomeTotal = function miscIncomeTotal(state) {
    return Object(lodash["sumBy"])(state.miscinc, 'amount');
};

/**
 * Get the general index for the miscellaneous income dataset
 *
 * @param  {Object} state
 * @return {Array}
 */
var miscIncomeIndex = function miscIncomeIndex(state) {
    if (state.miscinc.length > 0) {
        return state.miscinc[0].parsed_data.index;
    }

    return [];
};

/**
 * Get the total number of miscellaneous income items
 *
 * @param  {Object} state
 * @return {Number}
 */
var miscIncomeCount = function miscIncomeCount(state) {
    return state.miscinc.length;
};

/**
 * Get the total number of mapped items
 *
 * @param  {Object} state
 * @return {Number}
 */
var opexCount = function opexCount(state) {
    return state.mappings.length;
};

/**
 * Get the total number of excluded items in the mappings array
 *
 * @param  {Object} state
 * @return {Number}
 */
var excludedItemsCount = function excludedItemsCount(state) {
    return state.mappings.filter(function (item) {
        return item.our_category == null;
    }).length;
};

/* harmony default export */ var opex_importer_getters = ({
    opexCount: opexCount,
    excludedTotal: getters_excludedTotal,
    miscIncomeIndex: miscIncomeIndex,
    miscIncomeTotal: getters_miscIncomeTotal,
    aggregatedTotal: getters_aggregatedTotal,
    miscIncomeCount: miscIncomeCount,
    uploadSuccessful: uploadSuccessful,
    excludedItemsCount: excludedItemsCount,
    fileUploadCompleted: fileUploadCompleted,
    importedOpexSummary: importedOpexSummary,
    filteredSummaryByCategory: filteredSummaryByCategory
});
// CONCATENATED MODULE: ./src/state/modules/opex-importer/actions.js
/**
 * Dependencies
 */


/**
 * Upload a given file to the server and handle the mapping payload
 *
 * @param  {Function} options.commit
 * @param  {File} data
 * @return {Void}
 */
var opex_importer_actions_uploadFile = function uploadFile(_ref, data) {
    var commit = _ref.commit;

    var uploadUrl = 'projects/opex-importer/';
    var formData = new FormData();
    formData.append('file', data.file);
    if (data.excel_sheet !== null) {
        formData.append('excel_sheet', data.excel_sheet);
    }

    commit('BEGIN_UPLOAD');

    HttpService["a" /* default */].post(uploadUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: function onUploadProgress(progressEvent) {
            var val = progressEvent.loaded * 100 / progressEvent.total;
            var progress = Math.round(val);
            commit('UPDATE_UPLOAD_PROGRESS', progress);
        }
    }).then(function (res) {
        var payload = res.data;
        payload.category_list.push('Excluded Items');
        payload.category_list = payload.category_list.filter(function (item) {
            return item !== null;
        });
        commit('SET_DATA', payload);
        commit('projects/form/UPDATE_FILE_ID', {
            id: payload.meta.opex_file_id,
            type: 'opex_file_id'
        }, { root: true });
        return res;
    }).catch(function (err) {
        return commit('SET_DATA_ERROR', err.response.data);
    });
};

/**
 * Show the modal
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var showOpexModal = function showOpexModal(_ref2) {
    var commit = _ref2.commit;

    commit('SHOW_MODAL');
};

/**
 * Hide the modal
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var hideOpexModal = function hideOpexModal(_ref3) {
    var commit = _ref3.commit;

    commit('HIDE_MODAL');
};

/**
 * Update the selected category
 *
 * @param  {Function} options.commit
 * @param  {String} category
 * @return {Void}
 */
var actions_updateSelectedCategory = function updateSelectedCategory(_ref4, payload) {
    var commit = _ref4.commit;

    commit('UPDATE_SELECTED_CATEGORY', payload);
};

/**
 * Update an item's category
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_updateItemCategory = function updateItemCategory(_ref5, payload) {
    var commit = _ref5.commit;

    commit('UPDATE_ITEM_CATEGORY', payload);
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var opex_importer_actions_resetState = function resetState(_ref6) {
    var commit = _ref6.commit;

    commit('RESET_STATE');
};

/**
 * Update the given search term
 *
 * @param  {Function} options.commit
 * @param  {String} payload
 * @return {Promise}
 */
var opex_importer_actions_updateSearchTerm = function updateSearchTerm(_ref7, payload) {
    var commit = _ref7.commit;
    return commit('UPDATE_SEARCH_TERM', payload);
};

/**
 * Import the reviewed OPEX line items
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var opex_importer_actions_importItems = function importItems(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state,
        dispatch = _ref8.dispatch;

    var url = 'projects/opex-update/' + state.meta.opex_file_id + '/';
    commit('IMPORT_BEGIN');
    setTimeout(function () {
        HttpService["a" /* default */].patch(url, {
            miscinc: state.miscinc,
            mappings: state.mappings
        }).then(function (res) {
            dispatch('projects/form/ingestOpexValues', res.data, {
                root: true
            }).then(function () {
                return commit('IMPORT_SUCCESS');
            });
        }).catch(function (err) {
            return console.log(err);
        });
    }, 2000);
};

/**
 * Allow the user to request assistance with a file that fails to upload properly
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var opex_importer_actions_requestFileAssistance = function requestFileAssistance(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;

    commit('REQUEST_FILE_ASSISTANCE');
    HttpService["a" /* default */].post('projects/import-file/' + state.error.opex_file_id + '/support/').then(function (res) {
        return commit('SUPPORT_REQUEST_SUCCESS', res);
    }).catch(function (err) {
        return commit('SUPPORT_REQUEST_FAILURE', err);
    });
};

/* harmony default export */ var opex_importer_actions = ({
    resetState: opex_importer_actions_resetState,
    uploadFile: opex_importer_actions_uploadFile,
    importItems: opex_importer_actions_importItems,
    showOpexModal: showOpexModal,
    hideOpexModal: hideOpexModal,
    updateSearchTerm: opex_importer_actions_updateSearchTerm,
    updateItemCategory: actions_updateItemCategory,
    requestFileAssistance: opex_importer_actions_requestFileAssistance,
    updateSelectedCategory: actions_updateSelectedCategory
});
// CONCATENATED MODULE: ./src/state/modules/opex-importer/mutations.js
/**
 * Dependencies
 */



/**
 * Set the loading states
 *
 * @param  {[type]} state
 * @return {[type]}
 */
var BEGIN_UPLOAD = function BEGIN_UPLOAD(state) {
    state.error = null;
    state.uploading = true;
};

/**
 * Set the data on a successful POST
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var opex_importer_mutations_SET_DATA = function SET_DATA(state, payload) {
    state.category_list = payload.category_list;
    state.mappings = payload.mappings.map(function (item, idx) {
        item.id = idx + 1;
        return item;
    });
    state.meta = payload.meta;
    state.miscinc = payload.miscinc;
    state.file_name = payload.file_name;
    state.date = payload.date;
    state.uploading = false;
};

/**
 * Set the error state on failed POST
 *
 * @param  {Object} state
 * @return {Void}
 */
var mutations_SET_DATA_ERROR = function SET_DATA_ERROR(state, error) {
    state.error = error;
    state.uploading = false;
};

/**
 * Update the progress
 *
 * @param  {Object} state
 * @param  {Number} progress
 * @return {Void}
 */
var UPDATE_UPLOAD_PROGRESS = function UPDATE_UPLOAD_PROGRESS(state, progress) {
    state.progress = progress;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var opex_importer_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = opex_importer_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the modal state (true)
 *
 * @param  {Object} state
 * @return {Void}
 */
var SHOW_MODAL = function SHOW_MODAL(state) {
    state.showModal = true;
};

/**
 * Change the selected category state
 *
 * @param  {Object} state
 * @param  {String} category
 * @return {Void}
 */
var mutations_UPDATE_SELECTED_CATEGORY = function UPDATE_SELECTED_CATEGORY(state, payload) {
    state.selectedCategory = payload.cat;
    state.selectedColorIndex = payload.idx;
    state.searchTerm = null;
};

/**
 * Set the modal state (false)
 *
 * @param  {Object} state
 * @return {Void}
 */
var HIDE_MODAL = function HIDE_MODAL(state) {
    state.showModal = false;
};

/**
 * Update an item's category
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var mutations_UPDATE_ITEM_CATEGORY = function UPDATE_ITEM_CATEGORY(state, payload) {
    var item = state.mappings.find(function (item) {
        return item.id === payload.id;
    });

    item.our_category = payload.category;
};

/**
 * Change the search term
 *
 * @param  {Object} state
 * @param  {String} payload
 * @return {Void}
 */
var opex_importer_mutations_UPDATE_SEARCH_TERM = function UPDATE_SEARCH_TERM(state, payload) {
    state.searchTerm = payload;
};

/**
 * Import success
 *
 * @param  {Object} state
 * @return {Void}
 */
var IMPORT_SUCCESS = function IMPORT_SUCCESS(state) {
    state.imported = true;
    state.saving = false;
};

/**
 *
 * @param  {Object} state
 * @return {Void}
 */
var IMPORT_BEGIN = function IMPORT_BEGIN(state) {
    state.saving = true;
};

/**
 * Handle a successful request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var mutations_SUPPORT_REQUEST_SUCCESS = function SUPPORT_REQUEST_SUCCESS(state, payload) {
    state.helpRequested = true;
    state.requestingHelp = false;
};

/**
 * Handle a failed request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var mutations_SUPPORT_REQUEST_FAILURE = function SUPPORT_REQUEST_FAILURE(state, error) {
    state.helpRequested = true;
    state.requestingHelp = false;
};

/**
 * Set the loading indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var mutations_REQUEST_FILE_ASSISTANCE = function REQUEST_FILE_ASSISTANCE(state) {
    state.requestingHelp = true;
};

/* harmony default export */ var opex_importer_mutations = ({
    SET_DATA: opex_importer_mutations_SET_DATA,
    SHOW_MODAL: SHOW_MODAL,
    HIDE_MODAL: HIDE_MODAL,
    RESET_STATE: opex_importer_mutations_RESET_STATE,
    IMPORT_BEGIN: IMPORT_BEGIN,
    BEGIN_UPLOAD: BEGIN_UPLOAD,
    SET_DATA_ERROR: mutations_SET_DATA_ERROR,
    IMPORT_SUCCESS: IMPORT_SUCCESS,
    UPDATE_SEARCH_TERM: opex_importer_mutations_UPDATE_SEARCH_TERM,
    UPDATE_ITEM_CATEGORY: mutations_UPDATE_ITEM_CATEGORY,
    UPDATE_UPLOAD_PROGRESS: UPDATE_UPLOAD_PROGRESS,
    SUPPORT_REQUEST_SUCCESS: mutations_SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE: mutations_SUPPORT_REQUEST_FAILURE,
    REQUEST_FILE_ASSISTANCE: mutations_REQUEST_FILE_ASSISTANCE,
    UPDATE_SELECTED_CATEGORY: mutations_UPDATE_SELECTED_CATEGORY
});
// CONCATENATED MODULE: ./src/state/modules/opex-importer/index.js
/**
 * Module Dependencies
 */





/**
 * OPEX Importer Module Declaration
 *
 * @type {Object}
 */
var opex_importer_module = {
  namespaced: true,
  state: opex_importer_state,
  getters: opex_importer_getters,
  mutations: opex_importer_mutations,
  actions: opex_importer_actions
};

/* harmony default export */ var opex_importer = (opex_importer_module);
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/state.js
/**
 * Dependencies
 */


/**
 * State Definition
 *
 * @type {Object}
 */
var debt_servicing_state_state = {
  loading: false,
  errors: [],
  collateral: [],
  editing: null,
  uploadingContext: null,
  showFormModal: false,
  showUploadModal: false

  /**
   * Return a state copy
   *
   * @return {Object}
   */
};var debt_servicing_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(debt_servicing_state_state);
};

/* harmony default export */ var debt_servicing_state = (debt_servicing_state_getState());
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/uploader/state.js
/**
 * Dependencies
 */


/**
 * Debt Servicing Uploader State
 *
 * @type {Object}
 */
var uploader_state_state = {
    error: false,
    loading: false,
    activeStep: 'pnl',
    showModal: false,
    context: null,
    success: false,
    showInput: true,
    pnl: {
        data: {
            date: null,
            file_name: null,
            income: [],
            income_category_list: [],
            meta: {},
            opex: [],
            opex_category_list: []
        }
    },
    rentroll: {},
    reports: {
        file_uploads: []
    }

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var uploader_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(uploader_state_state);
};

/* harmony default export */ var uploader_state = (uploader_state_getState());
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/uploader/getters.js
/* harmony default export */ var uploader_getters = ({});
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/uploader/actions.js

/**
 * Dependencies
 */


/**
 * Change the active step
 *
 * @param  {Function} options.commit
 * @param  {String} step
 * @return {Promise}
 */
var changeStep = function changeStep(_ref, step) {
    var commit = _ref.commit;
    return commit('CHANGE_STEP', step);
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var uploader_actions_resetState = function resetState(_ref2) {
    var commit = _ref2.commit;
    return commit('RESET_STATE');
};

/**
 * Upload a P&L or rent roll file
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var uploader_actions_uploadFile = function uploadFile(_ref3, form) {
    var state = _ref3.state,
        commit = _ref3.commit;

    commit('SET_LOADING');
    HttpService["a" /* default */].post('servicing/collaterals/' + state.context + '/uploads/', form).then(function (res) {
        commit('SET_DATA_SUCCESS', res.data);
        commit('RESET_LOADING');
    }).catch(function (err) {
        commit('SET_DATA_FAILURE', err.response.data);
        commit('RESET_LOADING');
    });
};

/**
 * Toggle the uploader modal and set the collateral context
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Void}
 */
var toggleModal = function toggleModal(_ref4, id) {
    var commit = _ref4.commit;

    commit('SET_CONTEXT', id);
    commit('TOGGLE_MODAL');
};

/**
 * Toggle the PNL input/output visibility
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_toggleInputBindings = function toggleInputBindings(_ref5) {
    var commit = _ref5.commit;
    return commit('TOGGLE_PNL_INPUT');
};

/**
 * Reset the P&L state objects
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var resetPnlState = function resetPnlState(_ref6) {
    var commit = _ref6.commit;
    return commit('RESET_PNL_STATE');
};

/**
 * Update a P&L category
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_updatePnlCategory = function updatePnlCategory(_ref7, payload) {
    var state = _ref7.state,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    HttpService["a" /* default */].patch('servicing/file_uploads/' + state.pnl.meta.pnl_file_id + '/', payload).then(function (res) {
        commit('SET_DATA_SUCCESS', res.data);
        dispatch('addNotification', {
            title: 'Item Reassigned',
            type: 'success',
            text: 'The line item was successfully recategorized',
            timeout: true
        }, { root: true });
    }).catch(function (e) {
        if (e.response) {
            commit('SET_DATA_FAILURE', e.response.data);
        }
        dispatch('addNotification', {
            title: 'Error',
            type: 'error',
            text: 'There was a problem uploading your file.',
            timeout: true
        }, { root: true });
    });
};

/**
 * Download a report
 *
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
var actions_downloadReport = function downloadReport(_ref8, payload) {
    var state = _ref8.state;

    var id = payload.file_id || state.pnl.meta.pnl_file_id;
    return HttpService["a" /* default */].post('servicing/file_uploads/' + id + '/reports/', {
        name: payload.name,
        report_type: payload.report_type
    });
};

/**
 * List reports for a given collateral
 *
 * @param  {Object} options.state
 * @return {Void}
 */
var actions_getReports = function getReports(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;

    HttpService["a" /* default */].get('servicing/collaterals/' + state.context + '/uploads/').then(function (res) {
        return commit('SET_REPORTS', res.data);
    }).catch(function (err) {
        return console.log(err);
    });
};

var actions_deleteReport = function deleteReport(_ref10, payload) {
    var dispatch = _ref10.dispatch;

    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].del('servicing/reports/' + payload.id + '/').then(function (res) {
            dispatch('getReports');
            resolve('Successfully deleted.');
        }).catch(function (err) {
            return reject(err);
        });
    });
};

var actions_deleteFile = function deleteFile(_ref11, id) {
    var dispatch = _ref11.dispatch;

    HttpService["a" /* default */].del('servicing/file_uploads/' + id + '/').then(function (res) {
        return dispatch('getReports');
    }).catch(function (err) {
        return console.log(err);
    });
};

/* harmony default export */ var uploader_actions = ({
    getReports: actions_getReports,
    changeStep: changeStep,
    resetState: uploader_actions_resetState,
    uploadFile: uploader_actions_uploadFile,
    deleteFile: actions_deleteFile,
    toggleModal: toggleModal,
    deleteReport: actions_deleteReport,
    resetPnlState: resetPnlState,
    downloadReport: actions_downloadReport,
    updatePnlCategory: actions_updatePnlCategory,
    toggleInputBindings: actions_toggleInputBindings
});
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/uploader/mutations.js



var uploader_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = uploader_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

var CHANGE_STEP = function CHANGE_STEP(state, step) {
    state.activeStep = step;
};

var SET_CONTEXT = function SET_CONTEXT(state, id) {
    state.context = id;
};

var TOGGLE_MODAL = function TOGGLE_MODAL(state) {
    state.showModal = !state.showModal;
};

var SET_DATA_SUCCESS = function SET_DATA_SUCCESS(state, data) {
    state[state.activeStep] = data;
    state.success = true;
};

var SET_DATA_FAILURE = function SET_DATA_FAILURE(state, error) {
    state.error = error;
};

var TOGGLE_PNL_INPUT = function TOGGLE_PNL_INPUT(state) {
    state.showInput = !state.showInput;
};

var RESET_PNL_STATE = function RESET_PNL_STATE(state) {
    state.error = false;
    state.success = false;
    state.showInput = true;
    state.pnl = {
        data: {
            date: null,
            file_name: null,
            income: [],
            income_category_list: [],
            meta: {},
            opex: [],
            opex_category_list: []
        }
    };
};

var SET_REPORTS = function SET_REPORTS(state, payload) {
    state.reports = payload;
};

var uploader_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

var uploader_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

var REMOVE_REPORT = function REMOVE_REPORT(state) {};

/* harmony default export */ var uploader_mutations = ({
    CHANGE_STEP: CHANGE_STEP,
    RESET_STATE: uploader_mutations_RESET_STATE,
    SET_CONTEXT: SET_CONTEXT,
    SET_REPORTS: SET_REPORTS,
    TOGGLE_MODAL: TOGGLE_MODAL,
    SET_LOADING: uploader_mutations_SET_LOADING,
    REMOVE_REPORT: REMOVE_REPORT,
    RESET_LOADING: uploader_mutations_RESET_LOADING,
    RESET_PNL_STATE: RESET_PNL_STATE,
    TOGGLE_PNL_INPUT: TOGGLE_PNL_INPUT,
    SET_DATA_SUCCESS: SET_DATA_SUCCESS,
    SET_DATA_FAILURE: SET_DATA_FAILURE
});
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/uploader/index.js
/**
 * Module Dependencies
 */





/**
 * Servicing Uploader Module Declaration
 *
 * @type {Object}
 */
var uploader_module = {
  namespaced: true,
  state: uploader_state,
  getters: uploader_getters,
  mutations: uploader_mutations,
  actions: uploader_actions
};

/* harmony default export */ var uploader = (uploader_module);
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/actions.js
/**
 * Dependencies
 */


/**
 * Get the user's collateral
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_getCollateral = function getCollateral(_ref) {
  var commit = _ref.commit;

  commit('SET_LOADING');
  HttpService["a" /* default */].get('servicing/collaterals/').then(function (res) {
    return commit('GET_COLLATERAL_SUCCESS', res.data);
  }).then(function () {
    return commit('RESET_LOADING');
  }).then(function () {
    return commit('GET_COLLATERAL_FAILURE');
  });
};

/**
 * Generate a new collateral object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var actions_createCollateral = function createCollateral(_ref2, payload) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  HttpService["a" /* default */].post('servicing/collaterals/', payload).then(function () {
    return dispatch('getCollateral');
  }).then(function () {
    return dispatch('toggleFormModal');
  }).then(function () {
    return dispatch('addNotification', {
      title: 'Collateral created',
      type: 'success',
      text: 'The collateral was successfully created',
      timeout: true
    }, { root: true });
  }).catch(function (err) {
    return commit('SAVE_COLLATERAL_FAILURE', err.response.data);
  });
};

var actions_destroyCollateral = function destroyCollateral(_ref3, id) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  HttpService["a" /* default */].del('servicing/collaterals/' + id + '/').then(function () {
    return commit('REMOVE_COLLATERAL_SUCCESS', id);
  }).then(function () {
    return dispatch('addNotification', {
      title: 'Collateral deleted',
      type: 'success',
      text: 'The collateral was successfully deleted',
      timeout: true
    }, { root: true });
  });
};

/**
 * Toggle the visibility of the collateral creation modal
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Promise}
 */
var toggleFormModal = function toggleFormModal(_ref4) {
  var commit = _ref4.commit,
      state = _ref4.state;
  return commit('TOGGLE_CREATE_MODAL');
};

/**
 * Toggle the visibility of the upload file modal
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Promise}
 */
var toggleUploadModal = function toggleUploadModal(_ref5, id) {
  var commit = _ref5.commit,
      state = _ref5.state;
  return commit('TOGGLE_UPLOAD_MODAL', id);
};

/**
 * Clear validation errors for a given key
 *
 * @param  {Function} options.commit
 * @param  {String} key
 * @return {Promise}
 */
var actions_clearErrors = function clearErrors(_ref6, key) {
  var commit = _ref6.commit;
  return commit('CLEAR_ERRORS', key);
};

/**
 * Reset the form params
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var resetCollateralForm = function resetCollateralForm(_ref7) {
  var commit = _ref7.commit;
  return commit('RESET_FORM');
};

/**
 * Set up the edit context
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var editForm = function editForm(_ref8, id) {
  var commit = _ref8.commit;
  return commit('SET_EDITABLE_COLLATERAL', id);
};

/**
 * Update an existing collateral
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} form
 * @return {Void}
 */
var actions_updateColateral = function updateColateral(_ref9, form) {
  var commit = _ref9.commit,
      dispatch = _ref9.dispatch,
      state = _ref9.state;

  HttpService["a" /* default */].patch('servicing/collaterals/' + state.editing.id + '/', form).then(function () {
    return dispatch('getCollateral');
  }).then(function () {
    return dispatch('toggleFormModal');
  }).then(function () {
    return dispatch('addNotification', {
      title: 'Collateral Updated',
      type: 'success',
      text: 'The collateral was successfully updated',
      timeout: true
    }, { root: true });
  }).catch(function (err) {
    return commit('SAVE_COLLATERAL_FAILURE', err.response.data);
  });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var debt_servicing_actions_resetState = function resetState(_ref10) {
  var commit = _ref10.commit;
  return commit('RESET_STATE');
};

/* harmony default export */ var debt_servicing_actions = ({
  editForm: editForm,
  resetState: debt_servicing_actions_resetState,
  clearErrors: actions_clearErrors,
  getCollateral: actions_getCollateral,
  toggleFormModal: toggleFormModal,
  updateColateral: actions_updateColateral,
  createCollateral: actions_createCollateral,
  toggleUploadModal: toggleUploadModal,
  destroyCollateral: actions_destroyCollateral,
  resetCollateralForm: resetCollateralForm
});
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/getters.js
/* harmony default export */ var debt_servicing_getters = ({});
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/mutations.js
/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var debt_servicing_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = debt_servicing_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the collateral payload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var GET_COLLATERAL_SUCCESS = function GET_COLLATERAL_SUCCESS(state, payload) {
    state.collateral = payload;
};

/**
 * Set the collateral error state
 *
 * @param  {Object} state
 * @return {Void}
 */
var GET_COLLATERAL_FAILURE = function GET_COLLATERAL_FAILURE(state) {
    state.error = true;
};

/**
 * New collateral failed action
 *
 * @param  {Object} state
 * @param  {Object} response
 * @return {Void}
 */
var SAVE_COLLATERAL_FAILURE = function SAVE_COLLATERAL_FAILURE(state, errors) {
    state.errors = errors;
};

var TOGGLE_CREATE_MODAL = function TOGGLE_CREATE_MODAL(state) {
    state.showFormModal = !state.showFormModal;
};

/**
 * Remove collateral from state
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Void}
 */
var REMOVE_COLLATERAL_SUCCESS = function REMOVE_COLLATERAL_SUCCESS(state, id) {
    state.collateral = state.collateral.filter(function (i) {
        return i.id !== id;
    });
};

/**
 * Remove an error key
 *
 * @param  {Object} state
 * @param  {String} key
 * @return {Void}
 */
var debt_servicing_mutations_CLEAR_ERRORS = function CLEAR_ERRORS(state, key) {
    vue_esm["a" /* default */].delete(state.errors, key);
};

var debt_servicing_mutations_RESET_FORM = function RESET_FORM(state) {
    state.errors = [];
    state.editing = null;
};

var SET_EDITABLE_COLLATERAL = function SET_EDITABLE_COLLATERAL(state, id) {
    state.editing = state.collateral.find(function (i) {
        return i.id === id;
    });
    state.showFormModal = true;
};

var debt_servicing_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

var debt_servicing_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

var TOGGLE_UPLOAD_MODAL = function TOGGLE_UPLOAD_MODAL(state) {
    state.showUploadModal = !state.showUploadModal;
};

/* harmony default export */ var debt_servicing_mutations = ({
    RESET_FORM: debt_servicing_mutations_RESET_FORM,
    RESET_STATE: debt_servicing_mutations_RESET_STATE,
    SET_LOADING: debt_servicing_mutations_SET_LOADING,
    CLEAR_ERRORS: debt_servicing_mutations_CLEAR_ERRORS,
    RESET_LOADING: debt_servicing_mutations_RESET_LOADING,
    TOGGLE_UPLOAD_MODAL: TOGGLE_UPLOAD_MODAL,
    TOGGLE_CREATE_MODAL: TOGGLE_CREATE_MODAL,
    GET_COLLATERAL_SUCCESS: GET_COLLATERAL_SUCCESS,
    GET_COLLATERAL_FAILURE: GET_COLLATERAL_FAILURE,
    SAVE_COLLATERAL_FAILURE: SAVE_COLLATERAL_FAILURE,
    SET_EDITABLE_COLLATERAL: SET_EDITABLE_COLLATERAL,
    REMOVE_COLLATERAL_SUCCESS: REMOVE_COLLATERAL_SUCCESS
});
// CONCATENATED MODULE: ./src/state/modules/debt-servicing/index.js
/**
 * Module Dependencies
 */






/**
 * Debt Servicing Module Declaration
 *
 * @type {Object}
 */
var debt_servicing_module = {
    namespaced: true,
    state: debt_servicing_state,
    actions: debt_servicing_actions,
    getters: debt_servicing_getters,
    mutations: debt_servicing_mutations,
    modules: {
        uploader: uploader
    }
};

/* harmony default export */ var debt_servicing = (debt_servicing_module);
// CONCATENATED MODULE: ./src/state/modules/rent-roll-importer/state.js
/**
 * Dependencies
 */


/**
 * Rental income importer modal state
 *
 * @type {Object}
 */
var rent_roll_importer_state_state = {
    assistanceRequested: false,
    assistanceSuccess: false,
    assistanceMessage: null,
    attemptingImport: false,
    uploaded: false,
    loading: false,
    error: null,
    remapping: false,
    showTab: 0,
    data: {
        date: null,
        file_name: null,
        summary: {},
        table_data: {
            data: [],
            meta: {
                number_of_rows: 0
            }
        }
    },
    meta: {
        rentroll_file_id: null,
        assignment_options: {}
    },
    pagination: {
        currentPage: 1,
        pageLimit: 18
    },
    mapping: {}

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var rent_roll_importer_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(rent_roll_importer_state_state);
};

/* harmony default export */ var rent_roll_importer_state = (rent_roll_importer_state_getState());
// CONCATENATED MODULE: ./src/state/modules/rent-roll-importer/getters.js
/**
 * Total pages of data in the provided dataset
 *
 * @param  {Object} state
 * @return {Number}
 */
var rent_roll_importer_getters_totalPages = function totalPages(state) {
    var rows = state.data.table_data.meta.number_of_rows + 1;
    var limit = state.pagination.pageLimit;

    return Math.ceil(rows / limit);
};

/**
 * Get the offset for the dataset
 *
 * @return {Number}
 */
var rent_roll_importer_getters_offset = function offset(state) {
    return (state.pagination.currentPage - 1) * state.pagination.pageLimit;
};

/**
 * Paginated Dataset
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
var rent_roll_importer_getters_paginatedDataset = function paginatedDataset(state, getters) {
    return state.data.table_data.data.map(function (row) {
        return {
            format: row.format,
            is_calculated_total: row.is_calculated_total,
            our_label: row.our_label,
            their_label: row.their_label,
            data: row.data.slice(getters.offset, state.pagination.pageLimit * state.pagination.currentPage)
        };
    });
};

/* harmony default export */ var rent_roll_importer_getters = ({
    offset: rent_roll_importer_getters_offset,
    totalPages: rent_roll_importer_getters_totalPages,
    paginatedDataset: rent_roll_importer_getters_paginatedDataset
});
// CONCATENATED MODULE: ./src/state/modules/rent-roll-importer/actions.js

/**
 * Dependencies
 */


/**
 * Next page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var rent_roll_importer_actions_nextPage = function nextPage(_ref) {
    var commit = _ref.commit;
    return commit('PAGINATE_FORWARD');
};

/**
 * Previous Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var rent_roll_importer_actions_prevPage = function prevPage(_ref2) {
    var commit = _ref2.commit;
    return commit('PAGINATE_BACKWARD');
};

/**
 * First Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var firstPage = function firstPage(_ref3) {
    var commit = _ref3.commit;
    return commit('PAGINATE_FIRST');
};

/**
 * Last Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var lastPage = function lastPage(_ref4) {
    var commit = _ref4.commit;
    return commit('PAGINATE_LAST');
};

/**
 * Execute call to update a user's file mapping
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_updateMapping = function updateMapping(_ref5, payload) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;

    var url = 'data-import/import-files/' + state.meta.rentroll_file_id + '/update/';

    commit('SET_UPDATE_MAPPING');
    HttpService["a" /* default */].patch(url, { mapping: payload }).then(function (res) {
        setTimeout(function () {
            commit('LOAD_NEW_MAPPING', res.data);
            commit('RESET_UPDATE_MAPPING');
            dispatch('addNotification', {
                type: 'success',
                title: 'Mapping Updated',
                text: 'The file mappings have been updated successfully.',
                timeout: true
            }, { root: true });
        }, 1500);
    }).catch(function (err) {
        setTimeout(function () {
            commit('RESET_UPDATE_MAPPING', err);
        }, 1500);
    });
};

/**
 * Upload a file with metadata to be processed
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var rent_roll_importer_actions_uploadFile = function uploadFile(_ref6, payload) {
    var commit = _ref6.commit;

    var url = 'data-import/import-files/rentroll/';
    var headers = { 'Content-Type': 'multipart/form-data' };

    commit('RESET_STATE');
    commit('SET_LOADING');
    HttpService["a" /* default */].post(url, payload, { headers: headers }).then(function (res) {
        commit('GET_DATA_SUCCESS', res.data);
        commit('RESET_LOADING');
    }).catch(function (e) {
        if (e.response) {
            switch (e.response.data.error_type) {
                case 'file_rejected':
                    commit('FILE_REJECTED', e.response.data);
                    commit('RESET_LOADING');
                    break;
                default:
                    commit('FILE_FAILED', e.response.data.message);
                    commit('RESET_LOADING');
                    break;
            }
        } else {
            commit('FILE_FAILED', 'There was a problem uploading the file.');
            commit('RESET_LOADING');
        }
    });
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var rent_roll_importer_actions_resetState = function resetState(_ref7) {
    var commit = _ref7.commit;
    return commit('RESET_STATE');
};

/**
 * Update the mappings and get a new rendered dataset
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var rent_roll_importer_actions_importData = function importData(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state,
        dispatch = _ref8.dispatch;

    return new promise_default.a(function (resolve, reject) {
        commit('ATTEMPT_IMPORT');
        HttpService["a" /* default */].get('data-import/import-files/' + state.meta.rentroll_file_id + '/import/').then(function (res) {
            commit('projects/form/IMPORT_UNIT_VALUES', res.data, { root: true });
            commit('projects/form/UPDATE_FILE_ID', {
                id: state.meta.rentroll_file_id,
                type: 'rentroll_file_id'
            }, { root: true });
            dispatch('addNotification', {
                type: 'success',
                title: 'Rent Roll Imported',
                text: 'Rent Roll was successfully imported to your project.',
                timeout: true
            }, { root: true });
            commit('RESET_ATTEMPT_IMPORT');
            resolve();
        }).catch(function (err) {
            dispatch('addNotification', {
                type: 'error',
                title: 'Import Failed',
                text: 'Rent Roll was not successfully imported.',
                timeout: true
            }, { root: true });
            commit('RESET_ATTEMPT_IMPORT');
            reject(err);
        });
    });
};

/**
 * Allow the user to request assistance with a file that fails to upload properly
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var rent_roll_importer_actions_requestFileAssistance = function requestFileAssistance(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;

    commit('REQUEST_FILE_ASSISTANCE');
    HttpService["a" /* default */].post('data-import/import-files/' + state.meta.rentroll_file_id + '/support/').then(function (res) {
        return commit('SUPPORT_REQUEST_SUCCESS', res.data);
    }).catch(function (err) {
        return commit('SUPPORT_REQUEST_FAILURE', err);
    });
};

/**
 * Update the selected tab
 *
 * @param  {Function} options.commit
 * @param  {Number} tab
 * @return {Promise}
 */
var changeTab = function changeTab(_ref10, tab) {
    var commit = _ref10.commit;
    return commit('CHANGE_TAB', tab);
};

/* harmony default export */ var rent_roll_importer_actions = ({
    nextPage: rent_roll_importer_actions_nextPage,
    prevPage: rent_roll_importer_actions_prevPage,
    lastPage: lastPage,
    changeTab: changeTab,
    firstPage: firstPage,
    importData: rent_roll_importer_actions_importData,
    resetState: rent_roll_importer_actions_resetState,
    uploadFile: rent_roll_importer_actions_uploadFile,
    updateMapping: actions_updateMapping,
    requestFileAssistance: rent_roll_importer_actions_requestFileAssistance
});
// CONCATENATED MODULE: ./src/state/modules/rent-roll-importer/mutations.js
/**
 * Dependencies
 */



/**
 * Set the loading state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var rent_roll_importer_mutations_SET_LOADING = function SET_LOADING(state) {
    state.error = null;
    state.uploaded = false;
    state.loading = true;
};

/**
 * Reset the loading state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var rent_roll_importer_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/**
 * Assign the payload data to the state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var rent_roll_importer_mutations_GET_DATA_SUCCESS = function GET_DATA_SUCCESS(state, payload) {
    state.data.date = payload.date;
    state.data.file_name = payload.file_name;
    state.data.summary = payload.summary;
    state.data.table_data = payload.table_data;
    state.meta.rentroll_file_id = payload.meta.rentroll_file_id;
    state.meta.assignment_options = payload.meta.assigment_options;
    state.mapping = payload.mapping;
    state.uploaded = true;
};

/**
 * Paginate forward
 *
 * @param  {Object} state
 * @return {Promise}
 */
var PAGINATE_FORWARD = function PAGINATE_FORWARD(state) {
    state.pagination.currentPage++;
};

/**
 * Paginate back
 *
 * @param  {Object} state
 * @return {Promise}
 */
var PAGINATE_BACKWARD = function PAGINATE_BACKWARD(state) {
    state.pagination.currentPage--;
};

/**
 * Go to the first page
 *
 * @param  {Object} state
 * @return {Promise}
 */
var PAGINATE_FIRST = function PAGINATE_FIRST(state) {
    state.pagination.currentPage = 1;
};

/**
 * Go to the last page
 *
 * @param  {Object} state
 * @return {Promise}
 */
var PAGINATE_LAST = function PAGINATE_LAST(state) {
    var rows = state.data.table_data.meta.number_of_rows + 1;
    var limit = state.pagination.pageLimit;

    state.pagination.currentPage = Math.ceil(rows / limit);
};

/**
 * Handle file upload failure (rejected)
 *
 * @param  {Object} state
 * @param  {Object} message
 * @return {Promise}
 */
var FILE_REJECTED = function FILE_REJECTED(state, error) {
    state.error = error.message;
    state.meta.rentroll_file_id = error.rentroll_file_id;
    state.uploaded = false;
};

/**
 * Handle file upload failure (other)
 *
 * @param  {Object} state
 * @param  {Object} message
 * @return {Promise}
 */
var FILE_FAILED = function FILE_FAILED(state, message) {
    state.error = message;
    state.uploaded = false;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var rent_roll_importer_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = rent_roll_importer_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Set the remapping state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var SET_UPDATE_MAPPING = function SET_UPDATE_MAPPING(state) {
    state.remapping = true;
};

/**
 * Reset the remapping state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var RESET_UPDATE_MAPPING = function RESET_UPDATE_MAPPING(state) {
    state.remapping = false;
};

/**
 * Set the new mapping and data payload to the state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var LOAD_NEW_MAPPING = function LOAD_NEW_MAPPING(state, payload) {
    state.data.summary = payload.summary;
    state.data.table_data = payload.table_data;
    state.meta.assignment_options = payload.meta.assigment_options;
    state.mapping = payload.mapping;
};

/**
 * Change the tab
 *
 * @param  {Object} state
 * @param  {Number} tab
 * @return {Promise}
 */
var mutations_CHANGE_TAB = function CHANGE_TAB(state, tab) {
    state.showTab = tab;
};

/**
 * Set the importing state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var ATTEMPT_IMPORT = function ATTEMPT_IMPORT(state) {
    state.attemptingImport = true;
};

/**
 * Reset the importing state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var RESET_ATTEMPT_IMPORT = function RESET_ATTEMPT_IMPORT(state) {
    state.attemptingImport = false;
};

var rent_roll_importer_mutations_REQUEST_FILE_ASSISTANCE = function REQUEST_FILE_ASSISTANCE(state) {
    state.assistanceRequested = true;
};

var RESET_REQUEST_FILE_ASSISTANCE = function RESET_REQUEST_FILE_ASSISTANCE(state) {
    state.assistanceRequested = false;
};

var rent_roll_importer_mutations_SUPPORT_REQUEST_SUCCESS = function SUPPORT_REQUEST_SUCCESS(state, message) {
    state.assistanceMessage = message;
};

var rent_roll_importer_mutations_SUPPORT_REQUEST_FAILURE = function SUPPORT_REQUEST_FAILURE(state, message) {
    state.assistanceMessage = message;
};

/* harmony default export */ var rent_roll_importer_mutations = ({
    CHANGE_TAB: mutations_CHANGE_TAB,
    RESET_STATE: rent_roll_importer_mutations_RESET_STATE,
    FILE_FAILED: FILE_FAILED,
    SET_LOADING: rent_roll_importer_mutations_SET_LOADING,
    RESET_LOADING: rent_roll_importer_mutations_RESET_LOADING,
    FILE_REJECTED: FILE_REJECTED,
    PAGINATE_LAST: PAGINATE_LAST,
    ATTEMPT_IMPORT: ATTEMPT_IMPORT,
    PAGINATE_FIRST: PAGINATE_FIRST,
    LOAD_NEW_MAPPING: LOAD_NEW_MAPPING,
    GET_DATA_SUCCESS: rent_roll_importer_mutations_GET_DATA_SUCCESS,
    PAGINATE_FORWARD: PAGINATE_FORWARD,
    PAGINATE_BACKWARD: PAGINATE_BACKWARD,
    SET_UPDATE_MAPPING: SET_UPDATE_MAPPING,
    RESET_UPDATE_MAPPING: RESET_UPDATE_MAPPING,
    RESET_ATTEMPT_IMPORT: RESET_ATTEMPT_IMPORT,
    REQUEST_FILE_ASSISTANCE: rent_roll_importer_mutations_REQUEST_FILE_ASSISTANCE,
    SUPPORT_REQUEST_SUCCESS: rent_roll_importer_mutations_SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE: rent_roll_importer_mutations_SUPPORT_REQUEST_FAILURE,
    RESET_REQUEST_FILE_ASSISTANCE: RESET_REQUEST_FILE_ASSISTANCE
});
// CONCATENATED MODULE: ./src/state/modules/rent-roll-importer/index.js
/**
 * Module Dependencies
 */





/**
 * Rent Roll Importer Module Declaration
 *
 * @type {Object}
 */
var rent_roll_importer_module = {
  namespaced: true,
  state: rent_roll_importer_state,
  getters: rent_roll_importer_getters,
  mutations: rent_roll_importer_mutations,
  actions: rent_roll_importer_actions
};

/* harmony default export */ var rent_roll_importer = (rent_roll_importer_module);
// CONCATENATED MODULE: ./src/state/modules/rental-income-importer/state.js
/**
 * Dependencies
 */


/**
 * Rental income importer modal state
 *
 * @type {Object}
 */
var rental_income_importer_state_state = {
  saveError: null,
  uploading: false,
  uploadProgress: 0,
  showModal: false,
  mapping: {},
  parsed_data: {},
  meta: {},
  error: null,
  fileName: null,
  preview: null,
  saving: false,
  saved: false,
  file_name: null,
  date: null,
  helpRequested: false,
  requestingHelp: false
  /**
  
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var rental_income_importer_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(rental_income_importer_state_state);
};

/* harmony default export */ var rental_income_importer_state = (rental_income_importer_state_getState());
// CONCATENATED MODULE: ./src/state/modules/rental-income-importer/getters.js

var sortCaseInsesitive = function sortCaseInsesitive(a, b) {
  return a.toLowerCase().localeCompare(b.toLowerCase());
};

/**
 * Check if the upload progress has completed
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_fileUploadCompleted = function fileUploadCompleted(state) {
  return state.uploadProgress === 100;
};

/**
 * Check if there are mappings available from a file upload
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_hasMappings = function hasMappings(state) {
  return keys_default()(state.mapping).length > 0;
};

/**
 * Check if there is parsed data available from a file upload
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_hasParsedData = function hasParsedData(state) {
  return keys_default()(state.parsed_data).length > 0;
};

/**
 * Return alphabetically sorted list of labels
 *
 * @param  {Object}
 * @return {Array}
 */
var getters_localFields = function localFields(state) {
  return keys_default()(state.mapping).reduce(function (sum, key) {
    return sum.concat(state.mapping[key].map(function (item) {
      return item.label;
    }));
  }, []).sort(sortCaseInsesitive);
};

/**
 * Return the alphbetically sorted keys on the parsed data object
 *
 * @param  {Object} state
 * @return {Array}
 */
var getters_submittedFields = function submittedFields(state) {
  return keys_default()(state.parsed_data).sort(sortCaseInsesitive);
};

/* harmony default export */ var rental_income_importer_getters = ({
  localFields: getters_localFields,
  hasMappings: getters_hasMappings,
  hasParsedData: getters_hasParsedData,
  submittedFields: getters_submittedFields,
  fileUploadCompleted: getters_fileUploadCompleted
});
// CONCATENATED MODULE: ./src/state/modules/rental-income-importer/actions.js
/**
 * Dependencies
 */



/**
 * Upload a CSV file to the rent roll importer
 *
 * @param  {Function} options.commit
 * @param  {FormData} data
 * @return {Promise}
 */
var rental_income_importer_actions_uploadFile = function uploadFile(_ref, data) {
    var commit = _ref.commit;

    var formData = new FormData();
    formData.append('file', data.file);
    if (data.excel_sheet !== null) {
        formData.append('excel_sheet', data.excel_sheet);
    }

    commit('BEGIN_UPLOAD');

    HttpService["a" /* default */].post('projects/rentroll-importer/', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
            var progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
            commit('UPDATE_UPLOAD_PROGRESS', progress);
        }
    }).then(function (res) {
        commit('SET_MAPPINGS', res.data);
        commit('projects/form/UPDATE_FILE_ID', {
            id: res.data.meta.rentroll_file_id,
            type: 'rentroll_file_id'
        }, { root: true });
    }).catch(function (e) {
        return commit('SET_MAPPINGS_ERROR', e);
    });
};

/**
 * Update the user-confirmed bindings
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
var actions_updateImporterBindings = function updateImporterBindings(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    commit('SAVING_BINDINGS');
    HttpService["a" /* default */].patch('projects/rentroll-update/' + state.meta.rentroll_file_id + '/', state.mapping).then(function (res) {
        var data = res.data;
        if (data.meta) {
            vue_esm["a" /* default */].delete(data, 'meta');
        }
        dispatch('projects/form/updateUnitValues', data, { root: true }).then(function () {
            return commit('FILE_IMPORTED');
        }).catch(function () {
            return console.log('failed');
        });
    }).catch(function (err) {
        return commit('IMPORT_MAPPINGS_ERROR', err);
    });
};

/**
 * Reset the state
 *
 * @param  {Function} commit
 * @return {Void}
 */
var rental_income_importer_actions_resetState = function resetState(_ref3) {
    var commit = _ref3.commit;
    return commit('RESET_STATE');
};

/**
 * Reset a given binding
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var resetBinding = function resetBinding(_ref4, payload) {
    var commit = _ref4.commit;
    return commit('RESET_BINDING', payload);
};

/**
 * Set a given binding
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var setBinding = function setBinding(_ref5, payload) {
    var commit = _ref5.commit;
    return commit('SET_BINDING', payload);
};

/**
 * Allow the user to request assistance with a file that fails to upload properly
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var rental_income_importer_actions_requestFileAssistance = function requestFileAssistance(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    commit('REQUEST_FILE_ASSISTANCE');
    HttpService["a" /* default */].post('projects/import-file/' + state.error.rentroll_file_id + '/support/').then(function (res) {
        return commit('SUPPORT_REQUEST_SUCCESS', res);
    }).catch(function (err) {
        return commit('SUPPORT_REQUEST_FAILURE', err);
    });
};

/* harmony default export */ var rental_income_importer_actions = ({
    uploadFile: rental_income_importer_actions_uploadFile,
    resetState: rental_income_importer_actions_resetState,
    setBinding: setBinding,
    resetBinding: resetBinding,
    requestFileAssistance: rental_income_importer_actions_requestFileAssistance,
    updateImporterBindings: actions_updateImporterBindings
});
// CONCATENATED MODULE: ./src/state/modules/rental-income-importer/mutations.js

/**
 * Dependencies
 */



/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var rental_income_importer_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = rental_income_importer_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

/**
 * Update the file upload progress
 *
 * @param  {Object} state
 * @param  {Number} progress
 * @return {Promise}
 */
var mutations_UPDATE_UPLOAD_PROGRESS = function UPDATE_UPLOAD_PROGRESS(state, progress) {
    state.uploadProgress = progress;
};

/**
 * Set the retreived CSV mapping options
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var SET_MAPPINGS = function SET_MAPPINGS(state, payload) {
    state.mapping = payload.mappings;
    state.parsed_data = payload.parsed_data;
    state.meta = payload.meta;
    state.file_name = payload.file_name;
    state.date = payload.date;
    state.uploading = false;
};

/**
 * Set errors
 *
 * @param  {Object} state
 * @return {Promise}
 */
var SET_MAPPINGS_ERROR = function SET_MAPPINGS_ERROR(state, error) {
    state.error = error.response.data;
    state.uploading = false;
};

/**
 * Reset the error state
 *
 * @param  {Object} state
 * @return {Promise}
 */
var mutations_BEGIN_UPLOAD = function BEGIN_UPLOAD(state) {
    state.uploading = true;
    state.error = null;
};

/**
 * Shows the modal.
 *
 * @param      {Object}  state   state
 * @return     {Void}
 */
var mutations_SHOW_MODAL = function SHOW_MODAL(state) {
    state.showModal = true;
};

/**
 * Hides the modal.
 *
 * @param      {Object}  state   The state
 * @return     {Void}
 */
var mutations_HIDE_MODAL = function HIDE_MODAL(state) {
    state.showModal = false;
};

/**
 * Reset the state binding for a given row
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var mutations_RESET_BINDING = function RESET_BINDING(state, payload) {
    keys_default()(state.mapping).forEach(function (item) {
        state.mapping[item].forEach(function (subItem) {
            if (subItem.label === payload.label) {
                subItem.csv_column = '';
            }
        });
    });
};

/**
 * Set a given binding on the state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var mutations_SET_BINDING = function SET_BINDING(state, payload) {
    keys_default()(state.mapping).forEach(function (cat) {
        state.mapping[cat] = state.mapping[cat].map(function (item) {
            if (item.csv_column === payload.value) {
                item.csv_column = null;
            }
            return item;
        });
    });
    state.mapping[payload.mapping][payload.idx].csv_column = payload.value;
};

/**
 * Set the saving state attribute
 *
 * @param  {Object} state
 * @return {Promise}
 */
var SAVING_BINDINGS = function SAVING_BINDINGS(state) {
    state.saveError = null;
    state.saving = true;
};

/**
 * Set the saved state attribute
 *
 * @param  {Object} state
 * @return {Promise}
 */
var FILE_IMPORTED = function FILE_IMPORTED(state) {
    state.saving = false;
    state.saved = true;
};

/**
 * Handle failed import
 *
 * @param  {Vo} state
 * @param  {Object} error
 * @return {Promise}
 */
var IMPORT_MAPPINGS_ERROR = function IMPORT_MAPPINGS_ERROR(state, error) {
    state.saving = false;
    state.saved = false;
    state.saveError = error.response.data.message ? error.response.data.message : 'There was a problem importing your mappings. Please review the mappings below and make any necessary corrections.';
};

/**
 * Handle a successful request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var rental_income_importer_mutations_SUPPORT_REQUEST_SUCCESS = function SUPPORT_REQUEST_SUCCESS(state, payload) {
    state.helpRequested = true;
    state.requestingHelp = false;
};

/**
 * Handle a failed request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
var rental_income_importer_mutations_SUPPORT_REQUEST_FAILURE = function SUPPORT_REQUEST_FAILURE(state, error) {
    state.helpRequested = true;
    state.requestingHelp = false;
};

/**
 * Set the loading indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
var rental_income_importer_mutations_REQUEST_FILE_ASSISTANCE = function REQUEST_FILE_ASSISTANCE(state) {
    state.requestingHelp = true;
};

/* harmony default export */ var rental_income_importer_mutations = ({
    SHOW_MODAL: mutations_SHOW_MODAL,
    HIDE_MODAL: mutations_HIDE_MODAL,
    SET_BINDING: mutations_SET_BINDING,
    RESET_STATE: rental_income_importer_mutations_RESET_STATE,
    BEGIN_UPLOAD: mutations_BEGIN_UPLOAD,
    SET_MAPPINGS: SET_MAPPINGS,
    RESET_BINDING: mutations_RESET_BINDING,
    FILE_IMPORTED: FILE_IMPORTED,
    SAVING_BINDINGS: SAVING_BINDINGS,
    SET_MAPPINGS_ERROR: SET_MAPPINGS_ERROR,
    IMPORT_MAPPINGS_ERROR: IMPORT_MAPPINGS_ERROR,
    UPDATE_UPLOAD_PROGRESS: mutations_UPDATE_UPLOAD_PROGRESS,
    SUPPORT_REQUEST_SUCCESS: rental_income_importer_mutations_SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE: rental_income_importer_mutations_SUPPORT_REQUEST_FAILURE,
    REQUEST_FILE_ASSISTANCE: rental_income_importer_mutations_REQUEST_FILE_ASSISTANCE
});
// CONCATENATED MODULE: ./src/state/modules/rental-income-importer/index.js
/**
 * Module Dependencies
 */





/**
 * Rent Roll Importer Module Declaration
 *
 * @type {Object}
 */
var rental_income_importer_module = {
  namespaced: true,
  state: rental_income_importer_state,
  getters: rental_income_importer_getters,
  mutations: rental_income_importer_mutations,
  actions: rental_income_importer_actions
};

/* harmony default export */ var rental_income_importer = (rental_income_importer_module);
// CONCATENATED MODULE: ./src/digital-om/components/models/custom-tables.js
/* eslint-disable */
/* harmony default export */ var custom_tables = ({
  "meta": {
    "table_type": "opex_summary",
    "title": "Table A"
  },
  "data": [{
    "meta": {},
    "data": [{
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": false,
      "format": null,
      "alignment": null
    }, {
      "value": "T-12",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 3,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": false,
      "format": null,
      "alignment": null
    }, {
      "value": "T-12 (Adjusted)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 3,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": false,
      "format": null,
      "alignment": null
    }, {
      "value": "Pro Forma",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 3,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }]
  }, {
    "meta": {},
    "data": [{
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": false,
      "format": null,
      "alignment": null
    }, {
      "value": "Amount (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": "$/SQFT (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": "% of Total Income (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": false,
      "value": null,
      "format": null
    }, {
      "value": "Amount (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": "$/SQFT (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": "% of Total Income (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": false,
      "format": null,
      "alignment": null
    }, {
      "value": "Amount (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": "$/SQFT (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }, {
      "value": "% of Total Income (Monthly)",
      "is_header": true,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "center"
    }]
  }, {
    "meta": {},
    "data": [{
      "value": "Real Estate Taxes",
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "left"
    }, {
      "value": 50000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 15,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "percent",
      "alignment": "right"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": true,
      "format": null,
      "alignment": null
    }, {
      "value": 55000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2.2,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "value": 15,
      "format": "percent"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": true,
      "format": null,
      "alignment": null
    }, {
      "value": 60000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2.4,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 15,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "percent",
      "alignment": "right"
    }]
  }, {
    "meta": {},
    "data": [{
      "value": "General and Administrative",
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": false,
      "format": "string",
      "alignment": "left"
    }, {
      "value": 50000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 15,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "percent",
      "alignment": "right"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": true,
      "format": null,
      "alignment": null
    }, {
      "value": 55000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2.2,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "value": 15,
      "format": "percent"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": true,
      "format": null,
      "alignment": null
    }, {
      "value": 60000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2.4,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 15,
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "percent",
      "alignment": "right"
    }]
  }, {
    "meta": {},
    "data": [{
      "value": "Operating Expenses",
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": ["bold"],
      "shade": false,
      "format": "string",
      "alignment": "left"
    }, {
      "value": 50000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 15,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "percent",
      "alignment": "right"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": null,
      "shade": true,
      "format": null,
      "alignment": null
    }, {
      "value": 55000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2.2,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "value": 15,
      "format": "percent"
    }, {
      "value": null,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": null,
      "shade": true,
      "format": null,
      "alignment": null
    }, {
      "value": 60000,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2.4,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 15,
      "is_header": false,
      "is_total": false,
      "is_subtotal": true,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "percent",
      "alignment": "right"
    }]
  }, {
    "meta": {},
    "data": [{
      "value": "Totals",
      "is_header": false,
      "is_total": false,
      "is_subtotal": false,
      "span": 1,
      "stylings": ["bold"],
      "shade": false,
      "format": "string",
      "alignment": "left-indent"
    }, {
      "value": 50000,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 15,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "percent",
      "alignment": "right"
    }, {
      "value": null,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": true,
      "format": null,
      "alignment": null
    }, {
      "value": 55000,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2.2,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "value": 15,
      "format": "percent"
    }, {
      "value": null,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": null,
      "shade": true,
      "format": null,
      "alignment": null
    }, {
      "value": 60000,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 2.4,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "dollar",
      "alignment": "right"
    }, {
      "value": 15,
      "is_header": false,
      "is_total": true,
      "is_subtotal": false,
      "span": 1,
      "stylings": [],
      "shade": true,
      "format": "percent",
      "alignment": "right"
    }]
  }]
  /* eslint-enable */

});
// CONCATENATED MODULE: ./src/state/modules/dom/state.js
/**
 * Dependencies
 */



/**
 * War Room State
 *
 * @type {Object}
 */
var dom_state_state = {
    isEditing: false,
    showMenu: false,
    showLayoutModal: false,
    showComponentModal: false,
    showPanel: false,
    meta: {},
    warRoomId: null,
    digitalOM: {
        sections: []
    },
    pageSelection: {
        showModal: false,
        sectionId: null,
        sectionIndex: null,
        pageId: null,
        pageIndex: null
    },
    layouts: [{ name: 'layout_one', components: 4 }, { name: 'layout_two', components: 3 }, { name: 'layout_three', components: 2 }, { name: 'layout_four', components: 3 }, { name: 'layout_five', components: 2 }, { name: 'layout_six', components: 3 }, { name: 'layout_seven', components: 1 }, { name: 'layout_eight', components: 3 }, { name: 'layout_nine', components: 9 }, { name: 'layout_ten', components: 6 }],
    defaults: {
        'map': {
            type: 'map',
            value: {
                points: [],
                style: 'mapbox://styles/mapbox/streets-v9',
                center: [-97.922211, 39.381266],
                zoom: 3,
                radius: 1
            }
        },
        'text': {
            type: 'text',
            value: {
                body: [{
                    text: '',
                    attributes: []
                }]
            }
        },
        'image': {
            type: 'image',
            value: {}
        },
        'table': {
            type: 'table',
            value: {
                headers: [null, null],
                rows: [{
                    values: [{ data: null, format: 'string' }, { data: null, format: 'number' }],
                    is_total: false,
                    is_subtotal: false,
                    stylings: []
                }, {
                    values: [{ data: null, format: 'string' }, { data: null, format: 'number' }],
                    is_total: false,
                    is_subtotal: false,
                    stylings: []
                }, {
                    values: [{ data: null, format: 'string' }, { data: null, format: 'number' }],
                    is_total: true,
                    is_subtotal: false,
                    stylings: []
                }]
            }
        },
        'custom_table_box': {
            type: 'custom_table_box',
            value: Object(lodash["cloneDeep"])(custom_tables)
        },
        'generated_table': {
            type: 'generated_table',
            value: Object(lodash["cloneDeep"])(custom_tables)
        }
    }

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var dom_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(dom_state_state);
};

/* harmony default export */ var dom_state = (dom_state_getState());
// CONCATENATED MODULE: ./src/state/modules/dom/new-text/state.js
/**
 * Dependencies
 */


/**
 * New component modal state
 *
 * @type {Object}
 */
var new_text_state_state = {
  value: '',
  loading: false,
  error: false

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var new_text_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(new_text_state_state);
};

/* harmony default export */ var new_text_state = (new_text_state_getState());
// EXTERNAL MODULE: ./src/state/modules/dom/new-text/getters.js
var new_text_getters = __webpack_require__("cAvP");
var new_text_getters_default = /*#__PURE__*/__webpack_require__.n(new_text_getters);

// CONCATENATED MODULE: ./src/state/modules/dom/new-text/actions.js
/**
 * Reset the module state
 *
 * @return {Promise}
 */
var new_text_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;
    return commit('RESET_STATE');
};

/**
 * Update the editor's value
 *
 * @param  {Function} options.commit
 * @param  {String} val
 * @return {Promise}
 */
var updateValue = function updateValue(_ref2, val) {
    var commit = _ref2.commit;
    return commit('UPDATE_VALUE', val);
};

/**
 * Submit a new text module
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} options.rootState
 * @param  {Object} options.state
 * @return {Void}
 */
var actions_submit = function submit(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootState = _ref3.rootState,
        state = _ref3.state;

    var action = 'domAlt/createComponent';
    var data = getPostData(rootState, state);
    var options = { root: true };
    commit('SET_LOADING');
    commit('RESET_ERROR');
    dispatch(action, data, options).then(function (res) {
        commit('RESET_LOADING');
        dispatch('dom/newComponent/toggleModal', null, { root: true });
    }).catch(function () {
        commit('SET_ERROR');
        commit('RESET_LOADING');
    });
};

/**
 * Get the POST format for the module data
 *
 * @param  {Object} rootState
 * @param  {Object} state
 * @return {Object}
 */
var getPostData = function getPostData(rootState, state) {
    var page = rootState.dom.newComponent.context.page;
    var position = rootState.dom.newComponent.context.position;
    return {
        type: 'text',
        component: { page: page },
        model: {
            position: position,
            value: { body: state.value }
        }
    };
};

/* harmony default export */ var new_text_actions = ({
    submit: actions_submit,
    resetState: new_text_actions_resetState,
    updateValue: updateValue
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./src/state/modules/dom/new-text/mutations.js

/**
 * Dependencies
 */


var new_text_mutations_RESET_STATE = function RESET_STATE(state) {
    assign_default()(state, new_text_state_getState());
};

var UPDATE_VALUE = function UPDATE_VALUE(state, value) {
    state.value = value;
};

var new_text_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

var new_text_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

var mutations_SET_ERROR = function SET_ERROR(state) {
    state.error = true;
};

var RESET_ERROR = function RESET_ERROR(state) {
    state.error = false;
};

/* harmony default export */ var new_text_mutations = ({
    SET_ERROR: mutations_SET_ERROR,
    SET_LOADING: new_text_mutations_SET_LOADING,
    RESET_ERROR: RESET_ERROR,
    RESET_STATE: new_text_mutations_RESET_STATE,
    UPDATE_VALUE: UPDATE_VALUE,
    RESET_LOADING: new_text_mutations_RESET_LOADING
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-text/index.js
/**
 * Module Dependencies
 */





/**
 * New Text Module Declaration
 *
 * @type {Object}
 */
var new_text_module = {
  namespaced: true,
  state: new_text_state,
  getters: new_text_getters_default.a,
  mutations: new_text_mutations,
  actions: new_text_actions
};

/* harmony default export */ var new_text = (new_text_module);
// CONCATENATED MODULE: ./src/state/modules/dom/getters.js



var getters_pages = function pages(state) {
    return Object(lodash["get"])(state.digitalOM, 'sections[0].data', []);
};
var getters_sections = function sections(state) {
    return Object(lodash["get"])(state.digitalOM, 'sections', []);
};
var getters_address = function address(state) {
    var addressList = [];
    if (state.digitalOM.address !== undefined) {
        keys_default()(state.digitalOM.address).forEach(function (key, index) {
            if (state.digitalOM.address[key] !== null && state.digitalOM.address[key] !== '') {
                addressList.push(state.digitalOM.address[key]);
            }
        });
    }
    return {
        fullAddress: addressList.join(','),
        address: state.digitalOM.address
    };
};

/* harmony default export */ var dom_getters = ({
    pages: getters_pages,
    sections: getters_sections,
    address: getters_address
});
// CONCATENATED MODULE: ./src/state/modules/dom/actions.js

/**
 * Dependencies
 */


/** @function
 *  @actions for map component in Digital OM
 */
var addPoint = function addPoint(_ref, payload) {
    var commit = _ref.commit;
    return commit('ADD_POINT', payload);
};
var removePoint = function removePoint(_ref2, payload) {
    var commit = _ref2.commit;
    return commit('REMOVE_POINT', payload);
};
var focusPoint = function focusPoint(_ref3, payload) {
    var commit = _ref3.commit;
    return commit('FOCUS_POINT', payload);
};

/** @function
 *  @actions for text component in Digital OM
 */
var addText = function addText(_ref4, payload) {
    var commit = _ref4.commit;
    return commit('ADD_TEXT', payload);
};
var deleteText = function deleteText(_ref5, payload) {
    var commit = _ref5.commit;
    return commit('DELETE_TEXT', payload);
};

/** @function
 *  @actions for table component in Digital OM
 */
var updateTableData = function updateTableData(_ref6, payload) {
    var commit = _ref6.commit;
    return commit('UPDATE_TABLE_DATA', payload);
};
var updateTableHeader = function updateTableHeader(_ref7, payload) {
    var commit = _ref7.commit;
    return commit('UPDATE_TABLE_HEADER', payload);
};
var addTableRow = function addTableRow(_ref8, payload) {
    var commit = _ref8.commit;
    return commit('ADD_TABLE_ROW', payload);
};
var addTableColumn = function addTableColumn(_ref9, payload) {
    var commit = _ref9.commit;
    return commit('ADD_TABLE_COLUMN', payload);
};
var removeTableRow = function removeTableRow(_ref10, payload) {
    var commit = _ref10.commit;
    return commit('REMOVE_TABLE_ROW', payload);
};
var removeTableColumn = function removeTableColumn(_ref11, payload) {
    var commit = _ref11.commit;
    return commit('REMOVE_TABLE_COLUMN', payload);
};

/** @function
 *  @actions for table component in Digital OM
 */
var actions_uploadImage = function uploadImage(_ref12, payload) {
    var commit = _ref12.commit;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post('dom/images/', payload.form).then(function (res) {
            commit('IMAGE_UPLOAD_SUCCESS', {
                data: res.data,
                sectionIndex: payload.sectionIndex,
                pageIndex: payload.pageIndex,
                componentIndex: payload.componentIndex
            });
            resolve();
        }).catch(function (err) {
            commit('IMAGE_UPLOAD_FAILURE', err.response.data);
            reject(err);
        });
    });
};

/** @function
 *  @actions for modal component in Digital OM
 */
var actions_createComponent = function createComponent(_ref13, payload) {
    var commit = _ref13.commit;
    return commit('CREATE_NEW_COMPONENT', payload);
};

var actions_fetchDigitalOM = function fetchDigitalOM(_ref14, payload) {
    var commit = _ref14.commit,
        rootState = _ref14.rootState,
        dispatch = _ref14.dispatch;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/digital-om/').then(function (res) {
            commit('SETUP_DIGITAL_OM', {
                id: res.data.digital_om.id,
                address: res.data.digital_om.meta.address
            });
            commit('SET_DIGITAL_OM_META', res.data.digital_om.meta);
            commit('SET_WAR_ROOM_ID', res.data.digital_om.war_room);
            dispatch('getSections', res.data.digital_om.id).then(function (res) {
                var PromiseSections = [];
                res.data.data.forEach(function (section) {
                    PromiseSections.push(dispatch('getPages', section.id));
                });
                promise_default.a.all(PromiseSections).then(function (sections) {
                    sections.forEach(function (section) {
                        section.data.data.forEach(function (page) {
                            dispatch('getComponents', page.id);
                        });
                    });
                    resolve();
                });
            });
        }).catch(function (e) {
            return reject(e);
        });
    });
};

var actions_getPages = function getPages(_ref15, sectionId) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    return HttpService["a" /* default */].get('dom/sections/' + sectionId + '/pages/').then(function (res) {
        var pages = res.data.data;
        dispatch('getSection', sectionId).then(function (res) {
            if (pages.length > 0) {
                commit('GET_PAGES', { sectionIndex: res.data.order, data: pages });
            } else {
                commit('GET_PAGES', { sectionIndex: res.data.order, data: [] });
            }
        });
        return res;
    });
};

var actions_getPage = function getPage(_ref16, pageId) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    return HttpService["a" /* default */].get('dom/pages/' + pageId).then(function (res) {
        return res;
    });
};

var actions_getSections = function getSections(_ref17, id) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;

    return HttpService["a" /* default */].get('dom/digital-oms/' + id + '/sections/').then(function (res) {
        if (res.data.data.length > 0) {
            commit('GET_SECTIONS', res.data.data);
        } else {
            commit('GET_SECTIONS', []);
        }
        return res;
    }).catch(function (err) {
        return console.log(err);
    });
};

var actions_getSection = function getSection(_ref18, id) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;

    return HttpService["a" /* default */].get('dom/sections/' + id).then(function (res) {
        return res;
    }).catch(function (err) {
        promise_default.a.reject(err);
    });
};

var actions_createSection = function createSection(_ref19, payload) {
    var commit = _ref19.commit;
    return commit('CREATE_NEW_SECTION', payload);
};

var actions_postSection = function postSection(_ref20, payload) {
    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;

    if (payload.sectionId === null) {
        return HttpService["a" /* default */].post('dom/digital-oms/' + payload.domId + '/sections/', {
            title: payload.title,
            is_visible: payload.is_visible
        }).then(function (res) {
            commit('UPDATE_SECTION_ID', {
                sectionId: res.data.section_id,
                index: payload.index
            });
            commit('UPDATE_SECTION_TITLE', {
                sectionIndex: payload.index,
                value: payload.title
            });
        });
    } else {
        return dispatch('patchSection', {
            'sectionId': payload.sectionId,
            'title': payload.title
        }).then(function (res) {
            return promise_default.a.resolve(payload.sectionId);
        });
    }
};

var actions_patchSection = function patchSection(_ref21, payload) {
    var commit = _ref21.commit;

    return HttpService["a" /* default */].patch('dom/sections/' + payload.sectionId + '/', {
        'title': payload.title
    });
};

var actions_deleteSection = function deleteSection(_ref22, payload) {
    var commit = _ref22.commit,
        dispatch = _ref22.dispatch;

    HttpService["a" /* default */].del('dom/sections/' + payload.sectionId).then(function (res) {
        dispatch('removeSection', payload.sectionIndex);
    });
};

var removeSection = function removeSection(_ref23, payload) {
    var commit = _ref23.commit;
    return commit('REMOVE_SECTION', payload);
};

var actions_createPage = function createPage(_ref24, layout) {
    var commit = _ref24.commit,
        state = _ref24.state;
    return commit('CREATE_NEW_PAGE', layout);
};
var actions_postPage = function postPage(_ref25, payload) {
    var commit = _ref25.commit,
        dispatch = _ref25.dispatch;

    if (payload.pageId === null) {
        return HttpService["a" /* default */].post('dom/sections/' + payload.sectionId + '/pages/', {
            layout: payload.layout.name,
            title: payload.title
        }).then(function (res) {
            dispatch('createPage', {
                layout: payload.layout,
                sectionIndex: payload.sectionIndex,
                pageId: res.data.page_id,
                title: payload.title
            });
            return res.data.page_id;
        });
    } else {
        return dispatch('patchPage', {
            'pageId': payload.pageId,
            'layout': payload.layout,
            'title': ''
        }).then(function (res) {
            return payload.pageId;
        });
    }
};

var removePage = function removePage(_ref26, payload) {
    var commit = _ref26.commit;
    return commit('REMOVE_PAGE', payload);
};

var actions_deletePage = function deletePage(_ref27, payload) {
    var commit = _ref27.commit,
        dispatch = _ref27.dispatch;

    return HttpService["a" /* default */].del('dom/pages/' + payload.pageId).then(function (res) {
        dispatch('removePage', {
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        });
    });
};

var actions_patchPage = function patchPage(_ref28, payload) {
    var commit = _ref28.commit,
        dispatch = _ref28.dispatch;

    return HttpService["a" /* default */].patch('dom/pages/' + payload.pageId + '/', {
        'layout': payload.layout,
        'title': payload.title
    }).then(function () {
        dispatch('updatePage', {
            'layout': payload.layout,
            'title': payload.title,
            'pageIndex': payload.pageIndex,
            'sectionIndex': payload.sectionIndex,
            'id': payload.pageId
        });
    });
};

var actions_reorderPage = function reorderPage(_ref29, payload) {
    var commit = _ref29.commit;

    return HttpService["a" /* default */].put('dom/sections/' + payload.sectionId + '/re-order/', {
        'ordering': payload.pages
    }).then(function (res) {
        return promise_default.a.resolve(res.data);
    }).catch(function (e) {
        return promise_default.a.reject(e);
    });
};

var getMap = function getMap(_ref30, payload) {
    var commit = _ref30.commit,
        dispatch = _ref30.dispatch;

    if (payload.componentId === null) {
        dispatch('postMap', {
            pageId: payload.pageId,
            pageIndex: payload.pageIndex,
            sectionIndex: payload.sectionIndex,
            componentIndex: payload.componentIndex,
            value: payload.value
        });
    } else {
        dispatch('patchMap', {
            pageId: payload.pageId,
            componentId: payload.componentId,
            componentIndex: payload.componentIndex,
            points: payload.value.points
        });
    }
};

var getText = function getText(_ref31, payload) {
    var commit = _ref31.commit,
        dispatch = _ref31.dispatch;

    if (payload.componentId === null) {
        dispatch('postText', {
            pageId: payload.pageId,
            pageIndex: payload.pageIndex,
            sectionIndex: payload.sectionIndex,
            componentIndex: payload.componentIndex,
            value: payload.value
        });
    } else {
        dispatch('patchText', {
            pageId: payload.pageId,
            componentId: payload.componentId,
            componentIndex: payload.componentIndex,
            value: payload.value
        });
    }
};
var getImage = function getImage(_ref32, payload) {
    var commit = _ref32.commit,
        dispatch = _ref32.dispatch;

    if (payload.componentId === null) {
        dispatch('postImage', {
            pageId: payload.pageId,
            pageIndex: payload.pageIndex,
            sectionIndex: payload.sectionIndex,
            componentIndex: payload.componentIndex,
            value: payload.value
        });
    } else {
        dispatch('patchImage', {
            pageId: payload.pageId,
            componentId: payload.componentId,
            componentIndex: payload.componentIndex,
            value: payload.value
        });
    }
};

var getTable = function getTable(_ref33, payload) {
    var commit = _ref33.commit,
        dispatch = _ref33.dispatch;

    if (payload.componentId === null) {
        dispatch('postTable', {
            pageId: payload.pageId,
            pageIndex: payload.pageIndex,
            sectionIndex: payload.sectionIndex,
            componentIndex: payload.componentIndex,
            headers: payload.value.headers,
            rows: payload.value.rows
        });
    } else {
        dispatch('patchTable', {
            pageId: payload.pageId,
            componentId: payload.componentId,
            componentIndex: payload.componentIndex,
            headers: payload.value.headers,
            rows: payload.value.rows
        });
    }
};

var actions_postTable = function postTable(_ref34, payload) {
    var commit = _ref34.commit;

    return HttpService["a" /* default */].post('dom/pages/' + payload.pageId + '/components/table/', {
        'position': payload.componentIndex,
        'value': {
            'title': null,
            'headers': payload.value.headers,
            'rows': payload.value.rows,
            'stylings': []
        }
    }).then(function (res) {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        });
    }).catch(function (e) {
        console.log(e);
    });
};

var actions_patchTable = function patchTable(_ref35, payload) {
    var commit = _ref35.commit;

    return HttpService["a" /* default */].patch('dom/components/' + payload.componentId + '/', {
        'position': payload.componentIndex,
        'value': {
            'title': null,
            'headers': payload.value.headers,
            'rows': payload.value.rows,
            'stylings': []
        },
        'stylings': []
    }).catch(function (e) {
        return console.log(e);
    });
};

var actions_postText = function postText(_ref36, payload) {
    var commit = _ref36.commit;

    HttpService["a" /* default */].post('dom/pages/' + payload.pageId + '/components/text/', {
        'position': payload.componentIndex,
        'value': {
            'body': payload.value
        }
    }).then(function (res) {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        });
    }).catch(function (e) {
        return console.log(e);
    });
};

var actions_patchText = function patchText(_ref37, payload) {
    var commit = _ref37.commit;

    return HttpService["a" /* default */].patch('dom/components/' + payload.componentId + '/', {
        'value': {
            'body': payload.value
        }
    }).catch(function (e) {});
};

var actions_postMap = function postMap(_ref38, payload) {
    var commit = _ref38.commit;

    HttpService["a" /* default */].post('dom/pages/' + payload.pageId + '/components/map/', {
        'position': payload.componentIndex,
        'value': {
            'points': payload.value
        }
    }).then(function (res) {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        });
    }).catch(function (e) {
        return console.log(e);
    });
};

var actions_patchMap = function patchMap(_ref39, payload) {
    var commit = _ref39.commit;

    HttpService["a" /* default */].patch('dom/components/' + payload.componentId + '/', {
        'position': payload.componentIndex,
        'value': {
            'points': payload.value
        }
    }).catch(function (e) {
        return console.log(e);
    });
};

var actions_fetchImage = function fetchImage(_ref40, payload) {
    var commit = _ref40.commit;

    return HttpService["a" /* default */].get('dom/images/' + payload.imageId).then(function (res) {
        commit('LOAD_IMAGE', {
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex,
            componentIndex: payload.componentIndex,
            value: res.data.url
        });
    });
};

var actions_postImage = function postImage(_ref41, payload) {
    var commit = _ref41.commit;

    return HttpService["a" /* default */].post('dom/pages/' + payload.pageId + '/components/image/', {
        'position': payload.componentIndex,
        'value': {
            'image_id': payload.value.image_id
        }
    }).then(function (res) {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        });
    }).catch(function (e) {
        return console.log(e);
    });
};

var actions_patchImage = function patchImage(_ref42, payload) {
    var commit = _ref42.commit;

    return HttpService["a" /* default */].patch('dom/components/' + payload.componentId + '/', {
        'position': payload.componentIndex,
        'value': {
            'image_id': payload.value.image_id
        }
    }).then(function (res) {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        });
    }).catch(function (e) {
        return console.log(e);
    });
};

var actions_getComponents = function getComponents(_ref43, pageId) {
    var commit = _ref43.commit,
        dispatch = _ref43.dispatch;

    return HttpService["a" /* default */].get('dom/pages/' + pageId + '/components/').then(function (res) {
        var components = res.data.data;
        dispatch('getPage', pageId).then(function (res) {
            var pageIndex = res.data.order;
            dispatch('getSection', res.data.section).then(function (res) {
                if (components.length > 0) {
                    commit('GET_COMPONENTS', {
                        sectionIndex: res.data.order,
                        pageIndex: pageIndex,
                        data: components
                    });
                } else {
                    commit('GET_COMPONENTS', {
                        sectionIndex: res.data.order,
                        pageIndex: pageIndex,
                        data: []
                    });
                }
            });
        });
    });
};

var togglePanel = function togglePanel(_ref44) {
    var commit = _ref44.commit;
    return commit('TOGGLE_PANEL');
};

var setPageComponent = function setPageComponent(_ref45, payload) {
    var commit = _ref45.commit;
    return commit('SET_PAGE_COMPONENT', payload);
};

var actions_deleteComponent = function deleteComponent(_ref46, payload) {
    var commit = _ref46.commit;

    if (payload.componentId === null) {
        commit('REMOVE_COMPONENT', payload);
    } else {
        return HttpService["a" /* default */].del('dom/components/' + payload.componentId).then(function (res) {
            commit('REMOVE_COMPONENT', payload);
        });
    }
};

var updatePage = function updatePage(_ref47, payload) {
    var commit = _ref47.commit;
    return commit('UPDATE_PAGE', payload);
};

var updateSectionTitle = function updateSectionTitle(_ref48, payload) {
    var commit = _ref48.commit;
    return commit('UPDATE_SECTION_TITLE', payload);
};

var actions_reorderPages = function reorderPages(_ref49, payload) {
    var commit = _ref49.commit,
        dispatch = _ref49.dispatch;
    return commit('REORDER_PAGES', payload);
};
var nestPage = function nestPage(_ref50, payload) {
    var commit = _ref50.commit,
        dispatch = _ref50.dispatch;
    return commit('NEST_PAGE', payload);
};

var actions_postGeneratedTable = function postGeneratedTable(_ref51, payload) {
    var commit = _ref51.commit,
        dispatch = _ref51.dispatch;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post('dom/pages/' + payload.pageId + '/components/generated-table/', {
            position: payload.componentIndex,
            value: {
                key: payload.table,
                selected_options: {
                    time_frames: [],
                    columns: []
                },
                resource: 'project'
            }
        }).then(function (res) {
            commit('UPDATE_COMPONENT', {
                componentId: res.data.component_id,
                componentIndex: payload.componentIndex,
                sectionIndex: payload.sectionIndex,
                pageIndex: payload.pageIndex
            });
            dispatch('getGeneratedTable', res.data.component_id).then(function (data) {
                return resolve(data);
            });
        }).catch(function (err) {
            return reject(err);
        });
    });
};

var actions_getGeneratedTable = function getGeneratedTable(_ref52, id) {
    var commit = _ref52.commit;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].get('dom/components/' + id + '/').then(function (res) {
            var url = res.data.value.request_url.replace(/^\/+/g, '');
            HttpService["a" /* default */].get(url).then(function (r) {
                return resolve(r.data);
            });
        }).catch(function (err) {
            return reject(err);
        });
    });
};

var actions_updateGeneratedTable = function updateGeneratedTable(_ref53, payload) {
    var commit = _ref53.commit,
        dispatch = _ref53.dispatch;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].patch('dom/components/' + payload.id + '/', payload.data).then(function () {
            dispatch('getGeneratedTable', payload.id).then(function (data) {
                return resolve(data);
            });
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Toggle the primary navigation menu for the Digital OM
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var toggleMenu = function toggleMenu(_ref54) {
    var commit = _ref54.commit;
    return commit('TOGGLE_MENU');
};

/**
 * Reset the back to the original state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var dom_actions_resetState = function resetState(_ref55) {
    var commit = _ref55.commit;
    return commit('RESET_STATE');
};

/**
 * Set the target section ID and open the layout selection modal
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Void}
 */
var selectPageLayout = function selectPageLayout(_ref56, payload) {
    var commit = _ref56.commit;

    commit('SET_LAYOUT_SECTION', payload);
    commit('OPEN_LAYOUT_MODAL');
};

/**
 * Reset the page layout selection modal
 *
 * @param  {[type]} options.commit
 * @return {[type]}
 */
var closePageSelectionDialog = function closePageSelectionDialog(_ref57) {
    var commit = _ref57.commit;

    commit('CLOSE_LAYOUT_MODAL');
    commit('SET_LAYOUT_SECTION', null);
};

var actions_createInvisibleSectionWithPage = function createInvisibleSectionWithPage(_ref58, payload) {
    var commit = _ref58.commit,
        dispatch = _ref58.dispatch,
        state = _ref58.state;
    return new promise_default.a(function (resolve, reject) {
        dispatch('createSection', {
            title: 'Invisible',
            data: [],
            visible: false
        });
        dispatch('postSection', {
            sectionId: null,
            domId: state.digitalOM.id,
            title: 'Invisible',
            index: state.digitalOM.sections.length - 1,
            is_visible: false
        }).then(function (res) {
            dispatch('postPage', {
                title: payload.title,
                sectionIndex: state.digitalOM.sections.length - 1,
                sectionId: state.digitalOM.sections[state.digitalOM.sections.length - 1].id,
                pageIndex: null,
                pageId: null,
                layout: payload.layout
            });
            resolve();
        });
    });
};

/**
 * Toggle the edit mode for the Digital OM
 *
 * @param  {Function} options.commit
 * @param  {Boolean} value
 * @return {Promise}
 */
var toggleEditMode = function toggleEditMode(_ref59) {
    var commit = _ref59.commit;
    return commit('TOGGLE_EDIT_MODE');
};

/* harmony default export */ var dom_actions = ({
    resetState: dom_actions_resetState,
    deletePage: actions_deletePage,
    removePage: removePage,
    removeSection: removeSection,
    deleteSection: actions_deleteSection,
    updatePage: updatePage,
    updateSectionTitle: updateSectionTitle,
    togglePanel: togglePanel,
    addPoint: addPoint,
    removePoint: removePoint,
    focusPoint: focusPoint,
    addText: addText,
    deleteText: deleteText,
    updateTableData: updateTableData,
    updateTableHeader: updateTableHeader,
    addTableRow: addTableRow,
    setPageComponent: setPageComponent,
    deleteComponent: actions_deleteComponent,
    addTableColumn: addTableColumn,
    removeTableRow: removeTableRow,
    removeTableColumn: removeTableColumn,
    createPage: actions_createPage,
    createSection: actions_createSection,
    postSection: actions_postSection,
    postPage: actions_postPage,
    postTable: actions_postTable,
    postText: actions_postText,
    postMap: actions_postMap,
    fetchImage: actions_fetchImage,
    postImage: actions_postImage,
    patchSection: actions_patchSection,
    patchPage: actions_patchPage,
    patchTable: actions_patchTable,
    patchText: actions_patchText,
    patchMap: actions_patchMap,
    patchImage: actions_patchImage,
    createComponent: actions_createComponent,
    getComponents: actions_getComponents,
    fetchDigitalOM: actions_fetchDigitalOM,
    getSections: actions_getSections,
    getSection: actions_getSection,
    getPages: actions_getPages,
    getPage: actions_getPage,
    getTable: getTable,
    getMap: getMap,
    getImage: getImage,
    getText: getText,
    uploadImage: actions_uploadImage,
    reorderPage: actions_reorderPage,
    reorderPages: actions_reorderPages,
    nestPage: nestPage,
    getGeneratedTable: actions_getGeneratedTable,
    postGeneratedTable: actions_postGeneratedTable,
    updateGeneratedTable: actions_updateGeneratedTable,
    toggleMenu: toggleMenu,
    selectPageLayout: selectPageLayout,
    closePageSelectionDialog: closePageSelectionDialog,
    createInvisibleSectionWithPage: actions_createInvisibleSectionWithPage,
    toggleEditMode: toggleEditMode
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-table/state.js
/**
 * Dependencies
 */


/**
 * New component modal state
 *
 * @type {Object}
 */
var new_table_state_state = {
  value: {
    headers: [],
    title: '',
    stylings: [],
    rows: []
  },
  loading: false,
  error: false

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var new_table_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(new_table_state_state);
};

/* harmony default export */ var new_table_state = (new_table_state_getState());
// EXTERNAL MODULE: ./src/state/modules/dom/new-table/getters.js
var new_table_getters = __webpack_require__("Ncbd");
var new_table_getters_default = /*#__PURE__*/__webpack_require__.n(new_table_getters);

// CONCATENATED MODULE: ./src/state/modules/dom/new-table/actions.js
/**
 * Reset the module state
 *
 * @return {Promise}
 */
var new_table_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;
    return commit('RESET_STATE');
};

/**
 * Submit a new text module
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} options.rootState
 * @param  {Object} options.state
 * @return {Void}
 */
var new_table_actions_submit = function submit(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootState = _ref2.rootState,
        state = _ref2.state;

    var action = 'domAlt/createComponent';
    var data = actions_getPostData(rootState, state);
    var options = { root: true };
    commit('SET_LOADING');
    commit('RESET_ERROR');
    dispatch(action, data, options).then(function (res) {
        commit('RESET_LOADING');
        dispatch('dom/newComponent/toggleModal', null, { root: true });
    }).catch(function () {
        commit('SET_ERROR');
        commit('RESET_LOADING');
    });
};

/**
 * Get the POST format for the module data
 *
 * @param  {Object} rootState
 * @param  {Object} state
 * @return {Object}
 */
var actions_getPostData = function getPostData(rootState, state) {
    var page = rootState.dom.newComponent.context.page;
    var position = rootState.dom.newComponent.context.position;
    return {
        type: 'table',
        component: { page: page },
        model: {
            position: position,
            value: { body: state.value }
        }
    };
};

/* harmony default export */ var new_table_actions = ({
    submit: new_table_actions_submit,
    resetState: new_table_actions_resetState
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-table/mutations.js

/**
 * Dependencies
 */


var new_table_mutations_RESET_STATE = function RESET_STATE(state) {
    assign_default()(state, new_table_state_getState());
};

var new_table_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

var new_table_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

var new_table_mutations_SET_ERROR = function SET_ERROR(state) {
    state.error = true;
};

var mutations_RESET_ERROR = function RESET_ERROR(state) {
    state.error = false;
};

/* harmony default export */ var new_table_mutations = ({
    SET_ERROR: new_table_mutations_SET_ERROR,
    SET_LOADING: new_table_mutations_SET_LOADING,
    RESET_ERROR: mutations_RESET_ERROR,
    RESET_STATE: new_table_mutations_RESET_STATE,
    RESET_LOADING: new_table_mutations_RESET_LOADING
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-table/index.js
/**
 * Module Dependencies
 */





/**
 * New Text Module Declaration
 *
 * @type {Object}
 */
var new_table_module = {
  namespaced: true,
  state: new_table_state,
  getters: new_table_getters_default.a,
  mutations: new_table_mutations,
  actions: new_table_actions
};

/* harmony default export */ var new_table = (new_table_module);
// CONCATENATED MODULE: ./src/state/modules/dom/mutations.js

/**
 * Dependencies
 */



var ADD_POINT = function ADD_POINT(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.points.push(payload.feature);
};

var REMOVE_POINT = function REMOVE_POINT(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.page].components[payload.component].value.points.splice(payload.index, 1);
};

var FOCUS_POINT = function FOCUS_POINT(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.page].components[payload.component].value.center = payload.locale;
};

var ADD_TEXT = function ADD_TEXT(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.body = payload.value;
};

var DELETE_TEXT = function DELETE_TEXT(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.body = payload;
};

var UPDATE_TABLE_HEADER = function UPDATE_TABLE_HEADER(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.headers.splice(payload.cell, 1, payload.value);
};

var UPDATE_TABLE_DATA = function UPDATE_TABLE_DATA(state, payload) {
    var cell = state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.rows[payload.row].values[payload.cell];
    cell['data'] = payload.value;
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.rows[payload.row].values.splice(payload.cell, 1, cell);
};

var ADD_TABLE_ROW = function ADD_TABLE_ROW(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.page].components[payload.component].value.rows.push(payload.value);
};

var mutations_ADD_TABLE_COLUMN = function ADD_TABLE_COLUMN(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.page].components[payload.component].value.headers.push(payload.header);

    state.digitalOM.sections[payload.sectionIndex].data[payload.page].components[payload.component].value.rows.map(function (row) {
        row.values.push(JSON.parse(stringify_default()(payload.column)));
    });
};

var REMOVE_TABLE_ROW = function REMOVE_TABLE_ROW(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.rows.splice(payload.rowNumber, 1);
};

var REMOVE_TABLE_COLUMN = function REMOVE_TABLE_COLUMN(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.headers.splice(payload.columnNumber, 1);

    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value.rows.forEach(function (row) {
        row.values.splice(payload.columnNumber, 1);
    });
};

var UPDATE_PAGE = function UPDATE_PAGE(state, payload) {
    var page = state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex];
    page['title'] = payload.title;
    page['layout'] = payload.layout;
    page['id'] = payload.id;

    state.digitalOM.sections[payload.sectionIndex].data.splice(payload.pageIndex, 1, page);
};

var UPDATE_PAGE_TITLE = function UPDATE_PAGE_TITLE(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].title = payload.value;
};

var UPDATE_SECTION_TITLE = function UPDATE_SECTION_TITLE(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].title = payload.value;
};

var CREATE_NEW_SECTION = function CREATE_NEW_SECTION(state, payload) {
    state.digitalOM.sections.push({
        title: payload.title,
        data: payload.data,
        visible: payload.visible
    });
};

var CREATE_NEW_PAGE = function CREATE_NEW_PAGE(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data.push({
        id: payload.pageId,
        title: payload.title || null,
        layout: payload.layout.name,
        data: [],
        order: null,
        components: new Array(payload.layout.components).fill({}).map(function (item) {
            item.type = null;
            item.value = null;
            return item;
        })
    });
};

var CREATE_NEW_COMPONENT = function CREATE_NEW_COMPONENT(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.page].components[payload.position] = {
        type: payload.type,
        position: payload.position,
        value: payload.value
    };
};

var UPDATE_COMPONENT = function UPDATE_COMPONENT(state, payload) {
    var component = state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex];

    component['id'] = payload.componentId;

    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components.splice(payload.componentIndex, 1, component);
};

var SETUP_DIGITAL_OM = function SETUP_DIGITAL_OM(state, payload) {
    state.digitalOM['id'] = payload.id;
    state.digitalOM['address'] = payload.address;
};

var GET_SECTIONS = function GET_SECTIONS(state, payload) {
    var arr = [];
    payload.forEach(function (section) {
        var obj = {};
        obj['title'] = section.title;
        obj['id'] = section.id;
        obj['visible'] = section.is_visible;
        obj['data'] = [];
        arr.push(obj);
    });
    state.digitalOM.sections = arr;
};

var GET_PAGES = function GET_PAGES(state, payload) {
    var pages = state.digitalOM.sections[payload.sectionIndex];
    pages['data'] = payload.data;
    state.digitalOM.sections.splice(payload.sectionIndex, 1, pages);
};

var UPDATE_SECTION_ID = function UPDATE_SECTION_ID(state, payload) {
    var section = state.digitalOM.sections[payload.index];
    section['id'] = payload.sectionId;
    state.digitalOM.sections.splice(payload.index, 1, section);
};

var mutations_SET_PAGE_COMPONENT = function SET_PAGE_COMPONENT(state, payload) {
    var target = state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components;
    target.splice(payload.componentIndex, 1, JSON.parse(stringify_default()(state.defaults[payload.componentType])));
};

var mutations_GET_COMPONENTS = function GET_COMPONENTS(state, payload) {
    var page = JSON.parse(stringify_default()(state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex]));
    page['data'] = payload.data;
    console.log(page);
    var layout = state.layouts.find(function (layout) {
        return layout.name === page['layout'];
    });
    page['components'] = new Array(layout.components).fill({}).map(function (item) {
        item.type = null;
        item.value = null;
        return item;
    });
    payload.data.forEach(function (component) {
        page['components'][component.position] = {
            type: component.type,
            value: component.value,
            id: component.id
        };
    });
    state.digitalOM.sections[payload.sectionIndex].data.splice(payload.pageIndex, 1, page);
};

var TOGGLE_PANEL = function TOGGLE_PANEL(state) {
    state.showPanel = !state.showPanel;
};

var REMOVE_COMPONENT = function REMOVE_COMPONENT(state, payload) {
    var target = state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components;
    target.splice(payload.componentIndex, 1, {
        type: null,
        value: null
    });
};

var REMOVE_PAGE = function REMOVE_PAGE(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data.splice(payload.pageIndex, 1);
};

var REMOVE_SECTION = function REMOVE_SECTION(state, sectionIndex) {
    state.digitalOM.sections.splice(sectionIndex, 1);
};

var LOAD_IMAGE = function LOAD_IMAGE(state, payload) {
    var component = state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex];

    component.value['source'] = payload.value;

    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components.splice(payload.componentIndex, 1, component);
};

var IMAGE_UPLOAD_SUCCESS = function IMAGE_UPLOAD_SUCCESS(state, payload) {
    state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components[payload.componentIndex].value = {
        image_id: payload.data.image_id,
        source: payload.data.image.url
    };
    console.log('success');
};

var IMAGE_UPLOAD_FAILURE = function IMAGE_UPLOAD_FAILURE(state, payload) {};

var REORDER_PAGES = function REORDER_PAGES(state, payload) {
    state.digitalOM.sections[0].data = payload;
};

var NEST_PAGE = function NEST_PAGE(state, payload) {
    state.digitalOM.sections[0].data[payload.page].pages = payload.nest;
};

var TOGGLE_MENU = function TOGGLE_MENU(state) {
    state.showMenu = !state.showMenu;
};

var SET_DIGITAL_OM_META = function SET_DIGITAL_OM_META(state, payload) {
    state.meta = payload;
};

var SET_WAR_ROOM_ID = function SET_WAR_ROOM_ID(state, id) {
    state.warRoomId = id;
};

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
var dom_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = dom_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

var SET_LAYOUT_SECTION = function SET_LAYOUT_SECTION(state, payload) {
    if (payload) {
        state.pageSelection.sectionIndex = payload.sectionIndex;
        state.pageSelection.sectionId = payload.sectionId;
        state.pageSelection.pageIndex = payload.pageIndex;
    } else {
        state.pageSelection.sectionIndex = null;
        state.pageSelection.sectionId = null;
        state.pageSelection.pageIndex = null;
    }
};

var OPEN_LAYOUT_MODAL = function OPEN_LAYOUT_MODAL(state) {
    state.pageSelection.showModal = true;
};

var CLOSE_LAYOUT_MODAL = function CLOSE_LAYOUT_MODAL(state) {
    state.pageSelection.showModal = false;
    state.pageSelection.sectionIndex = null;
    state.pageSelection.sectionId = null;
    state.pageSelection.pageIndex = null;
};

var TOGGLE_EDIT_MODE = function TOGGLE_EDIT_MODE(state, value) {
    state.isEditing = !state.isEditing;
};

/* harmony default export */ var dom_mutations = ({
    RESET_STATE: dom_mutations_RESET_STATE,
    REMOVE_PAGE: REMOVE_PAGE,
    REMOVE_SECTION: REMOVE_SECTION,
    ADD_POINT: ADD_POINT,
    REMOVE_POINT: REMOVE_POINT,
    FOCUS_POINT: FOCUS_POINT,
    REMOVE_COMPONENT: REMOVE_COMPONENT,
    UPDATE_PAGE: UPDATE_PAGE,
    UPDATE_PAGE_TITLE: UPDATE_PAGE_TITLE,
    UPDATE_SECTION_TITLE: UPDATE_SECTION_TITLE,
    ADD_TEXT: ADD_TEXT,
    DELETE_TEXT: DELETE_TEXT,
    TOGGLE_PANEL: TOGGLE_PANEL,
    SET_PAGE_COMPONENT: mutations_SET_PAGE_COMPONENT,
    UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
    UPDATE_TABLE_HEADER: UPDATE_TABLE_HEADER,
    ADD_TABLE_ROW: ADD_TABLE_ROW,
    ADD_TABLE_COLUMN: mutations_ADD_TABLE_COLUMN,
    REMOVE_TABLE_ROW: REMOVE_TABLE_ROW,
    REMOVE_TABLE_COLUMN: REMOVE_TABLE_COLUMN,
    CREATE_NEW_PAGE: CREATE_NEW_PAGE,
    CREATE_NEW_COMPONENT: CREATE_NEW_COMPONENT,
    CREATE_NEW_SECTION: CREATE_NEW_SECTION,
    UPDATE_SECTION_ID: UPDATE_SECTION_ID,
    SETUP_DIGITAL_OM: SETUP_DIGITAL_OM,
    GET_SECTIONS: GET_SECTIONS,
    GET_PAGES: GET_PAGES,
    GET_COMPONENTS: mutations_GET_COMPONENTS,
    LOAD_IMAGE: LOAD_IMAGE,
    IMAGE_UPLOAD_SUCCESS: IMAGE_UPLOAD_SUCCESS,
    IMAGE_UPLOAD_FAILURE: IMAGE_UPLOAD_FAILURE,
    UPDATE_COMPONENT: UPDATE_COMPONENT,
    REORDER_PAGES: REORDER_PAGES,
    NEST_PAGE: NEST_PAGE,
    TOGGLE_MENU: TOGGLE_MENU,
    SET_DIGITAL_OM_META: SET_DIGITAL_OM_META,
    SET_WAR_ROOM_ID: SET_WAR_ROOM_ID,
    SET_LAYOUT_SECTION: SET_LAYOUT_SECTION,
    OPEN_LAYOUT_MODAL: OPEN_LAYOUT_MODAL,
    CLOSE_LAYOUT_MODAL: CLOSE_LAYOUT_MODAL,
    TOGGLE_EDIT_MODE: TOGGLE_EDIT_MODE
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-gen-table/state.js
/**
 * Dependencies
 */


/**
 * New component modal state
 *
 * @type {Object}
 */
var new_gen_table_state_state = {
  selected: null,
  options: [],
  loading: false,
  error: false

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var new_gen_table_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(new_gen_table_state_state);
};

/* harmony default export */ var new_gen_table_state = (new_gen_table_state_getState());
// EXTERNAL MODULE: ./src/state/modules/dom/new-gen-table/getters.js
var new_gen_table_getters = __webpack_require__("ULaz");
var new_gen_table_getters_default = /*#__PURE__*/__webpack_require__.n(new_gen_table_getters);

// CONCATENATED MODULE: ./src/state/modules/dom/new-gen-table/actions.js

/**
 * Dependencies
 */


/**
 * Reset the module state
 *
 * @return {Promise}
 */
var new_gen_table_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;
    return commit('RESET_STATE');
};

/**
 * Update the editor's value
 *
 * @param  {Function} options.commit
 * @param  {String} val
 * @return {Promise}
 */
var actions_updateValue = function updateValue(_ref2, val) {
    var commit = _ref2.commit;
    return commit('UPDATE_VALUE', val);
};

/**
 * Submit a new generated table module
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} options.rootState
 * @param  {Object} options.state
 * @return {Void}
 */
var new_gen_table_actions_submit = function submit(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootState = _ref3.rootState,
        state = _ref3.state;

    var action = 'domAlt/createComponent';
    var data = new_gen_table_actions_getPostData(rootState, state);
    var options = { root: true };
    commit('SET_LOADING');
    commit('RESET_ERROR');
    dispatch(action, data, options).then(function (res) {
        commit('RESET_LOADING');
        dispatch('dom/newComponent/toggleModal', null, { root: true });
    }).catch(function () {
        commit('SET_ERROR');
        commit('RESET_LOADING');
    });
};

/**
 * Get the POST format for the module data
 *
 * @param  {Object} rootState
 * @param  {Object} state
 * @return {Object}
 */
var new_gen_table_actions_getPostData = function getPostData(rootState, state) {
    var page = rootState.dom.newComponent.context.page;
    var position = rootState.dom.newComponent.context.position;
    return {
        type: 'generated-table',
        component: { page: page },
        model: {
            position: position,
            value: {
                key: state.selected,
                selected_options: {},
                resource: 'project'
            }
        }
    };
};

/**
 * Get a list of available tables
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_fetchOptions = function fetchOptions(_ref4) {
    var commit = _ref4.commit;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].get('dom/generated-tables/').then(function (res) {
            commit('SET_OPTIONS', res.data.data);
            resolve();
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Select an option and persist the component state
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {String} option
 * @return {Promise}
 */
var actions_selectOption = function selectOption(_ref5, option) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return commit('SELECT_OPTION', option);
};

/* harmony default export */ var new_gen_table_actions = ({
    submit: new_gen_table_actions_submit,
    resetState: new_gen_table_actions_resetState,
    updateValue: actions_updateValue,
    fetchOptions: actions_fetchOptions,
    selectOption: actions_selectOption
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-gen-table/mutations.js

/**
 * Dependencies
 */


var new_gen_table_mutations_RESET_STATE = function RESET_STATE(state) {
    assign_default()(state, new_gen_table_state_getState());
};

var new_gen_table_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

var new_gen_table_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

var new_gen_table_mutations_SET_ERROR = function SET_ERROR(state) {
    state.error = true;
};

var new_gen_table_mutations_RESET_ERROR = function RESET_ERROR(state) {
    state.error = false;
};

var SET_OPTIONS = function SET_OPTIONS(state, data) {
    state.options = data;
};

var SELECT_OPTION = function SELECT_OPTION(state, option) {
    state.selected = option;
};

/* harmony default export */ var new_gen_table_mutations = ({
    SET_ERROR: new_gen_table_mutations_SET_ERROR,
    SET_LOADING: new_gen_table_mutations_SET_LOADING,
    RESET_ERROR: new_gen_table_mutations_RESET_ERROR,
    RESET_STATE: new_gen_table_mutations_RESET_STATE,
    SET_OPTIONS: SET_OPTIONS,
    SELECT_OPTION: SELECT_OPTION,
    RESET_LOADING: new_gen_table_mutations_RESET_LOADING
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-gen-table/index.js
/**
 * Module Dependencies
 */





/**
 * New Generateed Table Module Declaration
 *
 * @type {Object}
 */
var new_gen_table_module = {
  namespaced: true,
  state: new_gen_table_state,
  getters: new_gen_table_getters_default.a,
  mutations: new_gen_table_mutations,
  actions: new_gen_table_actions
};

/* harmony default export */ var new_gen_table = (new_gen_table_module);
// CONCATENATED MODULE: ./src/state/modules/dom/new-component/state.js
/**
 * Dependencies
 */


/**
 * New component modal state
 *
 * @type {Object}
 */
var new_component_state_state = {
  showModal: false,
  componentType: null,
  context: {
    page: null,
    position: null
  }

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var new_component_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(new_component_state_state);
};

/* harmony default export */ var new_component_state = (new_component_state_getState());
// EXTERNAL MODULE: ./src/state/modules/dom/new-component/getters.js
var new_component_getters = __webpack_require__("dhua");
var new_component_getters_default = /*#__PURE__*/__webpack_require__.n(new_component_getters);

// CONCATENATED MODULE: ./src/state/modules/dom/new-component/actions.js
/**
 * Toggle the modal state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_toggleModal = function toggleModal(_ref) {
  var commit = _ref.commit;
  return commit('TOGGLE_MODAL');
};

/**
 * Set the component type
 *
 * @param  {Function} options.commit
 * @param  {String} type
 * @return {Promise}
 */
var setComponentType = function setComponentType(_ref2, type) {
  var commit = _ref2.commit;
  return commit('SET_COMPONENT_TYPE', type);
};

/**
 * Reset the module state
 *
 * @return {Promise}
 */
var new_component_actions_resetState = function resetState(_ref3) {
  var commit = _ref3.commit;
  return commit('RESET_STATE');
};

/**
 * Set the context for the component/page positions
 *
 * @param  {Function} options.commit
 * @param  {Object} meta
 * @return {Promise}
 */
var setContext = function setContext(_ref4, meta) {
  var commit = _ref4.commit;
  return commit('SET_CONTEXT', meta);
};

/* harmony default export */ var new_component_actions = ({
  resetState: new_component_actions_resetState,
  setContext: setContext,
  toggleModal: actions_toggleModal,
  setComponentType: setComponentType
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-component/mutations.js

/**
 * Dependencies
 */


var new_component_mutations_RESET_STATE = function RESET_STATE(state) {
    assign_default()(state, new_component_state_getState());
};

var SET_COMPONENT_TYPE = function SET_COMPONENT_TYPE(state, type) {
    state.componentType = type;
};

var mutations_TOGGLE_MODAL = function TOGGLE_MODAL(state) {
    state.showModal = !state.showModal;
};

var mutations_SET_CONTEXT = function SET_CONTEXT(state, meta) {
    state.context.page = meta.page;
    state.context.position = meta.position;
};

/* harmony default export */ var new_component_mutations = ({
    RESET_STATE: new_component_mutations_RESET_STATE,
    SET_CONTEXT: mutations_SET_CONTEXT,
    TOGGLE_MODAL: mutations_TOGGLE_MODAL,
    SET_COMPONENT_TYPE: SET_COMPONENT_TYPE
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-component/index.js
/**
 * Module Dependencies
 */





/**
 * New Component Module Declaration
 *
 * @type {Object}
 */
var new_component_module = {
  namespaced: true,
  state: new_component_state,
  getters: new_component_getters_default.a,
  mutations: new_component_mutations,
  actions: new_component_actions
};

/* harmony default export */ var new_component = (new_component_module);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__("kvU2");
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// CONCATENATED MODULE: ./src/state/modules/dom/image-uploader/state.js
/**
 * Dependencies
 */


/**
 * War Room State
 *
 * @type {Object}
 */
var image_uploader_state_state = {
  loading: false,
  data: {}

  /**
   * Return a fresh copy of the base state
   *
   * @return {Object}
   */
};var image_uploader_state_getState = function getState() {
  return cloneDeep_default()(image_uploader_state_state);
};

/* harmony default export */ var image_uploader_state = (image_uploader_state_getState());
// CONCATENATED MODULE: ./src/state/modules/dom/image-uploader/getters.js

/**
 * Determine if there is an uploaded photo in the state context
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_noPhotoUploaded = function noPhotoUploaded(state) {
  return keys_default()(state.data).length === 0;
};

/* harmony default export */ var image_uploader_getters = ({
  noPhotoUploaded: getters_noPhotoUploaded
});
// CONCATENATED MODULE: ./src/state/modules/dom/image-uploader/actions.js
/**
 * Toggle the new image creation modal
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var image_uploader_actions_toggleModal = function toggleModal(_ref) {
  var commit = _ref.commit;
  return commit('TOGGLE_MODAL');
};

/**
 * Set the photo data after successful upload
 *
 * @param  {Function} options.commit
 * @param  {Object} data
 * @return {Promise}
 */
var setPhoto = function setPhoto(_ref2, data) {
  var commit = _ref2.commit;
  return commit('SET_PHOTO', data);
};

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var image_uploader_actions_resetState = function resetState(_ref3) {
  var commit = _ref3.commit;
  return commit('RESET_STATE');
};

/**
 * Set the loading state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var setLoading = function setLoading(_ref4) {
  var commit = _ref4.commit;
  return commit('SET_LOADING');
};

/**
 * Reset the loading state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var resetLoading = function resetLoading(_ref5) {
  var commit = _ref5.commit;
  return commit('RESET_LOADING');
};

/* harmony default export */ var image_uploader_actions = ({
  setPhoto: setPhoto,
  setLoading: setLoading,
  resetState: image_uploader_actions_resetState,
  toggleModal: image_uploader_actions_toggleModal,
  resetLoading: resetLoading
});
// CONCATENATED MODULE: ./src/state/modules/dom/image-uploader/mutations.js

/**
 * Dependencies
 */


var image_uploader_mutations_TOGGLE_MODAL = function TOGGLE_MODAL(state) {
    state.showModal = !state.showModal;
};

var SET_PHOTO = function SET_PHOTO(state, data) {
    state.data = data;
};

var image_uploader_mutations_RESET_STATE = function RESET_STATE(state) {
    assign_default()(state, image_uploader_state_getState());
};

var image_uploader_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

var image_uploader_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/* harmony default export */ var image_uploader_mutations = ({
    SET_PHOTO: SET_PHOTO,
    SET_LOADING: image_uploader_mutations_SET_LOADING,
    RESET_STATE: image_uploader_mutations_RESET_STATE,
    TOGGLE_MODAL: image_uploader_mutations_TOGGLE_MODAL,
    RESET_LOADING: image_uploader_mutations_RESET_LOADING
});
// CONCATENATED MODULE: ./src/state/modules/dom/image-uploader/index.js
/**
 * Module Dependencies
 */





/**
 * DOM Image Uploader Module Declaration
 *
 * @type {Object}
 */
var image_uploader_module = {
  namespaced: true,
  state: image_uploader_state,
  getters: image_uploader_getters,
  mutations: image_uploader_mutations,
  actions: image_uploader_actions
};

/* harmony default export */ var image_uploader = (image_uploader_module);
// CONCATENATED MODULE: ./src/state/modules/dom/new-compset/state.js
/**
 * Dependencies
 */


/**
 * New Comp Set
 *
 * @type {Object}
 */
var new_compset_state_state = {
    selected: null,
    options: [{
        key: 'rent_comps',
        title: 'Rent Comps'
    }, {
        key: 'sales_comps',
        title: 'Sales Comps'
    }],
    data: null,
    loading: false,
    error: false

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var new_compset_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(new_compset_state_state);
};

/* harmony default export */ var new_compset_state = (new_compset_state_getState());
// EXTERNAL MODULE: ./src/state/modules/dom/new-compset/getters.js
var new_compset_getters = __webpack_require__("VRwF");
var new_compset_getters_default = /*#__PURE__*/__webpack_require__.n(new_compset_getters);

// CONCATENATED MODULE: ./src/state/modules/dom/new-compset/actions.js

/**
 * Dependencies
 */


/**
 * Submit a new generated table module
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} options.rootState
 * @param  {Object} options.state
 * @return {Void}
 */
var new_compset_actions_submit = function submit(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        rootState = _ref.rootState,
        state = _ref.state;

    var action = 'domAlt/createComponent';
    var data = new_compset_actions_getPostData(rootState, state);
    var options = { root: true };
    commit('SET_LOADING');
    commit('RESET_ERROR');
    dispatch(action, data, options).then(function (res) {
        commit('RESET_LOADING');
    }).catch(function () {
        commit('SET_ERROR');
        commit('RESET_LOADING');
    });
};

/**
 * Create a new rent comp
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {FormData} payload
 * @return {Promise}
 */
var actions_createComp = function createComp(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    return new promise_default.a(function (resolve, reject) {
        commit('SET_LOADING');
        commit('RESET_ERROR');
        HttpService["a" /* default */].post('comps/dashboard/' + payload.type + '/', payload.data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
            commit('RESET_LOADING');
            dispatch('addNotification', {
                title: res.data.message,
                text: 'Your comp has been saved and is available for selection.',
                type: 'success',
                timeout: 3000
            }, { root: true });
            resolve(res.data);
        }).catch(function (err) {
            return reject(err);
        });
    });
};

var actions_deleteRentComp = function deleteRentComp(_ref3, payload) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;

    var page = rootState.dom.newComponent.context.page;
    var position = rootState.dom.newComponent.context.position;
    HttpService["a" /* default */].del('comps/' + payload.comp.id).then(function (res) {
        commit('DELETE_RENT_COMP', {
            page: page,
            position: position,
            index: payload.index
        });
    });
};

var actions_fetchRentComps = function fetchRentComps(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return HttpService["a" /* default */].get('comps/dashboard/rent').then(function (res) {
        commit('FETCH_RENT_COMPS', res.data);
    });
};

var updateExistingRentComp = function updateExistingRentComp(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    console.log('hello there');
};

var addNewComp = function addNewComp(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    commit('SET_LOADING');
    commit('RESET_ERROR');
    commit('RESET_LOADING');
    dispatch('dom/newComponent/toggleModal', null, { root: true });
};

var updateExistingComp = function updateExistingComp(_ref7) {
    var commit = _ref7.commit;

    console.log('update!');
};

/**
 * Get the POST format for the module data
 *
 * @param  {Object} rootState
 * @param  {Object} state
 * @return {Object}
 */
var new_compset_actions_getPostData = function getPostData(rootState, state) {
    var page = rootState.dom.newComponent.context.page;
    var position = rootState.dom.newComponent.context.position;
    return {
        type: 'comp-set',
        component: { page: page },
        model: {
            position: position,
            value: {
                'title': null,
                'comp_ids': null,
                'selected_fields': ['address', 'total_sqft', 'total_units', 'weighted_avg_rent', 'rent_per_sqft', 'occupancy', 'year_built', 'year_renovated', 'notes']
            }
        }
    };
};

/**
 * Select an option and persist the component state
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {String} option
 * @return {Promise}
 */
var new_compset_actions_selectOption = function selectOption(_ref8, option) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return commit('SELECT_OPTION', option);
};

/* harmony default export */ var new_compset_actions = ({
    submit: new_compset_actions_submit,
    selectOption: new_compset_actions_selectOption,
    fetchRentComps: actions_fetchRentComps,
    createComp: actions_createComp,
    deleteRentComp: actions_deleteRentComp,
    updateExistingRentComp: updateExistingRentComp,
    addNewComp: addNewComp,
    updateExistingComp: updateExistingComp
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-compset/mutations.js

/**
 * Dependencies
 */


var CREATE_NEW_RENT_COMP = function CREATE_NEW_RENT_COMP(state, data) {
    state.data.push(data);
};

var DELETE_RENT_COMP = function DELETE_RENT_COMP(state, data) {
    state.data.splice(data.index, 1);
};

var FETCH_RENT_COMPS = function FETCH_RENT_COMPS(state, data) {
    state.data = data.data;
};

var new_compset_mutations_RESET_STATE = function RESET_STATE(state) {
    assign_default()(state, new_compset_state_getState());
};

var new_compset_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

var new_compset_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

var new_compset_mutations_SET_ERROR = function SET_ERROR(state) {
    state.error = true;
};

var new_compset_mutations_RESET_ERROR = function RESET_ERROR(state) {
    state.error = false;
};

var mutations_SET_OPTIONS = function SET_OPTIONS(state, data) {
    state.options = data;
};

var mutations_SELECT_OPTION = function SELECT_OPTION(state, option) {
    state.selected = option;
};

/* harmony default export */ var new_compset_mutations = ({
    FETCH_RENT_COMPS: FETCH_RENT_COMPS,
    CREATE_NEW_RENT_COMP: CREATE_NEW_RENT_COMP,
    DELETE_RENT_COMP: DELETE_RENT_COMP,
    SET_LOADING: new_compset_mutations_SET_LOADING,
    RESET_LOADING: new_compset_mutations_RESET_LOADING,
    SET_ERROR: new_compset_mutations_SET_ERROR,
    RESET_ERROR: new_compset_mutations_RESET_ERROR,
    RESET_STATE: new_compset_mutations_RESET_STATE,
    SET_OPTIONS: mutations_SET_OPTIONS,
    SELECT_OPTION: mutations_SELECT_OPTION
});
// CONCATENATED MODULE: ./src/state/modules/dom/new-compset/index.js
/**
 * Module Dependencies
 */





/**
 * New Compset Module Declaration
 *
 * @type {Object}
 */
var new_compset_module = {
  namespaced: true,
  state: new_compset_state,
  getters: new_compset_getters_default.a,
  mutations: new_compset_mutations,
  actions: new_compset_actions
};

/* harmony default export */ var new_compset = (new_compset_module);
// CONCATENATED MODULE: ./src/state/modules/dom/index.js
/**
 * Module Dependencies
 */











/**
 * War Room Module Declaration
 *
 * @type {Object}
 */
var dom_module = {
    namespaced: true,
    state: dom_state,
    getters: dom_getters,
    mutations: dom_mutations,
    actions: dom_actions,
    modules: {
        newText: new_text,
        newTable: new_table,
        newGenTable: new_gen_table,
        newComponent: new_component,
        imageUploader: image_uploader,
        newCompset: new_compset
    }
};

/* harmony default export */ var modules_dom = (dom_module);
// CONCATENATED MODULE: ./src/state/modules/importer/state.js
/**
 * Dependencies
 */


/**
 * State Definition
 *
 * @type {Object}
 */
var importer_state_state = {
    context: null,
    selectedStep: 0,
    imported_success: false,
    upload: {
        success: false,
        active: false,
        error: {},
        requestingAssistance: false,
        fileAssisted: false
    },
    data: {
        rentroll: {
            assistanceRequested: false,
            assistanceSuccess: false,
            assistanceMessage: null,
            attemptingImport: false,
            uploaded: false,
            loading: false,
            error: null,
            remapping: false,
            showTab: 0,
            data: {
                date: null,
                file_name: null,
                summary: {},
                table_data: {
                    data: [],
                    meta: {
                        number_of_rows: 0
                    }
                }
            },
            meta: {
                rentroll_file_id: null,
                assignment_options: {}
            },
            pagination: {
                currentPage: 1,
                pageLimit: 18
            },
            mapping: {}
        },
        pnl: {
            data: {}
        }
    },
    analysis: {
        loading: false,
        error: false,
        activeKey: 'opex',
        filterTerm: null,
        selectedItem: {},
        data: {
            meta: {
                time_frames: []
            },
            miscinc: {
                general: [],
                line_items: []
            },
            opex: {
                general: [],
                line_items: []
            }
        }
    },
    classification: {
        showInputBindings: true
    },
    importing: false,
    importSuccess: false

    /**
     * Return a state copy
     *
     * @return {Object}
     */
};var importer_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(importer_state_state);
};

/* harmony default export */ var importer_state = (importer_state_getState());
// CONCATENATED MODULE: ./src/state/modules/importer/getters.js

/**
 * Determine if there is an error in the state
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_hasError = function hasError(state) {
    return keys_default()(state.upload.error).length > 0;
};

/**
 * Determine if there is analysis data available
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_hasAnalysisData = function hasAnalysisData(state) {
    return keys_default()(state.analysis.data).length > 0;
};

/**
 * Return a normalized version of the filter key to use for narrowing down a list
 *
 * @param  {Object} state
 * @return {String}
 */
var normalizedFilterKey = function normalizedFilterKey(state) {
    return state.analysis.filterTerm ? state.analysis.filterTerm.toLowerCase() : '';
};

/**
 * Get a filtered list of sidebar items
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
var sidebarListItems = function sidebarListItems(state, getters) {
    return ['miscinc', 'opex'].reduce(function (topResult, key) {
        topResult[key] = state.analysis.data[key].line_items.map(function (i) {
            var obj = i;
            obj.show = i.name.toLowerCase().includes(getters.normalizedFilterKey);
            obj.type = key;
            return obj;
        }).reduce(function (result, i) {
            if (!result[i.category]) {
                result[i.category] = { items: [] };
            }
            result[i.category].items.push(i);
            return result;
        }, {});
        return topResult;
    }, { miscinc: {}, opex: {} });
};

/**
 * Determine if there is a selected item in state
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var getters_hasSelectedItem = function hasSelectedItem(state) {
    return keys_default()(state.analysis.selectedItem).length > 0;
};

/**
 * Total pages of data in the provided dataset
 *
 * @param  {Object} state
 * @return {Number}
 */
var importer_getters_totalPages = function totalPages(state) {
    var rows = state.data.rentroll.data.table_data.meta.number_of_rows + 1;
    var limit = state.data.rentroll.pagination.pageLimit;

    return Math.ceil(rows / limit);
};

/**
 * Get the offset for the dataset
 *
 * @return {Number}
 */
var importer_getters_offset = function offset(state) {
    return (state.data.rentroll.pagination.currentPage - 1) * state.data.rentroll.pagination.pageLimit;
};

/**
 * Paginated Dataset
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
var importer_getters_paginatedDataset = function paginatedDataset(state, getters) {
    return state.data.rentroll.data.table_data.data.map(function (row) {
        return {
            format: row.format,
            is_calculated_total: row.is_calculated_total,
            our_label: row.our_label,
            their_label: row.their_label,
            data: row.data.slice(getters.offset, state.data.rentroll.pagination.pageLimit * state.data.rentroll.pagination.currentPage)
        };
    });
};

/* harmony default export */ var importer_getters = ({
    offset: importer_getters_offset,
    hasError: getters_hasError,
    totalPages: importer_getters_totalPages,
    hasSelectedItem: getters_hasSelectedItem,
    hasAnalysisData: getters_hasAnalysisData,
    paginatedDataset: importer_getters_paginatedDataset,
    sidebarListItems: sidebarListItems,
    normalizedFilterKey: normalizedFilterKey
});
// CONCATENATED MODULE: ./src/state/modules/importer/actions.js

/**
 * Dependencies
 */


/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var importer_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;
    return commit('RESET_STATE');
};

/**
 * Change the selected step in the importer process
 *
 * @param  {Function} options.commit
 * @param  {Number} step
 * @return {Promise}
 */
var changeSelectedStep = function changeSelectedStep(_ref2, step) {
    var commit = _ref2.commit;
    return commit('CHANGE_STEP', step);
};

/**
 * Upload a rent roll or P&L file
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
var importer_actions_uploadFile = function uploadFile(_ref3, payload) {
    var commit = _ref3.commit;

    commit('SET_UPLOADING');
    HttpService["a" /* default */].post('data-import/import-files/' + payload.type + '/', payload.data).then(function (res) {
        commit('SET_CONTEXT', payload.type);
        commit('SET_FILE_DATA', { type: payload.type, data: res.data });
        commit('UPLOAD_SUCCESS');
        commit('RESET_UPLOADING');
    }).catch(function (err) {
        commit('SET_UPLOAD_ERROR', err.response.data);
        commit('UPLOAD_FAILED');
        commit('RESET_UPLOADING');
    });
};

/**
 * Allow the user to request assistance with a file that fails to upload properly
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
var importer_actions_requestFileAssistance = function requestFileAssistance(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var fileType = state.upload.error.rentroll_file_id ? 'rentroll_file_id' : 'opex_file_id';
    commit('REQUEST_FILE_ASSISTANCE');
    HttpService["a" /* default */].post('projects/import-file/' + state.upload.error[fileType] + '/support/').then(function (res) {
        return commit('SUPPORT_REQUEST_SUCCESS', res);
    }).catch(function (err) {
        return commit('SUPPORT_REQUEST_FAILURE', err);
    });
};

/**
 * Get the data analysis for an file.
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
var actions_getAnalysis = function getAnalysis(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return new promise_default.a(function (resolve, reject) {
        commit('SET_ANALYSIS_LOADING');
        HttpService["a" /* default */].get('data-import/import-files/' + state.data[state.context].data.meta[state.context + '_file_id'] + '/analysis/').then(function (_ref6) {
            var data = _ref6.data;

            data.opex.general[0].type = 'opex';
            data.opex.general[0].name = 'Operating Expenses';
            data.miscinc.general[0].type = 'miscinc';
            data.miscinc.general[0].name = 'Miscellaneous Income';
            commit('SET_ANALYSIS_DATA', data);
            commit('RESET_ANALYSIS_LOADING');
            resolve();
        }).catch(function (err) {
            commit('SET_ANALYSIS_ERROR');
            commit('RESET_ANALYSIS_LOADING');
            reject(err);
        });
    });
};

/**
 * Update the filter string
 *
 * @param  {Function} options.commit
 * @param  {String} value
 * @return {Promise}
 */
var updateFilterValue = function updateFilterValue(_ref7, value) {
    var commit = _ref7.commit;
    return commit('UPDATE_FILTER_VALUE', value);
};

/**
 * Update the actively viewed item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var changeActiveItem = function changeActiveItem(_ref8, payload) {
    var commit = _ref8.commit;

    console.log(payload);
    commit('CHANGE_ACTIVE_ITEM', payload);
};

/**
 * Update the selected timeframe for a line item
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {String} timeframe
 * @return {Void}
 */
var actions_updateTimeframe = function updateTimeframe(_ref9, timeframe) {
    var commit = _ref9.commit,
        state = _ref9.state,
        getters = _ref9.getters,
        dispatch = _ref9.dispatch;
    return new promise_default.a(function (resolve, reject) {
        var url = 'data-import/import-files/' + state.data[state.context].data.meta[state.context + '_file_id'] + '/analysis/';
        var data = getters.sidebarListItems[state.analysis.selectedItem.type][state.analysis.selectedItem.category].items.filter(function (i) {
            if (state.analysis.selectedItem.index === null) return true;
            return i.index === state.analysis.selectedItem.index;
        }).map(function (i) {
            return { index: i.index, time_frame: timeframe };
        });
        if (state.analysis.selectedItem.index !== null) {
            commit('SET_CURRENT_TIMEFRAME', timeframe);
        }
        HttpService["a" /* default */].patch(url, { time_frames: data }).then(function (res) {
            dispatch('getAnalysis');
            resolve();
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Adjust an item's value
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_adjustValue = function adjustValue(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state;
    return new promise_default.a(function (resolve, reject) {
        var url = 'data-import/import-files/' + state.data[state.context].data.meta[state.context + '_file_id'] + '/analysis/';
        HttpService["a" /* default */].patch(url, {
            values: [{
                index: state.analysis.selectedItem.index,
                data: {
                    index: state.analysis.data.meta.date_indexes[payload.dataIndex],
                    value: payload.value
                }
            }]
        }).then(function (res) {
            commit('UPDATE_LINE_ITEM_VALUE', {
                targetIndex: res.data.data[0].index,
                dataIndex: payload.dataIndex,
                value: payload.value
            });
            commit('UPDATE_ANNUALIZED_AMOUNTS', res.data.data[0]);
            resolve();
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Process the import
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_processImport = function processImport(_ref11) {
    var commit = _ref11.commit;
    return new promise_default.a(function (resolve, reject) {
        setTimeout(function () {
            commit('SET_IMPORT_SUCCESS');
            resolve();
        }, 1500);
    });
};

/**
 * Reset the analysis state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var resetAnalysis = function resetAnalysis(_ref12) {
    var commit = _ref12.commit;
    return commit('RESET_ANALYSIS_STATE');
};

/**
 * Toggle showing the the input/output bindings
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var importer_actions_toggleInputBindings = function toggleInputBindings(_ref13) {
    var commit = _ref13.commit;
    return commit('TOGGLE_INPUT_BINDINGS');
};

/**
 * Update the category for an existing output item
 *
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
var importer_actions_updateCategory = function updateCategory(_ref14, payload) {
    var commit = _ref14.commit,
        state = _ref14.state,
        dispatch = _ref14.dispatch;

    HttpService["a" /* default */].patch('data-import/import-files/' + state.data[state.context].data.meta[state.context + '_file_id'] + '/update/', payload).then(function (res) {
        commit('SET_FILE_DATA', { type: state.context, data: res.data });
        dispatch('addNotification', {
            title: 'Item Reassigned',
            type: 'success',
            text: 'The line item was successfully recategorized',
            timeout: true
        }, { root: true });
    }).catch(function (e) {
        dispatch('addNotification', {
            title: 'Error',
            type: 'error',
            text: 'There was a problem uploading your file.',
            timeout: true
        }, { root: true });
    });
};

/**
 * Next page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var importer_actions_nextPage = function nextPage(_ref15) {
    var commit = _ref15.commit;
    return commit('PAGINATE_FORWARD');
};

/**
 * Previous Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var importer_actions_prevPage = function prevPage(_ref16) {
    var commit = _ref16.commit;
    return commit('PAGINATE_BACKWARD');
};

/**
 * First Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_firstPage = function firstPage(_ref17) {
    var commit = _ref17.commit;
    return commit('PAGINATE_FIRST');
};

/**
 * Last Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var actions_lastPage = function lastPage(_ref18) {
    var commit = _ref18.commit;
    return commit('PAGINATE_LAST');
};

/**
 * Execute call to update a user's file mapping
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var importer_actions_updateMapping = function updateMapping(_ref19, payload) {
    var commit = _ref19.commit,
        state = _ref19.state,
        dispatch = _ref19.dispatch;

    var url = 'data-import/import-files/' + state.data.rentroll.data.meta.rentroll_file_id + '/update/';

    commit('SET_UPDATE_MAPPING');
    HttpService["a" /* default */].patch(url, { mapping: payload }).then(function (res) {
        setTimeout(function () {
            commit('LOAD_NEW_MAPPING', res.data);
            commit('RESET_UPDATE_MAPPING');
            dispatch('addNotification', {
                type: 'success',
                title: 'Mapping Updated',
                text: 'The file mappings have been updated successfully.',
                timeout: true
            }, { root: true });
        }, 1500);
    }).catch(function (err) {
        setTimeout(function () {
            commit('RESET_UPDATE_MAPPING', err);
        }, 1500);
    });
};

/**
 * Update the selected tab
 *
 * @param  {Function} options.commit
 * @param  {Number} tab
 * @return {Promise}
 */
var actions_changeTab = function changeTab(_ref20, tab) {
    var commit = _ref20.commit;
    return commit('CHANGE_TAB', tab);
};

/**
 * Import the data into a project
 *
 * @param  {Object} options.state
 * @param  {Function} options.dispatch
 * @return {Promise}
 */
var actions_importPnlData = function importPnlData(_ref21) {
    var state = _ref21.state,
        dispatch = _ref21.dispatch,
        commit = _ref21.commit;
    return new promise_default.a(function (resolve, reject) {
        commit('SET_IMPORTING');
        HttpService["a" /* default */].get('data-import/import-files/' + state.data[state.context].data.meta[state.context + '_file_id'] + '/import/').then(function (res) {
            dispatch('projects/form/ingestOpexValues', res.data, {
                root: true
            });
            commit('RESET_IMPORTING');
            commit('IMPORT_SUCCESSFUL');
            resolve(res);
        }).catch(function (err) {
            dispatch('addNotification', {
                type: 'error',
                title: 'Import failed',
                text: err.response.data,
                timeout: true
            }, { root: true });
            commit('RESET_IMPORTING');
            reject(err);
        });
    });
};

/**
 * Update the mappings and get a new rendered dataset
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
var actions_importRentRollData = function importRentRollData(_ref22) {
    var commit = _ref22.commit,
        state = _ref22.state,
        dispatch = _ref22.dispatch;
    return new promise_default.a(function (resolve, reject) {
        commit('SET_IMPORTING');
        HttpService["a" /* default */].get('data-import/import-files/' + state.data[state.context].data.meta[state.context + '_file_id'] + '/import/').then(function (res) {
            commit('projects/form/IMPORT_UNIT_VALUES', res.data, { root: true });
            commit('projects/form/UPDATE_FILE_ID', {
                id: state.data[state.context].data.meta[state.context + '_file_id'],
                type: 'rentroll_file_id'
            }, { root: true });
            dispatch('addNotification', {
                type: 'success',
                title: 'Rent Roll Imported',
                text: 'Rent Roll was successfully imported to your project.',
                timeout: true
            }, { root: true });
            commit('RESET_IMPORTING');
            commit('IMPORT_SUCCESSFUL');
            resolve();
        }).catch(function (err) {
            dispatch('addNotification', {
                type: 'error',
                title: 'Import Failed',
                text: 'Rent Roll was not successfully imported.',
                timeout: true
            }, { root: true });
            commit('RESET_IMPORTING');
            reject(err);
        });
    });
};

/* harmony default export */ var importer_actions = ({
    nextPage: importer_actions_nextPage,
    prevPage: importer_actions_prevPage,
    lastPage: actions_lastPage,
    changeTab: actions_changeTab,
    firstPage: actions_firstPage,
    resetState: importer_actions_resetState,
    uploadFile: importer_actions_uploadFile,
    getAnalysis: actions_getAnalysis,
    adjustValue: actions_adjustValue,
    updateMapping: importer_actions_updateMapping,
    resetAnalysis: resetAnalysis,
    importPnlData: actions_importPnlData,
    processImport: actions_processImport,
    updateCategory: importer_actions_updateCategory,
    updateTimeframe: actions_updateTimeframe,
    changeActiveItem: changeActiveItem,
    updateFilterValue: updateFilterValue,
    importRentRollData: actions_importRentRollData,
    changeSelectedStep: changeSelectedStep,
    toggleInputBindings: importer_actions_toggleInputBindings,
    requestFileAssistance: importer_actions_requestFileAssistance
});
// CONCATENATED MODULE: ./src/state/modules/importer/mutations.js
/**
 * Dependencies
 */



var getListItem = function getListItem(state, key) {
    return state.analysis.data[key].line_items.find(function (i) {
        return i.index === state.analysis.selectedItem.index;
    });
};

var importer_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = importer_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

var mutations_CHANGE_STEP = function CHANGE_STEP(state, step) {
    state.selectedStep = step;
};

var SET_FILE_DATA = function SET_FILE_DATA(state, payload) {
    state.data[payload.type].data = payload.data;
};

var SET_UPLOADING = function SET_UPLOADING(state) {
    state.upload.active = true;
};

var RESET_UPLOADING = function RESET_UPLOADING(state) {
    state.upload.active = false;
};

var SET_UPLOAD_ERROR = function SET_UPLOAD_ERROR(state, payload) {
    state.upload.error = payload;
};

var UPLOAD_SUCCESS = function UPLOAD_SUCCESS(state) {
    state.upload.success = true;
};

var UPLOAD_FAILED = function UPLOAD_FAILED(state) {
    state.upload.success = false;
};

var importer_mutations_REQUEST_FILE_ASSISTANCE = function REQUEST_FILE_ASSISTANCE(state) {
    state.upload.requestingAssistance = true;
};

var importer_mutations_SUPPORT_REQUEST_SUCCESS = function SUPPORT_REQUEST_SUCCESS(state) {
    state.upload.fileAssisted = true;
    state.upload.requestingAssistance = false;
};

var importer_mutations_SUPPORT_REQUEST_FAILURE = function SUPPORT_REQUEST_FAILURE(state) {
    state.upload.fileAssisted = false;
    state.upload.requestingAssistance = false;
};

var importer_mutations_SET_CONTEXT = function SET_CONTEXT(state, context) {
    state.context = context;
};

var SET_ANALYSIS_DATA = function SET_ANALYSIS_DATA(state, data) {
    state.analysis.data = data;
};

var SET_ANALYSIS_LOADING = function SET_ANALYSIS_LOADING(state) {
    state.analysis.loading = false;
};

var RESET_ANALYSIS_LOADING = function RESET_ANALYSIS_LOADING(state) {
    state.analysis.loading = false;
};

var SET_ANALYSIS_ERROR = function SET_ANALYSIS_ERROR(state) {
    state.analysis.error = true;
};

var UPDATE_FILTER_VALUE = function UPDATE_FILTER_VALUE(state, value) {
    state.analysis.filterTerm = value;
};

var CHANGE_ACTIVE_ITEM = function CHANGE_ACTIVE_ITEM(state, payload) {
    state.analysis.selectedItem = payload;
};

var SET_CURRENT_TIMEFRAME = function SET_CURRENT_TIMEFRAME(state, timeframe) {
    state.analysis.selectedItem.time_frame = timeframe;
};

var UPDATE_ANNUALIZED_AMOUNTS = function UPDATE_ANNUALIZED_AMOUNTS(state, payload) {
    var types = ['miscinc', 'opex'];
    state.analysis.selectedItem.annualized_amounts = payload.annualized_amounts;
    types.forEach(function (type) {
        state.analysis.data[type].line_items.forEach(function (i) {
            if (i.index === payload.index) {
                i.annualized_amounts = payload.annualized_amounts;
            }
        });
    });
};

var SET_IMPORT_SUCCESS = function SET_IMPORT_SUCCESS(state) {
    state.imported_success = true;
};

var UPDATE_LINE_ITEM_VALUE = function UPDATE_LINE_ITEM_VALUE(state, payload) {
    var obj = getListItem(state, 'opex') || getListItem(state, 'miscinc');
    state.analysis.selectedItem.values[payload.dataIndex].adjusted = payload.value;
    obj.values[payload.dataIndex].adjusted = payload.value === obj.values[payload.dataIndex].file ? null : payload.value;
};

var RESET_ANALYSIS_STATE = function RESET_ANALYSIS_STATE(state) {
    state.analysis = {
        loading: false,
        error: false,
        activeKey: 'opex',
        filterTerm: null,
        selectedItem: {},
        data: {
            meta: {
                time_frames: []
            },
            miscinc: {
                general: [],
                line_items: []
            },
            opex: {
                general: [],
                line_items: []
            }
        }
    };
};

var mutations_TOGGLE_INPUT_BINDINGS = function TOGGLE_INPUT_BINDINGS(state) {
    state.classification.showInputBindings = !state.classification.showInputBindings;
};

var mutations_PAGINATE_FORWARD = function PAGINATE_FORWARD(state) {
    state.data.rentroll.pagination.currentPage++;
};

var mutations_PAGINATE_BACKWARD = function PAGINATE_BACKWARD(state) {
    state.data.rentroll.pagination.currentPage--;
};

var mutations_PAGINATE_FIRST = function PAGINATE_FIRST(state) {
    state.data.rentroll.pagination.currentPage = 1;
};

var mutations_PAGINATE_LAST = function PAGINATE_LAST(state) {
    var rows = state.data.rentroll.data.table_data.meta.number_of_rows + 1;
    var limit = state.data.rentroll.pagination.pageLimit;

    state.data.rentroll.pagination.currentPage = Math.ceil(rows / limit);
};

var importer_mutations_CHANGE_TAB = function CHANGE_TAB(state, tab) {
    state.data.rentroll.showTab = tab;
};

var mutations_LOAD_NEW_MAPPING = function LOAD_NEW_MAPPING(state, payload) {
    state.data.rentroll.data.summary = payload.summary;
    state.data.rentroll.data.table_data = payload.table_data;
    state.data.rentroll.data.meta.assigment_options = payload.meta.assigment_options;
    state.data.rentroll.data.mapping = payload.mapping;
};

var mutations_SET_UPDATE_MAPPING = function SET_UPDATE_MAPPING(state) {
    state.data.rentroll.remapping = true;
};

var mutations_RESET_UPDATE_MAPPING = function RESET_UPDATE_MAPPING(state) {
    state.data.rentroll.remapping = false;
};

var SET_IMPORTING = function SET_IMPORTING(state) {
    state.importing = true;
};

var RESET_IMPORTING = function RESET_IMPORTING(state) {
    state.importing = false;
};

var mutations_IMPORT_SUCCESSFUL = function IMPORT_SUCCESSFUL(state) {
    state.importSuccess = true;
};

/* harmony default export */ var importer_mutations = ({
    RESET_STATE: importer_mutations_RESET_STATE,
    CHANGE_STEP: mutations_CHANGE_STEP,
    SET_CONTEXT: importer_mutations_SET_CONTEXT,
    SET_IMPORTING: SET_IMPORTING,
    UPLOAD_FAILED: UPLOAD_FAILED,
    SET_FILE_DATA: SET_FILE_DATA,
    SET_UPLOADING: SET_UPLOADING,
    UPLOAD_SUCCESS: UPLOAD_SUCCESS,
    RESET_IMPORTING: RESET_IMPORTING,
    RESET_UPLOADING: RESET_UPLOADING,
    SET_UPLOAD_ERROR: SET_UPLOAD_ERROR,
    IMPORT_SUCCESSFUL: mutations_IMPORT_SUCCESSFUL,
    SET_ANALYSIS_DATA: SET_ANALYSIS_DATA,
    CHANGE_ACTIVE_ITEM: CHANGE_ACTIVE_ITEM,
    SET_ANALYSIS_ERROR: SET_ANALYSIS_ERROR,
    SET_IMPORT_SUCCESS: SET_IMPORT_SUCCESS,
    UPDATE_FILTER_VALUE: UPDATE_FILTER_VALUE,
    RESET_ANALYSIS_STATE: RESET_ANALYSIS_STATE,
    SET_ANALYSIS_LOADING: SET_ANALYSIS_LOADING,
    TOGGLE_INPUT_BINDINGS: mutations_TOGGLE_INPUT_BINDINGS,
    SET_CURRENT_TIMEFRAME: SET_CURRENT_TIMEFRAME,
    UPDATE_LINE_ITEM_VALUE: UPDATE_LINE_ITEM_VALUE,
    RESET_ANALYSIS_LOADING: RESET_ANALYSIS_LOADING,
    REQUEST_FILE_ASSISTANCE: importer_mutations_REQUEST_FILE_ASSISTANCE,
    SUPPORT_REQUEST_SUCCESS: importer_mutations_SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE: importer_mutations_SUPPORT_REQUEST_FAILURE,
    UPDATE_ANNUALIZED_AMOUNTS: UPDATE_ANNUALIZED_AMOUNTS,

    // Rent Roll Mutations
    CHANGE_TAB: importer_mutations_CHANGE_TAB,
    PAGINATE_LAST: mutations_PAGINATE_LAST,
    PAGINATE_FIRST: mutations_PAGINATE_FIRST,
    LOAD_NEW_MAPPING: mutations_LOAD_NEW_MAPPING,
    PAGINATE_FORWARD: mutations_PAGINATE_FORWARD,
    PAGINATE_BACKWARD: mutations_PAGINATE_BACKWARD,
    SET_UPDATE_MAPPING: mutations_SET_UPDATE_MAPPING,
    RESET_UPDATE_MAPPING: mutations_RESET_UPDATE_MAPPING
});
// CONCATENATED MODULE: ./src/state/modules/importer/index.js
/**
 * Module Dependencies
 */





/**
 * Module
 *
 * @type {Object}
 */
var importer_module = {
  namespaced: true,
  state: importer_state,
  getters: importer_getters,
  mutations: importer_mutations,
  actions: importer_actions
};

/* harmony default export */ var importer = (importer_module);
// CONCATENATED MODULE: ./src/state/modules/dom-alt/state.js
/**
 * Dependencies
 */


/**
 * War Room State
 *
 * @type {Object}
 */
var dom_alt_state_state = {
    loading: false,
    isEditing: false,
    showMenu: false,
    data: {
        meta: {
            address: {},
            company_resources: {}
        },
        sections: []
    },
    newPageModal: {
        showModal: false,
        sectionId: null,
        sectionIndex: null,
        pageId: null,
        pageIndex: null
    },
    layouts: [{ name: 'layout_one', components: 4 }, { name: 'layout_two', components: 3 }, { name: 'layout_three', components: 2 }, { name: 'layout_four', components: 3 }, { name: 'layout_five', components: 2 }, { name: 'layout_six', components: 3 }, { name: 'layout_seven', components: 1 }, { name: 'layout_eight', components: 3 }, { name: 'layout_nine', components: 9 }, { name: 'layout_ten', components: 6 }]

    /**
     * Return a fresh copy of the base state
     *
     * @return {Object}
     */
};var dom_alt_state_getState = function getState() {
    return Object(lodash["cloneDeep"])(dom_alt_state_state);
};

/* harmony default export */ var dom_alt_state = (dom_alt_state_getState());
// CONCATENATED MODULE: ./src/state/modules/dom-alt/getters.js
/**
 * Determine if there are sections in the DOM
 *
 * @param  {Object} state
 * @return {Boolean}
 */
var hasSections = function hasSections(state) {
    return state.data.sections.length > 0;
};

/**
 * Return the branding or default branding from the account
 *
 * @param  {Object} state
 * @return {Object}
 */
var branding = function branding(state) {
    return {
        logo: state.data.meta.company_resources.logo,
        primary_color: state.data.meta.company_resources.primary_color || '#173158',
        secondary_color: state.data.meta.company_resources.secondary_color || '#f5f5f5'
    };
};

/* harmony default export */ var dom_alt_getters = ({
    branding: branding,
    hasSections: hasSections
});
// CONCATENATED MODULE: ./src/services/DomService.js
/**
 * Transform the Digital OM to include empty and filled component states
 *
 * @param  {Array} layouts
 * @param  {Object} DOM
 * @return {Object}
 */
var normalizeComponents = function normalizeComponents(layouts, dom) {
    dom.sections = dom.sections.map(function (section) {
        section.pages = section.pages.map(function (page) {
            var totalComponents = layouts.find(function (i) {
                return i.name === page.layout;
            }).components;
            var arr = new Array(totalComponents).fill({}).map(function (item, idx) {
                return {
                    id: null,
                    meta: {},
                    page: page.id,
                    position: idx,
                    type: null,
                    value: null
                };
            });
            page.components.forEach(function (i) {
                arr[i.position] = i;
            });
            page.components = arr;
            return page;
        });
        return section;
    });
    return dom;
};
// CONCATENATED MODULE: ./src/state/modules/dom-alt/actions.js

/**
 * Dependencies
 */



/**
 * Reset the back to the original state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var dom_alt_actions_resetState = function resetState(_ref) {
    var commit = _ref.commit;
    return commit('RESET_STATE');
};

/**
 * Reorder a set of pages
 *
 * @param  {Function} options.commit
 * @param  {Objec} payload
 * @return {Void}
 */
var dom_alt_actions_reorderPages = function reorderPages(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    HttpService["a" /* default */].put('dom/sections/' + state.data.sections[payload.sectionIndex].id + '/re-order/', {
        ordering: payload.list.map(function (i) {
            return i.id;
        })
    });
    commit('REORDER_PAGES', payload);
};

/**
 * Reorder top-level sections
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Object} payload
 * @return {Void}
 */
var actions_reorderSections = function reorderSections(_ref3, payload) {
    var commit = _ref3.commit,
        state = _ref3.state;

    HttpService["a" /* default */].put('dom/digital-oms/' + state.data.id + '/re-order/', {
        ordering: payload.map(function (i) {
            return i.id;
        })
    });
    commit('REORDER_SECTIONS', payload);
};

/**
 * Get the OM
 *
 * @param  {Object} state
 * @return {Promise}
 */
var actions_fetchDOM = function fetchDOM(_ref4) {
    var commit = _ref4.commit,
        rootState = _ref4.rootState,
        state = _ref4.state;
    return new promise_default.a(function (resolve, reject) {
        commit('SET_LOADING');
        HttpService["a" /* default */].get('projects/' + rootState.route.params.projectId + '/digital-om/').then(function (res) {
            var dom = normalizeComponents(state.layouts, res.data.digital_om);
            commit('SET_DOM', dom);
            commit('RESET_LOADING');
            resolve();
        }).catch(function (err) {
            commit('RESET_LOADING');
            reject(err);
        });
    });
};

/**
 * Toggle the navigation menu
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var toggleNav = function toggleNav(_ref5) {
    var commit = _ref5.commit;
    return commit('TOGGLE_NAV');
};

/**
 * Toggle the editing state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var toggleEdit = function toggleEdit(_ref6) {
    var commit = _ref6.commit;
    return commit('TOGGLE_EDIT');
};

/**
 * Toggle the page selection dialog
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
var togglePageSelectionModal = function togglePageSelectionModal(_ref7) {
    var commit = _ref7.commit;
    return commit('TOGGLE_PAGE_SELECTION_MODAL');
};

/**
 * Open the page selection modal
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var actions_selectPageLayout = function selectPageLayout(_ref8, payload) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    commit('SET_NEW_PAGE_OPTIONS', payload);
    dispatch('togglePageSelectionModal');
};

var dom_alt_actions_getSection = function getSection(_ref9, id) {
    var commit = _ref9.commit;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].get('dom/sections/' + id).then(function (res) {
            return resolve(res.data);
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Create a DOM section
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var dom_alt_actions_createSection = function createSection(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post('dom/digital-oms/' + state.data.id + '/sections/', payload).then(function (res) {
            commit('APPEND_SECTION', {
                digital_om: state.data.id,
                id: res.data.section_id,
                is_visible: payload.is_visible,
                order: state.data.sections.length,
                pages: [],
                title: payload.title
            });
            resolve(res.data.section_id);
        }).catch(function (err) {
            return reject(err);
        });
    });
};

var dom_alt_actions_deleteSection = function deleteSection(_ref11, id) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    if (window.confirm('Are you sure you want to remove this section?')) {
        HttpService["a" /* default */].del('dom/sections/' + id + '/').then(function (res) {
            commit('DELETE_SECTION', id);
            dispatch('addNotification', {
                type: 'success',
                timeout: true,
                title: 'Success',
                text: 'The section was successfully removed'
            }, { root: true });
        });
    }
};

var dom_alt_actions_patchSection = function patchSection(_ref12, payload) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    HttpService["a" /* default */].patch('dom/sections/' + payload.sectionId + '/', {
        title: payload.title
    }).then(function (res) {
        commit('PATCH_SECTION', {
            sectionIndex: payload.sectionIndex,
            title: payload.title
        });
        dispatch('addNotification', {
            type: 'success',
            timeout: true,
            title: 'Success',
            text: 'The section title was successfully updated'
        }, { root: true });
    });
};

// Page Actions //

/**
 * Create a new page
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var dom_alt_actions_createPage = function createPage(_ref13, payload) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].post('dom/sections/' + payload.sectionId + '/pages/', {
            layout: payload.layout.name,
            title: payload.title
        }).then(function (res) {
            dispatch('getPage', res.data.page_id).then(function (page) {
                page.components = new Array(payload.layout.components).fill({}).map(function (item, idx) {
                    return {
                        id: null,
                        meta: {},
                        page: page.id,
                        position: idx,
                        type: null,
                        value: null
                    };
                });
                commit('ADD_PAGE', { sectionId: payload.sectionId, page: page });
                resolve();
            });
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Get a DOM page by ID
 *
 * @param  {Number} id)
 * @return {Promise}
 */
var dom_alt_actions_getPage = function getPage(_ref14, id) {
    var commit = _ref14.commit;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].get('dom/pages/' + id + '/').then(function (res) {
            return resolve(res.data);
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Patch a DOM page by ID
 *
 * @param  {Number} id)
 * @return {Promise}
 */
var dom_alt_actions_patchPage = function patchPage(_ref15, payload) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    HttpService["a" /* default */].patch('dom/pages/' + payload.pageId + '/', {
        layout: payload.layout,
        title: payload.title
    }).then(function () {
        dispatch('getSection', payload.sectionId).then(function (res) {
            commit('PATCH_PAGE', {
                sectionIndex: res.order,
                pageIndex: payload.pageIndex,
                title: payload.title
            });
            dispatch('addNotification', {
                type: 'success',
                timeout: true,
                title: 'Success',
                text: 'The page was successfully updated'
            }, { root: true });
        });
    });
};

var dom_alt_actions_deletePage = function deletePage(_ref16, payload) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    var confirm = window.confirm('Are you sure you want to delete this page?');
    if (confirm) {
        HttpService["a" /* default */].del('dom/pages/' + payload.pageId).then(function (res) {
            dispatch('getSection', payload.sectionId).then(function (res) {
                if (res.title.toLowerCase() === 'sectionless') {
                    dispatch('deleteSection', {
                        sectionId: payload.sectionId,
                        sectionIndex: res.order
                    });
                }
                commit('DELETE_PAGE', {
                    sectionIndex: res.order,
                    pageIndex: payload.pageIndex
                });
            });
        });
    }
};

/**
 * Create a component
 *
 * @param  {Function} options.commit
 * @param  {Object} payload)
 * @return {Promise}
 */
var dom_alt_actions_createComponent = function createComponent(_ref17, payload) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;
    return new promise_default.a(function (resolve, reject) {
        var page = payload.component.page;
        var type = payload.type.replace(/_/, '-');
        HttpService["a" /* default */].post('dom/pages/' + page + '/components/' + type + '/', payload.model).then(function (res) {
            HttpService["a" /* default */].get('dom/components/' + res.data.component_id + '/').then(function (comp) {
                dispatch('addNotification', {
                    type: 'success',
                    timeout: true,
                    title: 'Success',
                    text: 'The component was successfully added to the Digital OM'
                }, { root: true });
                commit('SET_COMPONENT', comp.data);
                resolve();
            });
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Remove a component
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_removeComponent = function removeComponent(_ref18, component) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].del('dom/components/' + component.id + '/').then(function (res) {
            commit('SET_COMPONENT', {
                id: null,
                meta: {},
                page: component.page,
                position: component.position,
                type: null,
                value: null
            });
            dispatch('addNotification', {
                type: 'warning',
                timeout: true,
                title: 'Success',
                text: 'The component was successfully removed from the Digital OM'
            }, { root: true });
            resolve();
        }).catch(function (err) {
            return reject(err);
        });
    });
};

/**
 * Update a given component and replace its state
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} payload
 * @return {Promise}
 */
var actions_updateComponent = function updateComponent(_ref19, payload) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;
    return new promise_default.a(function (resolve, reject) {
        HttpService["a" /* default */].patch('dom/components/' + payload.id + '/', payload).then(function (res) {
            commit('SET_COMPONENT', res.data.data);
            dispatch('addNotification', {
                type: 'success',
                timeout: true,
                title: 'Component Updated',
                text: 'The component was successfully updated'
            }, { root: true });
            resolve();
        }).catch(function () {
            dispatch('addNotification', {
                type: 'error',
                timeout: true,
                title: 'Component Failed to Update',
                text: 'The component was not successfully updated'
            }, { root: true });
        });
    });
};

/**
 * Replace a component in-place
 *
 * @param  {Function} options.commit
 * @param  {Object} data
 * @return {Promise}
 */
var replaceComponent = function replaceComponent(_ref20, data) {
    var commit = _ref20.commit;
    return commit('SET_COMPONENT', data);
};

/* harmony default export */ var dom_alt_actions = ({
    getPage: dom_alt_actions_getPage,
    patchPage: dom_alt_actions_patchPage,
    deletePage: dom_alt_actions_deletePage,
    fetchDOM: actions_fetchDOM,
    toggleNav: toggleNav,
    toggleEdit: toggleEdit,
    resetState: dom_alt_actions_resetState,
    createPage: dom_alt_actions_createPage,
    reorderPages: dom_alt_actions_reorderPages,
    getSection: dom_alt_actions_getSection,
    createSection: dom_alt_actions_createSection,
    updateComponent: actions_updateComponent,
    patchSection: dom_alt_actions_patchSection,
    deleteSection: dom_alt_actions_deleteSection,
    removeComponent: actions_removeComponent,
    createComponent: dom_alt_actions_createComponent,
    reorderSections: actions_reorderSections,
    selectPageLayout: actions_selectPageLayout,
    replaceComponent: replaceComponent,
    togglePageSelectionModal: togglePageSelectionModal
});
// CONCATENATED MODULE: ./src/state/modules/dom-alt/mutations.js
/**
 * Dependencies
 */



var SET_DOM = function SET_DOM(state, data) {
    state.data = data;
};

var dom_alt_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

var dom_alt_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

var TOGGLE_NAV = function TOGGLE_NAV(state) {
    state.showMenu = !state.showMenu;
};

var TOGGLE_EDIT = function TOGGLE_EDIT(state) {
    state.isEditing = !state.isEditing;
};

var dom_alt_mutations_RESET_STATE = function RESET_STATE(state) {
    var originalState = dom_alt_state_getState();
    for (var prop in originalState) {
        vue_esm["a" /* default */].set(state, prop, originalState[prop]);
    }
};

var TOGGLE_PAGE_SELECTION_MODAL = function TOGGLE_PAGE_SELECTION_MODAL(state) {
    state.newPageModal.showModal = !state.newPageModal.showModal;
};

var mutations_REORDER_PAGES = function REORDER_PAGES(state, payload) {
    payload.list.map(function (item, index) {
        item['order'] = index;
    });
    state.data.sections[payload.sectionIndex].pages = payload.list;
};

var REORDER_SECTIONS = function REORDER_SECTIONS(state, payload) {
    payload.map(function (item, index) {
        item['order'] = index;
    });
    state.data.sections = payload;
};

var SET_NEW_PAGE_OPTIONS = function SET_NEW_PAGE_OPTIONS(state, payload) {
    state.newPageModal.sectionId = payload.sectionId;
    state.newPageModal.sectionIndex = payload.sectionIndex;
    state.newPageModal.pageIndex = payload.pageIndex;
};

var PATCH_PAGE = function PATCH_PAGE(state, payload) {
    var page = state.data.sections[payload.sectionIndex].pages[payload.pageIndex];
    page['title'] = payload.title;
    state.data.sections[payload.sectionIndex].pages.splice(payload.pageIndex, 1, page);
};

var DELETE_PAGE = function DELETE_PAGE(state, payload) {
    state.data.sections[payload.sectionIndex].pages.splice(payload.pageIndex, 1);
};

var APPEND_SECTION = function APPEND_SECTION(state, payload) {
    state.data.sections.push(payload);
};

var DELETE_SECTION = function DELETE_SECTION(state, id) {
    state.data.sections = state.data.sections.filter(function (s) {
        return s.id !== id;
    });
};

var PATCH_SECTION = function PATCH_SECTION(state, payload) {
    var section = state.data.sections[payload.sectionIndex];
    section['title'] = payload.title;
    state.data.sections.splice(payload.sectionIndex, 1, section);
};

var ADD_PAGE = function ADD_PAGE(state, payload) {
    var section = state.data.sections.find(function (s) {
        return s.id === payload.sectionId;
    });
    section.pages.push(payload.page);
};

var SET_COMPONENT = function SET_COMPONENT(state, component) {
    state.data.sections.forEach(function (section) {
        section.pages.forEach(function (page) {
            if (page.id === component.page) {
                page.components.splice(component.position, 1, component);
            }
        });
    });
};

/* harmony default export */ var dom_alt_mutations = ({
    SET_DOM: SET_DOM,
    ADD_PAGE: ADD_PAGE,
    PATCH_PAGE: PATCH_PAGE,
    DELETE_PAGE: DELETE_PAGE,
    TOGGLE_NAV: TOGGLE_NAV,
    RESET_STATE: dom_alt_mutations_RESET_STATE,
    TOGGLE_EDIT: TOGGLE_EDIT,
    SET_LOADING: dom_alt_mutations_SET_LOADING,
    SET_COMPONENT: SET_COMPONENT,
    RESET_LOADING: dom_alt_mutations_RESET_LOADING,
    REORDER_PAGES: mutations_REORDER_PAGES,
    APPEND_SECTION: APPEND_SECTION,
    DELETE_SECTION: DELETE_SECTION,
    PATCH_SECTION: PATCH_SECTION,
    REORDER_SECTIONS: REORDER_SECTIONS,
    SET_NEW_PAGE_OPTIONS: SET_NEW_PAGE_OPTIONS,
    TOGGLE_PAGE_SELECTION_MODAL: TOGGLE_PAGE_SELECTION_MODAL
});
// CONCATENATED MODULE: ./src/state/modules/dom-alt/index.js
/**
 * Module Dependencies
 */





/**
 * Digital OM Module Declaration
 *
 * @type {Object}
 */
var dom_alt_module = {
  namespaced: true,
  state: dom_alt_state,
  getters: dom_alt_getters,
  mutations: dom_alt_mutations,
  actions: dom_alt_actions
};

/* harmony default export */ var dom_alt = (dom_alt_module);
// CONCATENATED MODULE: ./src/state/modules/comps/state.js
/**
 * Dependencies
 */


/**
 * Root State
 *
 * @type {Object}
 */
var comps_state_state = {
  loading: false,
  data: {
    rent: [],
    sale: [],
    all: []
  }
};

var comps_state_getState = function getState() {
  return Object(lodash["cloneDeep"])(comps_state_state);
};

/* harmony default export */ var comps_state = (comps_state_getState());
// CONCATENATED MODULE: ./src/state/modules/comps/actions.js
/**
 * Dependencies
 */


var actions_fetchAll = function fetchAll(_ref) {
    var commit = _ref.commit;

    commit('SET_LOADING');
    HttpService["a" /* default */].get('comps/dashboard/').then(function (res) {
        commit('SET_DATA', {
            data: res.data,
            type: 'all'
        });
        commit('RESET_LOADING');
    }).catch(function () {
        return commit('RESET_LOADING');
    });
};

/**
 * Get the available comps for a given type
 *
 * @param  {Function} options.commit
 * @param  {String} type
 * @return {Void}
 */
var actions_fetchByType = function fetchByType(_ref2, type) {
    var commit = _ref2.commit;

    commit('SET_LOADING');
    HttpService["a" /* default */].get('comps/dashboard/' + type + '/').then(function (res) {
        commit('SET_DATA', {
            data: res.data,
            type: type
        });
        commit('RESET_LOADING');
    }).catch(function () {
        return commit('RESET_LOADING');
    });
};

/* harmony default export */ var comps_actions = ({
    fetchAll: actions_fetchAll,
    fetchByType: actions_fetchByType
});
// CONCATENATED MODULE: ./src/state/modules/comps/getters.js
/* harmony default export */ var comps_getters = ({});
// CONCATENATED MODULE: ./src/state/modules/comps/mutations.js
/**
 * Set the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
var comps_mutations_SET_LOADING = function SET_LOADING(state) {
    state.loading = true;
};

/**
 * Reset the loading state
 *
 * @param  {Object} state
 * @return {Void}
 */
var comps_mutations_RESET_LOADING = function RESET_LOADING(state) {
    state.loading = false;
};

/**
 * Set the data on the state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
var comps_mutations_SET_DATA = function SET_DATA(state, payload) {
    state.data[payload.type] = payload.data;
};

/* harmony default export */ var comps_mutations = ({
    SET_DATA: comps_mutations_SET_DATA,
    SET_LOADING: comps_mutations_SET_LOADING,
    RESET_LOADING: comps_mutations_RESET_LOADING
});
// CONCATENATED MODULE: ./src/state/modules/comps/index.js
/**
 * Module Dependencies
 */





/**
 * Comps Module Declaration
 *
 * @type {Object}
 */
var comps_module = {
  namespaced: true,
  state: comps_state,
  actions: comps_actions,
  getters: comps_getters,
  mutations: comps_mutations
};

/* harmony default export */ var comps = (comps_module);
// CONCATENATED MODULE: ./src/state/store.js
/**
 * Vuex Store Declarations
 */
























/**
 * Vue Store Plugins
 */
vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/**
 * Base Vuex Store Declaration
 */
/* harmony default export */ var store = __webpack_exports__["a"] = (new vuex_esm["a" /* default */].Store({
  state: src_state_state,
  actions: actions,
  mutations: state_mutations,
  modules: {
    user: user,
    comps: comps,
    shared: shared,
    warRoom: war_room,
    company: company,
    profile: modules_profile,
    activity: activity,
    pipeline: deal_pipeline,
    projects: projects,
    importer: importer,
    portfolios: modules_portfolios,
    pnlImporter: pnl_importer,
    opexImporter: opex_importer,
    debtServicing: debt_servicing,
    rentRollImporter: rent_roll_importer,
    rentalIncomeImporter: rental_income_importer,
    dom: modules_dom,
    domAlt: dom_alt
  }
}));

/***/ }),

/***/ "aVT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Route Dependencies
 */
var WarRoom = function WarRoom(r) {
    return __webpack_require__.e/* require.ensure */(10).then((function () {
        return r(__webpack_require__("T7He"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var WarRoomSummary = function WarRoomSummary(r) {
    return __webpack_require__.e/* require.ensure */(10).then((function () {
        return r(__webpack_require__("y/5K"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/**
 * Account Routes
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/war-rooms/:warRoomId',
    component: WarRoom,
    children: [{
        path: '',
        name: 'war_rooms.show',
        component: WarRoomSummary
    }]
});

/***/ }),

/***/ "c5pT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchProjects; });
/* unused harmony export fetchSingleProject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return generateDownloadKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return shareProjectWithUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getProjectLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateProjectLink; });
/* unused harmony export deleteProjectLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createProjectLink; });
/* unused harmony export humanizeCapexLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return saveProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProjectCardData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return removeLink; });
/* unused harmony export checkPin */
/* unused harmony export checkSharedProjectKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getSuggestedCopiedProjectName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createProjectCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createTemplateFromProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getProjectTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getProjectFromTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getUserDataForProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updatePrivilege; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return revokePrivilege; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPrivilege; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return revokeInvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateInvite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpService__ = __webpack_require__("VOtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/**
 * Service Dependencies
 */




var stripCapex = function stripCapex(data) {
    var obj = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(data);
    delete obj.capex.AcquisitionCostSerializer;
    delete obj.capex.HardCostSerializer;
    delete obj.capex.SoftCostSerializer;
    return obj;
};

/**
 * Retrieve the user's projects
 *
 * @return {Promise}
 */
var fetchProjects = function fetchProjects() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(params));
};

/**
 * Retrieve a single project for a given user
 *
 * @type {Promise}
 */
var fetchSingleProject = function fetchSingleProject() {
    var projectId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/' + projectId + '/', params);
};

/**
 * Generate a key to download an Excel document
 *
 * @param  {Number} projectId
 * @return {Promise}
 */
var generateDownloadKey = function generateDownloadKey() {
    var projectId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].post('projects/' + projectId + '/export-to-excel/');
};

/**
 * Share project request
 *
 * @param  {String} email
 * @param  {Number} level
 * @param  {Number} id
 * @return {Promise}
 */
var shareProjectWithUser = function shareProjectWithUser(email, level, id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].post('projects/collaborate', {
        invitee_email: email,
        privilege_level: level,
        project_id: id
    });
};

/**
 * Request a global list of project links generated
 *
 * @return {Promise}
 */
var getProjectLinks = function getProjectLinks() {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/link-invites/');
};

/**
 * Update the project link active status
 *
 * @param  {Number} id
 * @param  {Object} payload
 * @return {Promise}
 */
var updateProjectLink = function updateProjectLink(id, status) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].patch('projects/link-invites/' + id + '/', {
        active: status
    });
};

/**
 * Delete existing project link
 *
 * @param  {Number} id
 * @return {Promise}
 */
var deleteProjectLink = function deleteProjectLink(id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].del('projects/link-invites/' + id + '/');
};

/**
 * Generate a new project link
 *
 * @param  {Number} id
 * @return {Promise}
 */
var createProjectLink = function createProjectLink(id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].post('projects/link-invites/', {
        project_id: id
    });
};

/**
 * Return a humanized string from a serializer key
 *
 * @param  {String} key
 * @return {String}
 */
var humanizeCapexLabel = function humanizeCapexLabel(key) {
    switch (key) {
        case 'OneTimeReserveSerializer':
            return 'One Time Costs';
        case 'HardCostSerializer':
            return 'Hard Costs';
        case 'SoftCostSerializer':
            return 'Soft Costs';
        case 'AcquisitionCostSerializer':
            return 'Acquisition Costs';
        default:
            return key;
    }
};

/**
 * Return an existing project model from the API
 *
 * @param  {Number} id
 * @return {Promise}
 */
var getProject = function getProject(id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/' + id + '/?edit=true');
};

/**
 * Save a project with given data
 *
 * @return {Promise}
 */
var saveProject = function saveProject(data) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].post('projects/create/', stripCapex(data));
};

/**
 * Attempt to update the project via the API
 *
 * @param  {Number} id
 * @param  {Object} data
 * @return {Promise}
 */
var updateProject = function updateProject(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].put('projects/' + id + '/', stripCapex(data));
};

/**
 * Fetch the available tags
 *
 * @return {Promise}
 */
var fetchTags = function fetchTags() {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('information/tags');
};

/**
 * Fetch the project card data
 *
 * @return {Promise}
 */
var getProjectCardData = function getProjectCardData(id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/' + id + '/?card=true');
};

/**
 * Remove a link
 *
 * @param  {Number} id
 * @return {Promise}
 */
var removeLink = function removeLink(id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].del('projects/link-invites/' + id + '/');
};

/**
 * Check for a valid PIN and return the associated project if the challenge passes.
 *
 * @param  {Number} pin
 * @return {Promise}
 */
var checkPin = function checkPin(key, payload) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].post('auth/' + key + '/', payload);
};

/**
 * Check for a valid shared URL key
 *
 * @param  {String} key
 * @return {Promise}
 */
var checkSharedProjectKey = function checkSharedProjectKey(key) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('auth/' + key + '/');
};

/**
 * Get the suggested project name when copying a project
 *
 * @param  {Number} id
 * @return {Promise}
 */
var getSuggestedCopiedProjectName = function getSuggestedCopiedProjectName(id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/' + id + '/copy/');
};

/**
 * Create a copy of a project
 *
 * @param  {Number} id
 * @param  {String} name
 * @return {Promise}
 */
var createProjectCopy = function createProjectCopy(id, name) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].post('projects/' + id + '/copy/', {
        name: name,
        is_template: false
    });
};

/**
 * Attempt to create a template from a given project ID
 *
 * @param  {Number} id
 * @param  {String} name
 * @return {Promise}
 */
var createTemplateFromProject = function createTemplateFromProject(payload) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].post('projects/templates/', payload);
};

/**
 * Query the API for the available template list
 *
 * @return {Promise}
 */
var getProjectTemplates = function getProjectTemplates() {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/templates/');
};

/**
 * Retrieve a template by ID
 *
 * @param  {Number} id
 * @return {Promise}
 */
var getProjectFromTemplate = function getProjectFromTemplate(id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/templates/' + id);
};

/**
 * Get the user context for a given project ID
 *
 * @param  {Number} id
 * @return {Promise}
 */
var getUserDataForProject = function getUserDataForProject(id) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].get('projects/' + id + '/privileges/');
};

/**
 * Call the API and update a user's level on a project
 *
 * @param  {Number} projectId
 * @param  {Number} userId
 * @param  {Number} level
 * @return {Promise}
 */
var updatePrivilege = function updatePrivilege(projectId, privilegeId, level) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].patch('projects/' + projectId + '/privileges/' + privilegeId + '/', {
        privilege_level: level
    });
};

/**
 * Revoke a privilege on a given project
 *
 * @param  {Number} projectId
 * @param  {Number} privilegeid
 * @return {Promise}
 */
var revokePrivilege = function revokePrivilege(projectId, privilegeId) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].del('projects/' + projectId + '/privileges/' + privilegeId + '/');
};

/**
 * Request the API to generate a new privilege for a given project
 *
 * @param  {Number} projectId
 * @return {Promise}
 */
var createPrivilege = function createPrivilege(projectId, data) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].post('projects/' + projectId + '/privileges/', data);
};

/**
 * Destroy an invitation
 *
 * @param  {Number} invitationId
 * @return {Promise}
 */
var revokeInvite = function revokeInvite(invitationId) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].del('projects/collaborate/' + invitationId);
};

/**
 * Update an invite level
 *
 * @param  {Number} invitationId
 * @param  {Number} level
 * @return {Promise}
 */
var updateInvite = function updateInvite(invitationId, level) {
    return __WEBPACK_IMPORTED_MODULE_1__HttpService__["a" /* default */].patch('projects/collaborate/' + invitationId, {
        privilege_level: level
    });
};

/***/ }),

/***/ "cAvP":
/***/ (function(module, exports) {



/***/ }),

/***/ "d4Po":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dhua":
/***/ (function(module, exports) {



/***/ }),

/***/ "g523":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ibMf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iuxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/general/forms/misc/Cleave.vue + 2 modules
var Cleave = __webpack_require__("CIML");

// EXTERNAL MODULE: ./src/components/general/forms/BaseField.vue + 1 modules
var BaseField = __webpack_require__("j/QW");

// EXTERNAL MODULE: ./src/components/general/HelpText.vue + 2 modules
var HelpText = __webpack_require__("kC2x");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/CurrencyField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */




/**
 * Percentage Field Component
 */
/* harmony default export */ var CurrencyField = ({
    name: 'currency_field',
    extends: BaseField["a" /* default */],
    components: {
        Cleave: Cleave["a" /* default */],
        HelpText: HelpText["a" /* default */]
    },
    props: {
        value: {
            type: Number,
            required: false
        }
    },
    data: function data() {
        return {
            cleaveOptions: {
                numeral: true,
                numeralDecimalScale: 2,
                rawValueTrimPrefix: true
            }
        };
    },

    methods: {
        updateValue: function updateValue(value) {
            var val = Number(value);
            this.$emit('updated', !isNaN(val) ? val : null);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a0b5118","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/CurrencyField.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--currency",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns"},[(_vm.label)?_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"formatted-input formatted-input--monetary"},[(_vm.disabled)?_c('span',{staticClass:"formatted-input__disabled"}):_vm._e(),_vm._v(" "),_c('cleave',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"options":_vm.cleaveOptions,"disabled":_vm.disabled},on:{"input":_vm.updateValue}}),_vm._v(" "),_c('span',{staticClass:"formatted-input--monetary__prefix"},[_vm._v("\n                    $\n                ")])],1)])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var forms_CurrencyField = (esExports);
// CONCATENATED MODULE: ./src/components/general/forms/CurrencyField.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CurrencyField,
  forms_CurrencyField,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var general_forms_CurrencyField = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j/QW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/general/HelpText.vue + 2 modules
var HelpText = __webpack_require__("kC2x");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/BaseField.vue

/**
 * Dependencies
 */


/**
 * Base Field Component
 */
/* harmony default export */ var BaseField = ({
    name: 'base_field',
    components: {
        HelpText: HelpText["a" /* default */]
    },
    props: {
        label: {
            type: String,
            required: false
        },
        value: {
            required: false,
            default: null
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false
        },
        focusOnRender: {
            type: Boolean,
            required: false,
            default: false
        },
        errors: {
            type: Array,
            required: false,
            default: function _default() {
                return [];
            }
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        helptext: {
            type: String,
            required: false,
            default: null
        }
    },
    data: function data() {
        return {
            pristine: true
        };
    },

    methods: {
        updateValue: function updateValue(e) {
            this.$emit('updated', e.target.value);
        }
    },
    watch: {
        value: function value(newVal) {
            if (this.hasErrors) {
                this.$emit('clear-errors');
            }
        }
    },
    mounted: function mounted() {
        if (this.focusOnRender) {
            this.$refs.input.focus();
        }
    },

    computed: {
        hasErrors: function hasErrors() {
            return this.errors && this.errors.length > 0;
        },
        fieldClasses: function fieldClasses() {
            return {
                'has-errors': this.hasErrors || this.dirtyAndRequired
            };
        },
        labelClasses: function labelClasses() {
            return {
                'is-required': this.required
            };
        },
        noValue: function noValue() {
            return this.value === null || this.value === 'undefined' || this.value === '';
        },
        dirtyAndRequired: function dirtyAndRequired() {
            return this.required && !this.pristine && this.noValue;
        }
    }
});
// CONCATENATED MODULE: ./src/components/general/forms/BaseField.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  BaseField,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var forms_BaseField = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kC2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/HelpText.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HelpText = ({
    name: 'helptext',
    props: {
        helptext: {
            type: String,
            required: false,
            default: null
        }
    },
    data: function data() {
        return {
            showPopover: false
        };
    },

    methods: {
        togglePopover: function togglePopover() {
            this.showPopover = !this.showPopover;
        },
        closeOnClickaway: function closeOnClickaway(e) {
            if (!this.$refs.help) {
                return document.removeEventListener('click', this.closeOnClickaway);
            }

            if (!this.$refs.help.contains(e.target)) {
                this.showPopover = false;
            }
        }
    },
    watch: {
        showPopover: function showPopover(shown) {
            if (shown) {
                document.addEventListener('click', this.closeOnClickaway);
            } else {
                document.removeEventListener('click', this.closeOnClickaway);
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-442d7ac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/HelpText.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"help",staticClass:"help-text"},[_c('button',{staticClass:"help-text__trigger",attrs:{"type":"button"},on:{"click":function($event){_vm.togglePopover()}}},[_c('i',{staticClass:"fa",class:_vm.showPopover ? 'fa-times-circle' : 'fa-info-circle'})]),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopover),expression:"showPopover"}],staticClass:"help-text__popover"},[_c('p',{domProps:{"textContent":_vm._s(_vm.helptext)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var general_HelpText = (esExports);
// CONCATENATED MODULE: ./src/components/general/HelpText.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  HelpText,
  general_HelpText,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_general_HelpText = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lr7X":
/***/ (function(module, exports) {



/***/ }),

/***/ "mPSx":
/***/ (function(module, exports) {



/***/ }),

/***/ "t29X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/general/forms/misc/Cleave.vue + 2 modules
var Cleave = __webpack_require__("CIML");

// EXTERNAL MODULE: ./src/components/general/forms/BaseField.vue + 1 modules
var BaseField = __webpack_require__("j/QW");

// EXTERNAL MODULE: ./src/components/general/HelpText.vue + 2 modules
var HelpText = __webpack_require__("kC2x");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/NumberField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */




/**
 * Number Field Component
 */
/* harmony default export */ var NumberField = ({
    name: 'number_field',
    extends: BaseField["a" /* default */],
    components: {
        Cleave: Cleave["a" /* default */],
        HelpText: HelpText["a" /* default */]
    },
    props: {
        value: {
            type: Number,
            required: false
        }
    },
    data: function data() {
        return {
            cleaveOptions: {
                numeral: true,
                rawValueTrimPrefix: true
            }
        };
    },

    methods: {
        updateValue: function updateValue(value) {
            var val = Number(value);
            this.$emit('updated', !isNaN(val) ? val : null);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f20022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/NumberField.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--number",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('cleave',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"options":_vm.cleaveOptions,"disabled":_vm.disabled},on:{"input":function (val) { _vm.updateValue(val) }}})],1)]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var forms_NumberField = (esExports);
// CONCATENATED MODULE: ./src/components/general/forms/NumberField.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  NumberField,
  forms_NumberField,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var general_forms_NumberField = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ulap":
/***/ (function(module, exports) {



/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v+Uo":
/***/ (function(module, exports) {



/***/ }),

/***/ "vDvX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/general/forms/BaseField.vue + 1 modules
var BaseField = __webpack_require__("j/QW");

// EXTERNAL MODULE: ./src/components/general/HelpText.vue + 2 modules
var HelpText = __webpack_require__("kC2x");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/general/forms/TextField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component Dependencies
 */



/**
 * Component
 */
/* harmony default export */ var TextField = ({
    name: 'text_field',
    extends: BaseField["a" /* default */],
    components: {
        HelpText: HelpText["a" /* default */]
    },
    methods: {
        onBlur: function onBlur(e) {
            this.$emit('on-blur', e.target.value);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bccf69e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/forms/TextField.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--text",class:_vm.fieldClasses},[(_vm.helptext || _vm.label)?_c('div',{staticClass:"row collapse no-pad align-middle"},[(_vm.helptext)?_c('div',{staticClass:"columns shrink"},[_c('help-text',{attrs:{"helptext":_vm.helptext}})],1):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"columns"},[_c('label',{class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder,"disabled":_vm.disabled,"autofocus":_vm.autofocus},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.onBlur}})])]),_vm._v(" "),(_vm.hasErrors)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns"},[_c('ul',{staticClass:"field__errors"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var forms_TextField = (esExports);
// CONCATENATED MODULE: ./src/components/general/forms/TextField.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  TextField,
  forms_TextField,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var general_forms_TextField = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w/Np":
/***/ (function(module, exports) {



/***/ }),

/***/ "wmJy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xHDB":
/***/ (function(module, exports) {



/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2949ce323c91fa4d0552.js